/*4.49.0*/
!function() {
    var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {};
    function t(e) {
        return e && e.__esModule ? e.default : e
    }
    function n(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }
    function r(e, t, n) {
        Object.defineProperty(e, t, {
            get: n,
            enumerable: !0
        })
    }
    var i,
        o,
        a,
        s,
        l,
        u,
        c,
        d,
        p,
        f = {},
        h = {},
        m = !1;
    function v(e, t) {
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function g(e) {
        var t = e.parentNode;
        t && t.removeChild(e)
    }
    function y(e, t, n) {
        var r,
            i,
            o,
            a = arguments,
            s = {};
        for (o in t)
            "key" == o ? r = t[o] : "ref" == o ? i = t[o] : s[o] = t[o];
        if (arguments.length > 3)
            for (n = [n], o = 3; o < arguments.length; o++)
                n.push(a[o]);
        if (null != n && (s.children = n), "function" == typeof e && null != e.defaultProps)
            for (o in e.defaultProps)
                void 0 === s[o] && (s[o] = e.defaultProps[o]);
        return b(e, s, r, i, null)
    }
    function b(e, t, n, r, i) {
        var a = {
            type: e,
            props: t,
            key: n,
            ref: r,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == i ? ++o.__v : i
        };
        return null != o.vnode && o.vnode(a), a
    }
    function w() {
        return {
            current: null
        }
    }
    function x(e) {
        return e.children
    }
    function _(e, t) {
        this.props = e, this.context = t
    }
    function C(e, t) {
        if (null == t)
            return e.__ ? C(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var n; t < e.__k.length; t++)
            if (null != (n = e.__k[t]) && null != n.__e)
                return n.__e;
        return "function" == typeof e.type ? C(e) : null
    }
    function E(e) {
        var t,
            n;
        if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
                if (null != (n = e.__k[t]) && null != n.__e) {
                    e.__e = e.__c.base = n.__e;
                    break
                }
            return E(e)
        }
    }
    function S(e) {
        (!e.__d && (e.__d = !0) && a.push(e) && !k.__r++ || l !== o.debounceRendering) && ((l = o.debounceRendering) || s)(k)
    }
    function k() {
        for (var e; k.__r = a.length;)
            e = a.sort((function(e, t) {
                return e.__v.__b - t.__v.__b
            })), a = [], e.some((function(e) {
                var t,
                    n,
                    r,
                    i,
                    o,
                    a;
                e.__d && (o = (i = (t = e).__v).__e, (a = t.__P) && (n = [], (r = v({}, i)).__v = i.__v + 1, L(a, i, r, t.__n, void 0 !== a.ownerSVGElement, null != i.__h ? [o] : null, n, null == o ? C(i) : o, i.__h), D(n, i), i.__e != o && E(i)))
            }))
    }
    function T(e, t, n, r, i, o, a, s, l, u) {
        var p,
            f,
            h,
            m,
            v,
            g,
            y,
            w = r && r.__k || d,
            _ = w.length;
        for (n.__k = [], p = 0; p < t.length; p++)
            if (null != (m = n.__k[p] = null == (m = t[p]) || "boolean" == typeof m ? null : "string" == typeof m || "number" == typeof m ? b(null, m, null, null, m) : Array.isArray(m) ? b(x, {
                children: m
            }, null, null, null) : m.__b > 0 ? b(m.type, m.props, m.key, null, m.__v) : m)) {
                if (m.__ = n, m.__b = n.__b + 1, null === (h = w[p]) || h && m.key == h.key && m.type === h.type)
                    w[p] = void 0;
                else
                    for (f = 0; f < _; f++) {
                        if ((h = w[f]) && m.key == h.key && m.type === h.type) {
                            w[f] = void 0;
                            break
                        }
                        h = null
                    }
                L(e, m, h = h || c, i, o, a, s, l, u), v = m.__e, (f = m.ref) && h.ref != f && (y || (y = []), h.ref && y.push(h.ref, null, m), y.push(f, m.__c || v, m)), null != v ? (null == g && (g = v), "function" == typeof m.type && null != m.__k && m.__k === h.__k ? m.__d = l = O(m, l, e) : l = R(e, m, h, w, v, l), u || "option" !== n.type ? "function" == typeof n.type && (n.__d = l) : e.value = "") : l && h.__e == l && l.parentNode != e && (l = C(h))
            }
        for (n.__e = g, p = _; p--;)
            null != w[p] && ("function" == typeof n.type && null != w[p].__e && w[p].__e == n.__d && (n.__d = C(r, p + 1)), B(w[p], w[p]));
        if (y)
            for (p = 0; p < y.length; p++)
                N(y[p], y[++p], y[++p])
    }
    function O(e, t, n) {
        var r,
            i;
        for (r = 0; r < e.__k.length; r++)
            (i = e.__k[r]) && (i.__ = e, t = "function" == typeof i.type ? O(i, t, n) : R(n, i, i, e.__k, i.__e, t));
        return t
    }
    function M(e, t) {
        return t = t || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some((function(e) {
            M(e, t)
        })) : t.push(e)), t
    }
    function R(e, t, n, r, i, o) {
        var a,
            s,
            l;
        if (void 0 !== t.__d)
            a = t.__d, t.__d = void 0;
        else if (null == n || i != o || null == i.parentNode)
            e:
            if (null == o || o.parentNode !== e)
                e.appendChild(i), a = null;
            else {
                for (s = o, l = 0; (s = s.nextSibling) && l < r.length; l += 2)
                    if (s == i)
                        break e;
                e.insertBefore(i, o), a = o
            }
        return void 0 !== a ? a : i.nextSibling
    }
    function P(e, t, n) {
        "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || p.test(t) ? n : n + "px"
    }
    function A(e, t, n, r, i) {
        var o;
        e:
        if ("style" === t)
            if ("string" == typeof n)
                e.style.cssText = n;
            else {
                if ("string" == typeof r && (e.style.cssText = r = ""), r)
                    for (t in r)
                        n && t in n || P(e.style, t, "");
                if (n)
                    for (t in n)
                        r && n[t] === r[t] || P(e.style, t, n[t])
            }
        else if ("o" === t[0] && "n" === t[1])
            o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = n, n ? r || e.addEventListener(t, o ? z : I, o) : e.removeEventListener(t, o ? z : I, o);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (i)
                t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
            else if ("href" !== t && "list" !== t && "form" !== t && "download" !== t && t in e)
                try {
                    e[t] = null == n ? "" : n;
                    break e
                } catch (e) {}
            "function" == typeof n || (null != n && (!1 !== n || "a" === t[0] && "r" === t[1]) ? e.setAttribute(t, n) : e.removeAttribute(t))
        }
    }
    function I(e) {
        this.l[e.type + !1](o.event ? o.event(e) : e)
    }
    function z(e) {
        this.l[e.type + !0](o.event ? o.event(e) : e)
    }
    function L(e, t, n, r, i, a, s, l, u) {
        var p,
            f,
            h,
            m,
            y,
            b,
            w,
            C,
            E,
            S,
            k,
            O = t.type;
        if (void 0 !== t.constructor)
            return null;
        null != n.__h && (u = n.__h, l = t.__e = n.__e, t.__h = null, a = [l]), (p = o.__b) && p(t);
        try {
            e:
            if ("function" == typeof O) {
                if (C = t.props, E = (p = O.contextType) && r[p.__c], S = p ? E ? E.props.value : p.__ : r, n.__c ? w = (f = t.__c = n.__c).__ = f.__E : ("prototype" in O && O.prototype.render ? t.__c = f = new O(C, S) : (t.__c = f = new _(C, S), f.constructor = O, f.render = F), E && E.sub(f), f.props = C, f.state || (f.state = {}), f.context = S, f.__n = r, h = f.__d = !0, f.__h = []), null == f.__s && (f.__s = f.state), null != O.getDerivedStateFromProps && (f.__s == f.state && (f.__s = v({}, f.__s)), v(f.__s, O.getDerivedStateFromProps(C, f.__s))), m = f.props, y = f.state, h)
                    null == O.getDerivedStateFromProps && null != f.componentWillMount && f.componentWillMount(), null != f.componentDidMount && f.__h.push(f.componentDidMount);
                else {
                    if (null == O.getDerivedStateFromProps && C !== m && null != f.componentWillReceiveProps && f.componentWillReceiveProps(C, S), !f.__e && null != f.shouldComponentUpdate && !1 === f.shouldComponentUpdate(C, f.__s, S) || t.__v === n.__v) {
                        f.props = C, f.state = f.__s, t.__v !== n.__v && (f.__d = !1), f.__v = t, t.__e = n.__e, t.__k = n.__k, f.__h.length && s.push(f);
                        break e
                    }
                    null != f.componentWillUpdate && f.componentWillUpdate(C, f.__s, S), null != f.componentDidUpdate && f.__h.push((function() {
                        f.componentDidUpdate(m, y, b)
                    }))
                }
                f.context = S, f.props = C, f.state = f.__s, (p = o.__r) && p(t), f.__d = !1, f.__v = t, f.__P = e, p = f.render(f.props, f.state, f.context), f.state = f.__s, null != f.getChildContext && (r = v(v({}, r), f.getChildContext())), h || null == f.getSnapshotBeforeUpdate || (b = f.getSnapshotBeforeUpdate(m, y)), k = null != p && p.type === x && null == p.key ? p.props.children : p, T(e, Array.isArray(k) ? k : [k], t, n, r, i, a, s, l, u), f.base = t.__e, t.__h = null, f.__h.length && s.push(f), w && (f.__E = f.__ = null), f.__e = !1
            } else
                null == a && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = function(e, t, n, r, i, o, a, s) {
                    var l,
                        u,
                        p,
                        f,
                        h = n.props,
                        m = t.props,
                        v = t.type,
                        y = 0;
                    if ("svg" === v && (i = !0), null != o)
                        for (; y < o.length; y++)
                            if ((l = o[y]) && (l === e || (v ? l.localName == v : 3 == l.nodeType))) {
                                e = l, o[y] = null;
                                break
                            }
                    if (null == e) {
                        if (null === v)
                            return document.createTextNode(m);
                        e = i ? document.createElementNS("http://www.w3.org/2000/svg", v) : document.createElement(v, m.is && m), o = null, s = !1
                    }
                    if (null === v)
                        h === m || s && e.data === m || (e.data = m);
                    else {
                        if (o = o && d.slice.call(e.childNodes), u = (h = n.props || c).dangerouslySetInnerHTML, p = m.dangerouslySetInnerHTML, !s) {
                            if (null != o)
                                for (h = {}, f = 0; f < e.attributes.length; f++)
                                    h[e.attributes[f].name] = e.attributes[f].value;
                            (p || u) && (p && (u && p.__html == u.__html || p.__html === e.innerHTML) || (e.innerHTML = p && p.__html || ""))
                        }
                        if (function(e, t, n, r, i) {
                            var o;
                            for (o in n)
                                "children" === o || "key" === o || o in t || A(e, o, null, n[o], r);
                            for (o in t)
                                i && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || n[o] === t[o] || A(e, o, t[o], n[o], r)
                        }(e, m, h, i, s), p)
                            t.__k = [];
                        else if (y = t.props.children, T(e, Array.isArray(y) ? y : [y], t, n, r, i && "foreignObject" !== v, o, a, e.firstChild, s), null != o)
                            for (y = o.length; y--;)
                                null != o[y] && g(o[y]);
                        s || ("value" in m && void 0 !== (y = m.value) && (y !== e.value || "progress" === v && !y) && A(e, "value", y, h.value, !1), "checked" in m && void 0 !== (y = m.checked) && y !== e.checked && A(e, "checked", y, h.checked, !1))
                    }
                    return e
                }(n.__e, t, n, r, i, a, s, u);
            (p = o.diffed) && p(t)
        } catch (e) {
            t.__v = null, (u || null != a) && (t.__e = l, t.__h = !!u, a[a.indexOf(l)] = null), o.__e(e, t, n)
        }
    }
    function D(e, t) {
        o.__c && o.__c(t, e), e.some((function(t) {
            try {
                e = t.__h, t.__h = [], e.some((function(e) {
                    e.call(t)
                }))
            } catch (e) {
                o.__e(e, t.__v)
            }
        }))
    }
    function N(e, t, n) {
        try {
            "function" == typeof e ? e(t) : e.current = t
        } catch (e) {
            o.__e(e, n)
        }
    }
    function B(e, t, n) {
        var r,
            i,
            a;
        if (o.unmount && o.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || N(r, null, t)), n || "function" == typeof e.type || (n = null != (i = e.__e)), e.__e = e.__d = void 0, null != (r = e.__c)) {
            if (r.componentWillUnmount)
                try {
                    r.componentWillUnmount()
                } catch (e) {
                    o.__e(e, t)
                }
            r.base = r.__P = null
        }
        if (r = e.__k)
            for (a = 0; a < r.length; a++)
                r[a] && B(r[a], t, n);
        null != i && g(i)
    }
    function F(e, t, n) {
        return this.constructor(e, n)
    }
    function W(e, t, n) {
        var r,
            i,
            a;
        o.__ && o.__(e, t), i = (r = "function" == typeof n) ? null : n && n.__k || t.__k, a = [], L(t, e = (!r && n || t).__k = y(x, null, [e]), i || c, c, void 0 !== t.ownerSVGElement, !r && n ? [n] : i ? null : t.firstChild ? d.slice.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r), D(a, e)
    }
    function H(e, t) {
        W(e, t, H)
    }
    function j(e, t, n) {
        var r,
            i,
            o,
            a = arguments,
            s = v({}, e.props);
        for (o in t)
            "key" == o ? r = t[o] : "ref" == o ? i = t[o] : s[o] = t[o];
        if (arguments.length > 3)
            for (n = [n], o = 3; o < arguments.length; o++)
                n.push(a[o]);
        return null != n && (s.children = n), b(e.type, s, r || e.key, i || e.ref, null)
    }
    function $(e, t) {
        var n = {
            __c: t = "__cC" + u++,
            __: e,
            Consumer: function(e, t) {
                return e.children(t)
            },
            Provider: function(e) {
                var n,
                    r;
                return this.getChildContext || (n = [], (r = {})[t] = this, this.getChildContext = function() {
                    return r
                }, this.shouldComponentUpdate = function(e) {
                    this.props.value !== e.value && n.some(S)
                }, this.sub = function(e) {
                    n.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function() {
                        n.splice(n.indexOf(e), 1), t && t.call(e)
                    }
                }), e.children
            }
        };
        return n.Provider.__ = n.Consumer.contextType = n
    }
    function V() {
        return m || (m = !0, i = {}, c = {}, d = [], p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, o = {
            __e: function(e, t) {
                for (var n, r, i; t = t.__;)
                    if ((n = t.__c) && !n.__)
                        try {
                            if ((r = n.constructor) && null != r.getDerivedStateFromError && (n.setState(r.getDerivedStateFromError(e)), i = n.__d), null != n.componentDidCatch && (n.componentDidCatch(e), i = n.__d), i)
                                return n.__E = n
                        } catch (t) {
                            e = t
                        }
                throw e
            },
            __v: 0
        }, function(e) {
            return null != e && void 0 === e.constructor
        }, _.prototype.setState = function(e, t) {
            var n;
            n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state), "function" == typeof e && (e = e(v({}, n), this.props)), e && v(n, e), null != e && this.__v && (t && this.__h.push(t), S(this))
        }, _.prototype.forceUpdate = function(e) {
            this.__v && (this.__e = !0, e && this.__h.push(e), S(this))
        }, _.prototype.render = x, a = [], s = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, k.__r = 0, u = 0, r(i, "options", (function() {
            return o
        })), r(i, "toChildArray", (function() {
            return M
        })), r(i, "createContext", (function() {
            return $
        })), r(i, "cloneElement", (function() {
            return j
        })), r(i, "Component", (function() {
            return _
        })), r(i, "createRef", (function() {
            return w
        })), r(i, "Fragment", (function() {
            return x
        })), r(i, "createElement", (function() {
            return y
        })), r(i, "hydrate", (function() {
            return H
        })), r(i, "render", (function() {
            return W
        }))), i
    }
    V();
    var q,
        U,
        G,
        Z = 0,
        K = [],
        Y = V().options.__b,
        X = V().options.__r,
        J = V().options.diffed,
        Q = V().options.__c,
        ee = V().options.unmount;
    function te(e, t) {
        V().options.__h && V().options.__h(U, e, Z || t), Z = 0;
        var n = U.__H || (U.__H = {
            __: [],
            __h: []
        });
        return e >= n.__.length && n.__.push({}), n.__[e]
    }
    function ne(e) {
        return Z = 1, re(we, e)
    }
    function re(e, t, n) {
        var r = te(q++, 2);
        return r.t = e, r.__c || (r.__ = [n ? n(t) : we(void 0, t), function(e) {
            var t = r.t(r.__[0], e);
            r.__[0] !== t && (r.__ = [t, r.__[1]], r.__c.setState({}))
        }], r.__c = U), r.__
    }
    function ie(e, t) {
        var n = te(q++, 3);
        !V().options.__s && be(n.__H, t) && (n.__ = e, n.__H = t, U.__H.__h.push(n))
    }
    function oe(e, t) {
        var n = te(q++, 4);
        !V().options.__s && be(n.__H, t) && (n.__ = e, n.__H = t, U.__h.push(n))
    }
    function ae(e) {
        return Z = 5, le((function() {
            return {
                current: e
            }
        }), [])
    }
    function se(e, t, n) {
        Z = 6, oe((function() {
            "function" == typeof e ? e(t()) : e && (e.current = t())
        }), null == n ? n : n.concat(e))
    }
    function le(e, t) {
        var n = te(q++, 7);
        return be(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__
    }
    function ue(e, t) {
        return Z = 8, le((function() {
            return e
        }), t)
    }
    function ce(e) {
        var t = U.context[e.__c],
            n = te(q++, 9);
        return n.__c = e, t ? (null == n.__ && (n.__ = !0, t.sub(U)), t.props.value) : e.__
    }
    function de(e, t) {
        V().options.useDebugValue && V().options.useDebugValue(t ? t(e) : e)
    }
    function pe(e) {
        var t = te(q++, 10),
            n = ne();
        return t.__ = e, U.componentDidCatch || (U.componentDidCatch = function(e) {
            t.__ && t.__(e), n[1](e)
        }), [n[0], function() {
            n[1](void 0)
        }]
    }
    function fe() {
        K.forEach((function(e) {
            if (e.__P)
                try {
                    e.__H.__h.forEach(ge), e.__H.__h.forEach(ye), e.__H.__h = []
                } catch (t) {
                    e.__H.__h = [], V().options.__e(t, e.__v)
                }
        })), K = []
    }
    V().options.__b = function(e) {
        U = null, Y && Y(e)
    }, V().options.__r = function(e) {
        X && X(e), q = 0;
        var t = (U = e.__c).__H;
        t && (t.__h.forEach(ge), t.__h.forEach(ye), t.__h = [])
    }, V().options.diffed = function(e) {
        J && J(e);
        var t = e.__c;
        t && t.__H && t.__H.__h.length && (1 !== K.push(t) && G === V().options.requestAnimationFrame || ((G = V().options.requestAnimationFrame) || function(e) {
            var t,
                n = function() {
                    clearTimeout(r), ve && cancelAnimationFrame(t), setTimeout(e)
                },
                r = setTimeout(n, 100);
            ve && (t = requestAnimationFrame(n))
        })(fe)), U = void 0
    }, V().options.__c = function(e, t) {
        t.some((function(e) {
            try {
                e.__h.forEach(ge), e.__h = e.__h.filter((function(e) {
                    return !e.__ || ye(e)
                }))
            } catch (n) {
                t.some((function(e) {
                    e.__h && (e.__h = [])
                })), t = [], V().options.__e(n, e.__v)
            }
        })), Q && Q(e, t)
    }, V().options.unmount = function(e) {
        ee && ee(e);
        var t = e.__c;
        if (t && t.__H)
            try {
                t.__H.__.forEach(ge)
            } catch (e) {
                V().options.__e(e, t.__v)
            }
    };
    var he,
        me,
        ve = "function" == typeof requestAnimationFrame;
    function ge(e) {
        var t = U;
        "function" == typeof e.__c && e.__c(), U = t
    }
    function ye(e) {
        var t = U;
        e.__c = e.__(), U = t
    }
    function be(e, t) {
        return !e || e.length !== t.length || t.some((function(t, n) {
                return t !== e[n]
            }))
    }
    function we(e, t) {
        return "function" == typeof t ? t(e) : t
    }
    function xe(e, t) {
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function _e(e, t) {
        for (var n in e)
            if ("__source" !== n && !(n in t))
                return !0;
        for (var r in t)
            if ("__source" !== r && e[r] !== t[r])
                return !0;
        return !1
    }
    function Ce(e) {
        this.props = e
    }
    function Ee(e, t) {
        function n(e) {
            var n = this.props.ref,
                r = n == e.ref;
            return !r && n && (n.call ? n(null) : n.current = null), t ? !t(this.props, e) || !r : _e(this.props, e)
        }
        function r(t) {
            return this.shouldComponentUpdate = n, V().createElement(e, t)
        }
        return r.displayName = "Memo(" + (e.displayName || e.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r
    }
    r(h, "useErrorBoundary", (function() {
        return pe
    })), r(h, "useDebugValue", (function() {
        return de
    })), r(h, "useContext", (function() {
        return ce
    })), r(h, "useCallback", (function() {
        return ue
    })), r(h, "useMemo", (function() {
        return le
    })), r(h, "useImperativeHandle", (function() {
        return se
    })), r(h, "useRef", (function() {
        return ae
    })), r(h, "useLayoutEffect", (function() {
        return oe
    })), r(h, "useEffect", (function() {
        return ie
    })), r(h, "useReducer", (function() {
        return re
    })), r(h, "useState", (function() {
        return ne
    })), he = f, me = h, Object.keys(me).forEach((function(e) {
        "default" !== e && "__esModule" !== e && Object.defineProperty(he, e, {
            enumerable: !0,
            get: function() {
                return me[e]
            }
        })
    })), V(), V(), r(f, "Component", (function() {
        return V().Component
    })), r(f, "Fragment", (function() {
        return V().Fragment
    })), r(f, "createRef", (function() {
        return V().createRef
    })), r(f, "createContext", (function() {
        return V().createContext
    })), r(f, "createElement", (function() {
        return V().createElement
    })), (Ce.prototype = new (V().Component)).isPureReactComponent = !0, Ce.prototype.shouldComponentUpdate = function(e, t) {
        return _e(this.props, e) || _e(this.state, t)
    };
    var Se = V().options.__b;
    V().options.__b = function(e) {
        e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), Se && Se(e)
    };
    var ke = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
    function Te(e) {
        function t(t, n) {
            var r = xe({}, t);
            return delete r.ref, e(r, (n = t.ref || n) && ("object" != typeof n || "current" in n) ? n : null)
        }
        return t.$$typeof = ke, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t
    }
    var Oe = function(e, t) {
            return null == e ? null : V().toChildArray(V().toChildArray(e).map(t))
        },
        Me = {
            map: Oe,
            forEach: Oe,
            count: function(e) {
                return e ? V().toChildArray(e).length : 0
            },
            only: function(e) {
                var t = V().toChildArray(e);
                if (1 !== t.length)
                    throw "Children.only";
                return t[0]
            },
            toArray: V().toChildArray
        },
        Re = V().options.__e;
    function Pe() {
        this.__u = 0, this.t = null, this.__b = null
    }
    function Ae(e) {
        var t = e.__.__c;
        return t && t.__e && t.__e(e)
    }
    function Ie(e) {
        var t,
            n,
            r;
        function i(i) {
            if (t || (t = e()).then((function(e) {
                n = e.default || e
            }), (function(e) {
                r = e
            })), r)
                throw r;
            if (!n)
                throw t;
            return V().createElement(n, i)
        }
        return i.displayName = "Lazy", i.__f = !0, i
    }
    function ze() {
        this.u = null, this.o = null
    }
    V().options.__e = function(e, t, n) {
        if (e.then)
            for (var r, i = t; i = i.__;)
                if ((r = i.__c) && r.__c)
                    return null == t.__e && (t.__e = n.__e, t.__k = n.__k), r.__c(e, t);
        Re(e, t, n)
    }, (Pe.prototype = new (V().Component)).__c = function(e, t) {
        var n = t.__c,
            r = this;
        null == r.t && (r.t = []), r.t.push(n);
        var i = Ae(r.__v),
            o = !1,
            a = function() {
                o || (o = !0, n.componentWillUnmount = n.__c, i ? i(s) : s())
            };
        n.__c = n.componentWillUnmount, n.componentWillUnmount = function() {
            a(), n.__c && n.__c()
        };
        var s = function() {
                if (!--r.__u) {
                    if (r.state.__e) {
                        var e = r.state.__e;
                        r.__v.__k[0] = function e(t, n, r) {
                            return t && (t.__v = null, t.__k = t.__k && t.__k.map((function(t) {
                                return e(t, n, r)
                            })), t.__c && t.__c.__P === n && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t
                        }(e, e.__c.__P, e.__c.__O)
                    }
                    var t;
                    for (r.setState({
                        __e: r.__b = null
                    }); t = r.t.pop();)
                        t.forceUpdate()
                }
            },
            l = !0 === t.__h;
        r.__u++ || l || r.setState({
            __e: r.__b = r.__v.__k[0]
        }), e.then(a, a)
    }, Pe.prototype.componentWillUnmount = function() {
        this.t = []
    }, Pe.prototype.render = function(e, t) {
        if (this.__b) {
            if (this.__v.__k) {
                var n = document.createElement("div"),
                    r = this.__v.__k[0].__c;
                this.__v.__k[0] = function e(t, n, r) {
                    return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach((function(e) {
                        "function" == typeof e.__c && e.__c()
                    })), t.__c.__H = null), null != (t = xe({}, t)).__c && (t.__c.__P === r && (t.__c.__P = n), t.__c = null), t.__k = t.__k && t.__k.map((function(t) {
                        return e(t, n, r)
                    }))), t
                }(this.__b, n, r.__O = r.__P)
            }
            this.__b = null
        }
        var i = t.__e && V().createElement(V().Fragment, null, e.fallback);
        return i && (i.__h = null), [V().createElement(V().Fragment, null, t.__e ? null : e.children), i]
    };
    var Le = function(e, t, n) {
        if (++n[1] === n[0] && e.o.delete(t), e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.o.size))
            for (n = e.u; n;) {
                for (; n.length > 3;)
                    n.pop()();
                if (n[1] < n[0])
                    break;
                e.u = n = n[2]
            }
    };
    function De(e) {
        return this.getChildContext = function() {
            return e.context
        }, e.children
    }
    function Ne(e) {
        var t = this,
            n = e.i;
        t.componentWillUnmount = function() {
            V().render(null, t.l), t.l = null, t.i = null
        }, t.i && t.i !== n && t.componentWillUnmount(), e.__v ? (t.l || (t.i = n, t.l = {
            nodeType: 1,
            parentNode: n,
            childNodes: [],
            appendChild: function(e) {
                this.childNodes.push(e), t.i.appendChild(e)
            },
            insertBefore: function(e, n) {
                this.childNodes.push(e), t.i.appendChild(e)
            },
            removeChild: function(e) {
                this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t.i.removeChild(e)
            }
        }), V().render(V().createElement(De, {
            context: t.context
        }, e.__v), t.l)) : t.l && t.componentWillUnmount()
    }
    function Be(e, t) {
        return V().createElement(Ne, {
            __v: e,
            i: t
        })
    }
    (ze.prototype = new (V().Component)).__e = function(e) {
        var t = this,
            n = Ae(t.__v),
            r = t.o.get(e);
        return r[0]++, function(i) {
            var o = function() {
                t.props.revealOrder ? (r.push(i), Le(t, e, r)) : i()
            };
            n ? n(o) : o()
        }
    }, ze.prototype.render = function(e) {
        this.u = null, this.o = new Map;
        var t = V().toChildArray(e.children);
        e.revealOrder && "b" === e.revealOrder[0] && t.reverse();
        for (var n = t.length; n--;)
            this.o.set(t[n], this.u = [1, 0, this.u]);
        return e.children
    }, ze.prototype.componentDidUpdate = ze.prototype.componentDidMount = function() {
        var e = this;
        this.o.forEach((function(t, n) {
            Le(e, n, t)
        }))
    };
    var Fe = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
        We = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
        He = function(e) {
            return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(e)
        };
    function je(e, t, n) {
        return null == t.__k && (t.textContent = ""), V().render(e, t), "function" == typeof n && n(), e ? e.__c : null
    }
    function $e(e, t, n) {
        return V().hydrate(e, t), "function" == typeof n && n(), e ? e.__c : null
    }
    V().Component.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach((function(e) {
        Object.defineProperty(V().Component.prototype, e, {
            configurable: !0,
            get: function() {
                return this["UNSAFE_" + e]
            },
            set: function(t) {
                Object.defineProperty(this, e, {
                    configurable: !0,
                    writable: !0,
                    value: t
                })
            }
        })
    }));
    var Ve = V().options.event;
    function qe() {}
    function Ue() {
        return this.cancelBubble
    }
    function Ge() {
        return this.defaultPrevented
    }
    V().options.event = function(e) {
        return Ve && (e = Ve(e)), e.persist = qe, e.isPropagationStopped = Ue, e.isDefaultPrevented = Ge, e.nativeEvent = e
    };
    var Ze,
        Ke = {
            configurable: !0,
            get: function() {
                return this.class
            }
        },
        Ye = V().options.vnode;
    V().options.vnode = function(e) {
        var t = e.type,
            n = e.props,
            r = n;
        if ("string" == typeof t) {
            for (var i in r = {}, n) {
                var o = n[i];
                "value" === i && "defaultValue" in n && null == o || ("defaultValue" === i && "value" in n && null == n.value ? i = "value" : "download" === i && !0 === o ? o = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !He(n.type) ? i = "oninput" : /^on(Ani|Tra|Tou|BeforeInp)/.test(i) ? i = i.toLowerCase() : We.test(i) ? i = i.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === o && (o = void 0), r[i] = o)
            }
            "select" == t && r.multiple && Array.isArray(r.value) && (r.value = V().toChildArray(n.children).forEach((function(e) {
                e.props.selected = -1 != r.value.indexOf(e.props.value)
            }))), "select" == t && null != r.defaultValue && (r.value = V().toChildArray(n.children).forEach((function(e) {
                e.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(e.props.value) : r.defaultValue == e.props.value
            }))), e.props = r
        }
        t && n.class != n.className && (Ke.enumerable = "className" in n, null != n.className && (r.class = n.className), Object.defineProperty(r, "className", Ke)), e.$$typeof = Fe, Ye && Ye(e)
    };
    var Xe = V().options.__r;
    V().options.__r = function(e) {
        Xe && Xe(e), Ze = e.__c
    };
    var Je = {
        ReactCurrentDispatcher: {
            current: {
                readContext: function(e) {
                    return Ze.__n[e.__c].props.value
                }
            }
        }
    };
    function Qe(e, t) {
        return t()
    }
    var et = "object" == typeof performance && "function" == typeof performance.now ? performance.now.bind(performance) : function() {
        return Date.now()
    };
    function tt(e) {
        return V().createElement.bind(null, e)
    }
    function nt(e) {
        return !!e && e.$$typeof === Fe
    }
    function rt(e) {
        return nt(e) ? V().cloneElement.apply(null, arguments) : e
    }
    function it(e) {
        return !!e.__k && (V().render(null, e), !0)
    }
    function ot(e) {
        return e && (e.base || 1 === e.nodeType && e) || null
    }
    var at = function(e, t) {
            return e(t)
        },
        st = V().Fragment,
        lt = {
            useState: ne,
            useReducer: re,
            useEffect: ie,
            useLayoutEffect: oe,
            useRef: ae,
            useImperativeHandle: se,
            useMemo: le,
            useCallback: ue,
            useContext: ce,
            useDebugValue: de,
            version: "16.8.0",
            Children: Me,
            render: je,
            hydrate: $e,
            unmountComponentAtNode: it,
            createPortal: Be,
            createElement: V().createElement,
            createContext: V().createContext,
            createFactory: tt,
            cloneElement: rt,
            createRef: V().createRef,
            Fragment: V().Fragment,
            isValidElement: nt,
            findDOMNode: ot,
            Component: V().Component,
            PureComponent: Ce,
            memo: Ee,
            forwardRef: Te,
            unstable_batchedUpdates: at,
            StrictMode: V().Fragment,
            Suspense: Pe,
            SuspenseList: ze,
            lazy: Ie,
            __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: Je
        };
    function ut(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }
    function ct(e, t) {
        if (null == e)
            return {};
        var n,
            r,
            i = {},
            o = Object.keys(e);
        for (r = 0; r < o.length; r++)
            n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i
    }
    function dt(e, t) {
        if (null == e)
            return {};
        var n,
            r,
            i = ct(e, t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            for (r = 0; r < o.length; r++)
                n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n])
        }
        return i
    }
    function pt() {
        return (pt = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }
    r(f, "default", (function() {
        return lt
    })), r(f, "unstable_now", (function() {
        return et
    })), r(f, "unstable_runWithPriority", (function() {
        return Qe
    })), r(f, "unstable_IdlePriority", (function() {
        return 5
    })), r(f, "unstable_LowPriority", (function() {
        return 4
    })), r(f, "unstable_NormalPriority", (function() {
        return 3
    })), r(f, "unstable_UserBlockingPriority", (function() {
        return 2
    })), r(f, "unstable_ImmediatePriority", (function() {
        return 1
    })), r(f, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", (function() {
        return Je
    })), r(f, "lazy", (function() {
        return Ie
    })), r(f, "SuspenseList", (function() {
        return ze
    })), r(f, "Suspense", (function() {
        return Pe
    })), r(f, "StrictMode", (function() {
        return st
    })), r(f, "unstable_batchedUpdates", (function() {
        return at
    })), r(f, "forwardRef", (function() {
        return Te
    })), r(f, "memo", (function() {
        return Ee
    })), r(f, "PureComponent", (function() {
        return Ce
    })), r(f, "findDOMNode", (function() {
        return ot
    })), r(f, "isValidElement", (function() {
        return nt
    })), r(f, "cloneElement", (function() {
        return rt
    })), r(f, "createFactory", (function() {
        return tt
    })), r(f, "createPortal", (function() {
        return Be
    })), r(f, "unmountComponentAtNode", (function() {
        return it
    })), r(f, "hydrate", (function() {
        return $e
    })), r(f, "render", (function() {
        return je
    })), r(f, "Children", (function() {
        return Me
    })), r(f, "version", (function() {
        return "16.8.0"
    })), n(f);
    var ft = pt;
    function ht(e) {
        return (ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }
    var mt = ht;
    function vt(e) {
        return e && "object" === mt(e) && !Array.isArray(e)
    }
    function gt(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                clone: !0
            },
            r = n.clone ? ft({}, e) : e;
        return vt(e) && vt(t) && Object.keys(t).forEach((function(i) {
            "__proto__" !== i && (vt(t[i]) && i in e ? r[i] = gt(e[i], t[i], n) : r[i] = t[i])
        })), r
    }
    var yt,
        bt = !1;
    function wt() {
        return bt || (bt = !0, yt = {}, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", yt = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"), yt
    }
    var xt,
        _t,
        Ct = !1;
    function Et() {}
    function St() {}
    var kt = {},
        Tt = t(kt = (Ct || (Ct = !0, xt = {}, _t = wt(), St.resetWarningCache = Et, xt = function() {
            function e(e, t, n, r, i, o) {
                if (o !== _t) {
                    var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw a.name = "Invariant Violation", a
                }
            }
            function t() {
                return e
            }
            e.isRequired = e;
            var n = {
                array: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                elementType: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t,
                checkPropTypes: St,
                resetWarningCache: Et
            };
            return n.PropTypes = n, n
        }), xt)());
    var Ot = (Tt.element, function() {
        return null
    });
    Ot.isRequired = (Tt.element.isRequired, function() {
        return null
    });
    kt.elementType;
    var Mt,
        Rt,
        Pt,
        At,
        It,
        zt,
        Lt,
        Dt,
        Nt,
        Bt,
        Ft,
        Wt,
        Ht,
        jt,
        $t,
        Vt,
        qt,
        Ut,
        Gt,
        Zt,
        Kt,
        Yt,
        Xt,
        Jt,
        Qt,
        en,
        tn,
        nn,
        rn,
        on,
        an,
        sn,
        ln,
        un,
        cn,
        dn,
        pn,
        fn,
        hn,
        mn,
        vn,
        gn,
        yn,
        bn,
        wn,
        xn,
        _n,
        Cn = !1;
    function En(e) {
        if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
            case Pt:
                switch (e = e.type) {
                case Bt:
                case Ft:
                case It:
                case Lt:
                case zt:
                case Ht:
                    return e;
                default:
                    switch (e = e && e.$$typeof) {
                    case Nt:
                    case Wt:
                    case Vt:
                    case $t:
                    case Dt:
                        return e;
                    default:
                        return t
                    }
                }
            case At:
                return t
            }
        }
    }
    function Sn(e) {
        return En(e) === Ft
    }
    var kn = {};
    Cn || (Cn = !0, Mt = {}, Object.defineProperty(Mt, "__esModule", {
        value: !0
    }), Rt = "function" == typeof Symbol && Symbol.for, Pt = Rt ? Symbol.for("react.element") : 60103, At = Rt ? Symbol.for("react.portal") : 60106, It = Rt ? Symbol.for("react.fragment") : 60107, zt = Rt ? Symbol.for("react.strict_mode") : 60108, Lt = Rt ? Symbol.for("react.profiler") : 60114, Dt = Rt ? Symbol.for("react.provider") : 60109, Nt = Rt ? Symbol.for("react.context") : 60110, Bt = Rt ? Symbol.for("react.async_mode") : 60111, Ft = Rt ? Symbol.for("react.concurrent_mode") : 60111, Wt = Rt ? Symbol.for("react.forward_ref") : 60112, Ht = Rt ? Symbol.for("react.suspense") : 60113, jt = Rt ? Symbol.for("react.suspense_list") : 60120, $t = Rt ? Symbol.for("react.memo") : 60115, Vt = Rt ? Symbol.for("react.lazy") : 60116, qt = Rt ? Symbol.for("react.fundamental") : 60117, Ut = Rt ? Symbol.for("react.responder") : 60118, Gt = Rt ? Symbol.for("react.scope") : 60119, Zt = En, Mt.typeOf = Zt, Kt = Bt, Mt.AsyncMode = Kt, Yt = Ft, Mt.ConcurrentMode = Yt, Xt = Nt, Mt.ContextConsumer = Xt, Jt = Dt, Mt.ContextProvider = Jt, Qt = Pt, Mt.Element = Qt, en = Wt, Mt.ForwardRef = en, tn = It, Mt.Fragment = tn, nn = Vt, Mt.Lazy = nn, rn = $t, Mt.Memo = rn, on = At, Mt.Portal = on, an = Lt, Mt.Profiler = an, sn = zt, Mt.StrictMode = sn, ln = Ht, Mt.Suspense = ln, un = function(e) {
        return "string" == typeof e || "function" == typeof e || e === It || e === Ft || e === Lt || e === zt || e === Ht || e === jt || "object" == typeof e && null !== e && (e.$$typeof === Vt || e.$$typeof === $t || e.$$typeof === Dt || e.$$typeof === Nt || e.$$typeof === Wt || e.$$typeof === qt || e.$$typeof === Ut || e.$$typeof === Gt)
    }, Mt.isValidElementType = un, cn = function(e) {
        return Sn(e) || En(e) === Bt
    }, Mt.isAsyncMode = cn, dn = Sn, Mt.isConcurrentMode = dn, pn = function(e) {
        return En(e) === Nt
    }, Mt.isContextConsumer = pn, fn = function(e) {
        return En(e) === Dt
    }, Mt.isContextProvider = fn, hn = function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === Pt
    }, Mt.isElement = hn, mn = function(e) {
        return En(e) === Wt
    }, Mt.isForwardRef = mn, vn = function(e) {
        return En(e) === It
    }, Mt.isFragment = vn, gn = function(e) {
        return En(e) === Vt
    }, Mt.isLazy = gn, yn = function(e) {
        return En(e) === $t
    }, Mt.isMemo = yn, bn = function(e) {
        return En(e) === At
    }, Mt.isPortal = bn, wn = function(e) {
        return En(e) === Lt
    }, Mt.isProfiler = wn, xn = function(e) {
        return En(e) === zt
    }, Mt.isStrictMode = xn, _n = function(e) {
        return En(e) === Ht
    }, Mt.isSuspense = _n), kn = Mt;
    "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), Tt.oneOfType([Tt.func, Tt.object]);
    var Tn = ["xs", "sm", "md", "lg", "xl"];
    function On(e) {
        var t = e.values,
            n = void 0 === t ? {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920
            } : t,
            r = e.unit,
            i = void 0 === r ? "px" : r,
            o = e.step,
            a = void 0 === o ? 5 : o,
            s = dt(e, ["values", "unit", "step"]);
        function l(e) {
            var t = "number" == typeof n[e] ? n[e] : e;
            return "@media (min-width:".concat(t).concat(i, ")")
        }
        function u(e, t) {
            var r = Tn.indexOf(t);
            return r === Tn.length - 1 ? l(e) : "@media (min-width:".concat("number" == typeof n[e] ? n[e] : e).concat(i, ") and ") + "(max-width:".concat((-1 !== r && "number" == typeof n[Tn[r + 1]] ? n[Tn[r + 1]] : t) - a / 100).concat(i, ")")
        }
        return ft({
            keys: Tn,
            values: n,
            up: l,
            down: function(e) {
                var t = Tn.indexOf(e) + 1,
                    r = n[Tn[t]];
                return t === Tn.length ? l("xs") : "@media (max-width:".concat(("number" == typeof r && t > 0 ? r : e) - a / 100).concat(i, ")")
            },
            between: u,
            only: function(e) {
                return u(e, e)
            },
            width: function(e) {
                return n[e]
            }
        }, s)
    }
    function Mn(e, t, n) {
        var r;
        return ft({
            gutters: function() {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return ft({
                    paddingLeft: t(2),
                    paddingRight: t(2)
                }, n, ut({}, e.up("sm"), ft({
                    paddingLeft: t(3),
                    paddingRight: t(3)
                }, n[e.up("sm")])))
            },
            toolbar: (r = {
                minHeight: 56
            }, ut(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {
                minHeight: 48
            }), ut(r, e.up("sm"), {
                minHeight: 64
            }), r)
        }, n)
    }
    var Rn = {
            black: "#000",
            white: "#fff"
        },
        Pn = {
            50: "#fafafa",
            100: "#f5f5f5",
            200: "#eeeeee",
            300: "#e0e0e0",
            400: "#bdbdbd",
            500: "#9e9e9e",
            600: "#757575",
            700: "#616161",
            800: "#424242",
            900: "#212121",
            A100: "#d5d5d5",
            A200: "#aaaaaa",
            A400: "#303030",
            A700: "#616161"
        },
        An = {
            50: "#e8eaf6",
            100: "#c5cae9",
            200: "#9fa8da",
            300: "#7986cb",
            400: "#5c6bc0",
            500: "#3f51b5",
            600: "#3949ab",
            700: "#303f9f",
            800: "#283593",
            900: "#1a237e",
            A100: "#8c9eff",
            A200: "#536dfe",
            A400: "#3d5afe",
            A700: "#304ffe"
        },
        In = {
            50: "#fce4ec",
            100: "#f8bbd0",
            200: "#f48fb1",
            300: "#f06292",
            400: "#ec407a",
            500: "#e91e63",
            600: "#d81b60",
            700: "#c2185b",
            800: "#ad1457",
            900: "#880e4f",
            A100: "#ff80ab",
            A200: "#ff4081",
            A400: "#f50057",
            A700: "#c51162"
        },
        zn = {
            50: "#ffebee",
            100: "#ffcdd2",
            200: "#ef9a9a",
            300: "#e57373",
            400: "#ef5350",
            500: "#f44336",
            600: "#e53935",
            700: "#d32f2f",
            800: "#c62828",
            900: "#b71c1c",
            A100: "#ff8a80",
            A200: "#ff5252",
            A400: "#ff1744",
            A700: "#d50000"
        },
        Ln = {
            50: "#fff3e0",
            100: "#ffe0b2",
            200: "#ffcc80",
            300: "#ffb74d",
            400: "#ffa726",
            500: "#ff9800",
            600: "#fb8c00",
            700: "#f57c00",
            800: "#ef6c00",
            900: "#e65100",
            A100: "#ffd180",
            A200: "#ffab40",
            A400: "#ff9100",
            A700: "#ff6d00"
        },
        Dn = {
            50: "#e3f2fd",
            100: "#bbdefb",
            200: "#90caf9",
            300: "#64b5f6",
            400: "#42a5f5",
            500: "#2196f3",
            600: "#1e88e5",
            700: "#1976d2",
            800: "#1565c0",
            900: "#0d47a1",
            A100: "#82b1ff",
            A200: "#448aff",
            A400: "#2979ff",
            A700: "#2962ff"
        },
        Nn = {
            50: "#e8f5e9",
            100: "#c8e6c9",
            200: "#a5d6a7",
            300: "#81c784",
            400: "#66bb6a",
            500: "#4caf50",
            600: "#43a047",
            700: "#388e3c",
            800: "#2e7d32",
            900: "#1b5e20",
            A100: "#b9f6ca",
            A200: "#69f0ae",
            A400: "#00e676",
            A700: "#00c853"
        };
    function Bn(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return Math.min(Math.max(t, e), n)
    }
    function Fn(e) {
        if (e.type)
            return e;
        if ("#" === e.charAt(0))
            return Fn(function(e) {
                e = e.substr(1);
                var t = new RegExp(".{1,".concat(e.length / 3, "}"), "g"),
                    n = e.match(t);
                return n && 1 === n[0].length && (n = n.map((function(e) {
                    return e + e
                }))), n ? "rgb(".concat(n.map((function(e) {
                    return parseInt(e, 16)
                })).join(", "), ")") : ""
            }(e));
        var t = e.indexOf("("),
            n = e.substring(0, t);
        if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n))
            throw new Error(["Material-UI: unsupported `".concat(e, "` color."), "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."].join("\n"));
        var r = e.substring(t + 1, e.length - 1).split(",");
        return {
            type: n,
            values: r = r.map((function(e) {
                return parseFloat(e)
            }))
        }
    }
    function Wn(e) {
        var t = e.type,
            n = e.values;
        return -1 !== t.indexOf("rgb") ? n = n.map((function(e, t) {
            return t < 3 ? parseInt(e, 10) : e
        })) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(t, "(").concat(n.join(", "), ")")
    }
    function Hn(e, t) {
        var n = jn(e),
            r = jn(t);
        return (Math.max(n, r) + .05) / (Math.min(n, r) + .05)
    }
    function jn(e) {
        var t = "hsl" === (e = Fn(e)).type ? Fn(function(e) {
            var t = (e = Fn(e)).values,
                n = t[0],
                r = t[1] / 100,
                i = t[2] / 100,
                o = r * Math.min(i, 1 - i),
                a = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + n / 30) % 12;
                    return i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1)
                },
                s = "rgb",
                l = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];
            return "hsla" === e.type && (s += "a", l.push(t[3])), Wn({
                type: s,
                values: l
            })
        }(e)).values : e.values;
        return t = t.map((function(e) {
            return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)
        })), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3))
    }
    function $n(e, t) {
        return e = Fn(e), t = Bn(t), "rgb" !== e.type && "hsl" !== e.type || (e.type += "a"), e.values[3] = t, Wn(e)
    }
    var Vn = {
            text: {
                primary: "rgba(0, 0, 0, 0.87)",
                secondary: "rgba(0, 0, 0, 0.54)",
                disabled: "rgba(0, 0, 0, 0.38)",
                hint: "rgba(0, 0, 0, 0.38)"
            },
            divider: "rgba(0, 0, 0, 0.12)",
            background: {
                paper: Rn.white,
                default: Pn[50]
            },
            action: {
                active: "rgba(0, 0, 0, 0.54)",
                hover: "rgba(0, 0, 0, 0.04)",
                hoverOpacity: .04,
                selected: "rgba(0, 0, 0, 0.08)",
                selectedOpacity: .08,
                disabled: "rgba(0, 0, 0, 0.26)",
                disabledBackground: "rgba(0, 0, 0, 0.12)",
                disabledOpacity: .38,
                focus: "rgba(0, 0, 0, 0.12)",
                focusOpacity: .12,
                activatedOpaciy: .12
            }
        },
        qn = {
            text: {
                primary: Rn.white,
                secondary: "rgba(255, 255, 255, 0.7)",
                disabled: "rgba(255, 255, 255, 0.5)",
                hint: "rgba(255, 255, 255, 0.5)",
                icon: "rgba(255, 255, 255, 0.5)"
            },
            divider: "rgba(255, 255, 255, 0.12)",
            background: {
                paper: Pn[800],
                default: "#303030"
            },
            action: {
                active: Rn.white,
                hover: "rgba(255, 255, 255, 0.08)",
                hoverOpacity: .08,
                selected: "rgba(255, 255, 255, 0.16)",
                selectedOpacity: .16,
                disabled: "rgba(255, 255, 255, 0.3)",
                disabledBackground: "rgba(255, 255, 255, 0.12)",
                disabledOpacity: .38,
                focus: "rgba(255, 255, 255, 0.12)",
                focusOpacity: .12,
                activatedOpaciy: .24
            }
        };
    function Un(e, t, n, r) {
        e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : "light" === t ? e.light = function(e, t) {
            if (e = Fn(e), t = Bn(t), -1 !== e.type.indexOf("hsl"))
                e.values[2] += (100 - e.values[2]) * t;
            else if (-1 !== e.type.indexOf("rgb"))
                for (var n = 0; n < 3; n += 1)
                    e.values[n] += (255 - e.values[n]) * t;
            return Wn(e)
        }(e.main, r) : "dark" === t && (e.dark = function(e, t) {
            if (e = Fn(e), t = Bn(t), -1 !== e.type.indexOf("hsl"))
                e.values[2] *= 1 - t;
            else if (-1 !== e.type.indexOf("rgb"))
                for (var n = 0; n < 3; n += 1)
                    e.values[n] *= 1 - t;
            return Wn(e)
        }(e.main, 1.5 * r)))
    }
    function Gn(e) {
        var t = e.primary,
            n = void 0 === t ? {
                light: An[300],
                main: An[500],
                dark: An[700]
            } : t,
            r = e.secondary,
            i = void 0 === r ? {
                light: In.A200,
                main: In.A400,
                dark: In.A700
            } : r,
            o = e.error,
            a = void 0 === o ? {
                light: zn[300],
                main: zn[500],
                dark: zn[700]
            } : o,
            s = e.warning,
            l = void 0 === s ? {
                light: Ln[300],
                main: Ln[500],
                dark: Ln[700]
            } : s,
            u = e.info,
            c = void 0 === u ? {
                light: Dn[300],
                main: Dn[500],
                dark: Dn[700]
            } : u,
            d = e.success,
            p = void 0 === d ? {
                light: Nn[300],
                main: Nn[500],
                dark: Nn[700]
            } : d,
            f = e.type,
            h = void 0 === f ? "light" : f,
            m = e.contrastThreshold,
            v = void 0 === m ? 3 : m,
            g = e.tonalOffset,
            y = void 0 === g ? .2 : g,
            b = dt(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
        function w(e) {
            if (!e)
                throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(e, ")."));
            var t = Hn(e, qn.text.primary) >= v ? qn.text.primary : Vn.text.primary;
            return t
        }
        function x(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300,
                r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
            return !(e = ft({}, e)).main && e[t] && (e.main = e[t]), Un(e, "light", n, y), Un(e, "dark", r, y), e.contrastText || (e.contrastText = w(e.main)), e
        }
        var _ = {
            dark: qn,
            light: Vn
        };
        return gt(ft({
            common: Rn,
            type: h,
            primary: x(n),
            secondary: x(i, "A400", "A200", "A700"),
            error: x(a),
            warning: x(l),
            info: x(c),
            success: x(p),
            grey: Pn,
            contrastThreshold: v,
            getContrastText: w,
            augmentColor: x,
            tonalOffset: y
        }, _[h]), b)
    }
    function Zn(e) {
        return Math.round(1e5 * e) / 1e5
    }
    var Kn = {
            textTransform: "uppercase"
        },
        Yn = '"Roboto", "Helvetica", "Arial", sans-serif';
    function Xn(e, t) {
        var n = "function" == typeof t ? t(e) : t,
            r = n.fontFamily,
            i = void 0 === r ? Yn : r,
            o = n.fontSize,
            a = void 0 === o ? 14 : o,
            s = n.fontWeightLight,
            l = void 0 === s ? 300 : s,
            u = n.fontWeightRegular,
            c = void 0 === u ? 400 : u,
            d = n.fontWeightMedium,
            p = void 0 === d ? 500 : d,
            f = n.fontWeightBold,
            h = void 0 === f ? 700 : f,
            m = n.htmlFontSize,
            v = void 0 === m ? 16 : m,
            g = n.allVariants,
            y = n.pxToRem,
            b = dt(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
        var w = a / 14,
            x = y || function(e) {
                return "".concat(e / v * w, "rem")
            },
            _ = function(e, t, n, r, o) {
                return ft({
                    fontFamily: i,
                    fontWeight: e,
                    fontSize: x(t),
                    lineHeight: n
                }, i === Yn ? {
                    letterSpacing: "".concat(Zn(r / t), "em")
                } : {}, {}, o, {}, g)
            },
            C = {
                h1: _(l, 96, 1.167, -1.5),
                h2: _(l, 60, 1.2, -.5),
                h3: _(c, 48, 1.167, 0),
                h4: _(c, 34, 1.235, .25),
                h5: _(c, 24, 1.334, 0),
                h6: _(p, 20, 1.6, .15),
                subtitle1: _(c, 16, 1.75, .15),
                subtitle2: _(p, 14, 1.57, .1),
                body1: _(c, 16, 1.5, .15),
                body2: _(c, 14, 1.43, .15),
                button: _(p, 14, 1.75, .4, Kn),
                caption: _(c, 12, 1.66, .4),
                overline: _(c, 12, 2.66, 1, Kn)
            };
        return gt(ft({
            htmlFontSize: v,
            pxToRem: x,
            round: Zn,
            fontFamily: i,
            fontSize: a,
            fontWeightLight: l,
            fontWeightRegular: c,
            fontWeightMedium: p,
            fontWeightBold: h
        }, C), b, {
            clone: !1
        })
    }
    function Jn() {
        return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",")
    }
    var Qn = ["none", Jn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Jn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Jn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Jn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Jn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Jn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Jn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Jn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Jn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Jn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Jn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Jn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Jn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Jn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Jn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Jn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Jn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Jn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Jn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Jn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Jn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Jn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Jn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Jn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)],
        er = {
            borderRadius: 4
        };
    function tr() {
        var e,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
        if (t.mui)
            return t;
        e = "function" == typeof t ? t : function(e) {
            return t * e
        };
        var n = function() {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            return 0 === n.length ? e(1) : 1 === n.length ? e(n[0]) : n.map((function(t) {
                var n = e(t);
                return "number" == typeof n ? "".concat(n, "px") : n
            })).join(" ")
        };
        return Object.defineProperty(n, "unit", {
            get: function() {
                return t
            }
        }), n.mui = !0, n
    }
    var nr = {
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
            sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
        },
        rr = {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195
        };
    function ir(e) {
        return "".concat(Math.round(e), "ms")
    }
    var or = {
            easing: nr,
            duration: rr,
            create: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"],
                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = t.duration,
                    r = void 0 === n ? rr.standard : n,
                    i = t.easing,
                    o = void 0 === i ? nr.easeInOut : i,
                    a = t.delay,
                    s = void 0 === a ? 0 : a;
                dt(t, ["duration", "easing", "delay"]);
                return (Array.isArray(e) ? e : [e]).map((function(e) {
                    return "".concat(e, " ").concat("string" == typeof r ? r : ir(r), " ").concat(o, " ").concat("string" == typeof s ? s : ir(s))
                })).join(",")
            },
            getAutoHeightDuration: function(e) {
                if (!e)
                    return 0;
                var t = e / 36;
                return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5))
            }
        },
        ar = {
            mobileStepper: 1e3,
            speedDial: 1050,
            appBar: 1100,
            drawer: 1200,
            modal: 1300,
            snackbar: 1400,
            tooltip: 1500
        };
    function sr() {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, n = void 0 === t ? {} : t, r = e.mixins, i = void 0 === r ? {} : r, o = e.palette, a = void 0 === o ? {} : o, s = e.spacing, l = e.typography, u = void 0 === l ? {} : l, c = dt(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = Gn(a), p = On(n), f = tr(s), h = gt({
                breakpoints: p,
                direction: "ltr",
                mixins: Mn(p, f, i),
                overrides: {},
                palette: d,
                props: {},
                shadows: Qn,
                typography: Xn(d, u),
                spacing: f,
                shape: er,
                transitions: or,
                zIndex: ar
            }, c), m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
            v[g - 1] = arguments[g];
        return h = v.reduce((function(e, t) {
            return gt(e, t)
        }), h)
    }
    function lr(e) {
        var t = e.theme,
            n = e.name,
            r = e.props;
        if (!t || !t.props || !t.props[n])
            return r;
        var i,
            o = t.props[n];
        for (i in o)
            void 0 === r[i] && (r[i] = o[i]);
        return r
    }
    var ur = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        },
        cr = "object" === ("undefined" == typeof window ? "undefined" : ur(window)) && "object" === ("undefined" == typeof document ? "undefined" : ur(document)) && 9 === document.nodeType;
    function dr(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    function pr(e, t, n) {
        return t && dr(e.prototype, t), n && dr(e, n), e
    }
    function fr(e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t
    }
    function hr(e) {
        if (void 0 === e)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }
    var mr = {}.constructor;
    function vr(e) {
        if (null == e || "object" != typeof e)
            return e;
        if (Array.isArray(e))
            return e.map(vr);
        if (e.constructor !== mr)
            return e;
        var t = {};
        for (var n in e)
            t[n] = vr(e[n]);
        return t
    }
    function gr(e, t, n) {
        void 0 === e && (e = "unnamed");
        var r = n.jss,
            i = vr(t),
            o = r.plugins.onCreateRule(e, i, n);
        return o || (e[0], null)
    }
    var yr = function(e, t) {
        for (var n = "", r = 0; r < e.length && "!important" !== e[r]; r++)
            n && (n += t), n += e[r];
        return n
    };
    function br(e, t) {
        if (void 0 === t && (t = !1), !Array.isArray(e))
            return e;
        var n = "";
        if (Array.isArray(e[0]))
            for (var r = 0; r < e.length && "!important" !== e[r]; r++)
                n && (n += ", "), n += yr(e[r], " ");
        else
            n = yr(e, ", ");
        return t || "!important" !== e[e.length - 1] || (n += " !important"), n
    }
    function wr(e, t) {
        for (var n = "", r = 0; r < t; r++)
            n += "  ";
        return n + e
    }
    function xr(e, t, n) {
        void 0 === n && (n = {});
        var r = "";
        if (!t)
            return r;
        var i = n.indent,
            o = void 0 === i ? 0 : i,
            a = t.fallbacks;
        if (e && o++, a)
            if (Array.isArray(a))
                for (var s = 0; s < a.length; s++) {
                    var l = a[s];
                    for (var u in l) {
                        var c = l[u];
                        null != c && (r && (r += "\n"), r += "" + wr(u + ": " + br(c) + ";", o))
                    }
                }
            else
                for (var d in a) {
                    var p = a[d];
                    null != p && (r && (r += "\n"), r += "" + wr(d + ": " + br(p) + ";", o))
                }
        for (var f in t) {
            var h = t[f];
            null != h && "fallbacks" !== f && (r && (r += "\n"), r += "" + wr(f + ": " + br(h) + ";", o))
        }
        return (r || n.allowEmpty) && e ? (r && (r = "\n" + r + "\n"), wr(e + " {" + r, --o) + wr("}", o)) : r
    }
    var _r = /([[\].#*$><+~=|^:(),"'`\s])/g,
        Cr = "undefined" != typeof CSS && CSS.escape,
        Er = function(e) {
            return Cr ? Cr(e) : e.replace(_r, "\\$1")
        },
        Sr = function() {
            function e(e, t, n) {
                this.type = "style", this.key = void 0, this.isProcessed = !1, this.style = void 0, this.renderer = void 0, this.renderable = void 0, this.options = void 0;
                var r = n.sheet,
                    i = n.Renderer;
                this.key = e, this.options = n, this.style = t, r ? this.renderer = r.renderer : i && (this.renderer = new i)
            }
            return e.prototype.prop = function(e, t, n) {
                if (void 0 === t)
                    return this.style[e];
                var r = !!n && n.force;
                if (!r && this.style[e] === t)
                    return this;
                var i = t;
                n && !1 === n.process || (i = this.options.jss.plugins.onChangeValue(t, e, this));
                var o = null == i || !1 === i,
                    a = e in this.style;
                if (o && !a && !r)
                    return this;
                var s = o && a;
                if (s ? delete this.style[e] : this.style[e] = i, this.renderable && this.renderer)
                    return s ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, i), this;
                var l = this.options.sheet;
                return l && l.attached, this
            }, e
        }(),
        kr = function(e) {
            function t(t, n, r) {
                var i;
                (i = e.call(this, t, n, r) || this).selectorText = void 0, i.id = void 0, i.renderable = void 0;
                var o = r.selector,
                    a = r.scoped,
                    s = r.sheet,
                    l = r.generateId;
                return o ? i.selectorText = o : !1 !== a && (i.id = l(hr(hr(i)), s), i.selectorText = "." + Er(i.id)), i
            }
            fr(t, e);
            var n = t.prototype;
            return n.applyTo = function(e) {
                var t = this.renderer;
                if (t) {
                    var n = this.toJSON();
                    for (var r in n)
                        t.setProperty(e, r, n[r])
                }
                return this
            }, n.toJSON = function() {
                var e = {};
                for (var t in this.style) {
                    var n = this.style[t];
                    "object" != typeof n ? e[t] = n : Array.isArray(n) && (e[t] = br(n))
                }
                return e
            }, n.toString = function(e) {
                var t = this.options.sheet,
                    n = !!t && t.options.link ? ft({}, e, {
                        allowEmpty: !0
                    }) : e;
                return xr(this.selectorText, this.style, n)
            }, pr(t, [{
                key: "selector",
                set: function(e) {
                    if (e !== this.selectorText) {
                        this.selectorText = e;
                        var t = this.renderer,
                            n = this.renderable;
                        if (n && t)
                            t.setSelector(n, e) || t.replaceRule(n, this)
                    }
                },
                get: function() {
                    return this.selectorText
                }
            }]), t
        }(Sr),
        Tr = {
            onCreateRule: function(e, t, n) {
                return "@" === e[0] || n.parent && "keyframes" === n.parent.type ? null : new kr(e, t, n)
            }
        },
        Or = {
            indent: 1,
            children: !0
        },
        Mr = /@([\w-]+)/,
        Rr = function() {
            function e(e, t, n) {
                this.type = "conditional", this.at = void 0, this.key = void 0, this.query = void 0, this.rules = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.query = n.name;
                var r = e.match(Mr);
                for (var i in this.at = r ? r[1] : "unknown", this.options = n, this.rules = new Jr(ft({}, n, {
                    parent: this
                })), t)
                    this.rules.add(i, t[i]);
                this.rules.process()
            }
            var t = e.prototype;
            return t.getRule = function(e) {
                return this.rules.get(e)
            }, t.indexOf = function(e) {
                return this.rules.indexOf(e)
            }, t.addRule = function(e, t, n) {
                var r = this.rules.add(e, t, n);
                return r ? (this.options.jss.plugins.onProcessRule(r), r) : null
            }, t.toString = function(e) {
                if (void 0 === e && (e = Or), null == e.indent && (e.indent = Or.indent), null == e.children && (e.children = Or.children), !1 === e.children)
                    return this.query + " {}";
                var t = this.rules.toString(e);
                return t ? this.query + " {\n" + t + "\n}" : ""
            }, e
        }(),
        Pr = /@media|@supports\s+/,
        Ar = {
            onCreateRule: function(e, t, n) {
                return Pr.test(e) ? new Rr(e, t, n) : null
            }
        },
        Ir = {
            indent: 1,
            children: !0
        },
        zr = /@keyframes\s+([\w-]+)/,
        Lr = function() {
            function e(e, t, n) {
                this.type = "keyframes", this.at = "@keyframes", this.key = void 0, this.name = void 0, this.id = void 0, this.rules = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0;
                var r = e.match(zr);
                r && r[1] ? this.name = r[1] : this.name = "noname", this.key = this.type + "-" + this.name, this.options = n;
                var i = n.scoped,
                    o = n.sheet,
                    a = n.generateId;
                for (var s in this.id = !1 === i ? this.name : Er(a(this, o)), this.rules = new Jr(ft({}, n, {
                    parent: this
                })), t)
                    this.rules.add(s, t[s], ft({}, n, {
                        parent: this
                    }));
                this.rules.process()
            }
            return e.prototype.toString = function(e) {
                if (void 0 === e && (e = Ir), null == e.indent && (e.indent = Ir.indent), null == e.children && (e.children = Ir.children), !1 === e.children)
                    return this.at + " " + this.id + " {}";
                var t = this.rules.toString(e);
                return t && (t = "\n" + t + "\n"), this.at + " " + this.id + " {" + t + "}"
            }, e
        }(),
        Dr = /@keyframes\s+/,
        Nr = /\$([\w-]+)/g,
        Br = function(e, t) {
            return "string" == typeof e ? e.replace(Nr, (function(e, n) {
                return n in t ? t[n] : e
            })) : e
        },
        Fr = function(e, t, n) {
            var r = e[t],
                i = Br(r, n);
            i !== r && (e[t] = i)
        },
        Wr = {
            onCreateRule: function(e, t, n) {
                return "string" == typeof e && Dr.test(e) ? new Lr(e, t, n) : null
            },
            onProcessStyle: function(e, t, n) {
                return "style" === t.type && n ? ("animation-name" in e && Fr(e, "animation-name", n.keyframes), "animation" in e && Fr(e, "animation", n.keyframes), e) : e
            },
            onChangeValue: function(e, t, n) {
                var r = n.options.sheet;
                if (!r)
                    return e;
                switch (t) {
                case "animation":
                case "animation-name":
                    return Br(e, r.keyframes);
                default:
                    return e
                }
            }
        },
        Hr = function(e) {
            function t() {
                for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++)
                    r[i] = arguments[i];
                return (t = e.call.apply(e, [this].concat(r)) || this).renderable = void 0, t
            }
            return fr(t, e), t.prototype.toString = function(e) {
                var t = this.options.sheet,
                    n = !!t && t.options.link ? ft({}, e, {
                        allowEmpty: !0
                    }) : e;
                return xr(this.key, this.style, n)
            }, t
        }(Sr),
        jr = {
            onCreateRule: function(e, t, n) {
                return n.parent && "keyframes" === n.parent.type ? new Hr(e, t, n) : null
            }
        },
        $r = function() {
            function e(e, t, n) {
                this.type = "font-face", this.at = "@font-face", this.key = void 0, this.style = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.style = t, this.options = n
            }
            return e.prototype.toString = function(e) {
                if (Array.isArray(this.style)) {
                    for (var t = "", n = 0; n < this.style.length; n++)
                        t += xr(this.key, this.style[n]), this.style[n + 1] && (t += "\n");
                    return t
                }
                return xr(this.key, this.style, e)
            }, e
        }(),
        Vr = {
            onCreateRule: function(e, t, n) {
                return "@font-face" === e ? new $r(e, t, n) : null
            }
        },
        qr = function() {
            function e(e, t, n) {
                this.type = "viewport", this.at = "@viewport", this.key = void 0, this.style = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.style = t, this.options = n
            }
            return e.prototype.toString = function(e) {
                return xr(this.key, this.style, e)
            }, e
        }(),
        Ur = {
            onCreateRule: function(e, t, n) {
                return "@viewport" === e || "@-ms-viewport" === e ? new qr(e, t, n) : null
            }
        },
        Gr = function() {
            function e(e, t, n) {
                this.type = "simple", this.key = void 0, this.value = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.value = t, this.options = n
            }
            return e.prototype.toString = function(e) {
                if (Array.isArray(this.value)) {
                    for (var t = "", n = 0; n < this.value.length; n++)
                        t += this.key + " " + this.value[n] + ";", this.value[n + 1] && (t += "\n");
                    return t
                }
                return this.key + " " + this.value + ";"
            }, e
        }(),
        Zr = {
            "@charset": !0,
            "@import": !0,
            "@namespace": !0
        },
        Kr = [Tr, Ar, Wr, jr, Vr, Ur, {
            onCreateRule: function(e, t, n) {
                return e in Zr ? new Gr(e, t, n) : null
            }
        }],
        Yr = {
            process: !0
        },
        Xr = {
            force: !0,
            process: !0
        },
        Jr = function() {
            function e(e) {
                this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = void 0, this.classes = void 0, this.keyframes = void 0, this.options = e, this.classes = e.classes, this.keyframes = e.keyframes
            }
            var t = e.prototype;
            return t.add = function(e, t, n) {
                var r = this.options,
                    i = r.parent,
                    o = r.sheet,
                    a = r.jss,
                    s = r.Renderer,
                    l = r.generateId,
                    u = r.scoped,
                    c = ft({
                        classes: this.classes,
                        parent: i,
                        sheet: o,
                        jss: a,
                        Renderer: s,
                        generateId: l,
                        scoped: u,
                        name: e
                    }, n),
                    d = e;
                e in this.raw && (d = e + "-d" + this.counter++), this.raw[d] = t, d in this.classes && (c.selector = "." + Er(this.classes[d]));
                var p = gr(d, t, c);
                if (!p)
                    return null;
                this.register(p);
                var f = void 0 === c.index ? this.index.length : c.index;
                return this.index.splice(f, 0, p), p
            }, t.get = function(e) {
                return this.map[e]
            }, t.remove = function(e) {
                this.unregister(e), delete this.raw[e.key], this.index.splice(this.index.indexOf(e), 1)
            }, t.indexOf = function(e) {
                return this.index.indexOf(e)
            }, t.process = function() {
                var e = this.options.jss.plugins;
                this.index.slice(0).forEach(e.onProcessRule, e)
            }, t.register = function(e) {
                this.map[e.key] = e, e instanceof kr ? (this.map[e.selector] = e, e.id && (this.classes[e.key] = e.id)) : e instanceof Lr && this.keyframes && (this.keyframes[e.name] = e.id)
            }, t.unregister = function(e) {
                delete this.map[e.key], e instanceof kr ? (delete this.map[e.selector], delete this.classes[e.key]) : e instanceof Lr && delete this.keyframes[e.name]
            }, t.update = function() {
                var e,
                    t,
                    n;
                if ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (e = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1], n = arguments.length <= 2 ? void 0 : arguments[2]) : (t = arguments.length <= 0 ? void 0 : arguments[0], n = arguments.length <= 1 ? void 0 : arguments[1], e = null), e)
                    this.updateOne(this.map[e], t, n);
                else
                    for (var r = 0; r < this.index.length; r++)
                        this.updateOne(this.index[r], t, n)
            }, t.updateOne = function(t, n, r) {
                void 0 === r && (r = Yr);
                var i = this.options,
                    o = i.jss.plugins,
                    a = i.sheet;
                if (t.rules instanceof e)
                    t.rules.update(n, r);
                else {
                    var s = t,
                        l = s.style;
                    if (o.onUpdate(n, t, a, r), r.process && l && l !== s.style) {
                        for (var u in o.onProcessStyle(s.style, s, a), s.style) {
                            var c = s.style[u];
                            c !== l[u] && s.prop(u, c, Xr)
                        }
                        for (var d in l) {
                            var p = s.style[d],
                                f = l[d];
                            null == p && p !== f && s.prop(d, null, Xr)
                        }
                    }
                }
            }, t.toString = function(e) {
                for (var t = "", n = this.options.sheet, r = !!n && n.options.link, i = 0; i < this.index.length; i++) {
                    var o = this.index[i].toString(e);
                    (o || r) && (t && (t += "\n"), t += o)
                }
                return t
            }, e
        }(),
        Qr = function() {
            function e(e, t) {
                for (var n in this.options = void 0, this.deployed = void 0, this.attached = void 0, this.rules = void 0, this.renderer = void 0, this.classes = void 0, this.keyframes = void 0, this.queue = void 0, this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = ft({}, t, {
                    sheet: this,
                    parent: this,
                    classes: this.classes,
                    keyframes: this.keyframes
                }), t.Renderer && (this.renderer = new t.Renderer(this)), this.rules = new Jr(this.options), e)
                    this.rules.add(n, e[n]);
                this.rules.process()
            }
            var t = e.prototype;
            return t.attach = function() {
                return this.attached || (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy()), this
            }, t.detach = function() {
                return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this
            }, t.addRule = function(e, t, n) {
                var r = this.queue;
                this.attached && !r && (this.queue = []);
                var i = this.rules.add(e, t, n);
                return i ? (this.options.jss.plugins.onProcessRule(i), this.attached ? this.deployed ? (r ? r.push(i) : (this.insertRule(i), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0)), i) : i : (this.deployed = !1, i)) : null
            }, t.insertRule = function(e) {
                this.renderer && this.renderer.insertRule(e)
            }, t.addRules = function(e, t) {
                var n = [];
                for (var r in e) {
                    var i = this.addRule(r, e[r], t);
                    i && n.push(i)
                }
                return n
            }, t.getRule = function(e) {
                return this.rules.get(e)
            }, t.deleteRule = function(e) {
                var t = "object" == typeof e ? e : this.rules.get(e);
                return !!t && (this.rules.remove(t), !(this.attached && t.renderable && this.renderer) || this.renderer.deleteRule(t.renderable))
            }, t.indexOf = function(e) {
                return this.rules.indexOf(e)
            }, t.deploy = function() {
                return this.renderer && this.renderer.deploy(), this.deployed = !0, this
            }, t.update = function() {
                var e;
                return (e = this.rules).update.apply(e, arguments), this
            }, t.updateOne = function(e, t, n) {
                return this.rules.updateOne(e, t, n), this
            }, t.toString = function(e) {
                return this.rules.toString(e)
            }, e
        }(),
        ei = function() {
            function e() {
                this.plugins = {
                    internal: [],
                    external: []
                }, this.registry = void 0
            }
            var t = e.prototype;
            return t.onCreateRule = function(e, t, n) {
                for (var r = 0; r < this.registry.onCreateRule.length; r++) {
                    var i = this.registry.onCreateRule[r](e, t, n);
                    if (i)
                        return i
                }
                return null
            }, t.onProcessRule = function(e) {
                if (!e.isProcessed) {
                    for (var t = e.options.sheet, n = 0; n < this.registry.onProcessRule.length; n++)
                        this.registry.onProcessRule[n](e, t);
                    e.style && this.onProcessStyle(e.style, e, t), e.isProcessed = !0
                }
            }, t.onProcessStyle = function(e, t, n) {
                for (var r = 0; r < this.registry.onProcessStyle.length; r++)
                    t.style = this.registry.onProcessStyle[r](t.style, t, n)
            }, t.onProcessSheet = function(e) {
                for (var t = 0; t < this.registry.onProcessSheet.length; t++)
                    this.registry.onProcessSheet[t](e)
            }, t.onUpdate = function(e, t, n, r) {
                for (var i = 0; i < this.registry.onUpdate.length; i++)
                    this.registry.onUpdate[i](e, t, n, r)
            }, t.onChangeValue = function(e, t, n) {
                for (var r = e, i = 0; i < this.registry.onChangeValue.length; i++)
                    r = this.registry.onChangeValue[i](r, t, n);
                return r
            }, t.use = function(e, t) {
                void 0 === t && (t = {
                    queue: "external"
                });
                var n = this.plugins[t.queue];
                -1 === n.indexOf(e) && (n.push(e), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce((function(e, t) {
                    for (var n in t)
                        n in e && e[n].push(t[n]);
                    return e
                }), {
                    onCreateRule: [],
                    onProcessRule: [],
                    onProcessStyle: [],
                    onProcessSheet: [],
                    onChangeValue: [],
                    onUpdate: []
                }))
            }, e
        }(),
        ti = new (function() {
            function e() {
                this.registry = []
            }
            var t = e.prototype;
            return t.add = function(e) {
                var t = this.registry,
                    n = e.options.index;
                if (-1 === t.indexOf(e))
                    if (0 === t.length || n >= this.index)
                        t.push(e);
                    else
                        for (var r = 0; r < t.length; r++)
                            if (t[r].options.index > n)
                                return void t.splice(r, 0, e)
            }, t.reset = function() {
                this.registry = []
            }, t.remove = function(e) {
                var t = this.registry.indexOf(e);
                this.registry.splice(t, 1)
            }, t.toString = function(e) {
                for (var t = void 0 === e ? {} : e, n = t.attached, r = ct(t, ["attached"]), i = "", o = 0; o < this.registry.length; o++) {
                    var a = this.registry[o];
                    null != n && a.attached !== n || (i && (i += "\n"), i += a.toString(r))
                }
                return i
            }, pr(e, [{
                key: "index",
                get: function() {
                    return 0 === this.registry.length ? 0 : this.registry[this.registry.length - 1].options.index
                }
            }]), e
        }()),
        ni = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    null == ni["2f1acc6c3a606b082e5eef5e54414ffb"] && (ni["2f1acc6c3a606b082e5eef5e54414ffb"] = 0);
    var ri = ni["2f1acc6c3a606b082e5eef5e54414ffb"]++,
        ii = function(e) {
            void 0 === e && (e = {});
            var t = 0;
            return function(n, r) {
                t += 1;
                var i = "",
                    o = "";
                return r && (r.options.classNamePrefix && (o = r.options.classNamePrefix), null != r.options.jss.id && (i = String(r.options.jss.id))), e.minify ? "" + (o || "c") + ri + i + t : o + n.key + "-" + ri + (i ? "-" + i : "") + "-" + t
            }
        },
        oi = function(e) {
            var t;
            return function() {
                return t || (t = e()), t
            }
        };
    function ai(e, t) {
        try {
            return e.attributeStyleMap ? e.attributeStyleMap.get(t) : e.style.getPropertyValue(t)
        } catch (e) {
            return ""
        }
    }
    function si(e, t, n) {
        try {
            var r = n;
            if (Array.isArray(n) && (r = br(n, !0), "!important" === n[n.length - 1]))
                return e.style.setProperty(t, r, "important"), !0;
            e.attributeStyleMap ? e.attributeStyleMap.set(t, r) : e.style.setProperty(t, r)
        } catch (e) {
            return !1
        }
        return !0
    }
    function li(e, t) {
        try {
            e.attributeStyleMap ? e.attributeStyleMap.delete(t) : e.style.removeProperty(t)
        } catch (e) {}
    }
    function ui(e, t) {
        return e.selectorText = t, e.selectorText === t
    }
    var ci = oi((function() {
        return document.querySelector("head")
    }));
    function di(e) {
        var t = ti.registry;
        if (t.length > 0) {
            var n = function(e, t) {
                for (var n = 0; n < e.length; n++) {
                    var r = e[n];
                    if (r.attached && r.options.index > t.index && r.options.insertionPoint === t.insertionPoint)
                        return r
                }
                return null
            }(t, e);
            if (n && n.renderer)
                return {
                    parent: n.renderer.element.parentNode,
                    node: n.renderer.element
                };
            if ((n = function(e, t) {
                for (var n = e.length - 1; n >= 0; n--) {
                    var r = e[n];
                    if (r.attached && r.options.insertionPoint === t.insertionPoint)
                        return r
                }
                return null
            }(t, e)) && n.renderer)
                return {
                    parent: n.renderer.element.parentNode,
                    node: n.renderer.element.nextSibling
                }
        }
        var r = e.insertionPoint;
        if (r && "string" == typeof r) {
            var i = function(e) {
                for (var t = ci(), n = 0; n < t.childNodes.length; n++) {
                    var r = t.childNodes[n];
                    if (8 === r.nodeType && r.nodeValue.trim() === e)
                        return r
                }
                return null
            }(r);
            if (i)
                return {
                    parent: i.parentNode,
                    node: i.nextSibling
                }
        }
        return !1
    }
    var pi = oi((function() {
            var e = document.querySelector('meta[property="csp-nonce"]');
            return e ? e.getAttribute("content") : null
        })),
        fi = function(e, t, n) {
            var r = e.cssRules.length;
            (void 0 === n || n > r) && (n = r);
            try {
                if ("insertRule" in e)
                    e.insertRule(t, n);
                else if ("appendRule" in e) {
                    e.appendRule(t)
                }
            } catch (e) {
                return !1
            }
            return e.cssRules[n]
        },
        hi = function() {
            function e(e) {
                this.getPropertyValue = ai, this.setProperty = si, this.removeProperty = li, this.setSelector = ui, this.element = void 0, this.sheet = void 0, this.hasInsertedRules = !1, e && ti.add(e), this.sheet = e;
                var t,
                    n = this.sheet ? this.sheet.options : {},
                    r = n.media,
                    i = n.meta,
                    o = n.element;
                this.element = o || ((t = document.createElement("style")).textContent = "\n", t), this.element.setAttribute("data-jss", ""), r && this.element.setAttribute("media", r), i && this.element.setAttribute("data-meta", i);
                var a = pi();
                a && this.element.setAttribute("nonce", a)
            }
            var t = e.prototype;
            return t.attach = function() {
                if (!this.element.parentNode && this.sheet) {
                    !function(e, t) {
                        var n = t.insertionPoint,
                            r = di(t);
                        if (!1 !== r && r.parent)
                            r.parent.insertBefore(e, r.node);
                        else if (n && "number" == typeof n.nodeType) {
                            var i = n,
                                o = i.parentNode;
                            o && o.insertBefore(e, i.nextSibling)
                        } else
                            ci().appendChild(e)
                    }(this.element, this.sheet.options);
                    var e = Boolean(this.sheet && this.sheet.deployed);
                    this.hasInsertedRules && e && (this.hasInsertedRules = !1, this.deploy())
                }
            }, t.detach = function() {
                var e = this.element.parentNode;
                e && e.removeChild(this.element)
            }, t.deploy = function() {
                var e = this.sheet;
                e && (e.options.link ? this.insertRules(e.rules) : this.element.textContent = "\n" + e.toString() + "\n")
            }, t.insertRules = function(e, t) {
                for (var n = 0; n < e.index.length; n++)
                    this.insertRule(e.index[n], n, t)
            }, t.insertRule = function(e, t, n) {
                if (void 0 === n && (n = this.element.sheet), e.rules) {
                    var r = e,
                        i = n;
                    return ("conditional" !== e.type && "keyframes" !== e.type || !1 !== (i = fi(n, r.toString({
                            children: !1
                        }), t))) && (this.insertRules(r.rules, i), i)
                }
                if (e.renderable && e.renderable.parentStyleSheet === this.element.sheet)
                    return e.renderable;
                var o = e.toString();
                if (!o)
                    return !1;
                var a = fi(n, o, t);
                return !1 !== a && (this.hasInsertedRules = !0, e.renderable = a, a)
            }, t.deleteRule = function(e) {
                var t = this.element.sheet,
                    n = this.indexOf(e);
                return -1 !== n && (t.deleteRule(n), !0)
            }, t.indexOf = function(e) {
                for (var t = this.element.sheet.cssRules, n = 0; n < t.length; n++)
                    if (e === t[n])
                        return n;
                return -1
            }, t.replaceRule = function(e, t) {
                var n = this.indexOf(e);
                return -1 !== n && (this.element.sheet.deleteRule(n), this.insertRule(t, n))
            }, t.getRules = function() {
                return this.element.sheet.cssRules
            }, e
        }(),
        mi = 0,
        vi = function() {
            function e(e) {
                this.id = mi++, this.version = "10.0.4", this.plugins = new ei, this.options = {
                    id: {
                        minify: !1
                    },
                    createGenerateId: ii,
                    Renderer: cr ? hi : null,
                    plugins: []
                }, this.generateId = ii({
                    minify: !1
                });
                for (var t = 0; t < Kr.length; t++)
                    this.plugins.use(Kr[t], {
                        queue: "internal"
                    });
                this.setup(e)
            }
            var t = e.prototype;
            return t.setup = function(e) {
                return void 0 === e && (e = {}), e.createGenerateId && (this.options.createGenerateId = e.createGenerateId), e.id && (this.options.id = ft({}, this.options.id, e.id)), (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)), null != e.insertionPoint && (this.options.insertionPoint = e.insertionPoint), "Renderer" in e && (this.options.Renderer = e.Renderer), e.plugins && this.use.apply(this, e.plugins), this
            }, t.createStyleSheet = function(e, t) {
                void 0 === t && (t = {});
                var n = t.index;
                "number" != typeof n && (n = 0 === ti.index ? 0 : ti.index + 1);
                var r = new Qr(e, ft({}, t, {
                    jss: this,
                    generateId: t.generateId || this.generateId,
                    insertionPoint: this.options.insertionPoint,
                    Renderer: this.options.Renderer,
                    index: n
                }));
                return this.plugins.onProcessSheet(r), r
            }, t.removeStyleSheet = function(e) {
                return e.detach(), ti.remove(e), this
            }, t.createRule = function(e, t, n) {
                if (void 0 === t && (t = {}), void 0 === n && (n = {}), "object" == typeof e)
                    return this.createRule(void 0, e, t);
                var r = ft({}, n, {
                    name: e,
                    jss: this,
                    Renderer: this.options.Renderer
                });
                r.generateId || (r.generateId = this.generateId), r.classes || (r.classes = {}), r.keyframes || (r.keyframes = {});
                var i = gr(e, t, r);
                return i && this.plugins.onProcessRule(i), i
            }, t.use = function() {
                for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                    n[r] = arguments[r];
                return n.forEach((function(t) {
                    e.plugins.use(t)
                })), this
            }, e
        }();
    function gi(e) {
        var t = null;
        for (var n in e) {
            var r = e[n],
                i = typeof r;
            if ("function" === i)
                t || (t = {}), t[n] = r;
            else if ("object" === i && null !== r && !Array.isArray(r)) {
                var o = gi(r);
                o && (t || (t = {}), t[n] = o)
            }
        }
        return t
    }
    var yi = "undefined" != typeof CSS && CSS && "number" in CSS,
        bi = function(e) {
            return new vi(e)
        };
    /**
  * A better abstraction over CSS.
  *
  * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
  * @website https://github.com/cssinjs/jss
  * @license MIT
  */
    bi();
    function wi() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.baseClasses,
            n = e.newClasses;
        e.Component;
        if (!n)
            return t;
        var r = ft({}, t);
        return Object.keys(n).forEach((function(e) {
            n[e] && (r[e] = "".concat(t[e], " ").concat(n[e]))
        })), r
    }
    var xi = function(e, t, n, r) {
            var i = e.get(t);
            i || (i = new Map, e.set(t, i)), i.set(n, r)
        },
        _i = function(e, t, n) {
            var r = e.get(t);
            return r ? r.get(n) : void 0
        },
        Ci = function(e, t, n) {
            e.get(t).delete(n)
        },
        Ei = lt.createContext(null);
    function Si() {
        return lt.useContext(Ei)
    }
    var ki = "function" == typeof Symbol && Symbol.for ? Symbol.for("mui.nested") : "__THEME_NESTED__",
        Ti = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
    var Oi = Date.now(),
        Mi = "fnValues" + Oi,
        Ri = "fnStyle" + ++Oi;
    var Pi = "@global",
        Ai = "@global ",
        Ii = function() {
            function e(e, t, n) {
                for (var r in this.type = "global", this.at = Pi, this.rules = void 0, this.options = void 0, this.key = void 0, this.isProcessed = !1, this.key = e, this.options = n, this.rules = new Jr(ft({}, n, {
                    parent: this
                })), t)
                    this.rules.add(r, t[r]);
                this.rules.process()
            }
            var t = e.prototype;
            return t.getRule = function(e) {
                return this.rules.get(e)
            }, t.addRule = function(e, t, n) {
                var r = this.rules.add(e, t, n);
                return this.options.jss.plugins.onProcessRule(r), r
            }, t.indexOf = function(e) {
                return this.rules.indexOf(e)
            }, t.toString = function() {
                return this.rules.toString()
            }, e
        }(),
        zi = function() {
            function e(e, t, n) {
                this.type = "global", this.at = Pi, this.options = void 0, this.rule = void 0, this.isProcessed = !1, this.key = void 0, this.key = e, this.options = n;
                var r = e.substr(Ai.length);
                this.rule = n.jss.createRule(r, t, ft({}, n, {
                    parent: this
                }))
            }
            return e.prototype.toString = function(e) {
                return this.rule ? this.rule.toString(e) : ""
            }, e
        }(),
        Li = /\s*,\s*/g;
    function Di(e, t) {
        for (var n = e.split(Li), r = "", i = 0; i < n.length; i++)
            r += t + " " + n[i].trim(), n[i + 1] && (r += ", ");
        return r
    }
    function Ni() {
        return {
            onCreateRule: function(e, t, n) {
                if (!e)
                    return null;
                if (e === Pi)
                    return new Ii(e, t, n);
                if ("@" === e[0] && e.substr(0, Ai.length) === Ai)
                    return new zi(e, t, n);
                var r = n.parent;
                return r && ("global" === r.type || r.options.parent && "global" === r.options.parent.type) && (n.scoped = !1), !1 === n.scoped && (n.selector = e), null
            },
            onProcessRule: function(e) {
                "style" === e.type && (function(e) {
                    var t = e.options,
                        n = e.style,
                        r = n ? n["@global"] : null;
                    if (r) {
                        for (var i in r)
                            t.sheet.addRule(i, r[i], ft({}, t, {
                                selector: Di(i, e.selector)
                            }));
                        delete n["@global"]
                    }
                }(e), function(e) {
                    var t = e.options,
                        n = e.style;
                    for (var r in n)
                        if ("@" === r[0] && r.substr(0, Pi.length) === Pi) {
                            var i = Di(r.substr(Pi.length), e.selector);
                            t.sheet.addRule(i, n[r], ft({}, t, {
                                selector: i
                            })), delete n[r]
                        }
                }(e))
            }
        }
    }
    var Bi = /\s*,\s*/g,
        Fi = /&/g,
        Wi = /\$([\w-]+)/g;
    function Hi() {
        function e(e, t) {
            return function(n, r) {
                var i = e.getRule(r) || t && t.getRule(r);
                return i ? (i = i).selector : r
            }
        }
        function t(e, t) {
            for (var n = t.split(Bi), r = e.split(Bi), i = "", o = 0; o < n.length; o++)
                for (var a = n[o], s = 0; s < r.length; s++) {
                    var l = r[s];
                    i && (i += ", "), i += -1 !== l.indexOf("&") ? l.replace(Fi, a) : a + " " + l
                }
            return i
        }
        function n(e, t, n) {
            if (n)
                return ft({}, n, {
                    index: n.index + 1
                });
            var r = e.options.nestingLevel;
            r = void 0 === r ? 1 : r + 1;
            var i = ft({}, e.options, {
                nestingLevel: r,
                index: t.indexOf(e) + 1
            });
            return delete i.name, i
        }
        return {
            onProcessStyle: function(r, i, o) {
                if ("style" !== i.type)
                    return r;
                var a,
                    s,
                    l = i,
                    u = l.options.parent;
                for (var c in r) {
                    var d = -1 !== c.indexOf("&"),
                        p = "@" === c[0];
                    if (d || p) {
                        if (a = n(l, u, a), d) {
                            var f = t(c, l.selector);
                            s || (s = e(u, o)), f = f.replace(Wi, s), u.addRule(f, r[c], ft({}, a, {
                                selector: f
                            }))
                        } else
                            p && u.addRule(c, {}, a).addRule(l.key, r[c], {
                                selector: l.selector
                            });
                        delete r[c]
                    }
                }
                return r
            }
        }
    }
    var ji = /[A-Z]/g,
        $i = /^ms-/,
        Vi = {};
    function qi(e) {
        return "-" + e.toLowerCase()
    }
    function Ui(e) {
        if (Vi.hasOwnProperty(e))
            return Vi[e];
        var t = e.replace(ji, qi);
        return Vi[e] = $i.test(t) ? "-" + t : t
    }
    function Gi(e) {
        var t = {};
        for (var n in e) {
            t[0 === n.indexOf("--") ? n : Ui(n)] = e[n]
        }
        return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(Gi) : t.fallbacks = Gi(e.fallbacks)), t
    }
    var Zi = yi && CSS ? CSS.px : "px",
        Ki = yi && CSS ? CSS.ms : "ms",
        Yi = yi && CSS ? CSS.percent : "%";
    function Xi(e) {
        var t = /(-[a-z])/g,
            n = function(e) {
                return e[1].toUpperCase()
            },
            r = {};
        for (var i in e)
            r[i] = e[i], r[i.replace(t, n)] = e[i];
        return r
    }
    var Ji = Xi({
        "animation-delay": Ki,
        "animation-duration": Ki,
        "background-position": Zi,
        "background-position-x": Zi,
        "background-position-y": Zi,
        "background-size": Zi,
        border: Zi,
        "border-bottom": Zi,
        "border-bottom-left-radius": Zi,
        "border-bottom-right-radius": Zi,
        "border-bottom-width": Zi,
        "border-left": Zi,
        "border-left-width": Zi,
        "border-radius": Zi,
        "border-right": Zi,
        "border-right-width": Zi,
        "border-top": Zi,
        "border-top-left-radius": Zi,
        "border-top-right-radius": Zi,
        "border-top-width": Zi,
        "border-width": Zi,
        margin: Zi,
        "margin-bottom": Zi,
        "margin-left": Zi,
        "margin-right": Zi,
        "margin-top": Zi,
        padding: Zi,
        "padding-bottom": Zi,
        "padding-left": Zi,
        "padding-right": Zi,
        "padding-top": Zi,
        "mask-position-x": Zi,
        "mask-position-y": Zi,
        "mask-size": Zi,
        height: Zi,
        width: Zi,
        "min-height": Zi,
        "max-height": Zi,
        "min-width": Zi,
        "max-width": Zi,
        bottom: Zi,
        left: Zi,
        top: Zi,
        right: Zi,
        "box-shadow": Zi,
        "text-shadow": Zi,
        "column-gap": Zi,
        "column-rule": Zi,
        "column-rule-width": Zi,
        "column-width": Zi,
        "font-size": Zi,
        "font-size-delta": Zi,
        "letter-spacing": Zi,
        "text-indent": Zi,
        "text-stroke": Zi,
        "text-stroke-width": Zi,
        "word-spacing": Zi,
        motion: Zi,
        "motion-offset": Zi,
        outline: Zi,
        "outline-offset": Zi,
        "outline-width": Zi,
        perspective: Zi,
        "perspective-origin-x": Yi,
        "perspective-origin-y": Yi,
        "transform-origin": Yi,
        "transform-origin-x": Yi,
        "transform-origin-y": Yi,
        "transform-origin-z": Yi,
        "transition-delay": Ki,
        "transition-duration": Ki,
        "vertical-align": Zi,
        "flex-basis": Zi,
        "shape-margin": Zi,
        size: Zi,
        grid: Zi,
        "grid-gap": Zi,
        "grid-row-gap": Zi,
        "grid-column-gap": Zi,
        "grid-template-rows": Zi,
        "grid-template-columns": Zi,
        "grid-auto-rows": Zi,
        "grid-auto-columns": Zi,
        "box-shadow-x": Zi,
        "box-shadow-y": Zi,
        "box-shadow-blur": Zi,
        "box-shadow-spread": Zi,
        "font-line-height": Zi,
        "text-shadow-x": Zi,
        "text-shadow-y": Zi,
        "text-shadow-blur": Zi
    });
    function Qi(e, t, n) {
        if (!t)
            return t;
        if (Array.isArray(t))
            for (var r = 0; r < t.length; r++)
                t[r] = Qi(e, t[r], n);
        else if ("object" == typeof t)
            if ("fallbacks" === e)
                for (var i in t)
                    t[i] = Qi(i, t[i], n);
            else
                for (var o in t)
                    t[o] = Qi(e + "-" + o, t[o], n);
        else if ("number" == typeof t)
            return n[e] ? "" + t + n[e] : Ji[e] ? "function" == typeof Ji[e] ? Ji[e](t).toString() : "" + t + Ji[e] : t.toString();
        return t
    }
    function eo(e) {
        void 0 === e && (e = {});
        var t = Xi(e);
        return {
            onProcessStyle: function(e, n) {
                if ("style" !== n.type)
                    return e;
                for (var r in e)
                    e[r] = Qi(r, e[r], t);
                return e
            },
            onChangeValue: function(e, n) {
                return Qi(n, e, t)
            }
        }
    }
    function to(e) {
        return function(e) {
                if (Array.isArray(e)) {
                    for (var t = 0, n = new Array(e.length); t < e.length; t++)
                        n[t] = e[t];
                    return n
                }
            }(e) || function(e) {
                if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
                    return Array.from(e)
            }(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance")
            }()
    }
    var no = "",
        ro = "",
        io = "",
        oo = cr && "ontouchstart" in document.documentElement;
    if (cr) {
        var ao = {
                Moz: "-moz-",
                ms: "-ms-",
                O: "-o-",
                Webkit: "-webkit-"
            },
            so = document.createElement("p").style;
        for (var lo in ao)
            if (lo + "Transform" in so) {
                no = lo, ro = ao[lo];
                break
            }
        "Webkit" === no && "msHyphens" in so && (no = "ms", ro = ao.ms, "edge"), "Webkit" === no && "-apple-trailing-word" in so && (io = "apple")
    }
    var uo = no,
        co = ro,
        po = io,
        fo = oo;
    var ho = {
            noPrefill: ["appearance"],
            supportedProperty: function(e) {
                return "appearance" === e && ("ms" === uo ? "-webkit-" + e : co + e)
            }
        },
        mo = {
            noPrefill: ["color-adjust"],
            supportedProperty: function(e) {
                return "color-adjust" === e && ("Webkit" === uo ? co + "print-" + e : e)
            }
        },
        vo = /[-\s]+(.)?/g;
    function go(e, t) {
        return t ? t.toUpperCase() : ""
    }
    function yo(e) {
        return e.replace(vo, go)
    }
    function bo(e) {
        return yo("-" + e)
    }
    var wo,
        xo = {
            noPrefill: ["mask"],
            supportedProperty: function(e, t) {
                if (!/^mask/.test(e))
                    return !1;
                if ("Webkit" === uo) {
                    var n = "mask-image";
                    if (yo(n) in t)
                        return e;
                    if (uo + bo(n) in t)
                        return co + e
                }
                return e
            }
        },
        _o = {
            noPrefill: ["text-orientation"],
            supportedProperty: function(e) {
                return "text-orientation" === e && ("apple" !== po || fo ? e : co + e)
            }
        },
        Co = {
            noPrefill: ["transform"],
            supportedProperty: function(e, t, n) {
                return "transform" === e && (n.transform ? e : co + e)
            }
        },
        Eo = {
            noPrefill: ["transition"],
            supportedProperty: function(e, t, n) {
                return "transition" === e && (n.transition ? e : co + e)
            }
        },
        So = {
            noPrefill: ["writing-mode"],
            supportedProperty: function(e) {
                return "writing-mode" === e && ("Webkit" === uo || "ms" === uo ? co + e : e)
            }
        },
        ko = {
            noPrefill: ["user-select"],
            supportedProperty: function(e) {
                return "user-select" === e && ("Moz" === uo || "ms" === uo || "apple" === po ? co + e : e)
            }
        },
        To = {
            supportedProperty: function(e, t) {
                return !!/^break-/.test(e) && ("Webkit" === uo ? "WebkitColumn" + bo(e) in t && co + "column-" + e : "Moz" === uo && ("page" + bo(e) in t && "page-" + e))
            }
        },
        Oo = {
            supportedProperty: function(e, t) {
                if (!/^(border|margin|padding)-inline/.test(e))
                    return !1;
                if ("Moz" === uo)
                    return e;
                var n = e.replace("-inline", "");
                return uo + bo(n) in t && co + n
            }
        },
        Mo = {
            supportedProperty: function(e, t) {
                return yo(e) in t && e
            }
        },
        Ro = {
            supportedProperty: function(e, t) {
                var n = bo(e);
                return "-" === e[0] || "-" === e[0] && "-" === e[1] ? e : uo + n in t ? co + e : "Webkit" !== uo && "Webkit" + n in t && "-webkit-" + e
            }
        },
        Po = {
            supportedProperty: function(e) {
                return "scroll-snap" === e.substring(0, 11) && ("ms" === uo ? "" + co + e : e)
            }
        },
        Ao = {
            supportedProperty: function(e) {
                return "overscroll-behavior" === e && ("ms" === uo ? co + "scroll-chaining" : e)
            }
        },
        Io = {
            "flex-grow": "flex-positive",
            "flex-shrink": "flex-negative",
            "flex-basis": "flex-preferred-size",
            "justify-content": "flex-pack",
            order: "flex-order",
            "align-items": "flex-align",
            "align-content": "flex-line-pack"
        },
        zo = {
            supportedProperty: function(e, t) {
                var n = Io[e];
                return !!n && (uo + bo(n) in t && co + n)
            }
        },
        Lo = {
            flex: "box-flex",
            "flex-grow": "box-flex",
            "flex-direction": ["box-orient", "box-direction"],
            order: "box-ordinal-group",
            "align-items": "box-align",
            "flex-flow": ["box-orient", "box-direction"],
            "justify-content": "box-pack"
        },
        Do = Object.keys(Lo),
        No = function(e) {
            return co + e
        },
        Bo = [ho, mo, xo, _o, Co, Eo, So, ko, To, Oo, Mo, Ro, Po, Ao, zo, {
            supportedProperty: function(e, t, n) {
                var r = n.multiple;
                if (Do.indexOf(e) > -1) {
                    var i = Lo[e];
                    if (!Array.isArray(i))
                        return uo + bo(i) in t && co + i;
                    if (!r)
                        return !1;
                    for (var o = 0; o < i.length; o++)
                        if (!(uo + bo(i[0]) in t))
                            return !1;
                    return i.map(No)
                }
                return !1
            }
        }],
        Fo = Bo.filter((function(e) {
            return e.supportedProperty
        })).map((function(e) {
            return e.supportedProperty
        })),
        Wo = Bo.filter((function(e) {
            return e.noPrefill
        })).reduce((function(e, t) {
            return e.push.apply(e, to(t.noPrefill)), e
        }), []),
        Ho = {};
    if (cr) {
        wo = document.createElement("p");
        var jo = window.getComputedStyle(document.documentElement, "");
        for (var $o in jo)
            isNaN($o) || (Ho[jo[$o]] = jo[$o]);
        Wo.forEach((function(e) {
            return delete Ho[e]
        }))
    }
    function Vo(e, t) {
        if (void 0 === t && (t = {}), !wo)
            return e;
        if (null != Ho[e])
            return Ho[e];
        "transition" !== e && "transform" !== e || (t[e] = e in wo.style);
        for (var n = 0; n < Fo.length && (Ho[e] = Fo[n](e, wo.style, t), !Ho[e]); n++)
            ;
        try {
            wo.style[e] = ""
        } catch (e) {
            return !1
        }
        return Ho[e]
    }
    var qo,
        Uo = {},
        Go = {
            transition: 1,
            "transition-property": 1,
            "-webkit-transition": 1,
            "-webkit-transition-property": 1
        },
        Zo = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
    function Ko(e, t, n) {
        if ("var" === t)
            return "var";
        if ("all" === t)
            return "all";
        if ("all" === n)
            return ", all";
        var r = t ? Vo(t) : ", " + Vo(n);
        return r || (t || n)
    }
    function Yo(e, t) {
        var n = t;
        if (!qo || "content" === e)
            return t;
        if ("string" != typeof n || !isNaN(parseInt(n, 10)))
            return n;
        var r = e + n;
        if (null != Uo[r])
            return Uo[r];
        try {
            qo.style[e] = n
        } catch (e) {
            return Uo[r] = !1, !1
        }
        if (Go[e])
            n = n.replace(Zo, Ko);
        else if ("" === qo.style[e] && ("-ms-flex" === (n = co + n) && (qo.style[e] = "-ms-flexbox"), qo.style[e] = n, "" === qo.style[e]))
            return Uo[r] = !1, !1;
        return qo.style[e] = "", Uo[r] = n, Uo[r]
    }
    function Xo() {
        function e(t) {
            for (var n in t) {
                var r = t[n];
                if ("fallbacks" === n && Array.isArray(r))
                    t[n] = r.map(e);
                else {
                    var i = !1,
                        o = Vo(n);
                    o && o !== n && (i = !0);
                    var a = !1,
                        s = Yo(o, br(r));
                    s && s !== r && (a = !0), (i || a) && (i && delete t[n], t[o || n] = s || r)
                }
            }
            return t
        }
        return {
            onProcessRule: function(e) {
                if ("keyframes" === e.type) {
                    var t = e;
                    t.at = "-" === (n = t.at)[1] || "ms" === uo ? n : "@" + co + "keyframes" + n.substr(10)
                }
                var n
            },
            onProcessStyle: function(t, n) {
                return "style" !== n.type ? t : e(t)
            },
            onChangeValue: function(e, t) {
                return Yo(t, br(e)) || e
            }
        }
    }
    function Jo() {
        return {
            plugins: [{
                onCreateRule: function(e, t, n) {
                    if ("function" != typeof t)
                        return null;
                    var r = gr(e, {}, n);
                    return r[Ri] = t, r
                },
                onProcessStyle: function(e, t) {
                    if (Mi in t || Ri in t)
                        return e;
                    var n = {};
                    for (var r in e) {
                        var i = e[r];
                        "function" == typeof i && (delete e[r], n[r] = i)
                    }
                    return t[Mi] = n, e
                },
                onUpdate: function(e, t, n, r) {
                    var i = t,
                        o = i[Ri];
                    o && (i.style = o(e) || {});
                    var a = i[Mi];
                    if (a)
                        for (var s in a)
                            i.prop(s, a[s](e), r)
                }
            }, Ni(), Hi(), {
                onProcessStyle: function(e) {
                    if (Array.isArray(e)) {
                        for (var t = 0; t < e.length; t++)
                            e[t] = Gi(e[t]);
                        return e
                    }
                    return Gi(e)
                },
                onChangeValue: function(e, t, n) {
                    if (0 === t.indexOf("--"))
                        return e;
                    var r = Ui(t);
                    return t === r ? e : (n.prop(r, e), null)
                }
            }, eo(), "undefined" == typeof window ? null : Xo(), (e = function(e, t) {
                return e.length === t.length ? e > t ? 1 : -1 : e.length - t.length
            }, {
                onProcessStyle: function(t, n) {
                    if ("style" !== n.type)
                        return t;
                    for (var r = {}, i = Object.keys(t).sort(e), o = 0; o < i.length; o++)
                        r[i[o]] = t[i[o]];
                    return r
                }
            })]
        };
        var e
    }
    cr && (qo = document.createElement("p"));
    var Qo = bi(Jo()),
        ea = {
            disableGeneration: !1,
            generateClassName: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = e.disableGlobal,
                    n = void 0 !== t && t,
                    r = e.productionPrefix,
                    i = void 0 === r ? "pwzrjss" : r,
                    o = e.seed,
                    a = void 0 === o ? "" : o,
                    s = "" === a ? "" : "".concat(a, "-"),
                    l = 0;
                return function(e, t) {
                    l += 1;
                    var r = t.options.name;
                    if (r && 0 === r.indexOf("Pwzr") && !t.options.link && !n) {
                        if (-1 !== Ti.indexOf(e.key))
                            return "Pwzr-".concat(e.key);
                        var o = "".concat(s).concat(r, "-").concat(e.key);
                        return t.options.theme[ki] && "" === a ? "".concat(o, "-").concat(l) : o
                    }
                    return "".concat(s).concat(i).concat(l)
                }
            }(),
            jss: Qo,
            sheetsCache: null,
            sheetsManager: new Map,
            sheetsRegistry: null
        },
        ta = lt.createContext(ea);
    r({}, "StylesContext", (function() {
        return ta
    }));
    var na = -1e9;
    function ra() {
        return na += 1
    }
    var ia = {};
    function oa(e) {
        var t = "function" == typeof e;
        return {
            create: function(n, r) {
                var i;
                try {
                    i = t ? e(n) : e
                } catch (e) {
                    throw e
                }
                if (!r || !n.overrides || !n.overrides[r])
                    return i;
                var o = n.overrides[r],
                    a = ft({}, i);
                return Object.keys(o).forEach((function(e) {
                    a[e] = gt(a[e], o[e])
                })), a
            },
            options: {}
        }
    }
    function aa(e, t, n) {
        var r = e.state;
        if (e.stylesOptions.disableGeneration)
            return t || {};
        r.cacheClasses || (r.cacheClasses = {
            value: null,
            lastProp: null,
            lastJSS: {}
        });
        var i = !1;
        return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, i = !0), t !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = t, i = !0), i && (r.cacheClasses.value = wi({
            baseClasses: r.cacheClasses.lastJSS,
            newClasses: t,
            Component: n
        })), r.cacheClasses.value
    }
    function sa(e, t) {
        var n = e.state,
            r = e.theme,
            i = e.stylesOptions,
            o = e.stylesCreator,
            a = e.name;
        if (!i.disableGeneration) {
            var s = _i(i.sheetsManager, o, r);
            s || (s = {
                refs: 0,
                staticSheet: null,
                dynamicStyles: null
            }, xi(i.sheetsManager, o, r, s));
            var l = ft({}, o.options, {}, i, {
                theme: r,
                flip: "boolean" == typeof i.flip ? i.flip : "rtl" === r.direction
            });
            l.generateId = l.serverGenerateClassName || l.generateClassName;
            var u = i.sheetsRegistry;
            if (0 === s.refs) {
                var c;
                i.sheetsCache && (c = _i(i.sheetsCache, o, r));
                var d = o.create(r, a);
                c || ((c = i.jss.createStyleSheet(d, ft({
                    link: !1
                }, l))).attach(), i.sheetsCache && xi(i.sheetsCache, o, r, c)), u && u.add(c), s.staticSheet = c, s.dynamicStyles = gi(d)
            }
            if (s.dynamicStyles) {
                var p = i.jss.createStyleSheet(s.dynamicStyles, ft({
                    link: !0
                }, l));
                p.update(t), p.attach(), n.dynamicSheet = p, n.classes = wi({
                    baseClasses: s.staticSheet.classes,
                    newClasses: p.classes
                }), u && u.add(p)
            } else
                n.classes = s.staticSheet.classes;
            s.refs += 1
        }
    }
    function la(e, t) {
        var n = e.state;
        n.dynamicSheet && n.dynamicSheet.update(t)
    }
    function ua(e) {
        var t = e.state,
            n = e.theme,
            r = e.stylesOptions,
            i = e.stylesCreator;
        if (!r.disableGeneration) {
            var o = _i(r.sheetsManager, i, n);
            o.refs -= 1;
            var a = r.sheetsRegistry;
            0 === o.refs && (Ci(r.sheetsManager, i, n), r.jss.removeStyleSheet(o.staticSheet), a && a.remove(o.staticSheet)), t.dynamicSheet && (r.jss.removeStyleSheet(t.dynamicSheet), a && a.remove(t.dynamicSheet))
        }
    }
    function ca(e, t) {
        var n,
            r = lt.useRef([]),
            i = lt.useMemo((function() {
                return {}
            }), t);
        r.current !== i && (r.current = i, n = e()), lt.useEffect((function() {
            return function() {
                n && n()
            }
        }), [i])
    }
    function da(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.name,
            r = t.classNamePrefix,
            i = t.Component,
            o = t.defaultTheme,
            a = void 0 === o ? ia : o,
            s = dt(t, ["name", "classNamePrefix", "Component", "defaultTheme"]),
            l = oa(e),
            u = n || r || "makeStyles";
        return l.options = {
            index: ra(),
            name: n,
            meta: u,
            classNamePrefix: u
        }, function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = Si() || a,
                r = ft({}, lt.useContext(ta), {}, s),
                o = lt.useRef(),
                u = lt.useRef();
            return ca((function() {
                var i = {
                    name: n,
                    state: {},
                    stylesCreator: l,
                    stylesOptions: r,
                    theme: t
                };
                return sa(i, e), u.current = !1, o.current = i, function() {
                    ua(i)
                }
            }), [t, l]), lt.useEffect((function() {
                u.current && la(o.current, e), u.current = !0
            })), aa(o.current, e.classes, i)
        }
    }
    function pa(e) {
        var t,
            n,
            r = "";
        if (e)
            if ("object" == typeof e)
                if (e.push)
                    for (t = 0; t < e.length; t++)
                        e[t] && (n = pa(e[t])) && (r && (r += " "), r += n);
                else
                    for (t in e)
                        e[t] && (n = pa(t)) && (r && (r += " "), r += n);
            else
                "boolean" == typeof e || e.call || (r && (r += " "), r += e);
        return r
    }
    var fa = function() {
            for (var e, t = 0, n = ""; t < arguments.length;)
                (e = pa(arguments[t++])) && (n && (n += " "), n += e);
            return n
        },
        ha = {
            childContextTypes: !0,
            contextType: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            getDerivedStateFromError: !0,
            getDerivedStateFromProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0
        },
        ma = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            callee: !0,
            arguments: !0,
            arity: !0
        },
        va = {
            $$typeof: !0,
            compare: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0,
            type: !0
        },
        ga = {};
    function ya(e) {
        return kn.isMemo(e) ? va : ga[e.$$typeof] || ha
    }
    ga[kn.ForwardRef] = {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    }, ga[kn.Memo] = va;
    var ba = Object.defineProperty,
        wa = Object.getOwnPropertyNames,
        xa = Object.getOwnPropertySymbols,
        _a = Object.getOwnPropertyDescriptor,
        Ca = Object.getPrototypeOf,
        Ea = Object.prototype;
    var Sa = t((function e(t, n, r) {
        if ("string" != typeof n) {
            if (Ea) {
                var i = Ca(n);
                i && i !== Ea && e(t, i, r)
            }
            var o = wa(n);
            xa && (o = o.concat(xa(n)));
            for (var a = ya(t), s = ya(n), l = 0; l < o.length; ++l) {
                var u = o[l];
                if (!(ma[u] || r && r[u] || s && s[u] || a && a[u])) {
                    var c = _a(n, u);
                    try {
                        ba(t, u, c)
                    } catch (e) {}
                }
            }
        }
        return t
    }));
    function ka(e, t) {
        var n = {};
        return Object.keys(e).forEach((function(r) {
            -1 === t.indexOf(r) && (n[r] = e[r])
        })), n
    }
    function Ta(e) {
        var t = e.children,
            n = e.theme,
            r = Si();
        var i = lt.useMemo((function() {
            var e = null === r ? n : function(e, t) {
                if ("function" == typeof t) {
                    return t(e)
                }
                return ft({}, e, {}, t)
            }(r, n);
            return null != e && (e[ki] = null !== r), e
        }), [n, r]);
        return lt.createElement(Ei.Provider, {
            value: i
        }, t)
    }
    var Oa = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return function(n) {
                var r = t.defaultTheme,
                    i = t.withTheme,
                    o = void 0 !== i && i,
                    a = t.name,
                    s = dt(t, ["defaultTheme", "withTheme", "name"]);
                var l = a,
                    u = da(e, ft({
                        defaultTheme: r,
                        Component: n,
                        name: a || n.displayName,
                        classNamePrefix: l
                    }, s)),
                    c = lt.forwardRef((function(e, t) {
                        e.classes;
                        var i,
                            s = e.innerRef,
                            l = dt(e, ["classes", "innerRef"]),
                            c = u(e),
                            d = l;
                        return ("string" == typeof a || o) && (i = Si() || r, a && (d = lr({
                            theme: i,
                            name: a,
                            props: l
                        })), o && !d.theme && (d.theme = i)), lt.createElement(n, ft({
                            ref: s || t,
                            classes: c
                        }, d))
                    }));
                return c.defaultProps = n.defaultProps, Sa(c, n), c
            }
        },
        Ma = sr();
    function Ra(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return da(e, ft({
            defaultTheme: Ma
        }, t))
    }
    function Pa() {
        return Si() || Ma
    }
    var Aa,
        Ia = {};
    var za = Aa = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    };
    Object.defineProperty(Ia, "__esModule", {
        value: !0
    });
    var La = void 0;
    Ia.default = La;
    var Da;
    var Na,
        Ba = t(Da = function(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e
        });
    za(Da);
    var Fa = function(e, t) {
        if (null == e)
            return {};
        var n,
            r,
            i = {},
            o = Object.keys(e);
        for (r = 0; r < o.length; r++)
            n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i
    };
    var Wa = za(Na = function(e, t) {
            if (null == e)
                return {};
            var n,
                r,
                i = Fa(e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (r = 0; r < o.length; r++)
                    n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n])
            }
            return i
        }),
        Ha = {},
        ja = Aa;
    Object.defineProperty(Ha, "__esModule", {
        value: !0
    });
    var $a = function(e) {
        var t = e.values,
            n = void 0 === t ? {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920
            } : t,
            r = e.unit,
            i = void 0 === r ? "px" : r,
            o = e.step,
            a = void 0 === o ? 5 : o,
            s = (0, Ka.default)(e, ["values", "unit", "step"]);
        function l(e) {
            var t = "number" == typeof n[e] ? n[e] : e;
            return "@media (min-width:".concat(t).concat(i, ")")
        }
        function u(e, t) {
            var r = Ya.indexOf(t);
            return r === Ya.length - 1 ? l(e) : "@media (min-width:".concat("number" == typeof n[e] ? n[e] : e).concat(i, ") and ") + "(max-width:".concat((-1 !== r && "number" == typeof n[Ya[r + 1]] ? n[Ya[r + 1]] : t) - a / 100).concat(i, ")")
        }
        return (0, Za.default)({
            keys: Ya,
            values: n,
            up: l,
            down: function(e) {
                var t = Ya.indexOf(e) + 1,
                    r = n[Ya[t]];
                return t === Ya.length ? l("xs") : "@media (max-width:".concat(("number" == typeof r && t > 0 ? r : e) - a / 100).concat(i, ")")
            },
            between: u,
            only: function(e) {
                return u(e, e)
            },
            width: function(e) {
                return n[e]
            }
        }, s)
    };
    Ha.default = $a;
    var Va = void 0;
    Ha.keys = Va;
    var qa = {};
    function Ua() {
        return qa = Ua = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }, Ua.apply(this, arguments)
    }
    var Ga = t(qa = Ua),
        Za = ja(qa),
        Ka = ja(Na),
        Ya = ["xs", "sm", "md", "lg", "xl"];
    Va = Ya, Ha.keys = Va;
    var Xa = za(Ha),
        Ja = {},
        Qa = Aa;
    Object.defineProperty(Ja, "__esModule", {
        value: !0
    });
    var es = function(e, t, n) {
        var r;
        return (0, ns.default)({
            gutters: function() {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return (0, ns.default)({
                    paddingLeft: t(2),
                    paddingRight: t(2)
                }, n, (0, ts.default)({}, e.up("sm"), (0, ns.default)({
                    paddingLeft: t(3),
                    paddingRight: t(3)
                }, n[e.up("sm")])))
            },
            toolbar: (r = {
                minHeight: 56
            }, (0, ts.default)(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {
                minHeight: 48
            }), (0, ts.default)(r, e.up("sm"), {
                minHeight: 64
            }), r)
        }, n)
    };
    Ja.default = es;
    var ts = Qa(Da),
        ns = Qa(qa);
    var rs = za(Ja),
        is = {},
        os = Aa;
    Object.defineProperty(is, "__esModule", {
        value: !0
    });
    var as = function(e) {
        var t = e.primary,
            n = void 0 === t ? {
                light: ys.default[300],
                main: ys.default[500],
                dark: ys.default[700]
            } : t,
            r = e.secondary,
            i = void 0 === r ? {
                light: xs.default.A200,
                main: xs.default.A400,
                dark: xs.default.A700
            } : r,
            o = e.error,
            a = void 0 === o ? {
                light: Es.default[300],
                main: Es.default[500],
                dark: Es.default[700]
            } : o,
            s = e.warning,
            l = void 0 === s ? {
                light: Ts.default[300],
                main: Ts.default[500],
                dark: Ts.default[700]
            } : s,
            u = e.info,
            c = void 0 === u ? {
                light: Rs.default[300],
                main: Rs.default[500],
                dark: Rs.default[700]
            } : u,
            d = e.success,
            p = void 0 === d ? {
                light: Is.default[300],
                main: Is.default[500],
                dark: Is.default[700]
            } : d,
            f = e.type,
            h = void 0 === f ? "light" : f,
            m = e.contrastThreshold,
            v = void 0 === m ? 3 : m,
            g = e.tonalOffset,
            y = void 0 === g ? .2 : g,
            b = (0, us.default)(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
        function w(e) {
            if (!e)
                throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(e, ")."));
            var t = (0, zs.getContrastRatio)(e, nl.text.primary) >= v ? nl.text.primary : el.text.primary;
            return t
        }
        function x(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300,
                r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
            return !(e = (0, ls.default)({}, e)).main && e[t] && (e.main = e[t]), rl(e, "light", n, y), rl(e, "dark", r, y), e.contrastText || (e.contrastText = w(e.main)), e
        }
        var _ = {
            dark: nl,
            light: el
        };
        0;
        return gt((0, ls.default)({
            common: ps.default,
            type: h,
            primary: x(n),
            secondary: x(i, "A400", "A200", "A700"),
            error: x(a),
            warning: x(l),
            info: x(c),
            success: x(p),
            grey: ms.default,
            contrastThreshold: v,
            getContrastText: w,
            augmentColor: x,
            tonalOffset: y
        }, _[h]), b)
    };
    is.default = as;
    var ss = (tl = void 0, is.light = tl);
    is.dark = ss;
    var ls = os(qa),
        us = os(Na),
        cs = {};
    Object.defineProperty(cs, "__esModule", {
        value: !0
    });
    var ds = void 0;
    cs.default = ds;
    ds = {
        black: "#000",
        white: "#fff"
    }, cs.default = ds;
    var ps = os(cs),
        fs = {};
    Object.defineProperty(fs, "__esModule", {
        value: !0
    });
    var hs = void 0;
    fs.default = hs;
    hs = {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#eeeeee",
        300: "#e0e0e0",
        400: "#bdbdbd",
        500: "#9e9e9e",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        A100: "#d5d5d5",
        A200: "#aaaaaa",
        A400: "#303030",
        A700: "#616161"
    }, fs.default = hs;
    var ms = os(fs),
        vs = {};
    Object.defineProperty(vs, "__esModule", {
        value: !0
    });
    var gs = void 0;
    vs.default = gs;
    gs = {
        50: "#e8eaf6",
        100: "#c5cae9",
        200: "#9fa8da",
        300: "#7986cb",
        400: "#5c6bc0",
        500: "#3f51b5",
        600: "#3949ab",
        700: "#303f9f",
        800: "#283593",
        900: "#1a237e",
        A100: "#8c9eff",
        A200: "#536dfe",
        A400: "#3d5afe",
        A700: "#304ffe"
    }, vs.default = gs;
    var ys = os(vs),
        bs = {};
    Object.defineProperty(bs, "__esModule", {
        value: !0
    });
    var ws = void 0;
    bs.default = ws;
    ws = {
        50: "#fce4ec",
        100: "#f8bbd0",
        200: "#f48fb1",
        300: "#f06292",
        400: "#ec407a",
        500: "#e91e63",
        600: "#d81b60",
        700: "#c2185b",
        800: "#ad1457",
        900: "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162"
    }, bs.default = ws;
    var xs = os(bs),
        _s = {};
    Object.defineProperty(_s, "__esModule", {
        value: !0
    });
    var Cs = void 0;
    _s.default = Cs;
    Cs = {
        50: "#ffebee",
        100: "#ffcdd2",
        200: "#ef9a9a",
        300: "#e57373",
        400: "#ef5350",
        500: "#f44336",
        600: "#e53935",
        700: "#d32f2f",
        800: "#c62828",
        900: "#b71c1c",
        A100: "#ff8a80",
        A200: "#ff5252",
        A400: "#ff1744",
        A700: "#d50000"
    }, _s.default = Cs;
    var Es = os(_s),
        Ss = {};
    Object.defineProperty(Ss, "__esModule", {
        value: !0
    });
    var ks = void 0;
    Ss.default = ks;
    ks = {
        50: "#fff3e0",
        100: "#ffe0b2",
        200: "#ffcc80",
        300: "#ffb74d",
        400: "#ffa726",
        500: "#ff9800",
        600: "#fb8c00",
        700: "#f57c00",
        800: "#ef6c00",
        900: "#e65100",
        A100: "#ffd180",
        A200: "#ffab40",
        A400: "#ff9100",
        A700: "#ff6d00"
    }, Ss.default = ks;
    var Ts = os(Ss),
        Os = {};
    Object.defineProperty(Os, "__esModule", {
        value: !0
    });
    var Ms = void 0;
    Os.default = Ms;
    Ms = {
        50: "#e3f2fd",
        100: "#bbdefb",
        200: "#90caf9",
        300: "#64b5f6",
        400: "#42a5f5",
        500: "#2196f3",
        600: "#1e88e5",
        700: "#1976d2",
        800: "#1565c0",
        900: "#0d47a1",
        A100: "#82b1ff",
        A200: "#448aff",
        A400: "#2979ff",
        A700: "#2962ff"
    }, Os.default = Ms;
    var Rs = os(Os),
        Ps = {};
    Object.defineProperty(Ps, "__esModule", {
        value: !0
    });
    var As = void 0;
    Ps.default = As;
    As = {
        50: "#e8f5e9",
        100: "#c8e6c9",
        200: "#a5d6a7",
        300: "#81c784",
        400: "#66bb6a",
        500: "#4caf50",
        600: "#43a047",
        700: "#388e3c",
        800: "#2e7d32",
        900: "#1b5e20",
        A100: "#b9f6ca",
        A200: "#69f0ae",
        A400: "#00e676",
        A700: "#00c853"
    }, Ps.default = As;
    var Is = os(Ps),
        zs = {};
    Object.defineProperty(zs, "__esModule", {
        value: !0
    });
    var Ls = Gs;
    zs.hexToRgb = Ls;
    var Ds = function(e) {
        if (0 === e.indexOf("#"))
            return e;
        var t = Ks(e).values;
        return "#".concat(t.map((function(e) {
            return 1 === (t = e.toString(16)).length ? "0".concat(t) : t;
            var t
        })).join(""))
    };
    zs.rgbToHex = Ds;
    var Ns = Zs;
    zs.hslToRgb = Ns;
    var Bs = Ks;
    zs.decomposeColor = Bs;
    var Fs = Ys;
    zs.recomposeColor = Fs;
    var Ws = function(e, t) {
        var n = Xs(e),
            r = Xs(t);
        return (Math.max(n, r) + .05) / (Math.min(n, r) + .05)
    };
    zs.getContrastRatio = Ws;
    var Hs = Xs;
    zs.getLuminance = Hs;
    var js = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .15;
        return Xs(e) > .5 ? Js(e, t) : Qs(e, t)
    };
    zs.emphasize = js;
    var $s = function(e, t) {
        e = Ks(e), t = Us(t), ("rgb" === e.type || "hsl" === e.type) && (e.type += "a");
        return e.values[3] = t, Ys(e)
    };
    zs.fade = $s;
    var Vs = Js;
    zs.darken = Vs;
    var qs = Qs;
    function Us(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return Math.min(Math.max(t, e), n)
    }
    function Gs(e) {
        e = e.substr(1);
        var t = new RegExp(".{1,".concat(e.length / 3, "}"), "g"),
            n = e.match(t);
        return n && 1 === n[0].length && (n = n.map((function(e) {
            return e + e
        }))), n ? "rgb(".concat(n.map((function(e) {
            return parseInt(e, 16)
        })).join(", "), ")") : ""
    }
    function Zs(e) {
        var t = (e = Ks(e)).values,
            n = t[0],
            r = t[1] / 100,
            i = t[2] / 100,
            o = r * Math.min(i, 1 - i),
            a = function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + n / 30) % 12;
                return i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1)
            },
            s = "rgb",
            l = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];
        return "hsla" === e.type && (s += "a", l.push(t[3])), Ys({
            type: s,
            values: l
        })
    }
    function Ks(e) {
        if (e.type)
            return e;
        if ("#" === e.charAt(0))
            return Ks(Gs(e));
        var t = e.indexOf("("),
            n = e.substring(0, t);
        if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n))
            throw new Error(["Material-UI: unsupported `".concat(e, "` color."), "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."].join("\n"));
        var r = e.substring(t + 1, e.length - 1).split(",");
        return {
            type: n,
            values: r = r.map((function(e) {
                return parseFloat(e)
            }))
        }
    }
    function Ys(e) {
        var t = e.type,
            n = e.values;
        return -1 !== t.indexOf("rgb") ? n = n.map((function(e, t) {
            return t < 3 ? parseInt(e, 10) : e
        })) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(t, "(").concat(n.join(", "), ")")
    }
    function Xs(e) {
        var t = "hsl" === (e = Ks(e)).type ? Ks(Zs(e)).values : e.values;
        return t = t.map((function(e) {
            return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)
        })), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3))
    }
    function Js(e, t) {
        if (e = Ks(e), t = Us(t), -1 !== e.type.indexOf("hsl"))
            e.values[2] *= 1 - t;
        else if (-1 !== e.type.indexOf("rgb"))
            for (var n = 0; n < 3; n += 1)
                e.values[n] *= 1 - t;
        return Ys(e)
    }
    function Qs(e, t) {
        if (e = Ks(e), t = Us(t), -1 !== e.type.indexOf("hsl"))
            e.values[2] += (100 - e.values[2]) * t;
        else if (-1 !== e.type.indexOf("rgb"))
            for (var n = 0; n < 3; n += 1)
                e.values[n] += (255 - e.values[n]) * t;
        return Ys(e)
    }
    zs.lighten = qs;
    var el = {
            text: {
                primary: "rgba(0, 0, 0, 0.87)",
                secondary: "rgba(0, 0, 0, 0.54)",
                disabled: "rgba(0, 0, 0, 0.38)",
                hint: "rgba(0, 0, 0, 0.38)"
            },
            divider: "rgba(0, 0, 0, 0.12)",
            background: {
                paper: ps.default.white,
                default: ms.default[50]
            },
            action: {
                active: "rgba(0, 0, 0, 0.54)",
                hover: "rgba(0, 0, 0, 0.04)",
                hoverOpacity: .04,
                selected: "rgba(0, 0, 0, 0.08)",
                selectedOpacity: .08,
                disabled: "rgba(0, 0, 0, 0.26)",
                disabledBackground: "rgba(0, 0, 0, 0.12)",
                disabledOpacity: .38,
                focus: "rgba(0, 0, 0, 0.12)",
                focusOpacity: .12,
                activatedOpaciy: .12
            }
        },
        tl = el;
    is.light = tl;
    var nl = {
        text: {
            primary: ps.default.white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            hint: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
        },
        divider: "rgba(255, 255, 255, 0.12)",
        background: {
            paper: ms.default[800],
            default: "#303030"
        },
        action: {
            active: ps.default.white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: .08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: .16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .24
        }
    };
    function rl(e, t, n, r) {
        e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : "light" === t ? e.light = (0, zs.lighten)(e.main, r) : "dark" === t && (e.dark = (0, zs.darken)(e.main, 1.5 * r)))
    }
    ss = nl, is.dark = ss;
    var il = za(is),
        ol = {},
        al = Aa;
    Object.defineProperty(ol, "__esModule", {
        value: !0
    });
    var sl = function(e, t) {
        var n = "function" == typeof t ? t(e) : t,
            r = n.fontFamily,
            i = void 0 === r ? pl : r,
            o = n.fontSize,
            a = void 0 === o ? 14 : o,
            s = n.fontWeightLight,
            l = void 0 === s ? 300 : s,
            u = n.fontWeightRegular,
            c = void 0 === u ? 400 : u,
            d = n.fontWeightMedium,
            p = void 0 === d ? 500 : d,
            f = n.fontWeightBold,
            h = void 0 === f ? 700 : f,
            m = n.htmlFontSize,
            v = void 0 === m ? 16 : m,
            g = n.allVariants,
            y = n.pxToRem,
            b = (0, ul.default)(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
        0;
        var w = a / 14,
            x = y || function(e) {
                return "".concat(e / v * w, "rem")
            },
            _ = function(e, t, n, r, o) {
                return (0, ll.default)({
                    fontFamily: i,
                    fontWeight: e,
                    fontSize: x(t),
                    lineHeight: n
                }, i === pl ? {
                    letterSpacing: "".concat(cl(r / t), "em")
                } : {}, {}, o, {}, g)
            },
            C = {
                h1: _(l, 96, 1.167, -1.5),
                h2: _(l, 60, 1.2, -.5),
                h3: _(c, 48, 1.167, 0),
                h4: _(c, 34, 1.235, .25),
                h5: _(c, 24, 1.334, 0),
                h6: _(p, 20, 1.6, .15),
                subtitle1: _(c, 16, 1.75, .15),
                subtitle2: _(p, 14, 1.57, .1),
                body1: _(c, 16, 1.5, .15),
                body2: _(c, 14, 1.43, .15),
                button: _(p, 14, 1.75, .4, dl),
                caption: _(c, 12, 1.66, .4),
                overline: _(c, 12, 2.66, 1, dl)
            };
        return gt((0, ll.default)({
            htmlFontSize: v,
            pxToRem: x,
            round: cl,
            fontFamily: i,
            fontSize: a,
            fontWeightLight: l,
            fontWeightRegular: c,
            fontWeightMedium: p,
            fontWeightBold: h
        }, C), b, {
            clone: !1
        })
    };
    ol.default = sl;
    var ll = al(qa),
        ul = al(Na);
    function cl(e) {
        return Math.round(1e5 * e) / 1e5
    }
    var dl = {
            textTransform: "uppercase"
        },
        pl = '"Roboto", "Helvetica", "Arial", sans-serif';
    var fl = za(ol),
        hl = {};
    Object.defineProperty(hl, "__esModule", {
        value: !0
    });
    var ml = void 0;
    hl.default = ml;
    function vl() {
        return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",")
    }
    ml = ["none", vl(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), vl(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), vl(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), vl(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), vl(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), vl(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), vl(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), vl(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), vl(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), vl(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), vl(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), vl(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), vl(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), vl(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), vl(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), vl(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), vl(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), vl(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), vl(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), vl(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), vl(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), vl(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), vl(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), vl(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], hl.default = ml;
    var gl = za(hl),
        yl = {};
    Object.defineProperty(yl, "__esModule", {
        value: !0
    });
    var bl = void 0;
    yl.default = bl;
    bl = {
        borderRadius: 4
    }, yl.default = bl;
    var wl = za(yl),
        xl = {};
    Object.defineProperty(xl, "__esModule", {
        value: !0
    });
    var _l = function() {
        var e,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
        if (t.mui)
            return t;
        e = "function" == typeof t ? t : function(e) {
            return t * e
        };
        var n = function() {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            return 0 === n.length ? e(1) : 1 === n.length ? e(n[0]) : n.map((function(t) {
                var n = e(t);
                return "number" == typeof n ? "".concat(n, "px") : n
            })).join(" ")
        };
        return Object.defineProperty(n, "unit", {
            get: function() {
                return t
            }
        }), n.mui = !0, n
    };
    xl.default = _l;
    var Cl = za(xl),
        El = {},
        Sl = Aa;
    Object.defineProperty(El, "__esModule", {
        value: !0
    });
    var kl = (Ml = void 0, Pl = El.easing = Ml, El.duration = Pl);
    El.default = kl;
    var Tl = Sl(Na),
        Ol = {
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
            sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
        },
        Ml = Ol;
    El.easing = Ml;
    var Rl = {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195
        },
        Pl = Rl;
    function Al(e) {
        return "".concat(Math.round(e), "ms")
    }
    El.duration = Pl, kl = {
        easing: Ol,
        duration: Rl,
        create: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"],
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = t.duration,
                r = void 0 === n ? Rl.standard : n,
                i = t.easing,
                o = void 0 === i ? Ol.easeInOut : i,
                a = t.delay,
                s = void 0 === a ? 0 : a;
            (0, Tl.default)(t, ["duration", "easing", "delay"]);
            return (Array.isArray(e) ? e : [e]).map((function(e) {
                return "".concat(e, " ").concat("string" == typeof r ? r : Al(r), " ").concat(o, " ").concat("string" == typeof s ? s : Al(s))
            })).join(",")
        },
        getAutoHeightDuration: function(e) {
            if (!e)
                return 0;
            var t = e / 36;
            return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5))
        }
    }, El.default = kl;
    var Il = za(El),
        zl = {};
    Object.defineProperty(zl, "__esModule", {
        value: !0
    });
    var Ll = void 0;
    zl.default = Ll;
    Ll = {
        mobileStepper: 1e3,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
    }, zl.default = Ll;
    var Dl = za(zl);
    La = function() {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, n = void 0 === t ? {} : t, r = e.mixins, i = void 0 === r ? {} : r, o = e.palette, a = void 0 === o ? {} : o, s = e.spacing, l = e.typography, u = void 0 === l ? {} : l, c = (0, Wa.default)(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = (0, il.default)(a), p = (0, Xa.default)(n), f = (0, Cl.default)(s), h = gt({
                breakpoints: p,
                direction: "ltr",
                mixins: (0, rs.default)(p, f, i),
                overrides: {},
                palette: d,
                props: {},
                shadows: gl.default,
                typography: (0, fl.default)(d, u),
                spacing: f,
                shape: wl.default,
                transitions: Il.default,
                zIndex: Dl.default
            }, c), m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
            v[g - 1] = arguments[g];
        return h = v.reduce((function(e, t) {
            return gt(e, t)
        }), h)
    }, Ia.default = La;
    var Nl,
        Bl = t(Ia),
        Fl = !1;
    function Wl() {
        Nl = {}, Nl = () => {
            var e;
            !function() {
                if ("function" == typeof window.CustomEvent)
                    return !1;
                window.CustomEvent = function(e, t) {
                    t = t || {
                        bubbles: !1,
                        cancelable: !1,
                        detail: null
                    };
                    var n = document.createEvent("CustomEvent");
                    return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n
                }
            }(), history.pushState = (e = history.pushState, function() {
                var t = e.apply(this, arguments);
                return window.dispatchEvent(new CustomEvent("pushState")), window.dispatchEvent(new CustomEvent("locationchange")), t
            }), history.replaceState = function(e) {
                return function() {
                    var t = e.apply(this, arguments);
                    return window.dispatchEvent(new CustomEvent("replaceState")), window.dispatchEvent(new CustomEvent("locationchange")), t
                }
            }(history.replaceState), window.addEventListener("popstate", (function() {
                window.dispatchEvent(new CustomEvent("locationchange"))
            }))
        }
    }
    function Hl(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = Si(),
            r = lr({
                theme: n,
                name: "PwzrUseMediaQuery",
                props: {}
            });
        var i = "function" == typeof e ? e(n) : e;
        i = i.replace(/^@media( ?)/m, "");
        var o = "undefined" != typeof window && void 0 !== window.matchMedia,
            a = ft({}, r, {}, t),
            s = a.defaultMatches,
            l = void 0 !== s && s,
            u = a.matchMedia,
            c = void 0 === u ? o ? window.matchMedia : null : u,
            d = a.noSsr,
            p = void 0 !== d && d,
            f = a.ssrMatchMedia,
            h = void 0 === f ? null : f,
            m = lt.useState((function() {
                return p && o ? c(i).matches : h ? h(i).matches : l
            })),
            v = m[0],
            g = m[1];
        return lt.useEffect((function() {
            var e = !0;
            if (o) {
                var t = c(i),
                    n = function() {
                        e && g(t.matches)
                    };
                return n(), t.addListener(n), function() {
                    e = !1, t.removeListener(n)
                }
            }
        }), [i, c, o]), v
    }
    var jl = {},
        $l = Aa;
    Object.defineProperty(jl, "__esModule", {
        value: !0
    });
    var Vl = void 0;
    jl.default = Vl;
    var ql = $l(qa),
        Ul = {},
        Gl = Aa;
    Object.defineProperty(Ul, "__esModule", {
        value: !0
    });
    var Zl = void 0;
    Ul.default = Zl, Zl = (0, Gl(Ia).default)(), Ul.default = Zl;
    var Kl = $l(Ul);
    Vl = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return da(e, (0, ql.default)({
            defaultTheme: Kl.default
        }, t))
    }, jl.default = Vl;
    var Yl = t(jl),
        Xl = {},
        Jl = Aa;
    Object.defineProperty(Xl, "__esModule", {
        value: !0
    });
    var Ql = function() {
        return Si() || eu.default
    };
    Xl.default = Ql;
    var eu = Jl(Ul);
    var tu = t(Xl);
    function nu(e, t) {
        return Oa(e, ft({
            defaultTheme: Ma
        }, t))
    }
    function ru(e, t) {
        "function" == typeof e ? e(t) : e && (e.current = t)
    }
    function iu(e, t) {
        return lt.useMemo((function() {
            return null == e && null == t ? null : function(n) {
                ru(e, n), ru(t, n)
            }
        }), [e, t])
    }
    var ou = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect;
    function au(e) {
        var t = lt.useRef(e);
        return ou((function() {
            t.current = e
        })), lt.useCallback((function() {
            return t.current.apply(void 0, arguments)
        }), [])
    }
    var su = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect;
    function lu(e) {
        var t = e.children,
            n = e.defer,
            r = void 0 !== n && n,
            i = e.fallback,
            o = void 0 === i ? null : i,
            a = lt.useState(!1),
            s = a[0],
            l = a[1];
        return su((function() {
            r || l(!0)
        }), [r]), lt.useEffect((function() {
            r && l(!0)
        }), [r]), lt.createElement(lt.Fragment, null, s ? t : o)
    }
    var uu = !0,
        cu = !1,
        du = null,
        pu = {
            text: !0,
            search: !0,
            url: !0,
            tel: !0,
            email: !0,
            password: !0,
            number: !0,
            date: !0,
            month: !0,
            week: !0,
            time: !0,
            datetime: !0,
            "datetime-local": !0
        };
    function fu(e) {
        e.metaKey || e.altKey || e.ctrlKey || (uu = !0)
    }
    function hu() {
        uu = !1
    }
    function mu() {
        "hidden" === this.visibilityState && cu && (uu = !0)
    }
    function vu(e) {
        var t,
            n,
            r,
            i = e.target;
        try {
            return i.matches(":focus-visible")
        } catch (e) {}
        return uu || (n = (t = i).type, !("INPUT" !== (r = t.tagName) || !pu[n] || t.readOnly) || "TEXTAREA" === r && !t.readOnly || !!t.isContentEditable)
    }
    function gu() {
        cu = !0, window.clearTimeout(du), du = window.setTimeout((function() {
            cu = !1
        }), 100)
    }
    function yu() {
        return {
            isFocusVisible: vu,
            onBlurVisible: gu,
            ref: lt.useCallback((function(e) {
                var t,
                    n = lt.findDOMNode(e);
                null != n && ((t = n.ownerDocument).addEventListener("keydown", fu, !0), t.addEventListener("mousedown", hu, !0), t.addEventListener("pointerdown", hu, !0), t.addEventListener("touchstart", hu, !0), t.addEventListener("visibilitychange", mu, !0))
            }), [])
        }
    }
    var bu = lt.createContext(null);
    function wu(e, t) {
        var n = Object.create(null);
        return e && Me.map(e, (function(e) {
            return e
        })).forEach((function(e) {
            n[e.key] = function(e) {
                return t && nt(e) ? t(e) : e
            }(e)
        })), n
    }
    function xu(e, t, n) {
        return null != n[t] ? n[t] : e.props[t]
    }
    function _u(e, t, n) {
        var r = wu(e.children),
            i = function(e, t) {
                function n(n) {
                    return n in t ? t[n] : e[n]
                }
                e = e || {}, t = t || {};
                var r,
                    i = Object.create(null),
                    o = [];
                for (var a in e)
                    a in t ? o.length && (i[a] = o, o = []) : o.push(a);
                var s = {};
                for (var l in t) {
                    if (i[l])
                        for (r = 0; r < i[l].length; r++) {
                            var u = i[l][r];
                            s[i[l][r]] = n(u)
                        }
                    s[l] = n(l)
                }
                for (r = 0; r < o.length; r++)
                    s[o[r]] = n(o[r]);
                return s
            }(t, r);
        return Object.keys(i).forEach((function(o) {
            var a = i[o];
            if (nt(a)) {
                var s = o in t,
                    l = o in r,
                    u = t[o],
                    c = nt(u) && !u.props.in;
                !l || s && !c ? l || !s || c ? l && s && nt(u) && (i[o] = rt(a, {
                    onExited: n.bind(null, a),
                    in: u.props.in,
                    exit: xu(a, "exit", e),
                    enter: xu(a, "enter", e)
                })) : i[o] = rt(a, {
                    in: !1
                }) : i[o] = rt(a, {
                    onExited: n.bind(null, a),
                    in: !0,
                    exit: xu(a, "exit", e),
                    enter: xu(a, "enter", e)
                })
            }
        })), i
    }
    var Cu = Object.values || function(e) {
            return Object.keys(e).map((function(t) {
                return e[t]
            }))
        },
        Eu = function(e) {
            function t(t, n) {
                var r,
                    i = (r = e.call(this, t, n) || this).handleExited.bind(hr(hr(r)));
                return r.state = {
                    contextValue: {
                        isMounting: !0
                    },
                    handleExited: i,
                    firstRender: !0
                }, r
            }
            fr(t, e);
            var n = t.prototype;
            return n.componentDidMount = function() {
                this.mounted = !0, this.setState({
                    contextValue: {
                        isMounting: !1
                    }
                })
            }, n.componentWillUnmount = function() {
                this.mounted = !1
            }, t.getDerivedStateFromProps = function(e, t) {
                var n,
                    r,
                    i = t.children,
                    o = t.handleExited;
                return {
                    children: t.firstRender ? (n = e, r = o, wu(n.children, (function(e) {
                        return rt(e, {
                            onExited: r.bind(null, e),
                            in: !0,
                            appear: xu(e, "appear", n),
                            enter: xu(e, "enter", n),
                            exit: xu(e, "exit", n)
                        })
                    }))) : _u(e, i, o),
                    firstRender: !1
                }
            }, n.handleExited = function(e, t) {
                var n = wu(this.props.children);
                e.key in n || (e.props.onExited && e.props.onExited(t), this.mounted && this.setState((function(t) {
                    var n = ft({}, t.children);
                    return delete n[e.key], {
                        children: n
                    }
                })))
            }, n.render = function() {
                var e = this.props,
                    t = e.component,
                    n = e.childFactory,
                    r = ct(e, ["component", "childFactory"]),
                    i = this.state.contextValue,
                    o = Cu(this.state.children).map(n);
                return delete r.appear, delete r.enter, delete r.exit, null === t ? lt.createElement(bu.Provider, {
                    value: i
                }, o) : lt.createElement(bu.Provider, {
                    value: i
                }, lt.createElement(t, r, o))
            }, t
        }(lt.Component);
    Eu.propTypes = {}, Eu.defaultProps = {
        component: "div",
        childFactory: function(e) {
            return e
        }
    };
    var Su = !1,
        ku = "unmounted",
        Tu = "exited",
        Ou = "entering",
        Mu = "entered",
        Ru = "exiting",
        Pu = function(e) {
            function t(t, n) {
                var r;
                r = e.call(this, t, n) || this;
                var i,
                    o = n && !n.isMounting ? t.enter : t.appear;
                return r.appearStatus = null, t.in ? o ? (i = Tu, r.appearStatus = Ou) : i = Mu : i = t.unmountOnExit || t.mountOnEnter ? ku : Tu, r.state = {
                    status: i
                }, r.nextCallback = null, r
            }
            fr(t, e), t.getDerivedStateFromProps = function(e, t) {
                return e.in && t.status === ku ? {
                    status: Tu
                } : null
            };
            var n = t.prototype;
            return n.componentDidMount = function() {
                this.updateStatus(!0, this.appearStatus)
            }, n.componentDidUpdate = function(e) {
                var t = null;
                if (e !== this.props) {
                    var n = this.state.status;
                    this.props.in ? n !== Ou && n !== Mu && (t = Ou) : n !== Ou && n !== Mu || (t = Ru)
                }
                this.updateStatus(!1, t)
            }, n.componentWillUnmount = function() {
                this.cancelNextCallback()
            }, n.getTimeouts = function() {
                var e,
                    t,
                    n,
                    r = this.props.timeout;
                return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
                    exit: e,
                    enter: t,
                    appear: n
                }
            }, n.updateStatus = function(e, t) {
                if (void 0 === e && (e = !1), null !== t) {
                    this.cancelNextCallback();
                    var n = lt.findDOMNode(this);
                    t === Ou ? this.performEnter(n, e) : this.performExit(n)
                } else
                    this.props.unmountOnExit && this.state.status === Tu && this.setState({
                        status: ku
                    })
            }, n.performEnter = function(e, t) {
                var n = this,
                    r = this.props.enter,
                    i = this.context ? this.context.isMounting : t,
                    o = this.getTimeouts(),
                    a = i ? o.appear : o.enter;
                !t && !r || Su ? this.safeSetState({
                    status: Mu
                }, (function() {
                    n.props.onEntered(e)
                })) : (this.props.onEnter(e, i), this.safeSetState({
                    status: Ou
                }, (function() {
                    n.props.onEntering(e, i), n.onTransitionEnd(e, a, (function() {
                        n.safeSetState({
                            status: Mu
                        }, (function() {
                            n.props.onEntered(e, i)
                        }))
                    }))
                })))
            }, n.performExit = function(e) {
                var t = this,
                    n = this.props.exit,
                    r = this.getTimeouts();
                n && !Su ? (this.props.onExit(e), this.safeSetState({
                    status: Ru
                }, (function() {
                    t.props.onExiting(e), t.onTransitionEnd(e, r.exit, (function() {
                        t.safeSetState({
                            status: Tu
                        }, (function() {
                            t.props.onExited(e)
                        }))
                    }))
                }))) : this.safeSetState({
                    status: Tu
                }, (function() {
                    t.props.onExited(e)
                }))
            }, n.cancelNextCallback = function() {
                null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null)
            }, n.safeSetState = function(e, t) {
                t = this.setNextCallback(t), this.setState(e, t)
            }, n.setNextCallback = function(e) {
                var t = this,
                    n = !0;
                return this.nextCallback = function(r) {
                    n && (n = !1, t.nextCallback = null, e(r))
                }, this.nextCallback.cancel = function() {
                    n = !1
                }, this.nextCallback
            }, n.onTransitionEnd = function(e, t, n) {
                this.setNextCallback(n);
                var r = null == t && !this.props.addEndListener;
                e && !r ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback), null != t && setTimeout(this.nextCallback, t)) : setTimeout(this.nextCallback, 0)
            }, n.render = function() {
                var e = this.state.status;
                if (e === ku)
                    return null;
                var t = this.props,
                    n = t.children,
                    r = ct(t, ["children"]);
                if (delete r.in, delete r.mountOnEnter, delete r.unmountOnExit, delete r.appear, delete r.enter, delete r.exit, delete r.timeout, delete r.addEndListener, delete r.onEnter, delete r.onEntering, delete r.onEntered, delete r.onExit, delete r.onExiting, delete r.onExited, "function" == typeof n)
                    return lt.createElement(bu.Provider, {
                        value: null
                    }, n(e, r));
                var i = lt.Children.only(n);
                return lt.createElement(bu.Provider, {
                    value: null
                }, lt.cloneElement(i, r))
            }, t
        }(lt.Component);
    function Au() {}
    Pu.contextType = bu, Pu.propTypes = {}, Pu.defaultProps = {
        in: !1,
        mountOnEnter: !1,
        unmountOnExit: !1,
        appear: !1,
        enter: !0,
        exit: !0,
        onEnter: Au,
        onEntering: Au,
        onEntered: Au,
        onExit: Au,
        onExiting: Au,
        onExited: Au
    }, Pu.UNMOUNTED = 0, Pu.EXITED = 1, Pu.ENTERING = 2, Pu.ENTERED = 3, Pu.EXITING = 4;
    var Iu = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect;
    function zu(e) {
        var t = e.classes,
            n = e.pulsate,
            r = void 0 !== n && n,
            i = e.rippleX,
            o = e.rippleY,
            a = e.rippleSize,
            s = e.in,
            l = e.onExited,
            u = void 0 === l ? function() {} : l,
            c = e.timeout,
            d = lt.useState(!1),
            p = d[0],
            f = d[1],
            h = fa(t.ripple, t.rippleVisible, r && t.ripplePulsate),
            m = {
                width: a,
                height: a,
                top: -a / 2 + o,
                left: -a / 2 + i
            },
            v = fa(t.child, p && t.childLeaving, r && t.childPulsate),
            g = au(u);
        return Iu((function() {
            if (!s) {
                f(!0);
                var e = setTimeout(g, c);
                return function() {
                    clearTimeout(e)
                }
            }
        }), [g, s, c]), lt.createElement("span", {
            className: h,
            style: m
        }, lt.createElement("span", {
            className: v
        }))
    }
    var Lu = lt.forwardRef((function(e, t) {
            var n = e.center,
                r = void 0 !== n && n,
                i = e.classes,
                o = e.className,
                a = dt(e, ["center", "classes", "className"]),
                s = lt.useState([]),
                l = s[0],
                u = s[1],
                c = lt.useRef(0),
                d = lt.useRef(null);
            lt.useEffect((function() {
                d.current && (d.current(), d.current = null)
            }), [l]);
            var p = lt.useRef(!1),
                f = lt.useRef(null),
                h = lt.useRef(null),
                m = lt.useRef(null);
            lt.useEffect((function() {
                return function() {
                    clearTimeout(f.current)
                }
            }), []);
            var v = lt.useCallback((function(e) {
                    var t = e.pulsate,
                        n = e.rippleX,
                        r = e.rippleY,
                        o = e.rippleSize,
                        a = e.cb;
                    u((function(e) {
                        return [].concat(to(e), [lt.createElement(zu, {
                            key: c.current,
                            classes: i,
                            timeout: 550,
                            pulsate: t,
                            rippleX: n,
                            rippleY: r,
                            rippleSize: o
                        })])
                    })), c.current += 1, d.current = a
                }), [i]),
                g = lt.useCallback((function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        n = arguments.length > 2 ? arguments[2] : void 0,
                        i = t.pulsate,
                        o = void 0 !== i && i,
                        a = t.center,
                        s = void 0 === a ? r || t.pulsate : a,
                        l = t.fakeElement,
                        u = void 0 !== l && l;
                    if ("mousedown" === e.type && p.current)
                        p.current = !1;
                    else {
                        "touchstart" === e.type && (p.current = !0);
                        var c,
                            d,
                            g,
                            y = u ? null : m.current,
                            b = y ? y.getBoundingClientRect() : {
                                width: 0,
                                height: 0,
                                left: 0,
                                top: 0
                            };
                        if (s || 0 === e.clientX && 0 === e.clientY || !e.clientX && !e.touches)
                            c = Math.round(b.width / 2), d = Math.round(b.height / 2);
                        else {
                            var w = e.clientX ? e.clientX : e.touches[0].clientX,
                                x = e.clientY ? e.clientY : e.touches[0].clientY;
                            c = Math.round(w - b.left), d = Math.round(x - b.top)
                        }
                        if (s)
                            (g = Math.sqrt((2 * Math.pow(b.width, 2) + Math.pow(b.height, 2)) / 3)) % 2 == 0 && (g += 1);
                        else {
                            var _ = 2 * Math.max(Math.abs((y ? y.clientWidth : 0) - c), c) + 2,
                                C = 2 * Math.max(Math.abs((y ? y.clientHeight : 0) - d), d) + 2;
                            g = Math.sqrt(Math.pow(_, 2) + Math.pow(C, 2))
                        }
                        e.touches ? null === h.current && (h.current = function() {
                            v({
                                pulsate: o,
                                rippleX: c,
                                rippleY: d,
                                rippleSize: g,
                                cb: n
                            })
                        }, f.current = setTimeout((function() {
                            h.current && (h.current(), h.current = null)
                        }), 80)) : v({
                            pulsate: o,
                            rippleX: c,
                            rippleY: d,
                            rippleSize: g,
                            cb: n
                        })
                    }
                }), [r, v]),
                y = lt.useCallback((function() {
                    g({}, {
                        pulsate: !0
                    })
                }), [g]),
                b = lt.useCallback((function(e, t) {
                    if (clearTimeout(f.current), "touchend" === e.type && h.current)
                        return e.persist(), h.current(), h.current = null, void (f.current = setTimeout((function() {
                            b(e, t)
                        })));
                    h.current = null, u((function(e) {
                        return e.length > 0 ? e.slice(1) : e
                    })), d.current = t
                }), []);
            return lt.useImperativeHandle(t, (function() {
                return {
                    pulsate: y,
                    start: g,
                    stop: b
                }
            }), [y, g, b]), lt.createElement("span", ft({
                className: fa(i.root, o),
                ref: m
            }, a), lt.createElement(Eu, {
                component: null,
                exit: !0
            }, l))
        })),
        Du = nu((function(e) {
            return {
                root: {
                    overflow: "hidden",
                    pointerEvents: "none",
                    position: "absolute",
                    zIndex: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    borderRadius: "inherit"
                },
                ripple: {
                    opacity: 0,
                    position: "absolute"
                },
                rippleVisible: {
                    opacity: .3,
                    transform: "scale(1)",
                    animation: "$enter ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)
                },
                ripplePulsate: {
                    animationDuration: "".concat(e.transitions.duration.shorter, "ms")
                },
                child: {
                    opacity: 1,
                    display: "block",
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    backgroundColor: "currentColor"
                },
                childLeaving: {
                    opacity: 0,
                    animation: "$exit ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)
                },
                childPulsate: {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    animation: "$pulsate 2500ms ".concat(e.transitions.easing.easeInOut, " 200ms infinite")
                },
                "@keyframes enter": {
                    "0%": {
                        transform: "scale(0)",
                        opacity: .1
                    },
                    "100%": {
                        transform: "scale(1)",
                        opacity: .3
                    }
                },
                "@keyframes exit": {
                    "0%": {
                        opacity: 1
                    },
                    "100%": {
                        opacity: 0
                    }
                },
                "@keyframes pulsate": {
                    "0%": {
                        transform: "scale(1)"
                    },
                    "50%": {
                        transform: "scale(0.92)"
                    },
                    "100%": {
                        transform: "scale(1)"
                    }
                }
            }
        }), {
            flip: !1,
            name: "PwzrTouchRipple"
        })(lt.memo(Lu)),
        Nu = lt.forwardRef((function(e, t) {
            var n = e.action,
                r = e.buttonRef,
                i = e.centerRipple,
                o = void 0 !== i && i,
                a = e.children,
                s = e.classes,
                l = e.className,
                u = e.component,
                c = void 0 === u ? "button" : u,
                d = e.disabled,
                p = void 0 !== d && d,
                f = e.disableRipple,
                h = void 0 !== f && f,
                m = e.disableTouchRipple,
                v = void 0 !== m && m,
                g = e.focusRipple,
                y = void 0 !== g && g,
                b = e.focusVisibleClassName,
                w = e.onBlur,
                x = e.onClick,
                _ = e.onFocus,
                C = e.onFocusVisible,
                E = e.onKeyDown,
                S = e.onKeyUp,
                k = e.onMouseDown,
                T = e.onMouseLeave,
                O = e.onMouseUp,
                M = e.onTouchEnd,
                R = e.onTouchMove,
                P = e.onTouchStart,
                A = e.onDragLeave,
                I = e.tabIndex,
                z = void 0 === I ? 0 : I,
                L = e.TouchRippleProps,
                D = e.type,
                N = void 0 === D ? "button" : D,
                B = dt(e, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]),
                F = lt.useRef(null);
            var W = lt.useRef(null),
                H = lt.useState(!1),
                j = H[0],
                $ = H[1];
            p && j && $(!1);
            var V = yu(),
                q = V.isFocusVisible,
                U = V.onBlurVisible,
                G = V.ref;
            function Z(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : v;
                return au((function(r) {
                    return t && t(r), !n && W.current && W.current[e](r), !0
                }))
            }
            lt.useImperativeHandle(n, (function() {
                return {
                    focusVisible: function() {
                        $(!0), F.current.focus()
                    }
                }
            }), []), lt.useEffect((function() {
                j && y && !h && W.current.pulsate()
            }), [h, y, j]);
            var K = Z("start", k),
                Y = Z("stop", A),
                X = Z("stop", O),
                J = Z("stop", (function(e) {
                    j && e.preventDefault(), T && T(e)
                })),
                Q = Z("start", P),
                ee = Z("stop", M),
                te = Z("stop", R),
                ne = Z("stop", (function(e) {
                    j && (U(e), $(!1)), w && w(e)
                }), !1),
                re = au((function(e) {
                    p || (F.current || (F.current = e.currentTarget), q(e) && ($(!0), C && C(e)), _ && _(e))
                })),
                ie = function() {
                    var e = lt.findDOMNode(F.current);
                    return c && "button" !== c && !("A" === e.tagName && e.href)
                },
                oe = lt.useRef(!1),
                ae = au((function(e) {
                    y && !oe.current && j && W.current && " " === e.key && (oe.current = !0, e.persist(), W.current.stop(e, (function() {
                        W.current.start(e)
                    }))), E && E(e), e.target === e.currentTarget && ie() && "Enter" === e.key && (e.preventDefault(), x && x(e))
                })),
                se = au((function(e) {
                    y && " " === e.key && W.current && j && !e.defaultPrevented && (oe.current = !1, e.persist(), W.current.stop(e, (function() {
                        W.current.pulsate(e)
                    }))), S && S(e), e.target === e.currentTarget && ie() && " " === e.key && !e.defaultPrevented && (e.preventDefault(), x && x(e))
                })),
                le = c;
            "button" === le && B.href && (le = "a");
            var ue = {};
            "button" === le ? (ue.type = N, ue.disabled = p) : ("a" === le && B.href || (ue.role = "button"), ue["aria-disabled"] = p);
            var ce = iu(r, t),
                de = iu(G, F),
                pe = iu(ce, de);
            return lt.createElement(le, ft({
                className: fa(s.root, l, j && [s.focusVisible, b], p && s.disabled),
                onBlur: ne,
                onClick: x,
                onFocus: re,
                onKeyDown: ae,
                onKeyUp: se,
                onMouseDown: K,
                onMouseLeave: J,
                onMouseUp: X,
                onDragLeave: Y,
                onTouchEnd: ee,
                onTouchMove: te,
                onTouchStart: Q,
                ref: pe,
                tabIndex: p ? -1 : z
            }, ue, B), a, h || p ? null : lt.createElement(lu, null, lt.createElement(Du, ft({
                ref: W,
                center: o
            }, L))))
        })),
        Bu = nu({
            root: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                WebkitTapHighlightColor: "transparent",
                backgroundColor: "transparent",
                outline: 0,
                border: 0,
                margin: 0,
                borderRadius: 0,
                padding: 0,
                cursor: "pointer",
                userSelect: "none",
                verticalAlign: "middle",
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                textDecoration: "none",
                color: "inherit",
                "&::-moz-focus-inner": {
                    borderStyle: "none"
                },
                "&$disabled": {
                    pointerEvents: "none",
                    cursor: "default"
                }
            },
            disabled: {},
            focusVisible: {}
        }, {
            name: "PwzrButtonBase"
        })(Nu);
    function Fu(e) {
        return e.charAt(0).toUpperCase() + e.slice(1)
    }
    var Wu = lt.forwardRef((function(e, t) {
            var n = e.edge,
                r = void 0 !== n && n,
                i = e.children,
                o = e.classes,
                a = e.className,
                s = e.color,
                l = void 0 === s ? "default" : s,
                u = e.disabled,
                c = void 0 !== u && u,
                d = e.disableFocusRipple,
                p = void 0 !== d && d,
                f = e.size,
                h = void 0 === f ? "medium" : f,
                m = dt(e, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
            return lt.createElement(Bu, ft({
                className: fa(o.root, a, "default" !== l && o["color".concat(Fu(l))], c && o.disabled, "small" === h && o["size".concat(Fu(h))], {
                    start: o.edgeStart,
                    end: o.edgeEnd
                }[r]),
                centerRipple: !0,
                focusRipple: !p,
                disabled: c,
                ref: t
            }, m), lt.createElement("span", {
                className: o.label
            }, i))
        })),
        Hu = nu((function(e) {
            return {
                root: {
                    textAlign: "center",
                    flex: "0 0 auto",
                    fontSize: e.typography.pxToRem(24),
                    padding: 12,
                    borderRadius: "50%",
                    overflow: "visible",
                    color: e.palette.action.active,
                    transition: e.transitions.create("background-color", {
                        duration: e.transitions.duration.shortest
                    }),
                    "&:hover": {
                        backgroundColor: $n(e.palette.action.active, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    },
                    "&$disabled": {
                        backgroundColor: "transparent",
                        color: e.palette.action.disabled
                    }
                },
                edgeStart: {
                    marginLeft: -12,
                    "$sizeSmall&": {
                        marginLeft: -3
                    }
                },
                edgeEnd: {
                    marginRight: -12,
                    "$sizeSmall&": {
                        marginRight: -3
                    }
                },
                colorInherit: {
                    color: "inherit"
                },
                colorPrimary: {
                    color: e.palette.primary.main,
                    "&:hover": {
                        backgroundColor: $n(e.palette.primary.main, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                },
                colorSecondary: {
                    color: e.palette.secondary.main,
                    "&:hover": {
                        backgroundColor: $n(e.palette.secondary.main, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                },
                disabled: {},
                sizeSmall: {
                    padding: 3,
                    fontSize: e.typography.pxToRem(18)
                },
                label: {
                    width: "100%",
                    display: "flex",
                    alignItems: "inherit",
                    justifyContent: "inherit"
                }
            }
        }), {
            name: "PwzrIconButton"
        })(Wu),
        ju = function() {
            if ("undefined" != typeof Map)
                return Map;
            function e(e, t) {
                var n = -1;
                return e.some((function(e, r) {
                    return e[0] === t && (n = r, !0)
                })), n
            }
            return function() {
                function t() {
                    this.__entries__ = []
                }
                return Object.defineProperty(t.prototype, "size", {
                    get: function() {
                        return this.__entries__.length
                    },
                    enumerable: !0,
                    configurable: !0
                }), t.prototype.get = function(t) {
                    var n = e(this.__entries__, t),
                        r = this.__entries__[n];
                    return r && r[1]
                }, t.prototype.set = function(t, n) {
                    var r = e(this.__entries__, t);
                    ~r ? this.__entries__[r][1] = n : this.__entries__.push([t, n])
                }, t.prototype.delete = function(t) {
                    var n = this.__entries__,
                        r = e(n, t);
                    ~r && n.splice(r, 1)
                }, t.prototype.has = function(t) {
                    return !!~e(this.__entries__, t)
                }, t.prototype.clear = function() {
                    this.__entries__.splice(0)
                }, t.prototype.forEach = function(e, t) {
                    void 0 === t && (t = null);
                    for (var n = 0, r = this.__entries__; n < r.length; n++) {
                        var i = r[n];
                        e.call(t, i[1], i[0])
                    }
                }, t
            }()
        }(),
        $u = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
        Vu = void 0 !== e && e.Math === Math ? e : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
        qu = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(Vu) : function(e) {
            return setTimeout((function() {
                return e(Date.now())
            }), 1e3 / 60)
        };
    var Uu = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
        Gu = "undefined" != typeof MutationObserver,
        Zu = function() {
            function e() {
                this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function(e, t) {
                    var n = !1,
                        r = !1,
                        i = 0;
                    function o() {
                        n && (n = !1, e()), r && s()
                    }
                    function a() {
                        qu(o)
                    }
                    function s() {
                        var e = Date.now();
                        if (n) {
                            if (e - i < 2)
                                return;
                            r = !0
                        } else
                            n = !0, r = !1, setTimeout(a, t);
                        i = e
                    }
                    return s
                }(this.refresh.bind(this), 20)
            }
            return e.prototype.addObserver = function(e) {
                ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_()
            }, e.prototype.removeObserver = function(e) {
                var t = this.observers_,
                    n = t.indexOf(e);
                ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_()
            }, e.prototype.refresh = function() {
                this.updateObservers_() && this.refresh()
            }, e.prototype.updateObservers_ = function() {
                var e = this.observers_.filter((function(e) {
                    return e.gatherActive(), e.hasActive()
                }));
                return e.forEach((function(e) {
                    return e.broadcastActive()
                })), e.length > 0
            }, e.prototype.connect_ = function() {
                $u && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Gu ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
                    attributes: !0,
                    childList: !0,
                    characterData: !0,
                    subtree: !0
                })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0)
            }, e.prototype.disconnect_ = function() {
                $u && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1)
            }, e.prototype.onTransitionEnd_ = function(e) {
                var t = e.propertyName,
                    n = void 0 === t ? "" : t;
                Uu.some((function(e) {
                    return !!~n.indexOf(e)
                })) && this.refresh()
            }, e.getInstance = function() {
                return this.instance_ || (this.instance_ = new e), this.instance_
            }, e.instance_ = null, e
        }(),
        Ku = function(e, t) {
            for (var n = 0, r = Object.keys(t); n < r.length; n++) {
                var i = r[n];
                Object.defineProperty(e, i, {
                    value: t[i],
                    enumerable: !1,
                    writable: !1,
                    configurable: !0
                })
            }
            return e
        },
        Yu = function(e) {
            return e && e.ownerDocument && e.ownerDocument.defaultView || Vu
        },
        Xu = rc(0, 0, 0, 0);
    function Ju(e) {
        return parseFloat(e) || 0
    }
    function Qu(e) {
        for (var t = [], n = 1; n < arguments.length; n++)
            t[n - 1] = arguments[n];
        return t.reduce((function(t, n) {
            return t + Ju(e["border-" + n + "-width"])
        }), 0)
    }
    function ec(e) {
        var t = e.clientWidth,
            n = e.clientHeight;
        if (!t && !n)
            return Xu;
        var r = Yu(e).getComputedStyle(e),
            i = function(e) {
                for (var t = {}, n = 0, r = ["top", "right", "bottom", "left"]; n < r.length; n++) {
                    var i = r[n],
                        o = e["padding-" + i];
                    t[i] = Ju(o)
                }
                return t
            }(r),
            o = i.left + i.right,
            a = i.top + i.bottom,
            s = Ju(r.width),
            l = Ju(r.height);
        if ("border-box" === r.boxSizing && (Math.round(s + o) !== t && (s -= Qu(r, "left", "right") + o), Math.round(l + a) !== n && (l -= Qu(r, "top", "bottom") + a)), !function(e) {
            return e === Yu(e).document.documentElement
        }(e)) {
            var u = Math.round(s + o) - t,
                c = Math.round(l + a) - n;
            1 !== Math.abs(u) && (s -= u), 1 !== Math.abs(c) && (l -= c)
        }
        return rc(i.left, i.top, s, l)
    }
    var tc = "undefined" != typeof SVGGraphicsElement ? function(e) {
        return e instanceof Yu(e).SVGGraphicsElement
    } : function(e) {
        return e instanceof Yu(e).SVGElement && "function" == typeof e.getBBox
    };
    function nc(e) {
        return $u ? tc(e) ? function(e) {
            var t = e.getBBox();
            return rc(0, 0, t.width, t.height)
        }(e) : ec(e) : Xu
    }
    function rc(e, t, n, r) {
        return {
            x: e,
            y: t,
            width: n,
            height: r
        }
    }
    var ic = function() {
            function e(e) {
                this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = rc(0, 0, 0, 0), this.target = e
            }
            return e.prototype.isActive = function() {
                var e = nc(this.target);
                return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight
            }, e.prototype.broadcastRect = function() {
                var e = this.contentRect_;
                return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e
            }, e
        }(),
        oc = function(e, t) {
            var n,
                r,
                i,
                o,
                a,
                s,
                l,
                u = (r = (n = t).x, i = n.y, o = n.width, a = n.height, s = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, l = Object.create(s.prototype), Ku(l, {
                    x: r,
                    y: i,
                    width: o,
                    height: a,
                    top: i,
                    right: r + o,
                    bottom: a + i,
                    left: r
                }), l);
            Ku(this, {
                target: e,
                contentRect: u
            })
        },
        ac = function() {
            function e(e, t, n) {
                if (this.activeObservations_ = [], this.observations_ = new ju, "function" != typeof e)
                    throw new TypeError("The callback provided as parameter 1 is not a function.");
                this.callback_ = e, this.controller_ = t, this.callbackCtx_ = n
            }
            return e.prototype.observe = function(e) {
                if (!arguments.length)
                    throw new TypeError("1 argument required, but only 0 present.");
                if ("undefined" != typeof Element && Element instanceof Object) {
                    if (!(e instanceof Yu(e).Element))
                        throw new TypeError('parameter 1 is not of type "Element".');
                    var t = this.observations_;
                    t.has(e) || (t.set(e, new ic(e)), this.controller_.addObserver(this), this.controller_.refresh())
                }
            }, e.prototype.unobserve = function(e) {
                if (!arguments.length)
                    throw new TypeError("1 argument required, but only 0 present.");
                if ("undefined" != typeof Element && Element instanceof Object) {
                    if (!(e instanceof Yu(e).Element))
                        throw new TypeError('parameter 1 is not of type "Element".');
                    var t = this.observations_;
                    t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this))
                }
            }, e.prototype.disconnect = function() {
                this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this)
            }, e.prototype.gatherActive = function() {
                var e = this;
                this.clearActive(), this.observations_.forEach((function(t) {
                    t.isActive() && e.activeObservations_.push(t)
                }))
            }, e.prototype.broadcastActive = function() {
                if (this.hasActive()) {
                    var e = this.callbackCtx_,
                        t = this.activeObservations_.map((function(e) {
                            return new oc(e.target, e.broadcastRect())
                        }));
                    this.callback_.call(e, t, e), this.clearActive()
                }
            }, e.prototype.clearActive = function() {
                this.activeObservations_.splice(0)
            }, e.prototype.hasActive = function() {
                return this.activeObservations_.length > 0
            }, e
        }(),
        sc = "undefined" != typeof WeakMap ? new WeakMap : new ju,
        lc = function e(t) {
            if (!(this instanceof e))
                throw new TypeError("Cannot call a class as a function.");
            if (!arguments.length)
                throw new TypeError("1 argument required, but only 0 present.");
            var n = Zu.getInstance(),
                r = new ac(t, n, this);
            sc.set(this, r)
        };
    ["observe", "unobserve", "disconnect"].forEach((function(e) {
        lc.prototype[e] = function() {
            var t;
            return (t = sc.get(this))[e].apply(t, arguments)
        }
    }));
    var uc = void 0 !== Vu.ResizeObserver ? Vu.ResizeObserver : lc;
    function cc(e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t)
    }
    var dc = "object" == typeof e && e && e.Object === Object && e,
        pc = "object" == typeof self && self && self.Object === Object && self,
        fc = dc || pc || Function("return this")(),
        hc = function() {
            return fc.Date.now()
        },
        mc = fc.Symbol,
        vc = Object.prototype,
        gc = vc.hasOwnProperty,
        yc = vc.toString,
        bc = mc ? mc.toStringTag : void 0;
    var wc = Object.prototype.toString;
    var xc = mc ? mc.toStringTag : void 0;
    function _c(e) {
        return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : xc && xc in Object(e) ? function(e) {
            var t = gc.call(e, bc),
                n = e[bc];
            try {
                e[bc] = void 0;
                var r = !0
            } catch (e) {}
            var i = yc.call(e);
            return r && (t ? e[bc] = n : delete e[bc]), i
        }(e) : function(e) {
            return wc.call(e)
        }(e)
    }
    var Cc = /^\s+|\s+$/g,
        Ec = /^[-+]0x[0-9a-f]+$/i,
        Sc = /^0b[01]+$/i,
        kc = /^0o[0-7]+$/i,
        Tc = parseInt;
    function Oc(e) {
        if ("number" == typeof e)
            return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                    return null != e && "object" == typeof e
                }(e) && "[object Symbol]" == _c(e)
        }(e))
            return NaN;
        if (cc(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = cc(t) ? t + "" : t
        }
        if ("string" != typeof e)
            return 0 === e ? e : +e;
        e = e.replace(Cc, "");
        var n = Sc.test(e);
        return n || kc.test(e) ? Tc(e.slice(2), n ? 2 : 8) : Ec.test(e) ? NaN : +e
    }
    var Mc = Math.max,
        Rc = Math.min;
    function Pc(e, t, n) {
        var r,
            i,
            o,
            a,
            s,
            l,
            u = 0,
            c = !1,
            d = !1,
            p = !0;
        if ("function" != typeof e)
            throw new TypeError("Expected a function");
        function f(t) {
            var n = r,
                o = i;
            return r = i = void 0, u = t, a = e.apply(o, n)
        }
        function h(e) {
            return u = e, s = setTimeout(v, t), c ? f(e) : a
        }
        function m(e) {
            var n = e - l;
            return void 0 === l || n >= t || n < 0 || d && e - u >= o
        }
        function v() {
            var e = hc();
            if (m(e))
                return g(e);
            s = setTimeout(v, function(e) {
                var n = t - (e - l);
                return d ? Rc(n, o - (e - u)) : n
            }(e))
        }
        function g(e) {
            return s = void 0, p && r ? f(e) : (r = i = void 0, a)
        }
        function y() {
            var e = hc(),
                n = m(e);
            if (r = arguments, i = this, l = e, n) {
                if (void 0 === s)
                    return h(l);
                if (d)
                    return clearTimeout(s), s = setTimeout(v, t), f(l)
            }
            return void 0 === s && (s = setTimeout(v, t)), a
        }
        return t = Oc(t) || 0, cc(n) && (c = !!n.leading, o = (d = "maxWait" in n) ? Mc(Oc(n.maxWait) || 0, t) : o, p = "trailing" in n ? !!n.trailing : p), y.cancel = function() {
            void 0 !== s && clearTimeout(s), u = 0, r = l = i = s = void 0
        }, y.flush = function() {
            return void 0 === s ? a : g(hc())
        }, y
    }
    var Ac = {
            debounce: Pc,
            throttle: function(e, t, n) {
                var r = !0,
                    i = !0;
                if ("function" != typeof e)
                    throw new TypeError("Expected a function");
                return cc(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Pc(e, t, {
                    leading: r,
                    maxWait: t,
                    trailing: i
                })
            }
        },
        Ic = function(e) {
            return "function" == typeof e
        },
        zc = function() {
            return "undefined" == typeof window
        };
    function Lc(e) {
        return (Lc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }
    function Dc(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function Nc(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    function Bc(e, t) {
        return !t || "object" !== Lc(t) && "function" != typeof t ? function(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }(e) : t
    }
    function Fc(e) {
        return (Fc = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }
    function Wc(e, t) {
        return (Wc = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }
    var Hc = function(e) {
        function t() {
            return Dc(this, t), Bc(this, Fc(t).apply(this, arguments))
        }
        var n,
            r,
            i;
        return function(e, t) {
            if ("function" != typeof t && null !== t)
                throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), t && Wc(e, t)
        }(t, e), n = t, (r = [{
            key: "render",
            value: function() {
                return this.props.children
            }
        }]) && Nc(n.prototype, r), i && Nc(n, i), t
    }(Ce);
    function jc(e) {
        return (jc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }
    function $c(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    function Vc(e) {
        return (Vc = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }
    function qc(e) {
        if (void 0 === e)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }
    function Uc(e, t) {
        return (Uc = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }
    function Gc(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }
    var Zc = function(e) {
        function t(e) {
            var n;
            !function(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }(this, t), n = function(e, t) {
                return !t || "object" !== jc(t) && "function" != typeof t ? qc(e) : t
            }(this, Vc(t).call(this, e)), Gc(qc(n), "cancelHandler", (function() {
                n.resizeHandler && n.resizeHandler.cancel && (n.resizeHandler.cancel(), n.resizeHandler = null)
            })), Gc(qc(n), "rafClean", (function() {
                n.raf && n.raf.cancel && (n.raf.cancel(), n.raf = null)
            })), Gc(qc(n), "toggleObserver", (function(e) {
                var t = n.getElement();
                t && n.resizeObserver[e] && n.resizeObserver[e](t)
            })), Gc(qc(n), "getElement", (function() {
                var e = n.props,
                    t = e.querySelector,
                    r = e.targetDomEl;
                if (!zc()) {
                    if (t)
                        return document.querySelector(t);
                    if (r && ((i = r) instanceof Element || i instanceof HTMLDocument))
                        return r;
                    var i,
                        o = n.element && ot(n.element);
                    if (o)
                        return o.parentElement
                }
            })), Gc(qc(n), "createUpdater", (function() {
                var e,
                    t,
                    r,
                    i;
                return n.rafClean(), n.raf = (e = function(e) {
                    var t = e.width,
                        r = e.height,
                        i = n.props.onResize;
                    Ic(i) && i(t, r), n.setState({
                        width: t,
                        height: r
                    })
                }, t = [], r = null, (i = function() {
                    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
                        i[o] = arguments[o];
                    t = i, r || (r = requestAnimationFrame((function() {
                        r = null, e.apply(void 0, t)
                    })))
                }).cancel = function() {
                    r && (cancelAnimationFrame(r), r = null)
                }, i), n.raf
            })), Gc(qc(n), "createResizeHandler", (function(e) {
                var t = n.state,
                    r = t.width,
                    i = t.height,
                    o = n.props,
                    a = o.handleWidth,
                    s = o.handleHeight;
                if (a || s) {
                    var l = n.createUpdater();
                    e.forEach((function(e) {
                        var t = e && e.contentRect || {},
                            o = t.width,
                            u = t.height,
                            c = a && r !== o || s && i !== u;
                        !n.skipOnMount && c && !zc() && l({
                            width: o,
                            height: u
                        }), n.skipOnMount = !1
                    }))
                }
            })), Gc(qc(n), "onRef", (function(e) {
                n.element = e
            })), Gc(qc(n), "getRenderType", (function() {
                var e = n.props,
                    t = e.render,
                    r = e.children;
                return Ic(t) ? "renderProp" : Ic(r) ? "childFunction" : nt(r) ? "child" : Array.isArray(r) ? "childArray" : "parent"
            })), Gc(qc(n), "getTargetComponent", (function() {
                var e = n.props,
                    t = e.render,
                    r = e.children,
                    i = e.nodeType,
                    o = n.state,
                    a = {
                        width: o.width,
                        height: o.height
                    };
                switch (n.getRenderType()) {
                case "renderProp":
                    return rt(t(a), {
                        key: "resize-detector"
                    });
                case "childFunction":
                    return rt(r(a));
                case "child":
                    return rt(r, a);
                case "childArray":
                    return r.map((function(e) {
                        return !!e && rt(e, a)
                    }));
                default:
                    return V().createElement(i)
                }
            }));
            var r = e.skipOnMount,
                i = e.refreshMode,
                o = e.refreshRate,
                a = e.refreshOptions;
            n.state = {
                width: void 0,
                height: void 0
            }, n.skipOnMount = r, n.raf = null, n.element = null, n.unmounted = !1;
            var s = Ac[i];
            return n.resizeHandler = s ? s(n.createResizeHandler, o, a) : n.createResizeHandler, n.resizeObserver = new uc(n.resizeHandler), n
        }
        var n,
            r,
            i;
        return function(e, t) {
            if ("function" != typeof t && null !== t)
                throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), t && Uc(e, t)
        }(t, e), n = t, (r = [{
            key: "componentDidMount",
            value: function() {
                this.toggleObserver("observe")
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                this.toggleObserver("unobserve"), this.rafClean(), this.cancelHandler(), this.unmounted = !0
            }
        }, {
            key: "render",
            value: function() {
                return lt.createElement(Hc, {
                    ref: this.onRef
                }, this.getTargetComponent())
            }
        }]) && $c(n.prototype, r), i && $c(n, i), t
    }(Ce);
    Zc.propTypes = {
        handleWidth: kt.bool,
        handleHeight: kt.bool,
        skipOnMount: kt.bool,
        refreshRate: kt.number,
        refreshMode: kt.string,
        refreshOptions: kt.shape({
            leading: kt.bool,
            trailing: kt.bool
        }),
        querySelector: kt.string,
        targetDomEl: kt.any,
        onResize: kt.func,
        render: kt.func,
        children: kt.any,
        nodeType: kt.node
    }, Zc.defaultProps = {
        handleWidth: !1,
        handleHeight: !1,
        skipOnMount: !1,
        refreshRate: 1e3,
        refreshMode: void 0,
        refreshOptions: void 0,
        querySelector: null,
        targetDomEl: null,
        onResize: null,
        render: void 0,
        children: null,
        nodeType: "div"
    };
    var Kc = Zc,
        Yc = {},
        Xc = Aa;
    Object.defineProperty(Yc, "__esModule", {
        value: !0
    });
    var Jc = void 0;
    Yc.default = Jc;
    var Qc = Xc(f),
        ed = {},
        td = Aa;
    Object.defineProperty(ed, "__esModule", {
        value: !0
    });
    var nd = function(e, t) {
        var n = id.default.memo(id.default.forwardRef((function(t, n) {
            return id.default.createElement(ld.default, (0, rd.default)({
                ref: n
            }, t), e)
        })));
        0;
        return n.muiName = ld.default.muiName, n
    };
    ed.default = nd;
    var rd = td(qa),
        id = td(f),
        od = {},
        ad = lt.forwardRef((function(e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.color,
                a = void 0 === o ? "inherit" : o,
                s = e.component,
                l = void 0 === s ? "svg" : s,
                u = e.fontSize,
                c = void 0 === u ? "default" : u,
                d = e.htmlColor,
                p = e.titleAccess,
                f = e.viewBox,
                h = void 0 === f ? "0 0 24 24" : f,
                m = dt(e, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
            return lt.createElement(l, ft({
                className: fa(r.root, i, "inherit" !== a && r["color".concat(Fu(a))], "default" !== c && r["fontSize".concat(Fu(c))]),
                focusable: "false",
                viewBox: h,
                color: d,
                "aria-hidden": p ? void 0 : "true",
                role: p ? "img" : "presentation",
                ref: t
            }, m), n, p ? lt.createElement("title", null, p) : null)
        }));
    ad.muiName = "SvgIcon";
    var sd = nu((function(e) {
        return {
            root: {
                userSelect: "none",
                width: "1em",
                height: "1em",
                display: "inline-block",
                fill: "currentColor",
                flexShrink: 0,
                fontSize: e.typography.pxToRem(24),
                transition: e.transitions.create("fill", {
                    duration: e.transitions.duration.shorter
                })
            },
            colorPrimary: {
                color: e.palette.primary.main
            },
            colorSecondary: {
                color: e.palette.secondary.main
            },
            colorAction: {
                color: e.palette.action.active
            },
            colorError: {
                color: e.palette.error.main
            },
            colorDisabled: {
                color: e.palette.action.disabled
            },
            fontSizeInherit: {
                fontSize: "inherit"
            },
            fontSizeSmall: {
                fontSize: e.typography.pxToRem(20)
            },
            fontSizeLarge: {
                fontSize: e.typography.pxToRem(35)
            }
        }
    }), {
        name: "PwzrSvgIcon"
    })(ad);
    r(od, "default", (function() {
        return sd
    })), n(od);
    var ld = td(od);
    Jc = (0, Xc(ed).default)(Qc.default.createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), "KeyboardArrowLeft"), Yc.default = Jc;
    var ud = t(Yc),
        cd = {},
        dd = Aa;
    Object.defineProperty(cd, "__esModule", {
        value: !0
    });
    var pd = void 0;
    cd.default = pd;
    var fd = dd(f);
    pd = (0, dd(ed).default)(fd.default.createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), "KeyboardArrowRight"), cd.default = pd;
    var hd = t(cd),
        md = {},
        vd = Aa;
    Object.defineProperty(md, "__esModule", {
        value: !0
    });
    var gd = void 0;
    md.default = gd;
    var yd = vd(f);
    gd = (0, vd(ed).default)(yd.default.createElement("path", {
        d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
    }), "KeyboardArrowDown"), md.default = gd;
    var bd = t(md),
        wd = {},
        xd = Aa;
    Object.defineProperty(wd, "__esModule", {
        value: !0
    });
    var _d = void 0;
    wd.default = _d;
    var Cd = xd(f);
    _d = (0, xd(ed).default)(Cd.default.createElement("path", {
        d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
    }), "KeyboardArrowUp"), wd.default = _d;
    var Ed = t(wd),
        Sd = {},
        kd = {},
        Td = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
    if (Td) {
        var Od = new Uint8Array(16);
        kd = function() {
            return Td(Od), Od
        }
    } else {
        var Md = new Array(16);
        kd = function() {
            for (var e, t = 0; t < 16; t++)
                0 == (3 & t) && (e = 4294967296 * Math.random()), Md[t] = e >>> ((3 & t) << 3) & 255;
            return Md
        }
    }
    for (var Rd, Pd = kd, Ad = [], Id = 0; Id < 256; ++Id)
        Ad[Id] = (Id + 256).toString(16).substr(1);
    var zd,
        Ld,
        Dd = Rd = function(e, t) {
            var n = t || 0,
                r = Ad;
            return [r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]]].join("")
        },
        Nd = 0,
        Bd = 0;
    var Fd = function(e, t, n) {
            var r = t && n || 0,
                i = t || [],
                o = (e = e || {}).node || zd,
                a = void 0 !== e.clockseq ? e.clockseq : Ld;
            if (null == o || null == a) {
                var s = Pd();
                null == o && (o = zd = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), null == a && (a = Ld = 16383 & (s[6] << 8 | s[7]))
            }
            var l = void 0 !== e.msecs ? e.msecs : (new Date).getTime(),
                u = void 0 !== e.nsecs ? e.nsecs : Bd + 1,
                c = l - Nd + (u - Bd) / 1e4;
            if (c < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (c < 0 || l > Nd) && void 0 === e.nsecs && (u = 0), u >= 1e4)
                throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
            Nd = l, Bd = u, Ld = a;
            var d = (1e4 * (268435455 & (l += 122192928e5)) + u) % 4294967296;
            i[r++] = d >>> 24 & 255, i[r++] = d >>> 16 & 255, i[r++] = d >>> 8 & 255, i[r++] = 255 & d;
            var p = l / 4294967296 * 1e4 & 268435455;
            i[r++] = p >>> 8 & 255, i[r++] = 255 & p, i[r++] = p >>> 24 & 15 | 16, i[r++] = p >>> 16 & 255, i[r++] = a >>> 8 | 128, i[r++] = 255 & a;
            for (var f = 0; f < 6; ++f)
                i[r + f] = o[f];
            return t || Dd(i)
        },
        Wd = kd,
        Hd = Rd;
    var jd = function(e, t, n) {
            var r = t && n || 0;
            "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
            var i = (e = e || {}).random || (e.rng || Wd)();
            if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t)
                for (var o = 0; o < 16; ++o)
                    t[r + o] = i[o];
            return t || Hd(i)
        },
        $d = jd;
    $d.v1 = Fd, $d.v4 = jd, Sd = $d;
    var Vd,
        qd,
        Ud = !1;
    function Gd(e) {
        return (Gd = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }
    function Zd(e) {
        return qd ? e instanceof HTMLElement : e && "object" === Gd(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
    }
    function Kd(e, t) {
        t.forEach((function(t) {
            e.classList.add(t)
        }))
    }
    function Yd(e, t) {
        t.forEach((function(t) {
            e.classList.remove(t)
        }))
    }
    function Xd() {
        return Ud || (Ud = !0, Vd = {}, qd = "object" === ("undefined" == typeof HTMLElement ? "undefined" : Gd(HTMLElement)), r(Vd, "isDOMElement", (function() {
            return Zd
        })), r(Vd, "addClasses", (function() {
            return Kd
        })), r(Vd, "removeClasses", (function() {
            return Yd
        }))), Vd
    }
    var Jd,
        Qd,
        ep = !1;
    function tp() {
        if (!document.querySelector(".pwzrdrift-base-styles")) {
            var e = document.createElement("style");
            e.type = "text/css", e.classList.add("pwzrdrift-base-styles"), e.appendChild(document.createTextNode(Qd));
            var t = document.head;
            t.insertBefore(e, t.firstChild)
        }
    }
    function np() {
        return ep || (ep = !0, Qd = ".pwzrdrift-bounding-box,.pwzrdrift-zoom-pane{position:absolute;pointer-events:none}@keyframes pwzrnoop{0%{zoom:1}}@-webkit-keyframes pwzrnoop{0%{zoom:1}}.pwzrdrift-zoom-pane.pwzrdrift-open{display:block}.pwzrdrift-zoom-pane.pwzrdrift-closing,.pwzrdrift-zoom-pane.pwzrdrift-opening{animation:pwzrnoop 1ms;-webkit-animation:pwzrnoop 1ms}.pwzrdrift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.pwzrdrift-zoom-pane-loader{display:none}.pwzrdrift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}", r(Jd = {}, "default", (function() {
            return tp
        }))), Jd
    }
    var rp,
        ip = !1;
    function op() {
        throw new Error("Missing parameter")
    }
    function ap() {
        return ip || (ip = !0, r(rp = {}, "default", (function() {
            return op
        }))), rp
    }
    var sp,
        lp,
        up = !1;
    function cp(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    function dp() {
        sp = {}, ap(), Xd(), lp = function() {
            function e(t) {
                !function(e, t) {
                    if (!(e instanceof t))
                        throw new TypeError("Cannot call a class as a function")
                }(this, e), this.isShowing = !1;
                var n = t.namespace,
                    r = void 0 === n ? null : n,
                    i = t.zoomFactor,
                    o = void 0 === i ? ap().default() : i,
                    a = t.containerEl,
                    s = void 0 === a ? ap().default() : a;
                this.settings = {
                    namespace: r,
                    zoomFactor: o,
                    containerEl: s
                }, this.openClasses = this._buildClasses("open"), this._buildElement()
            }
            var t,
                n,
                r;
            return t = e, (n = [{
                key: "_buildClasses",
                value: function(e) {
                    var t = ["pwzrdrift-".concat(e)],
                        n = this.settings.namespace;
                    return n && t.push("".concat(n, "-").concat(e)), t
                }
            }, {
                key: "_buildElement",
                value: function() {
                    this.el = document.createElement("div"), Xd().addClasses(this.el, this._buildClasses("bounding-box"))
                }
            }, {
                key: "show",
                value: function(e, t) {
                    this.isShowing = !0, this.settings.containerEl.appendChild(this.el);
                    var n = this.el.style;
                    n.width = "".concat(Math.round(e / this.settings.zoomFactor), "px"), n.height = "".concat(Math.round(t / this.settings.zoomFactor), "px"), Xd().addClasses(this.el, this.openClasses)
                }
            }, {
                key: "hide",
                value: function() {
                    this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = !1, Xd().removeClasses(this.el, this.openClasses)
                }
            }, {
                key: "setPosition",
                value: function(e, t, n) {
                    var r = window.pageXOffset,
                        i = window.pageYOffset,
                        o = n.left + e * n.width - this.el.clientWidth / 2 + r,
                        a = n.top + t * n.height - this.el.clientHeight / 2 + i;
                    o < n.left + r ? o = n.left + r : o + this.el.clientWidth > n.left + n.width + r && (o = n.left + n.width - this.el.clientWidth + r), a < n.top + i ? a = n.top + i : a + this.el.clientHeight > n.top + n.height + i && (a = n.top + n.height - this.el.clientHeight + i), this.el.style.left = "".concat(o, "px"), this.el.style.top = "".concat(a, "px")
                }
            }]) && cp(t.prototype, n), r && cp(t, r), e
        }(), r(sp, "default", (function() {
            return lp
        }))
    }
    function pp() {
        return up || (up = !0, dp()), sp
    }
    var fp,
        hp,
        mp = !1;
    function vp(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function gp(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    function yp() {
        fp = {}, ap(), pp(), hp = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                vp(this, e), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
                var n = t.el,
                    r = void 0 === n ? ap().default() : n,
                    i = t.zoomPane,
                    o = void 0 === i ? ap().default() : i,
                    a = t.sourceAttribute,
                    s = void 0 === a ? ap().default() : a,
                    l = t.handleTouch,
                    u = void 0 === l ? ap().default() : l,
                    c = t.onShow,
                    d = void 0 === c ? null : c,
                    p = t.onHide,
                    f = void 0 === p ? null : p,
                    h = t.hoverDelay,
                    m = void 0 === h ? 0 : h,
                    v = t.touchDelay,
                    g = void 0 === v ? 0 : v,
                    y = t.hoverBoundingBox,
                    b = void 0 === y ? ap().default() : y,
                    w = t.touchBoundingBox,
                    x = void 0 === w ? ap().default() : w,
                    _ = t.namespace,
                    C = void 0 === _ ? null : _,
                    E = t.zoomFactor,
                    S = void 0 === E ? ap().default() : E,
                    k = t.boundingBoxContainer,
                    T = void 0 === k ? ap().default() : k,
                    O = t.inlineContainer,
                    M = void 0 === O ? ap().default() : O;
                this.settings = {
                    el: r,
                    zoomPane: o,
                    sourceAttribute: s,
                    handleTouch: u,
                    onShow: d,
                    onHide: f,
                    hoverDelay: m,
                    touchDelay: g,
                    hoverBoundingBox: b,
                    touchBoundingBox: x,
                    namespace: C,
                    zoomFactor: S,
                    boundingBoxContainer: T,
                    inlineContainer: M
                }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new (pp().default)({
                    namespace: this.settings.namespace,
                    zoomFactor: this.settings.zoomFactor,
                    containerEl: this.settings.boundingBoxContainer
                })), this.enabled = !0, this._bindEvents()
            }
            var t,
                n,
                r;
            return t = e, (n = [{
                key: "_preventDefault",
                value: function(e) {
                    e.preventDefault()
                }
            }, {
                key: "_preventDefaultAllowTouchScroll",
                value: function(e) {
                    this.settings.touchDelay && this._isTouchEvent(e) && !this.isShowing || e.preventDefault()
                }
            }, {
                key: "_isTouchEvent",
                value: function(e) {
                    return !!e.touches
                }
            }, {
                key: "_bindEvents",
                value: function() {
                    this.settings.el.addEventListener("mouseenter", this._handleEntry, !1), this.settings.el.addEventListener("mouseleave", this._hide, !1), this.settings.el.addEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, !1), this.settings.el.addEventListener("touchend", this._hide, !1), this.settings.el.addEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, !1), this.settings.el.addEventListener("touchend", this._preventDefault, !1), this.settings.el.addEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_unbindEvents",
                value: function() {
                    this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1), this.settings.el.removeEventListener("mouseleave", this._hide, !1), this.settings.el.removeEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1), this.settings.el.removeEventListener("touchend", this._hide, !1), this.settings.el.removeEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault, !1), this.settings.el.removeEventListener("touchend", this._preventDefault, !1), this.settings.el.removeEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_handleEntry",
                value: function(e) {
                    this._preventDefaultAllowTouchScroll(e), this._lastMovement = e, "mouseenter" == e.type && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show()
                }
            }, {
                key: "_show",
                value: function() {
                    if (this.enabled) {
                        var e = this.settings.onShow;
                        if (e && "function" == typeof e && e(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement) {
                            var t = this._lastMovement.touches;
                            (t && this.settings.touchBoundingBox || !t && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight)
                        }
                        this._handleMovement()
                    }
                }
            }, {
                key: "_hide",
                value: function(e) {
                    e && this._preventDefaultAllowTouchScroll(e), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
                    var t = this.settings.onHide;
                    t && "function" == typeof t && t(), this.settings.zoomPane.hide()
                }
            }, {
                key: "_handleMovement",
                value: function(e) {
                    if (e)
                        this._preventDefaultAllowTouchScroll(e), this._lastMovement = e;
                    else {
                        if (!this._lastMovement)
                            return;
                        e = this._lastMovement
                    }
                    var t,
                        n;
                    if (e.touches) {
                        var r = e.touches[0];
                        t = r.clientX, n = r.clientY
                    } else
                        t = e.clientX, n = e.clientY;
                    var i = this.settings.el.getBoundingClientRect(),
                        o = t - i.left,
                        a = n - i.top,
                        s = o / this.settings.el.clientWidth,
                        l = a / this.settings.el.clientHeight,
                        u = this.settings.inlineContainer.getBoundingClientRect(),
                        c = {
                            left: i.left - u.left,
                            top: i.top - u.top,
                            width: i.width,
                            height: i.height
                        };
                    this.boundingBox && this.boundingBox.setPosition(s, l, c), this.settings.zoomPane.setPosition(s, l, c)
                }
            }, {
                key: "isShowing",
                get: function() {
                    return this.settings.zoomPane.isShowing
                }
            }]) && gp(t.prototype, n), r && gp(t, r), e
        }(), r(fp, "default", (function() {
            return hp
        }))
    }
    function bp() {
        return mp || (mp = !0, yp()), fp
    }
    var wp,
        xp,
        _p,
        Cp,
        Ep = !1;
    function Sp(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function kp(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    function Tp() {
        wp = {}, ap(), Xd(), xp = document.createElement("div").style, _p = "undefined" != typeof document && ("animation" in xp || "webkitAnimation" in xp), Cp = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                Sp(this, e), this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = !1;
                var n = t.container,
                    r = void 0 === n ? null : n,
                    i = t.zoomFactor,
                    o = void 0 === i ? ap().default() : i,
                    a = t.inline,
                    s = void 0 === a ? ap().default() : a,
                    l = t.namespace,
                    u = void 0 === l ? null : l,
                    c = t.showWhitespaceAtEdges,
                    d = void 0 === c ? ap().default() : c,
                    p = t.containInline,
                    f = void 0 === p ? ap().default() : p,
                    h = t.inlineOffsetX,
                    m = void 0 === h ? 0 : h,
                    v = t.inlineOffsetY,
                    g = void 0 === v ? 0 : v,
                    y = t.inlineContainer,
                    b = void 0 === y ? document.body : y;
                this.settings = {
                    container: r,
                    zoomFactor: o,
                    inline: s,
                    namespace: u,
                    showWhitespaceAtEdges: d,
                    containInline: f,
                    inlineOffsetX: m,
                    inlineOffsetY: g,
                    inlineContainer: b
                }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement()
            }
            var t,
                n,
                r;
            return t = e, (n = [{
                key: "_buildClasses",
                value: function(e) {
                    var t = ["pwzrdrift-".concat(e)],
                        n = this.settings.namespace;
                    return n && t.push("".concat(n, "-").concat(e)), t
                }
            }, {
                key: "_buildElement",
                value: function() {
                    this.el = document.createElement("div"), Xd().addClasses(this.el, this._buildClasses("zoom-pane"));
                    var e = document.createElement("div");
                    Xd().addClasses(e, this._buildClasses("zoom-pane-loader")), this.el.appendChild(e), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl)
                }
            }, {
                key: "_setImageURL",
                value: function(e) {
                    this.imgEl.setAttribute("src", e)
                }
            }, {
                key: "_setImageSize",
                value: function(e, t) {
                    this.imgEl.style.width = "".concat(e * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(t * this.settings.zoomFactor, "px"), this.imgEl.style.maxWidth = "none"
                }
            }, {
                key: "setPosition",
                value: function(e, t, n) {
                    var r = this.imgEl.offsetWidth,
                        i = this.imgEl.offsetHeight,
                        o = this.el.offsetWidth,
                        a = this.el.offsetHeight,
                        s = o / 2 - r * e,
                        l = a / 2 - i * t,
                        u = o - r,
                        c = a - i,
                        d = u > 0,
                        p = c > 0,
                        f = d ? u / 2 : 0,
                        h = p ? c / 2 : 0,
                        m = d ? u / 2 : u,
                        v = p ? c / 2 : c;
                    if (this.el.parentElement === this.settings.inlineContainer) {
                        var g = n.left + e * n.width - o / 2 + this.settings.inlineOffsetX + 0,
                            y = n.top + t * n.height - a / 2 + this.settings.inlineOffsetY + 0;
                        this.settings.containInline && (g < n.left + 0 ? g = n.left + 0 : g + o > n.left + n.width + 0 && (g = n.left + n.width - o + 0), y < n.top + 0 ? y = n.top + 0 : y + a > n.top + n.height + 0 && (y = n.top + n.height - a + 0)), "yes" === getComputedStyle(this.el).getPropertyValue("--magnify-width-full") && (g = 0), "yes" === getComputedStyle(this.el).getPropertyValue("--magnify-height-full") && (y = 0), this.el.style.left = "".concat(g, "px"), this.el.style.top = "".concat(y, "px")
                    }
                    this.settings.showWhitespaceAtEdges || (s > f ? s = f : s < m && (s = m), l > h ? l = h : l < v && (l = v)), this.imgEl.style.transform = "translate(".concat(s, "px, ").concat(l, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(s, "px, ").concat(l, "px)")
                }
            }, {
                key: "_removeListenersAndResetClasses",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), Xd().removeClasses(this.el, this.openClasses), Xd().removeClasses(this.el, this.closingClasses)
                }
            }, {
                key: "show",
                value: function(e, t, n) {
                    if (this._removeListenersAndResetClasses(), this.isShowing = !0, Xd().addClasses(this.el, this.openClasses), this.imgEl.getAttribute("src") != e) {
                        var r = this.el.querySelector(".pwzrdrift-zoom-pane-loader");
                        r && (r.style.display = "block"), Xd().addClasses(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad, !1), this._setImageURL(e)
                    }
                    this._setImageSize(t, n), this._isInline ? this._showInline() : this._showInContainer(), _p && (this.el.addEventListener("animationend", this._completeShow, !1), this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1), Xd().addClasses(this.el, this.openingClasses))
                }
            }, {
                key: "_showInline",
                value: function() {
                    this.settings.inlineContainer.appendChild(this.el), Xd().addClasses(this.el, this.inlineClasses)
                }
            }, {
                key: "_showInContainer",
                value: function() {
                    this.settings.container.appendChild(this.el)
                }
            }, {
                key: "hide",
                value: function() {
                    this._removeListenersAndResetClasses(), this.isShowing = !1, _p ? (this.el.addEventListener("animationend", this._completeHide, !1), this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1), Xd().addClasses(this.el, this.closingClasses)) : (Xd().removeClasses(this.el, this.openClasses), Xd().removeClasses(this.el, this.inlineClasses))
                }
            }, {
                key: "_completeShow",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), Xd().removeClasses(this.el, this.openingClasses)
                }
            }, {
                key: "_completeHide",
                value: function() {
                    this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), Xd().removeClasses(this.el, this.openClasses), Xd().removeClasses(this.el, this.closingClasses), Xd().removeClasses(this.el, this.inlineClasses), this.el.setAttribute("style", ""), this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el)
                }
            }, {
                key: "_handleLoad",
                value: function() {
                    var e = this.el.querySelector(".pwzrdrift-zoom-pane-loader");
                    e && (e.style.display = "none"), this.imgEl.removeEventListener("load", this._handleLoad, !1), Xd().removeClasses(this.el, this.loadingClasses)
                }
            }, {
                key: "_isInline",
                get: function() {
                    var e = this.settings.inline;
                    return !0 === e || "number" == typeof e && window.innerWidth <= e
                }
            }]) && kp(t.prototype, n), r && kp(t, r), e
        }(), r(wp, "default", (function() {
            return Cp
        }))
    }
    function Op() {
        return Ep || (Ep = !0, Tp()), wp
    }
    var Mp,
        Rp,
        Pp = !1;
    function Ap(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
    function Ip(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    function zp() {
        Mp = {}, Xd(), np(), bp(), Op(), Rp = function() {
            function e(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (Ap(this, e), this.VERSION = "1.4.0", this.triggerEl = t, this.destroy = this.destroy.bind(this), !Xd().isDOMElement(this.triggerEl))
                    throw new TypeError("`new Drift` requires a DOM element as its first argument.");
                var r = n.namespace || null,
                    i = n.showWhitespaceAtEdges || !1,
                    o = n.containInline || !1,
                    a = n.inlineOffsetX || 0,
                    s = n.inlineOffsetY || 0,
                    l = n.inlineContainer || document.body,
                    u = n.sourceAttribute || "data-zoom",
                    c = n.zoomFactor || 3,
                    d = void 0 === n.paneContainer ? document.body : n.paneContainer,
                    p = n.inlinePane || 375,
                    f = !("handleTouch" in n) || !!n.handleTouch,
                    h = n.onShow || null,
                    m = n.onHide || null,
                    v = !("injectBaseStyles" in n) || !!n.injectBaseStyles,
                    g = n.hoverDelay || 0,
                    y = n.touchDelay || 0,
                    b = n.hoverBoundingBox || !1,
                    w = n.touchBoundingBox || !1,
                    x = n.boundingBoxContainer || document.body;
                if (!0 !== p && !Xd().isDOMElement(d))
                    throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
                if (!Xd().isDOMElement(l))
                    throw new TypeError("`inlineContainer` must be a DOM element");
                this.settings = {
                    namespace: r,
                    showWhitespaceAtEdges: i,
                    containInline: o,
                    inlineOffsetX: a,
                    inlineOffsetY: s,
                    inlineContainer: l,
                    sourceAttribute: u,
                    zoomFactor: c,
                    paneContainer: d,
                    inlinePane: p,
                    handleTouch: f,
                    onShow: h,
                    onHide: m,
                    injectBaseStyles: v,
                    hoverDelay: g,
                    touchDelay: y,
                    hoverBoundingBox: b,
                    touchBoundingBox: w,
                    boundingBoxContainer: x
                }, this.settings.injectBaseStyles && np().default(), this._buildZoomPane(), this._buildTrigger()
            }
            var t,
                n,
                r;
            return t = e, (n = [{
                key: "_buildZoomPane",
                value: function() {
                    this.zoomPane = new (Op().default)({
                        container: this.settings.paneContainer,
                        zoomFactor: this.settings.zoomFactor,
                        showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                        containInline: this.settings.containInline,
                        inline: this.settings.inlinePane,
                        namespace: this.settings.namespace,
                        inlineOffsetX: this.settings.inlineOffsetX,
                        inlineOffsetY: this.settings.inlineOffsetY,
                        inlineContainer: this.settings.inlineContainer
                    })
                }
            }, {
                key: "_buildTrigger",
                value: function() {
                    this.trigger = new (bp().default)({
                        el: this.triggerEl,
                        zoomPane: this.zoomPane,
                        handleTouch: this.settings.handleTouch,
                        onShow: this.settings.onShow,
                        onHide: this.settings.onHide,
                        sourceAttribute: this.settings.sourceAttribute,
                        hoverDelay: this.settings.hoverDelay,
                        touchDelay: this.settings.touchDelay,
                        hoverBoundingBox: this.settings.hoverBoundingBox,
                        touchBoundingBox: this.settings.touchBoundingBox,
                        namespace: this.settings.namespace,
                        zoomFactor: this.settings.zoomFactor,
                        boundingBoxContainer: this.settings.boundingBoxContainer,
                        inlineContainer: this.settings.inlineContainer
                    })
                }
            }, {
                key: "setZoomImageURL",
                value: function(e) {
                    this.zoomPane._setImageURL(e)
                }
            }, {
                key: "disable",
                value: function() {
                    this.trigger.enabled = !1
                }
            }, {
                key: "enable",
                value: function() {
                    this.trigger.enabled = !0
                }
            }, {
                key: "destroy",
                value: function() {
                    this.trigger._hide(), this.trigger._unbindEvents()
                }
            }, {
                key: "isShowing",
                get: function() {
                    return this.zoomPane.isShowing
                }
            }, {
                key: "zoomFactor",
                get: function() {
                    return this.settings.zoomFactor
                },
                set: function(e) {
                    this.settings.zoomFactor = e, this.zoomPane.settings.zoomFactor = e, this.trigger.settings.zoomFactor = e, this.boundingBox.settings.zoomFactor = e
                }
            }]) && Ip(t.prototype, n), r && Ip(t, r), e
        }(), r(Mp, "default", (function() {
            return Rp
        })), Object.defineProperty(Rp.prototype, "isShowing", {
            get: function() {
                return this.isShowing
            }
        }), Object.defineProperty(Rp.prototype, "zoomFactor", {
            get: function() {
                return this.zoomFactor
            },
            set: function(e) {
                this.zoomFactor = e
            }
        }), Rp.prototype.setZoomImageURL = Rp.prototype.setZoomImageURL, Rp.prototype.disable = Rp.prototype.disable, Rp.prototype.enable = Rp.prototype.enable, Rp.prototype.destroy = Rp.prototype.destroy
    }
    var Lp = {},
        Dp = Aa;
    Object.defineProperty(Lp, "__esModule", {
        value: !0
    });
    var Np = void 0;
    Lp.default = Np;
    var Bp = Dp(qa),
        Fp = Dp(Ul);
    Np = function(e, t) {
        return Oa(e, (0, Bp.default)({
            defaultTheme: Fp.default
        }, t))
    }, Lp.default = Np;
    var Wp = t(Lp);
    function Hp(e) {
        return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object
    }
    function jp(e, t) {
        void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach((function(n) {
            void 0 === e[n] ? e[n] = t[n] : Hp(t[n]) && Hp(e[n]) && Object.keys(t[n]).length > 0 && jp(e[n], t[n])
        }))
    }
    var $p = {
        body: {},
        addEventListener: function() {},
        removeEventListener: function() {},
        activeElement: {
            blur: function() {},
            nodeName: ""
        },
        querySelector: function() {
            return null
        },
        querySelectorAll: function() {
            return []
        },
        getElementById: function() {
            return null
        },
        createEvent: function() {
            return {
                initEvent: function() {}
            }
        },
        createElement: function() {
            return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute: function() {},
                getElementsByTagName: function() {
                    return []
                }
            }
        },
        createElementNS: function() {
            return {}
        },
        importNode: function() {
            return null
        },
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        }
    };
    function Vp() {
        var e = "undefined" != typeof document ? document : {};
        return jp(e, $p), e
    }
    var qp = {
        document: $p,
        navigator: {
            userAgent: ""
        },
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        },
        history: {
            replaceState: function() {},
            pushState: function() {},
            go: function() {},
            back: function() {}
        },
        CustomEvent: function() {
            return this
        },
        addEventListener: function() {},
        removeEventListener: function() {},
        getComputedStyle: function() {
            return {
                getPropertyValue: function() {
                    return ""
                }
            }
        },
        Image: function() {},
        Date: function() {},
        screen: {},
        setTimeout: function() {},
        clearTimeout: function() {},
        matchMedia: function() {
            return {}
        },
        requestAnimationFrame: function(e) {
            return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)
        },
        cancelAnimationFrame: function(e) {
            "undefined" != typeof setTimeout && clearTimeout(e)
        }
    };
    function Up() {
        var e = "undefined" != typeof window ? window : {};
        return jp(e, qp), e
    }
    function Gp(e) {
        return (Gp = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }
    function Zp(e, t) {
        return (Zp = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e
        })(e, t)
    }
    function Kp() {
        if ("undefined" == typeof Reflect || !Reflect.construct)
            return !1;
        if (Reflect.construct.sham)
            return !1;
        if ("function" == typeof Proxy)
            return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}))), !0
        } catch (e) {
            return !1
        }
    }
    function Yp(e, t, n) {
        return (Yp = Kp() ? Reflect.construct : function(e, t, n) {
            var r = [null];
            r.push.apply(r, t);
            var i = new (Function.bind.apply(e, r));
            return n && Zp(i, n.prototype), i
        }).apply(null, arguments)
    }
    function Xp(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return (Xp = function(e) {
            if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]")))
                return e;
            var n;
            if ("function" != typeof e)
                throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e))
                    return t.get(e);
                t.set(e, r)
            }
            function r() {
                return Yp(e, arguments, Gp(this).constructor)
            }
            return r.prototype = Object.create(e.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), Zp(r, e)
        })(e)
    }
    var Jp = function(e) {
        var t,
            n;
        function r(t) {
            var n,
                r,
                i;
            return n = e.call.apply(e, [this].concat(t)) || this, r = function(e) {
                if (void 0 === e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e
            }(n), i = r.__proto__, Object.defineProperty(r, "__proto__", {
                get: function() {
                    return i
                },
                set: function(e) {
                    i.__proto__ = e
                }
            }), n
        }
        return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, r
    }(Xp(Array));
    function Qp(e) {
        void 0 === e && (e = []);
        var t = [];
        return e.forEach((function(e) {
            Array.isArray(e) ? t.push.apply(t, Qp(e)) : t.push(e)
        })), t
    }
    function ef(e, t) {
        return Array.prototype.filter.call(e, t)
    }
    function tf(e, t) {
        var n = Up(),
            r = Vp(),
            i = [];
        if (!t && e instanceof Jp)
            return e;
        if (!e)
            return new Jp(i);
        if ("string" == typeof e) {
            var o = e.trim();
            if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
                var a = "div";
                0 === o.indexOf("<li") && (a = "ul"), 0 === o.indexOf("<tr") && (a = "tbody"), 0 !== o.indexOf("<td") && 0 !== o.indexOf("<th") || (a = "tr"), 0 === o.indexOf("<tbody") && (a = "table"), 0 === o.indexOf("<option") && (a = "select");
                var s = r.createElement(a);
                s.innerHTML = o;
                for (var l = 0; l < s.childNodes.length; l += 1)
                    i.push(s.childNodes[l])
            } else
                i = function(e, t) {
                    if ("string" != typeof e)
                        return [e];
                    for (var n = [], r = t.querySelectorAll(e), i = 0; i < r.length; i += 1)
                        n.push(r[i]);
                    return n
                }(e.trim(), t || r)
        } else if (e.nodeType || e === n || e === r)
            i.push(e);
        else if (Array.isArray(e)) {
            if (e instanceof Jp)
                return e;
            i = e
        }
        return new Jp(function(e) {
            for (var t = [], n = 0; n < e.length; n += 1)
                -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t
        }(i))
    }
    tf.fn = Jp.prototype;
    var nf = "resize scroll".split(" ");
    function rf(e) {
        return function() {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            if (void 0 === n[0]) {
                for (var i = 0; i < this.length; i += 1)
                    nf.indexOf(e) < 0 && (e in this[i] ? this[i][e]() : tf(this[i]).trigger(e));
                return this
            }
            return this.on.apply(this, [e].concat(n))
        }
    }
    rf("click"), rf("blur"), rf("focus"), rf("focusin"), rf("focusout"), rf("keyup"), rf("keydown"), rf("keypress"), rf("submit"), rf("change"), rf("mousedown"), rf("mousemove"), rf("mouseup"), rf("mouseenter"), rf("mouseleave"), rf("mouseout"), rf("mouseover"), rf("touchstart"), rf("touchend"), rf("touchmove"), rf("resize"), rf("scroll");
    var of = {
        addClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Qp(t.map((function(e) {
                return e.split(" ")
            })));
            return this.forEach((function(e) {
                var t;
                (t = e.classList).add.apply(t, r)
            })), this
        },
        removeClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Qp(t.map((function(e) {
                return e.split(" ")
            })));
            return this.forEach((function(e) {
                var t;
                (t = e.classList).remove.apply(t, r)
            })), this
        },
        hasClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Qp(t.map((function(e) {
                return e.split(" ")
            })));
            return ef(this, (function(e) {
                return r.filter((function(t) {
                    return e.classList.contains(t)
                })).length > 0
            })).length > 0
        },
        toggleClass: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = Qp(t.map((function(e) {
                return e.split(" ")
            })));
            this.forEach((function(e) {
                r.forEach((function(t) {
                    e.classList.toggle(t)
                }))
            }))
        },
        attr: function(e, t) {
            if (1 === arguments.length && "string" == typeof e)
                return this[0] ? this[0].getAttribute(e) : void 0;
            for (var n = 0; n < this.length; n += 1)
                if (2 === arguments.length)
                    this[n].setAttribute(e, t);
                else
                    for (var r in e)
                        this[n][r] = e[r], this[n].setAttribute(r, e[r]);
            return this
        },
        removeAttr: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].removeAttribute(e);
            return this
        },
        transform: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].style.transform = e;
            return this
        },
        transition: function(e) {
            for (var t = 0; t < this.length; t += 1)
                this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e;
            return this
        },
        on: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = t[0],
                i = t[1],
                o = t[2],
                a = t[3];
            function s(e) {
                var t = e.target;
                if (t) {
                    var n = e.target.dom7EventData || [];
                    if (n.indexOf(e) < 0 && n.unshift(e), tf(t).is(i))
                        o.apply(t, n);
                    else
                        for (var r = tf(t).parents(), a = 0; a < r.length; a += 1)
                            tf(r[a]).is(i) && o.apply(r[a], n)
                }
            }
            function l(e) {
                var t = e && e.target && e.target.dom7EventData || [];
                t.indexOf(e) < 0 && t.unshift(e), o.apply(this, t)
            }
            "function" == typeof t[1] && (r = t[0], o = t[1], a = t[2], i = void 0), a || (a = !1);
            for (var u, c = r.split(" "), d = 0; d < this.length; d += 1) {
                var p = this[d];
                if (i)
                    for (u = 0; u < c.length; u += 1) {
                        var f = c[u];
                        p.dom7LiveListeners || (p.dom7LiveListeners = {}), p.dom7LiveListeners[f] || (p.dom7LiveListeners[f] = []), p.dom7LiveListeners[f].push({
                            listener: o,
                            proxyListener: s
                        }), p.addEventListener(f, s, a)
                    }
                else
                    for (u = 0; u < c.length; u += 1) {
                        var h = c[u];
                        p.dom7Listeners || (p.dom7Listeners = {}), p.dom7Listeners[h] || (p.dom7Listeners[h] = []), p.dom7Listeners[h].push({
                            listener: o,
                            proxyListener: l
                        }), p.addEventListener(h, l, a)
                    }
            }
            return this
        },
        off: function() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                t[n] = arguments[n];
            var r = t[0],
                i = t[1],
                o = t[2],
                a = t[3];
            "function" == typeof t[1] && (r = t[0], o = t[1], a = t[2], i = void 0), a || (a = !1);
            for (var s = r.split(" "), l = 0; l < s.length; l += 1)
                for (var u = s[l], c = 0; c < this.length; c += 1) {
                    var d = this[c],
                        p = void 0;
                    if (!i && d.dom7Listeners ? p = d.dom7Listeners[u] : i && d.dom7LiveListeners && (p = d.dom7LiveListeners[u]), p && p.length)
                        for (var f = p.length - 1; f >= 0; f -= 1) {
                            var h = p[f];
                            o && h.listener === o || o && h.listener && h.listener.dom7proxy && h.listener.dom7proxy === o ? (d.removeEventListener(u, h.proxyListener, a), p.splice(f, 1)) : o || (d.removeEventListener(u, h.proxyListener, a), p.splice(f, 1))
                        }
                }
            return this
        },
        trigger: function() {
            for (var e = Up(), t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                n[r] = arguments[r];
            for (var i = n[0].split(" "), o = n[1], a = 0; a < i.length; a += 1)
                for (var s = i[a], l = 0; l < this.length; l += 1) {
                    var u = this[l];
                    if (e.CustomEvent) {
                        var c = new e.CustomEvent(s, {
                            detail: o,
                            bubbles: !0,
                            cancelable: !0
                        });
                        u.dom7EventData = n.filter((function(e, t) {
                            return t > 0
                        })), u.dispatchEvent(c), u.dom7EventData = [], delete u.dom7EventData
                    }
                }
            return this
        },
        transitionEnd: function(e) {
            var t = this;
            return e && t.on("transitionend", (function n(r) {
                r.target === this && (e.call(this, r), t.off("transitionend", n))
            })), this
        },
        outerWidth: function(e) {
            if (this.length > 0) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"))
                }
                return this[0].offsetWidth
            }
            return null
        },
        outerHeight: function(e) {
            if (this.length > 0) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"))
                }
                return this[0].offsetHeight
            }
            return null
        },
        styles: function() {
            var e = Up();
            return this[0] ? e.getComputedStyle(this[0], null) : {}
        },
        offset: function() {
            if (this.length > 0) {
                var e = Up(),
                    t = Vp(),
                    n = this[0],
                    r = n.getBoundingClientRect(),
                    i = t.body,
                    o = n.clientTop || i.clientTop || 0,
                    a = n.clientLeft || i.clientLeft || 0,
                    s = n === e ? e.scrollY : n.scrollTop,
                    l = n === e ? e.scrollX : n.scrollLeft;
                return {
                    top: r.top + s - o,
                    left: r.left + l - a
                }
            }
            return null
        },
        css: function(e, t) {
            var n,
                r = Up();
            if (1 === arguments.length) {
                if ("string" != typeof e) {
                    for (n = 0; n < this.length; n += 1)
                        for (var i in e)
                            this[n].style[i] = e[i];
                    return this
                }
                if (this[0])
                    return r.getComputedStyle(this[0], null).getPropertyValue(e)
            }
            if (2 === arguments.length && "string" == typeof e) {
                for (n = 0; n < this.length; n += 1)
                    this[n].style[e] = t;
                return this
            }
            return this
        },
        each: function(e) {
            return e ? (this.forEach((function(t, n) {
                e.apply(t, [t, n])
            })), this) : this
        },
        html: function(e) {
            if (void 0 === e)
                return this[0] ? this[0].innerHTML : null;
            for (var t = 0; t < this.length; t += 1)
                this[t].innerHTML = e;
            return this
        },
        text: function(e) {
            if (void 0 === e)
                return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1)
                this[t].textContent = e;
            return this
        },
        is: function(e) {
            var t,
                n,
                r = Up(),
                i = Vp(),
                o = this[0];
            if (!o || void 0 === e)
                return !1;
            if ("string" == typeof e) {
                if (o.matches)
                    return o.matches(e);
                if (o.webkitMatchesSelector)
                    return o.webkitMatchesSelector(e);
                if (o.msMatchesSelector)
                    return o.msMatchesSelector(e);
                for (t = tf(e), n = 0; n < t.length; n += 1)
                    if (t[n] === o)
                        return !0;
                return !1
            }
            if (e === i)
                return o === i;
            if (e === r)
                return o === r;
            if (e.nodeType || e instanceof Jp) {
                for (t = e.nodeType ? [e] : e, n = 0; n < t.length; n += 1)
                    if (t[n] === o)
                        return !0;
                return !1
            }
            return !1
        },
        index: function() {
            var e,
                t = this[0];
            if (t) {
                for (e = 0; null !== (t = t.previousSibling);)
                    1 === t.nodeType && (e += 1);
                return e
            }
        },
        eq: function(e) {
            if (void 0 === e)
                return this;
            var t = this.length;
            if (e > t - 1)
                return tf([]);
            if (e < 0) {
                var n = t + e;
                return tf(n < 0 ? [] : [this[n]])
            }
            return tf([this[e]])
        },
        append: function() {
            for (var e, t = Vp(), n = 0; n < arguments.length; n += 1) {
                e = n < 0 || arguments.length <= n ? void 0 : arguments[n];
                for (var r = 0; r < this.length; r += 1)
                    if ("string" == typeof e) {
                        var i = t.createElement("div");
                        for (i.innerHTML = e; i.firstChild;)
                            this[r].appendChild(i.firstChild)
                    } else if (e instanceof Jp)
                        for (var o = 0; o < e.length; o += 1)
                            this[r].appendChild(e[o]);
                    else
                        this[r].appendChild(e)
            }
            return this
        },
        prepend: function(e) {
            var t,
                n,
                r = Vp();
            for (t = 0; t < this.length; t += 1)
                if ("string" == typeof e) {
                    var i = r.createElement("div");
                    for (i.innerHTML = e, n = i.childNodes.length - 1; n >= 0; n -= 1)
                        this[t].insertBefore(i.childNodes[n], this[t].childNodes[0])
                } else if (e instanceof Jp)
                    for (n = 0; n < e.length; n += 1)
                        this[t].insertBefore(e[n], this[t].childNodes[0]);
                else
                    this[t].insertBefore(e, this[t].childNodes[0]);
            return this
        },
        next: function(e) {
            return this.length > 0 ? e ? this[0].nextElementSibling && tf(this[0].nextElementSibling).is(e) ? tf([this[0].nextElementSibling]) : tf([]) : this[0].nextElementSibling ? tf([this[0].nextElementSibling]) : tf([]) : tf([])
        },
        nextAll: function(e) {
            var t = [],
                n = this[0];
            if (!n)
                return tf([]);
            for (; n.nextElementSibling;) {
                var r = n.nextElementSibling;
                e ? tf(r).is(e) && t.push(r) : t.push(r), n = r
            }
            return tf(t)
        },
        prev: function(e) {
            if (this.length > 0) {
                var t = this[0];
                return e ? t.previousElementSibling && tf(t.previousElementSibling).is(e) ? tf([t.previousElementSibling]) : tf([]) : t.previousElementSibling ? tf([t.previousElementSibling]) : tf([])
            }
            return tf([])
        },
        prevAll: function(e) {
            var t = [],
                n = this[0];
            if (!n)
                return tf([]);
            for (; n.previousElementSibling;) {
                var r = n.previousElementSibling;
                e ? tf(r).is(e) && t.push(r) : t.push(r), n = r
            }
            return tf(t)
        },
        parent: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                null !== this[n].parentNode && (e ? tf(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
            return tf(t)
        },
        parents: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                for (var r = this[n].parentNode; r;)
                    e ? tf(r).is(e) && t.push(r) : t.push(r), r = r.parentNode;
            return tf(t)
        },
        closest: function(e) {
            var t = this;
            return void 0 === e ? tf([]) : (t.is(e) || (t = t.parents(e).eq(0)), t)
        },
        find: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                for (var r = this[n].querySelectorAll(e), i = 0; i < r.length; i += 1)
                    t.push(r[i]);
            return tf(t)
        },
        children: function(e) {
            for (var t = [], n = 0; n < this.length; n += 1)
                for (var r = this[n].children, i = 0; i < r.length; i += 1)
                    e && !tf(r[i]).is(e) || t.push(r[i]);
            return tf(t)
        },
        filter: function(e) {
            return tf(ef(this, e))
        },
        remove: function() {
            for (var e = 0; e < this.length; e += 1)
                this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this
        }
    };
    Object.keys(of).forEach((function(e) {
        tf.fn[e] = of[e]
    }));
    var af,
        sf,
        lf,
        uf = tf;
    function cf(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t)
    }
    function df() {
        return Date.now()
    }
    function pf(e) {
        return "object" == typeof e && null !== e && e.constructor && e.constructor === Object
    }
    function ff() {
        for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = 1; t < arguments.length; t += 1) {
            var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
            if (null != n)
                for (var r = Object.keys(Object(n)), i = 0, o = r.length; i < o; i += 1) {
                    var a = r[i],
                        s = Object.getOwnPropertyDescriptor(n, a);
                    void 0 !== s && s.enumerable && (pf(e[a]) && pf(n[a]) ? ff(e[a], n[a]) : !pf(e[a]) && pf(n[a]) ? (e[a] = {}, ff(e[a], n[a])) : e[a] = n[a])
                }
        }
        return e
    }
    function hf(e, t) {
        Object.keys(t).forEach((function(n) {
            pf(t[n]) && Object.keys(t[n]).forEach((function(r) {
                "function" == typeof t[n][r] && (t[n][r] = t[n][r].bind(e))
            })), e[n] = t[n]
        }))
    }
    function mf() {
        return af || (af = function() {
            var e = Up(),
                t = Vp();
            return {
                touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
                pointerEvents: !!e.PointerEvent && "maxTouchPoints" in e.navigator && e.navigator.maxTouchPoints >= 0,
                observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
                passiveListener: function() {
                    var t = !1;
                    try {
                        var n = Object.defineProperty({}, "passive", {
                            get: function() {
                                t = !0
                            }
                        });
                        e.addEventListener("testPassiveListener", null, n)
                    } catch (e) {}
                    return t
                }(),
                gestures: "ongesturestart" in e
            }
        }()), af
    }
    function vf(e) {
        return void 0 === e && (e = {}), sf || (sf = function(e) {
            var t = (void 0 === e ? {} : e).userAgent,
                n = mf(),
                r = Up(),
                i = r.navigator.platform,
                o = t || r.navigator.userAgent,
                a = {
                    ios: !1,
                    android: !1
                },
                s = r.screen.width,
                l = r.screen.height,
                u = o.match(/(Android);?[\s\/]+([\d.]+)?/),
                c = o.match(/(iPad).*OS\s([\d_]+)/),
                d = o.match(/(iPod)(.*OS\s([\d_]+))?/),
                p = !c && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                f = "Win32" === i,
                h = "MacIntel" === i;
            return !c && h && n.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(s + "x" + l) >= 0 && ((c = o.match(/(Version)\/([\d.]+)/)) || (c = [0, 1, "13_0_0"]), h = !1), u && !f && (a.os = "android", a.android = !0), (c || p || d) && (a.os = "ios", a.ios = !0), a
        }(e)), sf
    }
    function gf() {
        return lf || (lf = function() {
            var e,
                t = Up();
            return {
                isEdge: !!t.navigator.userAgent.match(/Edge/g),
                isSafari: (e = t.navigator.userAgent.toLowerCase(), e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
            }
        }()), lf
    }
    var yf = {
        name: "resize",
        create: function() {
            var e = this;
            ff(e, {
                resize: {
                    resizeHandler: function() {
                        e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"))
                    },
                    orientationChangeHandler: function() {
                        e && !e.destroyed && e.initialized && e.emit("orientationchange")
                    }
                }
            })
        },
        on: {
            init: function(e) {
                var t = Up();
                t.addEventListener("resize", e.resize.resizeHandler), t.addEventListener("orientationchange", e.resize.orientationChangeHandler)
            },
            destroy: function(e) {
                var t = Up();
                t.removeEventListener("resize", e.resize.resizeHandler), t.removeEventListener("orientationchange", e.resize.orientationChangeHandler)
            }
        }
    };
    function bf() {
        return (bf = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }
    var wf = {
            attach: function(e, t) {
                void 0 === t && (t = {});
                var n = Up(),
                    r = this,
                    i = new (n.MutationObserver || n.WebkitMutationObserver)((function(e) {
                        if (1 !== e.length) {
                            var t = function() {
                                r.emit("observerUpdate", e[0])
                            };
                            n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0)
                        } else
                            r.emit("observerUpdate", e[0])
                    }));
                i.observe(e, {
                    attributes: void 0 === t.attributes || t.attributes,
                    childList: void 0 === t.childList || t.childList,
                    characterData: void 0 === t.characterData || t.characterData
                }), r.observer.observers.push(i)
            },
            init: function() {
                var e = this;
                if (e.support.observer && e.params.observer) {
                    if (e.params.observeParents)
                        for (var t = e.$el.parents(), n = 0; n < t.length; n += 1)
                            e.observer.attach(t[n]);
                    e.observer.attach(e.$el[0], {
                        childList: e.params.observeSlideChildren
                    }), e.observer.attach(e.$wrapperEl[0], {
                        attributes: !1
                    })
                }
            },
            destroy: function() {
                this.observer.observers.forEach((function(e) {
                    e.disconnect()
                })), this.observer.observers = []
            }
        },
        xf = {
            name: "observer",
            params: {
                observer: !1,
                observeParents: !1,
                observeSlideChildren: !1
            },
            create: function() {
                hf(this, {
                    observer: bf({}, wf, {
                        observers: []
                    })
                })
            },
            on: {
                init: function(e) {
                    e.observer.init()
                },
                destroy: function(e) {
                    e.observer.destroy()
                }
            }
        };
    function _f(e) {
        var t = this,
            n = Vp(),
            r = Up(),
            i = t.touchEventsData,
            o = t.params,
            a = t.touches;
        if (!t.animating || !o.preventInteractionOnTransition) {
            var s = e;
            s.originalEvent && (s = s.originalEvent);
            var l = uf(s.target);
            if ("wrapper" !== o.touchEventsTarget || l.closest(t.wrapperEl).length)
                if (i.isTouchEvent = "touchstart" === s.type, i.isTouchEvent || !("which" in s) || 3 !== s.which)
                    if (!(!i.isTouchEvent && "button" in s && s.button > 0))
                        if (!i.isTouched || !i.isMoved)
                            if (!!o.noSwipingClass && "" !== o.noSwipingClass && s.target && s.target.shadowRoot && e.path && e.path[0] && (l = uf(e.path[0])), o.noSwiping && l.closest(o.noSwipingSelector ? o.noSwipingSelector : "." + o.noSwipingClass)[0])
                                t.allowClick = !0;
                            else if (!o.swipeHandler || l.closest(o.swipeHandler)[0]) {
                                a.currentX = "touchstart" === s.type ? s.targetTouches[0].pageX : s.pageX, a.currentY = "touchstart" === s.type ? s.targetTouches[0].pageY : s.pageY;
                                var u = a.currentX,
                                    c = a.currentY,
                                    d = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
                                    p = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
                                if (d && (u <= p || u >= r.innerWidth - p)) {
                                    if ("prevent" !== d)
                                        return;
                                    e.preventDefault()
                                }
                                if (ff(i, {
                                    isTouched: !0,
                                    isMoved: !1,
                                    allowTouchCallbacks: !0,
                                    isScrolling: void 0,
                                    startMoving: void 0
                                }), a.startX = u, a.startY = c, i.touchStartTime = df(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, o.threshold > 0 && (i.allowThresholdMove = !1), "touchstart" !== s.type) {
                                    var f = !0;
                                    l.is(i.formElements) && (f = !1), n.activeElement && uf(n.activeElement).is(i.formElements) && n.activeElement !== l[0] && n.activeElement.blur();
                                    var h = f && t.allowTouchMove && o.touchStartPreventDefault;
                                    !o.touchStartForcePreventDefault && !h || l[0].isContentEditable || s.preventDefault()
                                }
                                t.emit("touchStart", s)
                            }
        }
    }
    function Cf(e) {
        var t = Vp(),
            n = this,
            r = n.touchEventsData,
            i = n.params,
            o = n.touches,
            a = n.rtlTranslate,
            s = e;
        if (s.originalEvent && (s = s.originalEvent), r.isTouched) {
            if (!r.isTouchEvent || "touchmove" === s.type) {
                var l = "touchmove" === s.type && s.targetTouches && (s.targetTouches[0] || s.changedTouches[0]),
                    u = "touchmove" === s.type ? l.pageX : s.pageX,
                    c = "touchmove" === s.type ? l.pageY : s.pageY;
                if (s.preventedByNestedSwiper)
                    return o.startX = u, void (o.startY = c);
                if (!n.allowTouchMove)
                    return n.allowClick = !1, void (r.isTouched && (ff(o, {
                        startX: u,
                        startY: c,
                        currentX: u,
                        currentY: c
                    }), r.touchStartTime = df()));
                if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
                    if (n.isVertical()) {
                        if (c < o.startY && n.translate <= n.maxTranslate() || c > o.startY && n.translate >= n.minTranslate())
                            return r.isTouched = !1, void (r.isMoved = !1)
                    } else if (u < o.startX && n.translate <= n.maxTranslate() || u > o.startX && n.translate >= n.minTranslate())
                        return;
                if (r.isTouchEvent && t.activeElement && s.target === t.activeElement && uf(s.target).is(r.formElements))
                    return r.isMoved = !0, void (n.allowClick = !1);
                if (r.allowTouchCallbacks && n.emit("touchMove", s), !(s.targetTouches && s.targetTouches.length > 1)) {
                    o.currentX = u, o.currentY = c;
                    var d = o.currentX - o.startX,
                        p = o.currentY - o.startY;
                    if (!(n.params.threshold && Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) < n.params.threshold)) {
                        var f;
                        if (void 0 === r.isScrolling)
                            n.isHorizontal() && o.currentY === o.startY || n.isVertical() && o.currentX === o.startX ? r.isScrolling = !1 : d * d + p * p >= 25 && (f = 180 * Math.atan2(Math.abs(p), Math.abs(d)) / Math.PI, r.isScrolling = n.isHorizontal() ? f > i.touchAngle : 90 - f > i.touchAngle);
                        if (r.isScrolling && n.emit("touchMoveOpposite", s), void 0 === r.startMoving && (o.currentX === o.startX && o.currentY === o.startY || (r.startMoving = !0)), r.isScrolling)
                            r.isTouched = !1;
                        else if (r.startMoving) {
                            n.allowClick = !1, !i.cssMode && s.cancelable && s.preventDefault(), i.touchMoveStopPropagation && !i.nested && s.stopPropagation(), r.isMoved || (i.loop && n.loopFix(), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"), r.allowMomentumBounce = !1, !i.grabCursor || !0 !== n.allowSlideNext && !0 !== n.allowSlidePrev || n.setGrabCursor(!0), n.emit("sliderFirstMove", s)), n.emit("sliderMove", s), r.isMoved = !0;
                            var h = n.isHorizontal() ? d : p;
                            o.diff = h, h *= i.touchRatio, a && (h = -h), n.swipeDirection = h > 0 ? "prev" : "next", r.currentTranslate = h + r.startTranslate;
                            var m = !0,
                                v = i.resistanceRatio;
                            if (i.touchReleaseOnEdges && (v = 0), h > 0 && r.currentTranslate > n.minTranslate() ? (m = !1, i.resistance && (r.currentTranslate = n.minTranslate() - 1 + Math.pow(-n.minTranslate() + r.startTranslate + h, v))) : h < 0 && r.currentTranslate < n.maxTranslate() && (m = !1, i.resistance && (r.currentTranslate = n.maxTranslate() + 1 - Math.pow(n.maxTranslate() - r.startTranslate - h, v))), m && (s.preventedByNestedSwiper = !0), !n.allowSlideNext && "next" === n.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && "prev" === n.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), i.threshold > 0) {
                                if (!(Math.abs(h) > i.threshold || r.allowThresholdMove))
                                    return void (r.currentTranslate = r.startTranslate);
                                if (!r.allowThresholdMove)
                                    return r.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, r.currentTranslate = r.startTranslate, void (o.diff = n.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY)
                            }
                            i.followFinger && !i.cssMode && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (n.updateActiveIndex(), n.updateSlidesClasses()), i.freeMode && (0 === r.velocities.length && r.velocities.push({
                                position: o[n.isHorizontal() ? "startX" : "startY"],
                                time: r.touchStartTime
                            }), r.velocities.push({
                                position: o[n.isHorizontal() ? "currentX" : "currentY"],
                                time: df()
                            })), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate))
                        }
                    }
                }
            }
        } else
            r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", s)
    }
    function Ef(e) {
        var t = this,
            n = t.touchEventsData,
            r = t.params,
            i = t.touches,
            o = t.rtlTranslate,
            a = t.$wrapperEl,
            s = t.slidesGrid,
            l = t.snapGrid,
            u = e;
        if (u.originalEvent && (u = u.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", u), n.allowTouchCallbacks = !1, !n.isTouched)
            return n.isMoved && r.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, void (n.startMoving = !1);
        r.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
        var c,
            d = df(),
            p = d - n.touchStartTime;
        if (t.allowClick && (t.updateClickedSlide(u), t.emit("tap click", u), p < 300 && d - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", u)), n.lastClickTime = df(), cf((function() {
            t.destroyed || (t.allowClick = !0)
        })), !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === i.diff || n.currentTranslate === n.startTranslate)
            return n.isTouched = !1, n.isMoved = !1, void (n.startMoving = !1);
        if (n.isTouched = !1, n.isMoved = !1, n.startMoving = !1, c = r.followFinger ? o ? t.translate : -t.translate : -n.currentTranslate, !r.cssMode)
            if (r.freeMode) {
                if (c < -t.minTranslate())
                    return void t.slideTo(t.activeIndex);
                if (c > -t.maxTranslate())
                    return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                if (r.freeModeMomentum) {
                    if (n.velocities.length > 1) {
                        var f = n.velocities.pop(),
                            h = n.velocities.pop(),
                            m = f.position - h.position,
                            v = f.time - h.time;
                        t.velocity = m / v, t.velocity /= 2, Math.abs(t.velocity) < r.freeModeMinimumVelocity && (t.velocity = 0), (v > 150 || df() - f.time > 300) && (t.velocity = 0)
                    } else
                        t.velocity = 0;
                    t.velocity *= r.freeModeMomentumVelocityRatio, n.velocities.length = 0;
                    var g = 1e3 * r.freeModeMomentumRatio,
                        y = t.velocity * g,
                        b = t.translate + y;
                    o && (b = -b);
                    var w,
                        x,
                        _ = !1,
                        C = 20 * Math.abs(t.velocity) * r.freeModeMomentumBounceRatio;
                    if (b < t.maxTranslate())
                        r.freeModeMomentumBounce ? (b + t.maxTranslate() < -C && (b = t.maxTranslate() - C), w = t.maxTranslate(), _ = !0, n.allowMomentumBounce = !0) : b = t.maxTranslate(), r.loop && r.centeredSlides && (x = !0);
                    else if (b > t.minTranslate())
                        r.freeModeMomentumBounce ? (b - t.minTranslate() > C && (b = t.minTranslate() + C), w = t.minTranslate(), _ = !0, n.allowMomentumBounce = !0) : b = t.minTranslate(), r.loop && r.centeredSlides && (x = !0);
                    else if (r.freeModeSticky) {
                        for (var E, S = 0; S < l.length; S += 1)
                            if (l[S] > -b) {
                                E = S;
                                break
                            }
                        b = -(b = Math.abs(l[E] - b) < Math.abs(l[E - 1] - b) || "next" === t.swipeDirection ? l[E] : l[E - 1])
                    }
                    if (x && t.once("transitionEnd", (function() {
                        t.loopFix()
                    })), 0 !== t.velocity) {
                        if (g = o ? Math.abs((-b - t.translate) / t.velocity) : Math.abs((b - t.translate) / t.velocity), r.freeModeSticky) {
                            var k = Math.abs((o ? -b : b) - t.translate),
                                T = t.slidesSizesGrid[t.activeIndex];
                            g = k < T ? r.speed : k < 2 * T ? 1.5 * r.speed : 2.5 * r.speed
                        }
                    } else if (r.freeModeSticky)
                        return void t.slideToClosest();
                    r.freeModeMomentumBounce && _ ? (t.updateProgress(w), t.setTransition(g), t.setTranslate(b), t.transitionStart(!0, t.swipeDirection), t.animating = !0, a.transitionEnd((function() {
                        t && !t.destroyed && n.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(r.speed), setTimeout((function() {
                            t.setTranslate(w), a.transitionEnd((function() {
                                t && !t.destroyed && t.transitionEnd()
                            }))
                        }), 0))
                    }))) : t.velocity ? (t.updateProgress(b), t.setTransition(g), t.setTranslate(b), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, a.transitionEnd((function() {
                        t && !t.destroyed && t.transitionEnd()
                    })))) : t.updateProgress(b), t.updateActiveIndex(), t.updateSlidesClasses()
                } else if (r.freeModeSticky)
                    return void t.slideToClosest();
                (!r.freeModeMomentum || p >= r.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
            } else {
                for (var O = 0, M = t.slidesSizesGrid[0], R = 0; R < s.length; R += R < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
                    var P = R < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                    void 0 !== s[R + P] ? c >= s[R] && c < s[R + P] && (O = R, M = s[R + P] - s[R]) : c >= s[R] && (O = R, M = s[s.length - 1] - s[s.length - 2])
                }
                var A = (c - s[O]) / M,
                    I = O < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                if (p > r.longSwipesMs) {
                    if (!r.longSwipes)
                        return void t.slideTo(t.activeIndex);
                    "next" === t.swipeDirection && (A >= r.longSwipesRatio ? t.slideTo(O + I) : t.slideTo(O)), "prev" === t.swipeDirection && (A > 1 - r.longSwipesRatio ? t.slideTo(O + I) : t.slideTo(O))
                } else {
                    if (!r.shortSwipes)
                        return void t.slideTo(t.activeIndex);
                    t.navigation && (u.target === t.navigation.nextEl || u.target === t.navigation.prevEl) ? u.target === t.navigation.nextEl ? t.slideTo(O + I) : t.slideTo(O) : ("next" === t.swipeDirection && t.slideTo(O + I), "prev" === t.swipeDirection && t.slideTo(O))
                }
            }
    }
    function Sf() {
        var e = this,
            t = e.params,
            n = e.el;
        if (!n || 0 !== n.offsetWidth) {
            t.breakpoints && e.setBreakpoint();
            var r = e.allowSlideNext,
                i = e.allowSlidePrev,
                o = e.snapGrid;
            e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = i, e.allowSlideNext = r, e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow()
        }
    }
    function kf(e) {
        var t = this;
        t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation()))
    }
    function Tf() {
        var e = this,
            t = e.wrapperEl,
            n = e.rtlTranslate;
        e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = n ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft : e.translate = -t.scrollTop, -0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
        var r = e.maxTranslate() - e.minTranslate();
        (0 === r ? 0 : (e.translate - e.minTranslate()) / r) !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1)
    }
    var Of = !1;
    function Mf() {}
    var Rf = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        nested: !1,
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: .02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        loopPreventsSlide: !0,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "pwzrswiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "pwzrswiper-container-",
        slideClass: "pwzrswiper-slide",
        slideBlankClass: "pwzrswiper-slide-invisible-blank",
        slideActiveClass: "pwzrswiper-slide-active",
        slideDuplicateActiveClass: "pwzrswiper-slide-duplicate-active",
        slideVisibleClass: "pwzrswiper-slide-visible",
        slideDuplicateClass: "pwzrswiper-slide-duplicate",
        slideNextClass: "pwzrswiper-slide-next",
        slideDuplicateNextClass: "pwzrswiper-slide-duplicate-next",
        slidePrevClass: "pwzrswiper-slide-prev",
        slideDuplicatePrevClass: "pwzrswiper-slide-duplicate-prev",
        wrapperClass: "pwzrswiper-wrapper",
        runCallbacksOnInit: !0,
        _emitClasses: !1
    };
    function Pf(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }
    var Af = {
            modular: {
                useParams: function(e) {
                    var t = this;
                    t.modules && Object.keys(t.modules).forEach((function(n) {
                        var r = t.modules[n];
                        r.params && ff(e, r.params)
                    }))
                },
                useModules: function(e) {
                    void 0 === e && (e = {});
                    var t = this;
                    t.modules && Object.keys(t.modules).forEach((function(n) {
                        var r = t.modules[n],
                            i = e[n] || {};
                        r.on && t.on && Object.keys(r.on).forEach((function(e) {
                            t.on(e, r.on[e])
                        })), r.create && r.create.bind(t)(i)
                    }))
                }
            },
            eventsEmitter: {
                on: function(e, t, n) {
                    var r = this;
                    if ("function" != typeof t)
                        return r;
                    var i = n ? "unshift" : "push";
                    return e.split(" ").forEach((function(e) {
                        r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t)
                    })), r
                },
                once: function(e, t, n) {
                    var r = this;
                    if ("function" != typeof t)
                        return r;
                    function i() {
                        r.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
                        for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
                            o[a] = arguments[a];
                        t.apply(r, o)
                    }
                    return i.__emitterProxy = t, r.on(e, i, n)
                },
                onAny: function(e, t) {
                    var n = this;
                    if ("function" != typeof e)
                        return n;
                    var r = t ? "unshift" : "push";
                    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n
                },
                offAny: function(e) {
                    var t = this;
                    if (!t.eventsAnyListeners)
                        return t;
                    var n = t.eventsAnyListeners.indexOf(e);
                    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t
                },
                off: function(e, t) {
                    var n = this;
                    return n.eventsListeners ? (e.split(" ").forEach((function(e) {
                        void 0 === t ? n.eventsListeners[e] = [] : n.eventsListeners[e] && n.eventsListeners[e].forEach((function(r, i) {
                            (r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[e].splice(i, 1)
                        }))
                    })), n) : n
                },
                emit: function() {
                    var e,
                        t,
                        n,
                        r = this;
                    if (!r.eventsListeners)
                        return r;
                    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
                        o[a] = arguments[a];
                    "string" == typeof o[0] || Array.isArray(o[0]) ? (e = o[0], t = o.slice(1, o.length), n = r) : (e = o[0].events, t = o[0].data, n = o[0].context || r), t.unshift(n);
                    var s = Array.isArray(e) ? e : e.split(" ");
                    return s.forEach((function(e) {
                        r.eventsAnyListeners && r.eventsAnyListeners.length && r.eventsAnyListeners.forEach((function(r) {
                            r.apply(n, [e].concat(t))
                        })), r.eventsListeners && r.eventsListeners[e] && r.eventsListeners[e].forEach((function(e) {
                            e.apply(n, t)
                        }))
                    })), r
                }
            },
            update: {
                updateSize: function() {
                    var e,
                        t,
                        n = this,
                        r = n.$el;
                    e = void 0 !== n.params.width && null !== n.params.width ? n.params.width : r[0].clientWidth, t = void 0 !== n.params.height && null !== n.params.height ? n.params.height : r[0].clientHeight, 0 === e && n.isHorizontal() || 0 === t && n.isVertical() || (e = e - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10), t = t - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), ff(n, {
                        width: e,
                        height: t,
                        size: n.isHorizontal() ? e : t
                    }))
                },
                updateSlides: function() {
                    var e = this,
                        t = function(t) {
                            return e.isHorizontal() ? t : {
                                width: "height",
                                "margin-top": "margin-left",
                                "margin-bottom ": "margin-right",
                                "margin-left": "margin-top",
                                "margin-right": "margin-bottom",
                                "padding-left": "padding-top",
                                "padding-right": "padding-bottom",
                                marginRight: "marginBottom"
                            }[t]
                        },
                        n = function(e, n) {
                            return parseFloat(e.getPropertyValue(t(n)) || 0)
                        },
                        r = Up(),
                        i = e.params,
                        o = e.$wrapperEl,
                        a = e.size,
                        s = e.rtlTranslate,
                        l = e.wrongRTL,
                        u = e.virtual && i.virtual.enabled,
                        c = u ? e.virtual.slides.length : e.slides.length,
                        d = o.children("." + e.params.slideClass),
                        p = u ? e.virtual.slides.length : d.length,
                        f = [],
                        h = [],
                        m = [],
                        v = i.slidesOffsetBefore;
                    "function" == typeof v && (v = i.slidesOffsetBefore.call(e));
                    var g = i.slidesOffsetAfter;
                    "function" == typeof g && (g = i.slidesOffsetAfter.call(e));
                    var y = e.snapGrid.length,
                        b = e.slidesGrid.length,
                        w = i.spaceBetween,
                        x = -v,
                        _ = 0,
                        C = 0;
                    if (void 0 !== a) {
                        var E,
                            S;
                        "string" == typeof w && w.indexOf("%") >= 0 && (w = parseFloat(w.replace("%", "")) / 100 * a), e.virtualSize = -w, s ? d.css({
                            marginLeft: "",
                            marginTop: ""
                        }) : d.css({
                            marginRight: "",
                            marginBottom: ""
                        }), i.slidesPerColumn > 1 && (E = Math.floor(p / i.slidesPerColumn) === p / e.params.slidesPerColumn ? p : Math.ceil(p / i.slidesPerColumn) * i.slidesPerColumn, "auto" !== i.slidesPerView && "row" === i.slidesPerColumnFill && (E = Math.max(E, i.slidesPerView * i.slidesPerColumn)));
                        for (var k, T, O, M = i.slidesPerColumn, R = E / M, P = Math.floor(p / i.slidesPerColumn), A = 0; A < p; A += 1) {
                            S = 0;
                            var I = d.eq(A);
                            if (i.slidesPerColumn > 1) {
                                var z = void 0,
                                    L = void 0,
                                    D = void 0;
                                if ("row" === i.slidesPerColumnFill && i.slidesPerGroup > 1) {
                                    var N = Math.floor(A / (i.slidesPerGroup * i.slidesPerColumn)),
                                        B = A - i.slidesPerColumn * i.slidesPerGroup * N,
                                        F = 0 === N ? i.slidesPerGroup : Math.min(Math.ceil((p - N * M * i.slidesPerGroup) / M), i.slidesPerGroup);
                                    z = (L = B - (D = Math.floor(B / F)) * F + N * i.slidesPerGroup) + D * E / M, I.css({
                                        "-webkit-box-ordinal-group": z,
                                        "-moz-box-ordinal-group": z,
                                        "-ms-flex-order": z,
                                        "-webkit-order": z,
                                        order: z
                                    })
                                } else
                                    "column" === i.slidesPerColumnFill ? (D = A - (L = Math.floor(A / M)) * M, (L > P || L === P && D === M - 1) && (D += 1) >= M && (D = 0, L += 1)) : L = A - (D = Math.floor(A / R)) * R;
                                I.css(t("margin-top"), 0 !== D && i.spaceBetween && i.spaceBetween + "px")
                            }
                            if ("none" !== I.css("display")) {
                                if ("auto" === i.slidesPerView) {
                                    var W = r.getComputedStyle(I[0], null),
                                        H = I[0].style.transform,
                                        j = I[0].style.webkitTransform;
                                    if (H && (I[0].style.transform = "none"), j && (I[0].style.webkitTransform = "none"), i.roundLengths)
                                        S = e.isHorizontal() ? I.outerWidth(!0) : I.outerHeight(!0);
                                    else {
                                        var $ = n(W, "width"),
                                            V = n(W, "padding-left"),
                                            q = n(W, "padding-right"),
                                            U = n(W, "margin-left"),
                                            G = n(W, "margin-right"),
                                            Z = W.getPropertyValue(W, "box-sizing");
                                        if (Z && "border-box" === Z)
                                            S = $ + U + G;
                                        else {
                                            var K = I[0],
                                                Y = K.clientWidth;
                                            S = $ + V + q + U + G + (K.offsetWidth - Y)
                                        }
                                    }
                                    H && (I[0].style.transform = H), j && (I[0].style.webkitTransform = j), i.roundLengths && (S = Math.floor(S))
                                } else
                                    S = (a - (i.slidesPerView - 1) * w) / i.slidesPerView, i.roundLengths && (S = Math.floor(S)), d[A] && (d[A].style[t("width")] = S + "px");
                                d[A] && (d[A].swiperSlideSize = S), m.push(S), i.centeredSlides ? (x = x + S / 2 + _ / 2 + w, 0 === _ && 0 !== A && (x = x - a / 2 - w), 0 === A && (x = x - a / 2 - w), Math.abs(x) < .001 && (x = 0), i.roundLengths && (x = Math.floor(x)), C % i.slidesPerGroup == 0 && f.push(x), h.push(x)) : (i.roundLengths && (x = Math.floor(x)), (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 && f.push(x), h.push(x), x = x + S + w), e.virtualSize += S + w, _ = S, C += 1
                            }
                        }
                        if (e.virtualSize = Math.max(e.virtualSize, a) + g, s && l && ("slide" === i.effect || "coverflow" === i.effect) && o.css({
                            width: e.virtualSize + i.spaceBetween + "px"
                        }), i.setWrapperSize)
                            o.css(((T = {})[t("width")] = e.virtualSize + i.spaceBetween + "px", T));
                        if (i.slidesPerColumn > 1)
                            if (e.virtualSize = (S + i.spaceBetween) * E, e.virtualSize = Math.ceil(e.virtualSize / i.slidesPerColumn) - i.spaceBetween, o.css(((O = {})[t("width")] = e.virtualSize + i.spaceBetween + "px", O)), i.centeredSlides) {
                                k = [];
                                for (var X = 0; X < f.length; X += 1) {
                                    var J = f[X];
                                    i.roundLengths && (J = Math.floor(J)), f[X] < e.virtualSize + f[0] && k.push(J)
                                }
                                f = k
                            }
                        if (!i.centeredSlides) {
                            k = [];
                            for (var Q = 0; Q < f.length; Q += 1) {
                                var ee = f[Q];
                                i.roundLengths && (ee = Math.floor(ee)), f[Q] <= e.virtualSize - a && k.push(ee)
                            }
                            f = k, Math.floor(e.virtualSize - a) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - a)
                        }
                        if (0 === f.length && (f = [0]), 0 !== i.spaceBetween) {
                            var te,
                                ne = e.isHorizontal() && s ? "marginLeft" : t("marginRight");
                            d.filter((function(e, t) {
                                return !i.cssMode || t !== d.length - 1
                            })).css(((te = {})[ne] = w + "px", te))
                        }
                        if (i.centeredSlides && i.centeredSlidesBounds) {
                            var re = 0;
                            m.forEach((function(e) {
                                re += e + (i.spaceBetween ? i.spaceBetween : 0)
                            }));
                            var ie = (re -= i.spaceBetween) - a;
                            f = f.map((function(e) {
                                return e < 0 ? -v : e > ie ? ie + g : e
                            }))
                        }
                        if (i.centerInsufficientSlides) {
                            var oe = 0;
                            if (m.forEach((function(e) {
                                oe += e + (i.spaceBetween ? i.spaceBetween : 0)
                            })), (oe -= i.spaceBetween) < a) {
                                var ae = (a - oe) / 2;
                                f.forEach((function(e, t) {
                                    f[t] = e - ae
                                })), h.forEach((function(e, t) {
                                    h[t] = e + ae
                                }))
                            }
                        }
                        ff(e, {
                            slides: d,
                            snapGrid: f,
                            slidesGrid: h,
                            slidesSizesGrid: m
                        }), p !== c && e.emit("slidesLengthChange"), f.length !== y && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== b && e.emit("slidesGridLengthChange"), (i.watchSlidesProgress || i.watchSlidesVisibility) && e.updateSlidesOffset()
                    }
                },
                updateAutoHeight: function(e) {
                    var t,
                        n = this,
                        r = [],
                        i = 0;
                    if ("number" == typeof e ? n.setTransition(e) : !0 === e && n.setTransition(n.params.speed), "auto" !== n.params.slidesPerView && n.params.slidesPerView > 1)
                        if (n.params.centeredSlides)
                            n.visibleSlides.each((function(e) {
                                r.push(e)
                            }));
                        else
                            for (t = 0; t < Math.ceil(n.params.slidesPerView); t += 1) {
                                var o = n.activeIndex + t;
                                if (o > n.slides.length)
                                    break;
                                r.push(n.slides.eq(o)[0])
                            }
                    else
                        r.push(n.slides.eq(n.activeIndex)[0]);
                    for (t = 0; t < r.length; t += 1)
                        if (void 0 !== r[t]) {
                            var a = r[t].offsetHeight;
                            i = a > i ? a : i
                        }
                    i && n.$wrapperEl.css("height", i + "px")
                },
                updateSlidesOffset: function() {
                    for (var e = this.slides, t = 0; t < e.length; t += 1)
                        e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop
                },
                updateSlidesProgress: function(e) {
                    void 0 === e && (e = this && this.translate || 0);
                    var t = this,
                        n = t.params,
                        r = t.slides,
                        i = t.rtlTranslate;
                    if (0 !== r.length) {
                        void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
                        var o = -e;
                        i && (o = e), r.removeClass(n.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
                        for (var a = 0; a < r.length; a += 1) {
                            var s = r[a],
                                l = (o + (n.centeredSlides ? t.minTranslate() : 0) - s.swiperSlideOffset) / (s.swiperSlideSize + n.spaceBetween);
                            if (n.watchSlidesVisibility || n.centeredSlides && n.autoHeight) {
                                var u = -(o - s.swiperSlideOffset),
                                    c = u + t.slidesSizesGrid[a];
                                (u >= 0 && u < t.size - 1 || c > 1 && c <= t.size || u <= 0 && c >= t.size) && (t.visibleSlides.push(s), t.visibleSlidesIndexes.push(a), r.eq(a).addClass(n.slideVisibleClass))
                            }
                            s.progress = i ? -l : l
                        }
                        t.visibleSlides = uf(t.visibleSlides)
                    }
                },
                updateProgress: function(e) {
                    var t = this;
                    if (void 0 === e) {
                        var n = t.rtlTranslate ? -1 : 1;
                        e = t && t.translate && t.translate * n || 0
                    }
                    var r = t.params,
                        i = t.maxTranslate() - t.minTranslate(),
                        o = t.progress,
                        a = t.isBeginning,
                        s = t.isEnd,
                        l = a,
                        u = s;
                    0 === i ? (o = 0, a = !0, s = !0) : (a = (o = (e - t.minTranslate()) / i) <= 0, s = o >= 1), ff(t, {
                        progress: o,
                        isBeginning: a,
                        isEnd: s
                    }), (r.watchSlidesProgress || r.watchSlidesVisibility || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e), a && !l && t.emit("reachBeginning toEdge"), s && !u && t.emit("reachEnd toEdge"), (l && !a || u && !s) && t.emit("fromEdge"), t.emit("progress", o)
                },
                updateSlidesClasses: function() {
                    var e,
                        t = this,
                        n = t.slides,
                        r = t.params,
                        i = t.$wrapperEl,
                        o = t.activeIndex,
                        a = t.realIndex,
                        s = t.virtual && r.virtual.enabled;
                    n.removeClass(r.slideActiveClass + " " + r.slideNextClass + " " + r.slidePrevClass + " " + r.slideDuplicateActiveClass + " " + r.slideDuplicateNextClass + " " + r.slideDuplicatePrevClass), (e = s ? t.$wrapperEl.find("." + r.slideClass + '[data-pwzrswiper-slide-index="' + o + '"]') : n.eq(o)).addClass(r.slideActiveClass), r.loop && (e.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + a + '"]').addClass(r.slideDuplicateActiveClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + a + '"]').addClass(r.slideDuplicateActiveClass));
                    var l = e.nextAll("." + r.slideClass).eq(0).addClass(r.slideNextClass);
                    r.loop && 0 === l.length && (l = n.eq(0)).addClass(r.slideNextClass);
                    var u = e.prevAll("." + r.slideClass).eq(0).addClass(r.slidePrevClass);
                    r.loop && 0 === u.length && (u = n.eq(-1)).addClass(r.slidePrevClass), r.loop && (l.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + l.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + l.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass), u.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + u.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + u.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass)), t.emitSlidesClasses()
                },
                updateActiveIndex: function(e) {
                    var t,
                        n = this,
                        r = n.rtlTranslate ? n.translate : -n.translate,
                        i = n.slidesGrid,
                        o = n.snapGrid,
                        a = n.params,
                        s = n.activeIndex,
                        l = n.realIndex,
                        u = n.snapIndex,
                        c = e;
                    if (void 0 === c) {
                        for (var d = 0; d < i.length; d += 1)
                            void 0 !== i[d + 1] ? r >= i[d] && r < i[d + 1] - (i[d + 1] - i[d]) / 2 ? c = d : r >= i[d] && r < i[d + 1] && (c = d + 1) : r >= i[d] && (c = d);
                        a.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0)
                    }
                    if (o.indexOf(r) >= 0)
                        t = o.indexOf(r);
                    else {
                        var p = Math.min(a.slidesPerGroupSkip, c);
                        t = p + Math.floor((c - p) / a.slidesPerGroup)
                    }
                    if (t >= o.length && (t = o.length - 1), c !== s) {
                        var f = parseInt(n.slides.eq(c).attr("data-pwzrswiper-slide-index") || c, 10);
                        ff(n, {
                            snapIndex: t,
                            realIndex: f,
                            previousIndex: s,
                            activeIndex: c
                        }), n.emit("activeIndexChange"), n.emit("snapIndexChange"), l !== f && n.emit("realIndexChange"), (n.initialized || n.params.runCallbacksOnInit) && n.emit("slideChange")
                    } else
                        t !== u && (n.snapIndex = t, n.emit("snapIndexChange"))
                },
                updateClickedSlide: function(e) {
                    var t = this,
                        n = t.params,
                        r = uf(e.target).closest("." + n.slideClass)[0],
                        i = !1;
                    if (r)
                        for (var o = 0; o < t.slides.length; o += 1)
                            t.slides[o] === r && (i = !0);
                    if (!r || !i)
                        return t.clickedSlide = void 0, void (t.clickedIndex = void 0);
                    t.clickedSlide = r, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(uf(r).attr("data-pwzrswiper-slide-index"), 10) : t.clickedIndex = uf(r).index(), n.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide()
                }
            },
            translate: {
                getTranslate: function(e) {
                    void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                    var t = this,
                        n = t.params,
                        r = t.rtlTranslate,
                        i = t.translate,
                        o = t.$wrapperEl;
                    if (n.virtualTranslate)
                        return r ? -i : i;
                    if (n.cssMode)
                        return i;
                    var a = function(e, t) {
                        void 0 === t && (t = "x");
                        var n,
                            r,
                            i,
                            o = Up(),
                            a = o.getComputedStyle(e, null);
                        return o.WebKitCSSMatrix ? ((r = a.transform || a.webkitTransform).split(",").length > 6 && (r = r.split(", ").map((function(e) {
                            return e.replace(",", ".")
                        })).join(", ")), i = new o.WebKitCSSMatrix("none" === r ? "" : r)) : n = (i = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (r = o.WebKitCSSMatrix ? i.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])), "y" === t && (r = o.WebKitCSSMatrix ? i.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])), r || 0
                    }(o[0], e);
                    return r && (a = -a), a || 0
                },
                setTranslate: function(e, t) {
                    var n = this,
                        r = n.rtlTranslate,
                        i = n.params,
                        o = n.$wrapperEl,
                        a = n.wrapperEl,
                        s = n.progress,
                        l = 0,
                        u = 0;
                    n.isHorizontal() ? l = r ? -e : e : u = e, i.roundLengths && (l = Math.floor(l), u = Math.floor(u)), i.cssMode ? a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -u : i.virtualTranslate || o.transform("translate3d(" + l + "px, " + u + "px, 0px)"), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? l : u;
                    var c = n.maxTranslate() - n.minTranslate();
                    (0 === c ? 0 : (e - n.minTranslate()) / c) !== s && n.updateProgress(e), n.emit("setTranslate", n.translate, t)
                },
                minTranslate: function() {
                    return -this.snapGrid[0]
                },
                maxTranslate: function() {
                    return -this.snapGrid[this.snapGrid.length - 1]
                },
                translateTo: function(e, t, n, r, i) {
                    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), void 0 === r && (r = !0);
                    var o = this,
                        a = o.params,
                        s = o.wrapperEl;
                    if (o.animating && a.preventInteractionOnTransition)
                        return !1;
                    var l,
                        u = o.minTranslate(),
                        c = o.maxTranslate();
                    if (l = r && e > u ? u : r && e < c ? c : e, o.updateProgress(l), a.cssMode) {
                        var d,
                            p = o.isHorizontal();
                        if (0 === t)
                            s[p ? "scrollLeft" : "scrollTop"] = -l;
                        else if (s.scrollTo)
                            s.scrollTo(((d = {})[p ? "left" : "top"] = -l, d.behavior = "smooth", d));
                        else
                            s[p ? "scrollLeft" : "scrollTop"] = -l;
                        return !0
                    }
                    return 0 === t ? (o.setTransition(0), o.setTranslate(l), n && (o.emit("beforeTransitionStart", t, i), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(l), n && (o.emit("beforeTransitionStart", t, i), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(e) {
                        o && !o.destroyed && e.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, n && o.emit("transitionEnd"))
                    }), o.$wrapperEl[0].addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd))), !0
                }
            },
            transition: {
                setTransition: function(e, t) {
                    var n = this;
                    n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t)
                },
                transitionStart: function(e, t) {
                    void 0 === e && (e = !0);
                    var n = this,
                        r = n.activeIndex,
                        i = n.params,
                        o = n.previousIndex;
                    if (!i.cssMode) {
                        i.autoHeight && n.updateAutoHeight();
                        var a = t;
                        if (a || (a = r > o ? "next" : r < o ? "prev" : "reset"), n.emit("transitionStart"), e && r !== o) {
                            if ("reset" === a)
                                return void n.emit("slideResetTransitionStart");
                            n.emit("slideChangeTransitionStart"), "next" === a ? n.emit("slideNextTransitionStart") : n.emit("slidePrevTransitionStart")
                        }
                    }
                },
                transitionEnd: function(e, t) {
                    void 0 === e && (e = !0);
                    var n = this,
                        r = n.activeIndex,
                        i = n.previousIndex,
                        o = n.params;
                    if (n.animating = !1, !o.cssMode) {
                        n.setTransition(0);
                        var a = t;
                        if (a || (a = r > i ? "next" : r < i ? "prev" : "reset"), n.emit("transitionEnd"), e && r !== i) {
                            if ("reset" === a)
                                return void n.emit("slideResetTransitionEnd");
                            n.emit("slideChangeTransitionEnd"), "next" === a ? n.emit("slideNextTransitionEnd") : n.emit("slidePrevTransitionEnd")
                        }
                    }
                }
            },
            slide: {
                slideTo: function(e, t, n, r) {
                    if (void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), "number" != typeof e && "string" != typeof e)
                        throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof e + "] given.");
                    if ("string" == typeof e) {
                        var i = parseInt(e, 10);
                        if (!isFinite(i))
                            throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + e + "] given.");
                        e = i
                    }
                    var o = this,
                        a = e;
                    a < 0 && (a = 0);
                    var s = o.params,
                        l = o.snapGrid,
                        u = o.slidesGrid,
                        c = o.previousIndex,
                        d = o.activeIndex,
                        p = o.rtlTranslate,
                        f = o.wrapperEl;
                    if (o.animating && s.preventInteractionOnTransition)
                        return !1;
                    var h = Math.min(o.params.slidesPerGroupSkip, a),
                        m = h + Math.floor((a - h) / o.params.slidesPerGroup);
                    m >= l.length && (m = l.length - 1), (d || s.initialSlide || 0) === (c || 0) && n && o.emit("beforeSlideChangeStart");
                    var v,
                        g = -l[m];
                    if (o.updateProgress(g), s.normalizeSlideIndex)
                        for (var y = 0; y < u.length; y += 1) {
                            var b = -Math.floor(100 * g),
                                w = Math.floor(100 * u[y]),
                                x = Math.floor(100 * u[y + 1]);
                            void 0 !== u[y + 1] ? b >= w && b < x - (x - w) / 2 ? a = y : b >= w && b < x && (a = y + 1) : b >= w && (a = y)
                        }
                    if (o.initialized && a !== d) {
                        if (!o.allowSlideNext && g < o.translate && g < o.minTranslate())
                            return !1;
                        if (!o.allowSlidePrev && g > o.translate && g > o.maxTranslate() && (d || 0) !== a)
                            return !1
                    }
                    if (v = a > d ? "next" : a < d ? "prev" : "reset", p && -g === o.translate || !p && g === o.translate)
                        return o.updateActiveIndex(a), s.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== s.effect && o.setTranslate(g), "reset" !== v && (o.transitionStart(n, v), o.transitionEnd(n, v)), !1;
                    if (s.cssMode) {
                        var _,
                            C = o.isHorizontal(),
                            E = -g;
                        if (p && (E = f.scrollWidth - f.offsetWidth - E), 0 === t)
                            f[C ? "scrollLeft" : "scrollTop"] = E;
                        else if (f.scrollTo)
                            f.scrollTo(((_ = {})[C ? "left" : "top"] = E, _.behavior = "smooth", _));
                        else
                            f[C ? "scrollLeft" : "scrollTop"] = E;
                        return !0
                    }
                    return 0 === t ? (o.setTransition(0), o.setTranslate(g), o.updateActiveIndex(a), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, v), o.transitionEnd(n, v)) : (o.setTransition(t), o.setTranslate(g), o.updateActiveIndex(a), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, v), o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(e) {
                        o && !o.destroyed && e.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(n, v))
                    }), o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd))), !0
                },
                slideToLoop: function(e, t, n, r) {
                    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0);
                    var i = this,
                        o = e;
                    return i.params.loop && (o += i.loopedSlides), i.slideTo(o, t, n, r)
                },
                slideNext: function(e, t, n) {
                    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                    var r = this,
                        i = r.params,
                        o = r.animating,
                        a = r.activeIndex < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup;
                    if (i.loop) {
                        if (o && i.loopPreventsSlide)
                            return !1;
                        r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft
                    }
                    return r.slideTo(r.activeIndex + a, e, t, n)
                },
                slidePrev: function(e, t, n) {
                    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                    var r = this,
                        i = r.params,
                        o = r.animating,
                        a = r.snapGrid,
                        s = r.slidesGrid,
                        l = r.rtlTranslate;
                    if (i.loop) {
                        if (o && i.loopPreventsSlide)
                            return !1;
                        r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft
                    }
                    function u(e) {
                        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                    }
                    var c,
                        d = u(l ? r.translate : -r.translate),
                        p = a.map((function(e) {
                            return u(e)
                        })),
                        f = (a[p.indexOf(d)], a[p.indexOf(d) - 1]);
                    return void 0 === f && i.cssMode && a.forEach((function(e) {
                        !f && d >= e && (f = e)
                    })), void 0 !== f && (c = s.indexOf(f)) < 0 && (c = r.activeIndex - 1), r.slideTo(c, e, t, n)
                },
                slideReset: function(e, t, n) {
                    return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, n)
                },
                slideToClosest: function(e, t, n, r) {
                    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === r && (r = .5);
                    var i = this,
                        o = i.activeIndex,
                        a = Math.min(i.params.slidesPerGroupSkip, o),
                        s = a + Math.floor((o - a) / i.params.slidesPerGroup),
                        l = i.rtlTranslate ? i.translate : -i.translate;
                    if (l >= i.snapGrid[s]) {
                        var u = i.snapGrid[s];
                        l - u > (i.snapGrid[s + 1] - u) * r && (o += i.params.slidesPerGroup)
                    } else {
                        var c = i.snapGrid[s - 1];
                        l - c <= (i.snapGrid[s] - c) * r && (o -= i.params.slidesPerGroup)
                    }
                    return o = Math.max(o, 0), o = Math.min(o, i.slidesGrid.length - 1), i.slideTo(o, e, t, n)
                },
                slideToClickedSlide: function() {
                    var e,
                        t = this,
                        n = t.params,
                        r = t.$wrapperEl,
                        i = "auto" === n.slidesPerView ? t.slidesPerViewDynamic() : n.slidesPerView,
                        o = t.clickedIndex;
                    if (n.loop) {
                        if (t.animating)
                            return;
                        e = parseInt(uf(t.clickedSlide).attr("data-pwzrswiper-slide-index"), 10), n.centeredSlides ? o < t.loopedSlides - i / 2 || o > t.slides.length - t.loopedSlides + i / 2 ? (t.loopFix(), o = r.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(), cf((function() {
                            t.slideTo(o)
                        }))) : t.slideTo(o) : o > t.slides.length - i ? (t.loopFix(), o = r.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(), cf((function() {
                            t.slideTo(o)
                        }))) : t.slideTo(o)
                    } else
                        t.slideTo(o)
                }
            },
            loop: {
                loopCreate: function() {
                    var e = this,
                        t = Vp(),
                        n = e.params,
                        r = e.$wrapperEl;
                    r.children("." + n.slideClass + "." + n.slideDuplicateClass).remove();
                    var i = r.children("." + n.slideClass);
                    if (n.loopFillGroupWithBlank) {
                        var o = n.slidesPerGroup - i.length % n.slidesPerGroup;
                        if (o !== n.slidesPerGroup) {
                            for (var a = 0; a < o; a += 1) {
                                var s = uf(t.createElement("div")).addClass(n.slideClass + " " + n.slideBlankClass);
                                r.append(s)
                            }
                            i = r.children("." + n.slideClass)
                        }
                    }
                    "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = i.length), e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10)), e.loopedSlides += n.loopAdditionalSlides, e.loopedSlides > i.length && (e.loopedSlides = i.length);
                    var l = [],
                        u = [];
                    i.each((function(t, n) {
                        var r = uf(t);
                        n < e.loopedSlides && u.push(t), n < i.length && n >= i.length - e.loopedSlides && l.push(t), r.attr("data-pwzrswiper-slide-index", n)
                    }));
                    for (var c = 0; c < u.length; c += 1)
                        r.append(uf(u[c].cloneNode(!0)).addClass(n.slideDuplicateClass));
                    for (var d = l.length - 1; d >= 0; d -= 1)
                        r.prepend(uf(l[d].cloneNode(!0)).addClass(n.slideDuplicateClass))
                },
                loopFix: function() {
                    var e = this;
                    e.emit("beforeLoopFix");
                    var t,
                        n = e.activeIndex,
                        r = e.slides,
                        i = e.loopedSlides,
                        o = e.allowSlidePrev,
                        a = e.allowSlideNext,
                        s = e.snapGrid,
                        l = e.rtlTranslate;
                    e.allowSlidePrev = !0, e.allowSlideNext = !0;
                    var u = -s[n] - e.getTranslate();
                    if (n < i)
                        t = r.length - 3 * i + n, t += i, e.slideTo(t, 0, !1, !0) && 0 !== u && e.setTranslate((l ? -e.translate : e.translate) - u);
                    else if (n >= r.length - i) {
                        t = -r.length + n + i, t += i, e.slideTo(t, 0, !1, !0) && 0 !== u && e.setTranslate((l ? -e.translate : e.translate) - u)
                    }
                    e.allowSlidePrev = o, e.allowSlideNext = a, e.emit("loopFix")
                },
                loopDestroy: function() {
                    var e = this,
                        t = e.$wrapperEl,
                        n = e.params,
                        r = e.slides;
                    t.children("." + n.slideClass + "." + n.slideDuplicateClass + ",." + n.slideClass + "." + n.slideBlankClass).remove(), r.removeAttr("data-pwzrswiper-slide-index")
                }
            },
            grabCursor: {
                setGrabCursor: function(e) {
                    var t = this;
                    if (!(t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)) {
                        var n = t.el;
                        n.style.cursor = "move", n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", n.style.cursor = e ? "-moz-grabbin" : "-moz-grab", n.style.cursor = e ? "grabbing" : "grab"
                    }
                },
                unsetGrabCursor: function() {
                    var e = this;
                    e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.el.style.cursor = "")
                }
            },
            manipulation: {
                appendSlide: function(e) {
                    var t = this,
                        n = t.$wrapperEl,
                        r = t.params;
                    if (r.loop && t.loopDestroy(), "object" == typeof e && "length" in e)
                        for (var i = 0; i < e.length; i += 1)
                            e[i] && n.append(e[i]);
                    else
                        n.append(e);
                    r.loop && t.loopCreate(), r.observer && t.support.observer || t.update()
                },
                prependSlide: function(e) {
                    var t = this,
                        n = t.params,
                        r = t.$wrapperEl,
                        i = t.activeIndex;
                    n.loop && t.loopDestroy();
                    var o = i + 1;
                    if ("object" == typeof e && "length" in e) {
                        for (var a = 0; a < e.length; a += 1)
                            e[a] && r.prepend(e[a]);
                        o = i + e.length
                    } else
                        r.prepend(e);
                    n.loop && t.loopCreate(), n.observer && t.support.observer || t.update(), t.slideTo(o, 0, !1)
                },
                addSlide: function(e, t) {
                    var n = this,
                        r = n.$wrapperEl,
                        i = n.params,
                        o = n.activeIndex;
                    i.loop && (o -= n.loopedSlides, n.loopDestroy(), n.slides = r.children("." + i.slideClass));
                    var a = n.slides.length;
                    if (e <= 0)
                        n.prependSlide(t);
                    else if (e >= a)
                        n.appendSlide(t);
                    else {
                        for (var s = o > e ? o + 1 : o, l = [], u = a - 1; u >= e; u -= 1) {
                            var c = n.slides.eq(u);
                            c.remove(), l.unshift(c)
                        }
                        if ("object" == typeof t && "length" in t) {
                            for (var d = 0; d < t.length; d += 1)
                                t[d] && r.append(t[d]);
                            s = o > e ? o + t.length : o
                        } else
                            r.append(t);
                        for (var p = 0; p < l.length; p += 1)
                            r.append(l[p]);
                        i.loop && n.loopCreate(), i.observer && n.support.observer || n.update(), i.loop ? n.slideTo(s + n.loopedSlides, 0, !1) : n.slideTo(s, 0, !1)
                    }
                },
                removeSlide: function(e) {
                    var t = this,
                        n = t.params,
                        r = t.$wrapperEl,
                        i = t.activeIndex;
                    n.loop && (i -= t.loopedSlides, t.loopDestroy(), t.slides = r.children("." + n.slideClass));
                    var o,
                        a = i;
                    if ("object" == typeof e && "length" in e) {
                        for (var s = 0; s < e.length; s += 1)
                            o = e[s], t.slides[o] && t.slides.eq(o).remove(), o < a && (a -= 1);
                        a = Math.max(a, 0)
                    } else
                        o = e, t.slides[o] && t.slides.eq(o).remove(), o < a && (a -= 1), a = Math.max(a, 0);
                    n.loop && t.loopCreate(), n.observer && t.support.observer || t.update(), n.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1)
                },
                removeAllSlides: function() {
                    for (var e = [], t = 0; t < this.slides.length; t += 1)
                        e.push(t);
                    this.removeSlide(e)
                }
            },
            events: {
                attachEvents: function() {
                    var e = this,
                        t = Vp(),
                        n = e.params,
                        r = e.touchEvents,
                        i = e.el,
                        o = e.wrapperEl,
                        a = e.device,
                        s = e.support;
                    e.onTouchStart = _f.bind(e), e.onTouchMove = Cf.bind(e), e.onTouchEnd = Ef.bind(e), n.cssMode && (e.onScroll = Tf.bind(e)), e.onClick = kf.bind(e);
                    var l = !!n.nested;
                    if (!s.touch && s.pointerEvents)
                        i.addEventListener(r.start, e.onTouchStart, !1), t.addEventListener(r.move, e.onTouchMove, l), t.addEventListener(r.end, e.onTouchEnd, !1);
                    else {
                        if (s.touch) {
                            var u = !("touchstart" !== r.start || !s.passiveListener || !n.passiveListeners) && {
                                passive: !0,
                                capture: !1
                            };
                            i.addEventListener(r.start, e.onTouchStart, u), i.addEventListener(r.move, e.onTouchMove, s.passiveListener ? {
                                passive: !1,
                                capture: l
                            } : l), i.addEventListener(r.end, e.onTouchEnd, u), r.cancel && i.addEventListener(r.cancel, e.onTouchEnd, u), Of || (t.addEventListener("touchstart", Mf), Of = !0)
                        }
                        (n.simulateTouch && !a.ios && !a.android || n.simulateTouch && !s.touch && a.ios) && (i.addEventListener("mousedown", e.onTouchStart, !1), t.addEventListener("mousemove", e.onTouchMove, l), t.addEventListener("mouseup", e.onTouchEnd, !1))
                    }
                    (n.preventClicks || n.preventClicksPropagation) && i.addEventListener("click", e.onClick, !0), n.cssMode && o.addEventListener("scroll", e.onScroll), n.updateOnWindowResize ? e.on(a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Sf, !0) : e.on("observerUpdate", Sf, !0)
                },
                detachEvents: function() {
                    var e = this,
                        t = Vp(),
                        n = e.params,
                        r = e.touchEvents,
                        i = e.el,
                        o = e.wrapperEl,
                        a = e.device,
                        s = e.support,
                        l = !!n.nested;
                    if (!s.touch && s.pointerEvents)
                        i.removeEventListener(r.start, e.onTouchStart, !1), t.removeEventListener(r.move, e.onTouchMove, l), t.removeEventListener(r.end, e.onTouchEnd, !1);
                    else {
                        if (s.touch) {
                            var u = !("onTouchStart" !== r.start || !s.passiveListener || !n.passiveListeners) && {
                                passive: !0,
                                capture: !1
                            };
                            i.removeEventListener(r.start, e.onTouchStart, u), i.removeEventListener(r.move, e.onTouchMove, l), i.removeEventListener(r.end, e.onTouchEnd, u), r.cancel && i.removeEventListener(r.cancel, e.onTouchEnd, u)
                        }
                        (n.simulateTouch && !a.ios && !a.android || n.simulateTouch && !s.touch && a.ios) && (i.removeEventListener("mousedown", e.onTouchStart, !1), t.removeEventListener("mousemove", e.onTouchMove, l), t.removeEventListener("mouseup", e.onTouchEnd, !1))
                    }
                    (n.preventClicks || n.preventClicksPropagation) && i.removeEventListener("click", e.onClick, !0), n.cssMode && o.removeEventListener("scroll", e.onScroll), e.off(a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Sf)
                }
            },
            breakpoints: {
                setBreakpoint: function() {
                    var e = this,
                        t = e.activeIndex,
                        n = e.initialized,
                        r = e.loopedSlides,
                        i = void 0 === r ? 0 : r,
                        o = e.params,
                        a = e.$el,
                        s = o.breakpoints;
                    if (s && (!s || 0 !== Object.keys(s).length)) {
                        var l = e.getBreakpoint(s);
                        if (l && e.currentBreakpoint !== l) {
                            var u = l in s ? s[l] : void 0;
                            u && ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach((function(e) {
                                var t = u[e];
                                void 0 !== t && (u[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto")
                            }));
                            var c = u || e.originalParams,
                                d = o.slidesPerColumn > 1,
                                p = c.slidesPerColumn > 1;
                            d && !p ? (a.removeClass(o.containerModifierClass + "multirow " + o.containerModifierClass + "multirow-column"), e.emitContainerClasses()) : !d && p && (a.addClass(o.containerModifierClass + "multirow"), "column" === c.slidesPerColumnFill && a.addClass(o.containerModifierClass + "multirow-column"), e.emitContainerClasses());
                            var f = c.direction && c.direction !== o.direction,
                                h = o.loop && (c.slidesPerView !== o.slidesPerView || f);
                            f && n && e.changeDirection(), ff(e.params, c), ff(e, {
                                allowTouchMove: e.params.allowTouchMove,
                                allowSlideNext: e.params.allowSlideNext,
                                allowSlidePrev: e.params.allowSlidePrev
                            }), e.currentBreakpoint = l, e.emit("_beforeBreakpoint", c), h && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit("breakpoint", c)
                        }
                    }
                },
                getBreakpoint: function(e) {
                    var t = Up();
                    if (e) {
                        var n = !1,
                            r = Object.keys(e).map((function(e) {
                                if ("string" == typeof e && 0 === e.indexOf("@")) {
                                    var n = parseFloat(e.substr(1));
                                    return {
                                        value: t.innerHeight * n,
                                        point: e
                                    }
                                }
                                return {
                                    value: e,
                                    point: e
                                }
                            }));
                        r.sort((function(e, t) {
                            return parseInt(e.value, 10) - parseInt(t.value, 10)
                        }));
                        for (var i = 0; i < r.length; i += 1) {
                            var o = r[i],
                                a = o.point;
                            o.value <= t.innerWidth && (n = a)
                        }
                        return n || "max"
                    }
                }
            },
            checkOverflow: {
                checkOverflow: function() {
                    var e = this,
                        t = e.params,
                        n = e.isLocked,
                        r = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
                    t.slidesOffsetBefore && t.slidesOffsetAfter && r ? e.isLocked = r <= e.size : e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, n !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"), n && n !== e.isLocked && (e.isEnd = !1, e.navigation && e.navigation.update())
                }
            },
            classes: {
                addClasses: function() {
                    var e,
                        t,
                        n,
                        r = this,
                        i = r.classNames,
                        o = r.params,
                        a = r.rtl,
                        s = r.$el,
                        l = r.device,
                        u = r.support,
                        c = (e = ["initialized", o.direction, {
                            "pointer-events": u.pointerEvents && !u.touch
                        }, {
                            "free-mode": o.freeMode
                        }, {
                            autoheight: o.autoHeight
                        }, {
                            rtl: a
                        }, {
                            multirow: o.slidesPerColumn > 1
                        }, {
                            "multirow-column": o.slidesPerColumn > 1 && "column" === o.slidesPerColumnFill
                        }, {
                            android: l.android
                        }, {
                            ios: l.ios
                        }, {
                            "css-mode": o.cssMode
                        }], t = o.containerModifierClass, n = [], e.forEach((function(e) {
                            "object" == typeof e ? Object.entries(e).forEach((function(e) {
                                var r = e[0];
                                e[1] && n.push(t + r)
                            })) : "string" == typeof e && n.push(t + e)
                        })), n);
                    i.push.apply(i, c), s.addClass([].concat(i).join(" ")), r.emitContainerClasses()
                },
                removeClasses: function() {
                    var e = this,
                        t = e.$el,
                        n = e.classNames;
                    t.removeClass(n.join(" ")), e.emitContainerClasses()
                }
            },
            images: {
                loadImage: function(e, t, n, r, i, o) {
                    var a,
                        s = Up();
                    function l() {
                        o && o()
                    }
                    uf(e).parent("picture")[0] || e.complete && i ? l() : t ? ((a = new s.Image).onload = l, a.onerror = l, r && (a.sizes = r), n && (a.srcset = n), t && (a.src = t)) : l()
                },
                preloadImages: function() {
                    var e = this;
                    function t() {
                        null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")))
                    }
                    e.imagesToLoad = e.$el.find("img");
                    for (var n = 0; n < e.imagesToLoad.length; n += 1) {
                        var r = e.imagesToLoad[n];
                        e.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t)
                    }
                }
            }
        },
        If = {},
        zf = function() {
            function e() {
                for (var t, n, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
                    i[o] = arguments[o];
                if (1 === i.length && i[0].constructor && i[0].constructor === Object ? n = i[0] : (t = i[0], n = i[1]), n || (n = {}), n = ff({}, n), t && !n.el && (n.el = t), n.el && uf(n.el).length > 1) {
                    var a = [];
                    return uf(n.el).each((function(t) {
                        var r = ff({}, n, {
                            el: t
                        });
                        a.push(new e(r))
                    })), a
                }
                var s = this;
                s.support = mf(), s.device = vf({
                    userAgent: n.userAgent
                }), s.browser = gf(), s.eventsListeners = {}, s.eventsAnyListeners = [], void 0 === s.modules && (s.modules = {}), Object.keys(s.modules).forEach((function(e) {
                    var t = s.modules[e];
                    if (t.params) {
                        var r = Object.keys(t.params)[0],
                            i = t.params[r];
                        if ("object" != typeof i || null === i)
                            return;
                        if (!(r in n) || !("enabled" in i))
                            return;
                        !0 === n[r] && (n[r] = {
                            enabled: !0
                        }), "object" != typeof n[r] || "enabled" in n[r] || (n[r].enabled = !0), n[r] || (n[r] = {
                            enabled: !1
                        })
                    }
                }));
                var l,
                    u,
                    c = ff({}, Rf);
                return s.useParams(c), s.params = ff({}, c, If, n), s.originalParams = ff({}, s.params), s.passedParams = ff({}, n), s.params && s.params.on && Object.keys(s.params.on).forEach((function(e) {
                    s.on(e, s.params.on[e])
                })), s.params && s.params.onAny && s.onAny(s.params.onAny), s.$ = uf, ff(s, {
                    el: t,
                    classNames: [],
                    slides: uf(),
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: function() {
                        return "horizontal" === s.params.direction
                    },
                    isVertical: function() {
                        return "vertical" === s.params.direction
                    },
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    allowSlideNext: s.params.allowSlideNext,
                    allowSlidePrev: s.params.allowSlidePrev,
                    touchEvents: (l = ["touchstart", "touchmove", "touchend", "touchcancel"], u = ["mousedown", "mousemove", "mouseup"], s.support.pointerEvents && (u = ["pointerdown", "pointermove", "pointerup"]), s.touchEventsTouch = {
                        start: l[0],
                        move: l[1],
                        end: l[2],
                        cancel: l[3]
                    }, s.touchEventsDesktop = {
                        start: u[0],
                        move: u[1],
                        end: u[2]
                    }, s.support.touch || !s.params.simulateTouch ? s.touchEventsTouch : s.touchEventsDesktop),
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        formElements: "input, select, option, textarea, button, video, label",
                        lastClickTime: df(),
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        isTouchEvent: void 0,
                        startMoving: void 0
                    },
                    allowClick: !0,
                    allowTouchMove: s.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0
                }), s.useModules(), s.emit("_swiper"), s.params.init && s.init(), s
            }
            var t,
                n,
                r,
                i = e.prototype;
            return i.emitContainerClasses = function() {
                var e = this;
                if (e.params._emitClasses && e.el) {
                    var t = e.el.className.split(" ").filter((function(t) {
                        return 0 === t.indexOf("pwzrswiper-container") || 0 === t.indexOf(e.params.containerModifierClass)
                    }));
                    e.emit("_containerClasses", t.join(" "))
                }
            }, i.getSlideClasses = function(e) {
                var t = this;
                return e.className.split(" ").filter((function(e) {
                    return 0 === e.indexOf("pwzrswiper-slide") || 0 === e.indexOf(t.params.slideClass)
                })).join(" ")
            }, i.emitSlidesClasses = function() {
                var e = this;
                if (e.params._emitClasses && e.el) {
                    var t = [];
                    e.slides.each((function(n) {
                        var r = e.getSlideClasses(n);
                        t.push({
                            slideEl: n,
                            classNames: r
                        }), e.emit("_slideClass", n, r)
                    })), e.emit("_slideClasses", t)
                }
            }, i.slidesPerViewDynamic = function() {
                var e = this,
                    t = e.params,
                    n = e.slides,
                    r = e.slidesGrid,
                    i = e.size,
                    o = e.activeIndex,
                    a = 1;
                if (t.centeredSlides) {
                    for (var s, l = n[o].swiperSlideSize, u = o + 1; u < n.length; u += 1)
                        n[u] && !s && (a += 1, (l += n[u].swiperSlideSize) > i && (s = !0));
                    for (var c = o - 1; c >= 0; c -= 1)
                        n[c] && !s && (a += 1, (l += n[c].swiperSlideSize) > i && (s = !0))
                } else
                    for (var d = o + 1; d < n.length; d += 1)
                        r[d] - r[o] < i && (a += 1);
                return a
            }, i.update = function() {
                var e = this;
                if (e && !e.destroyed) {
                    var t = e.snapGrid,
                        n = e.params;
                    n.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode ? (r(), e.params.autoHeight && e.updateAutoHeight()) : (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || r(), n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update")
                }
                function r() {
                    var t = e.rtlTranslate ? -1 * e.translate : e.translate,
                        n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                    e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses()
                }
            }, i.changeDirection = function(e, t) {
                void 0 === t && (t = !0);
                var n = this,
                    r = n.params.direction;
                return e || (e = "horizontal" === r ? "vertical" : "horizontal"), e === r || "horizontal" !== e && "vertical" !== e || (n.$el.removeClass("" + n.params.containerModifierClass + r).addClass("" + n.params.containerModifierClass + e), n.emitContainerClasses(), n.params.direction = e, n.slides.each((function(t) {
                    "vertical" === e ? t.style.width = "" : t.style.height = ""
                })), n.emit("changeDirection"), t && n.update()), n
            }, i.mount = function(e) {
                var t = this;
                if (t.mounted)
                    return !0;
                var n,
                    r = uf(e || t.params.el);
                return !!(e = r[0]) && (e.swiper = t, e && e.shadowRoot && e.shadowRoot.querySelector ? (n = uf(e.shadowRoot.querySelector("." + t.params.wrapperClass))).children = function(e) {
                        return r.children(e)
                    } : n = r.children("." + t.params.wrapperClass), ff(t, {
                        $el: r,
                        el: e,
                        $wrapperEl: n,
                        wrapperEl: n[0],
                        mounted: !0,
                        rtl: "rtl" === e.dir.toLowerCase() || "rtl" === r.css("direction"),
                        rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === r.css("direction")),
                        wrongRTL: "-webkit-box" === n.css("display")
                    }), !0)
            }, i.init = function(e) {
                var t = this;
                return t.initialized || !1 === t.mount(e) || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t
            }, i.destroy = function(e, t) {
                void 0 === e && (e = !0), void 0 === t && (t = !0);
                var n,
                    r = this,
                    i = r.params,
                    o = r.$el,
                    a = r.$wrapperEl,
                    s = r.slides;
                return void 0 === r.params || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), i.loop && r.loopDestroy(), t && (r.removeClasses(), o.removeAttr("style"), a.removeAttr("style"), s && s.length && s.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-pwzrswiper-slide-index")), r.emit("destroy"), Object.keys(r.eventsListeners).forEach((function(e) {
                    r.off(e)
                })), !1 !== e && (r.$el[0].swiper = null, n = r, Object.keys(n).forEach((function(e) {
                    try {
                        n[e] = null
                    } catch (e) {}
                    try {
                        delete n[e]
                    } catch (e) {}
                }))), r.destroyed = !0), null
            }, e.extendDefaults = function(e) {
                ff(If, e)
            }, e.installModule = function(t) {
                e.prototype.modules || (e.prototype.modules = {});
                var n = t.name || Object.keys(e.prototype.modules).length + "_" + df();
                e.prototype.modules[n] = t
            }, e.use = function(t) {
                return Array.isArray(t) ? (t.forEach((function(t) {
                    return e.installModule(t)
                })), e) : (e.installModule(t), e)
            }, t = e, r = [{
                key: "extendedDefaults",
                get: function() {
                    return If
                }
            }, {
                key: "defaults",
                get: function() {
                    return Rf
                }
            }], (n = null) && Pf(t.prototype, n), r && Pf(t, r), e
        }();
    function Lf() {
        return (Lf = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }
    Object.keys(Af).forEach((function(e) {
        Object.keys(Af[e]).forEach((function(t) {
            zf.prototype[t] = Af[e][t]
        }))
    })), zf.use([yf, xf]);
    var Df = {
            update: function() {
                var e = this,
                    t = e.params.navigation;
                if (!e.params.loop) {
                    var n = e.navigation,
                        r = n.$nextEl,
                        i = n.$prevEl;
                    i && i.length > 0 && (e.isBeginning ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)), r && r.length > 0 && (e.isEnd ? r.addClass(t.disabledClass) : r.removeClass(t.disabledClass), r[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass))
                }
            },
            onPrevClick: function(e) {
                var t = this;
                e.preventDefault(), t.isBeginning && !t.params.loop || t.slidePrev()
            },
            onNextClick: function(e) {
                var t = this;
                e.preventDefault(), t.isEnd && !t.params.loop || t.slideNext()
            },
            init: function() {
                var e,
                    t,
                    n = this,
                    r = n.params.navigation;
                (r.nextEl || r.prevEl) && (r.nextEl && (e = uf(r.nextEl), n.params.uniqueNavElements && "string" == typeof r.nextEl && e.length > 1 && 1 === n.$el.find(r.nextEl).length && (e = n.$el.find(r.nextEl))), r.prevEl && (t = uf(r.prevEl), n.params.uniqueNavElements && "string" == typeof r.prevEl && t.length > 1 && 1 === n.$el.find(r.prevEl).length && (t = n.$el.find(r.prevEl))), e && e.length > 0 && e.on("click", n.navigation.onNextClick), t && t.length > 0 && t.on("click", n.navigation.onPrevClick), ff(n.navigation, {
                    $nextEl: e,
                    nextEl: e && e[0],
                    $prevEl: t,
                    prevEl: t && t[0]
                }))
            },
            destroy: function() {
                var e = this,
                    t = e.navigation,
                    n = t.$nextEl,
                    r = t.$prevEl;
                n && n.length && (n.off("click", e.navigation.onNextClick), n.removeClass(e.params.navigation.disabledClass)), r && r.length && (r.off("click", e.navigation.onPrevClick), r.removeClass(e.params.navigation.disabledClass))
            }
        },
        Nf = {
            name: "navigation",
            params: {
                navigation: {
                    nextEl: null,
                    prevEl: null,
                    hideOnClick: !1,
                    disabledClass: "pwzrswiper-button-disabled",
                    hiddenClass: "pwzrswiper-button-hidden",
                    lockClass: "pwzrswiper-button-lock"
                }
            },
            create: function() {
                hf(this, {
                    navigation: Lf({}, Df)
                })
            },
            on: {
                init: function(e) {
                    e.navigation.init(), e.navigation.update()
                },
                toEdge: function(e) {
                    e.navigation.update()
                },
                fromEdge: function(e) {
                    e.navigation.update()
                },
                destroy: function(e) {
                    e.navigation.destroy()
                },
                click: function(e, t) {
                    var n,
                        r = e.navigation,
                        i = r.$nextEl,
                        o = r.$prevEl;
                    !e.params.navigation.hideOnClick || uf(t.target).is(o) || uf(t.target).is(i) || (i ? n = i.hasClass(e.params.navigation.hiddenClass) : o && (n = o.hasClass(e.params.navigation.hiddenClass)), !0 === n ? e.emit("navigationShow") : e.emit("navigationHide"), i && i.toggleClass(e.params.navigation.hiddenClass), o && o.toggleClass(e.params.navigation.hiddenClass))
                }
            }
        };
    function Bf() {
        return (Bf = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }
    var Ff = {
            update: function() {
                var e = this,
                    t = e.rtl,
                    n = e.params.pagination;
                if (n.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                    var r,
                        i = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                        o = e.pagination.$el,
                        a = e.params.loop ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                    if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > i - 1 - 2 * e.loopedSlides && (r -= i - 2 * e.loopedSlides), r > a - 1 && (r -= a), r < 0 && "bullets" !== e.params.paginationType && (r = a + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0) {
                        var s,
                            l,
                            u,
                            c = e.pagination.bullets;
                        if (n.dynamicBullets && (e.pagination.bulletSize = c.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0), o.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"), n.dynamicMainBullets > 1 && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex, e.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = n.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), s = r - e.pagination.dynamicBulletIndex, u = ((l = s + (Math.min(c.length, n.dynamicMainBullets) - 1)) + s) / 2), c.removeClass(n.bulletActiveClass + " " + n.bulletActiveClass + "-next " + n.bulletActiveClass + "-next-next " + n.bulletActiveClass + "-prev " + n.bulletActiveClass + "-prev-prev " + n.bulletActiveClass + "-main"), o.length > 1)
                            c.each((function(e) {
                                var t = uf(e),
                                    i = t.index();
                                i === r && t.addClass(n.bulletActiveClass), n.dynamicBullets && (i >= s && i <= l && t.addClass(n.bulletActiveClass + "-main"), i === s && t.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), i === l && t.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next"))
                            }));
                        else {
                            var d = c.eq(r),
                                p = d.index();
                            if (d.addClass(n.bulletActiveClass), n.dynamicBullets) {
                                for (var f = c.eq(s), h = c.eq(l), m = s; m <= l; m += 1)
                                    c.eq(m).addClass(n.bulletActiveClass + "-main");
                                if (e.params.loop)
                                    if (p >= c.length - n.dynamicMainBullets) {
                                        for (var v = n.dynamicMainBullets; v >= 0; v -= 1)
                                            c.eq(c.length - v).addClass(n.bulletActiveClass + "-main");
                                        c.eq(c.length - n.dynamicMainBullets - 1).addClass(n.bulletActiveClass + "-prev")
                                    } else
                                        f.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), h.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next");
                                else
                                    f.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), h.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next")
                            }
                        }
                        if (n.dynamicBullets) {
                            var g = Math.min(c.length, n.dynamicMainBullets + 4),
                                y = (e.pagination.bulletSize * g - e.pagination.bulletSize) / 2 - u * e.pagination.bulletSize,
                                b = t ? "right" : "left";
                            c.css(e.isHorizontal() ? b : "top", y + "px")
                        }
                    }
                    if ("fraction" === n.type && (o.find("." + n.currentClass).text(n.formatFractionCurrent(r + 1)), o.find("." + n.totalClass).text(n.formatFractionTotal(a))), "progressbar" === n.type) {
                        var w;
                        w = n.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
                        var x = (r + 1) / a,
                            _ = 1,
                            C = 1;
                        "horizontal" === w ? _ = x : C = x, o.find("." + n.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + _ + ") scaleY(" + C + ")").transition(e.params.speed)
                    }
                    "custom" === n.type && n.renderCustom ? (o.html(n.renderCustom(e, r + 1, a)), e.emit("paginationRender", o[0])) : e.emit("paginationUpdate", o[0]), o[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](n.lockClass)
                }
            },
            render: function() {
                var e = this,
                    t = e.params.pagination;
                if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                    var n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                        r = e.pagination.$el,
                        i = "";
                    if ("bullets" === t.type) {
                        var o = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                        e.params.freeMode && !e.params.loop && o > n && (o = n);
                        for (var a = 0; a < o; a += 1)
                            t.renderBullet ? i += t.renderBullet.call(e, a, t.bulletClass) : i += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
                        r.html(i), e.pagination.bullets = r.find("." + t.bulletClass.replace(/ /g, "."))
                    }
                    "fraction" === t.type && (i = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', r.html(i)), "progressbar" === t.type && (i = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', r.html(i)), "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0])
                }
            },
            init: function() {
                var e = this,
                    t = e.params.pagination;
                if (t.el) {
                    var n = uf(t.el);
                    0 !== n.length && (e.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && (n = e.$el.find(t.el)), "bullets" === t.type && t.clickable && n.addClass(t.clickableClass), n.addClass(t.modifierClass + t.type), "bullets" === t.type && t.dynamicBullets && (n.addClass("" + t.modifierClass + t.type + "-dynamic"), e.pagination.dynamicBulletIndex = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass), t.clickable && n.on("click", "." + t.bulletClass.replace(/ /g, "."), (function(t) {
                        t.preventDefault();
                        var n = uf(this).index() * e.params.slidesPerGroup;
                        e.params.loop && (n += e.loopedSlides), e.slideTo(n)
                    })), ff(e.pagination, {
                        $el: n,
                        el: n[0]
                    }))
                }
            },
            destroy: function() {
                var e = this,
                    t = e.params.pagination;
                if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                    var n = e.pagination.$el;
                    n.removeClass(t.hiddenClass), n.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && n.off("click", "." + t.bulletClass.replace(/ /g, "."))
                }
            }
        },
        Wf = {
            name: "pagination",
            params: {
                pagination: {
                    el: null,
                    bulletElement: "span",
                    clickable: !1,
                    hideOnClick: !1,
                    renderBullet: null,
                    renderProgressbar: null,
                    renderFraction: null,
                    renderCustom: null,
                    progressbarOpposite: !1,
                    type: "bullets",
                    dynamicBullets: !1,
                    dynamicMainBullets: 1,
                    formatFractionCurrent: function(e) {
                        return e
                    },
                    formatFractionTotal: function(e) {
                        return e
                    },
                    bulletClass: "pwzrswiper-pagination-bullet",
                    bulletActiveClass: "pwzrswiper-pagination-bullet-active",
                    modifierClass: "pwzrswiper-pagination-",
                    currentClass: "pwzrswiper-pagination-current",
                    totalClass: "pwzrswiper-pagination-total",
                    hiddenClass: "pwzrswiper-pagination-hidden",
                    progressbarFillClass: "pwzrswiper-pagination-progressbar-fill",
                    progressbarOppositeClass: "pwzrswiper-pagination-progressbar-opposite",
                    clickableClass: "pwzrswiper-pagination-clickable",
                    lockClass: "pwzrswiper-pagination-lock"
                }
            },
            create: function() {
                hf(this, {
                    pagination: Bf({
                        dynamicBulletIndex: 0
                    }, Ff)
                })
            },
            on: {
                init: function(e) {
                    e.pagination.init(), e.pagination.render(), e.pagination.update()
                },
                activeIndexChange: function(e) {
                    (e.params.loop || void 0 === e.snapIndex) && e.pagination.update()
                },
                snapIndexChange: function(e) {
                    e.params.loop || e.pagination.update()
                },
                slidesLengthChange: function(e) {
                    e.params.loop && (e.pagination.render(), e.pagination.update())
                },
                snapGridLengthChange: function(e) {
                    e.params.loop || (e.pagination.render(), e.pagination.update())
                },
                destroy: function(e) {
                    e.pagination.destroy()
                },
                click: function(e, t) {
                    e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !uf(t.target).hasClass(e.params.pagination.bulletClass) && (!0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit("paginationShow") : e.emit("paginationHide"), e.pagination.$el.toggleClass(e.params.pagination.hiddenClass))
                }
            }
        };
    function Hf() {
        return (Hf = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }
    var jf = {
            loadInSlide: function(e, t) {
                void 0 === t && (t = !0);
                var n = this,
                    r = n.params.lazy;
                if (void 0 !== e && 0 !== n.slides.length) {
                    var i = n.virtual && n.params.virtual.enabled ? n.$wrapperEl.children("." + n.params.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]') : n.slides.eq(e),
                        o = i.find("." + r.elementClass + ":not(." + r.loadedClass + "):not(." + r.loadingClass + ")");
                    !i.hasClass(r.elementClass) || i.hasClass(r.loadedClass) || i.hasClass(r.loadingClass) || o.push(i[0]), 0 !== o.length && o.each((function(e) {
                        var o = uf(e);
                        o.addClass(r.loadingClass);
                        var a = o.attr("data-background"),
                            s = o.attr("data-src"),
                            l = o.attr("data-srcset"),
                            u = o.attr("data-sizes"),
                            c = o.parent("picture");
                        n.loadImage(o[0], s || a, l, u, !1, (function() {
                            if (null != n && n && (!n || n.params) && !n.destroyed) {
                                if (a ? (o.css("background-image", 'url("' + a + '")'), o.removeAttr("data-background")) : (l && (o.attr("srcset", l), o.removeAttr("data-srcset")), u && (o.attr("sizes", u), o.removeAttr("data-sizes")), c.length && c.children("source").each((function(e) {
                                    var t = uf(e);
                                    t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")), t.removeAttr("data-srcset"))
                                })), s && (o.attr("src", s), o.removeAttr("data-src"))), o.addClass(r.loadedClass).removeClass(r.loadingClass), i.find("." + r.preloaderClass).remove(), n.params.loop && t) {
                                    var e = i.attr("data-pwzrswiper-slide-index");
                                    if (i.hasClass(n.params.slideDuplicateClass)) {
                                        var d = n.$wrapperEl.children('[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.params.slideDuplicateClass + ")");
                                        n.lazy.loadInSlide(d.index(), !1)
                                    } else {
                                        var p = n.$wrapperEl.children("." + n.params.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + e + '"]');
                                        n.lazy.loadInSlide(p.index(), !1)
                                    }
                                }
                                n.emit("lazyImageReady", i[0], o[0]), n.params.autoHeight && n.updateAutoHeight()
                            }
                        })), n.emit("lazyImageLoad", i[0], o[0])
                    }))
                }
            },
            load: function() {
                var e = this,
                    t = e.$wrapperEl,
                    n = e.params,
                    r = e.slides,
                    i = e.activeIndex,
                    o = e.virtual && n.virtual.enabled,
                    a = n.lazy,
                    s = n.slidesPerView;
                function l(e) {
                    if (o) {
                        if (t.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]').length)
                            return !0
                    } else if (r[e])
                        return !0;
                    return !1
                }
                function u(e) {
                    return o ? uf(e).attr("data-pwzrswiper-slide-index") : uf(e).index()
                }
                if ("auto" === s && (s = 0), e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0), e.params.watchSlidesVisibility)
                    t.children("." + n.slideVisibleClass).each((function(t) {
                        var n = o ? uf(t).attr("data-pwzrswiper-slide-index") : uf(t).index();
                        e.lazy.loadInSlide(n)
                    }));
                else if (s > 1)
                    for (var c = i; c < i + s; c += 1)
                        l(c) && e.lazy.loadInSlide(c);
                else
                    e.lazy.loadInSlide(i);
                if (a.loadPrevNext)
                    if (s > 1 || a.loadPrevNextAmount && a.loadPrevNextAmount > 1) {
                        for (var d = a.loadPrevNextAmount, p = s, f = Math.min(i + p + Math.max(d, p), r.length), h = Math.max(i - Math.max(p, d), 0), m = i + s; m < f; m += 1)
                            l(m) && e.lazy.loadInSlide(m);
                        for (var v = h; v < i; v += 1)
                            l(v) && e.lazy.loadInSlide(v)
                    } else {
                        var g = t.children("." + n.slideNextClass);
                        g.length > 0 && e.lazy.loadInSlide(u(g));
                        var y = t.children("." + n.slidePrevClass);
                        y.length > 0 && e.lazy.loadInSlide(u(y))
                    }
            },
            checkInViewOnLoad: function() {
                var e = Up(),
                    t = this;
                if (t && !t.destroyed) {
                    var n = t.params.lazy.scrollingElement ? uf(t.params.lazy.scrollingElement) : uf(e),
                        r = n[0] === e,
                        i = r ? e.innerWidth : n[0].offsetWidth,
                        o = r ? e.innerHeight : n[0].offsetHeight,
                        a = t.$el.offset(),
                        s = !1;
                    t.rtlTranslate && (a.left -= t.$el[0].scrollLeft);
                    for (var l = [[a.left, a.top], [a.left + t.width, a.top], [a.left, a.top + t.height], [a.left + t.width, a.top + t.height]], u = 0; u < l.length; u += 1) {
                        var c = l[u];
                        if (c[0] >= 0 && c[0] <= i && c[1] >= 0 && c[1] <= o) {
                            if (0 === c[0] && 0 === c[1])
                                continue;
                            s = !0
                        }
                    }
                    s ? (t.lazy.load(), n.off("scroll", t.lazy.checkInViewOnLoad)) : t.lazy.scrollHandlerAttached || (t.lazy.scrollHandlerAttached = !0, n.on("scroll", t.lazy.checkInViewOnLoad))
                }
            }
        },
        $f = {
            name: "lazy",
            params: {
                lazy: {
                    checkInView: !1,
                    enabled: !1,
                    loadPrevNext: !1,
                    loadPrevNextAmount: 1,
                    loadOnTransitionStart: !1,
                    scrollingElement: "",
                    elementClass: "pwzrswiper-lazy",
                    loadingClass: "pwzrswiper-lazy-loading",
                    loadedClass: "pwzrswiper-lazy-loaded",
                    preloaderClass: "pwzrswiper-lazy-preloader"
                }
            },
            create: function() {
                hf(this, {
                    lazy: Hf({
                        initialImageLoaded: !1
                    }, jf)
                })
            },
            on: {
                beforeInit: function(e) {
                    e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1)
                },
                init: function(e) {
                    e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && (e.params.lazy.checkInView ? e.lazy.checkInViewOnLoad() : e.lazy.load())
                },
                scroll: function(e) {
                    e.params.freeMode && !e.params.freeModeSticky && e.lazy.load()
                },
                resize: function(e) {
                    e.params.lazy.enabled && e.lazy.load()
                },
                scrollbarDragMove: function(e) {
                    e.params.lazy.enabled && e.lazy.load()
                },
                transitionStart: function(e) {
                    e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load()
                },
                transitionEnd: function(e) {
                    e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load()
                },
                slideChange: function(e) {
                    e.params.lazy.enabled && e.params.cssMode && e.lazy.load()
                }
            }
        },
        Vf = function(e, t) {
            var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
            return n ? Tn.indexOf(e) <= Tn.indexOf(t) : Tn.indexOf(e) < Tn.indexOf(t)
        },
        qf = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect,
        Uf = "complete",
        Gf = "canceled";
    function Zf(e, t, n, r, i) {
        e.self === e ? e.scrollTo(t, n) : (r || (e.scrollLeft = t), i || (e.scrollTop = n))
    }
    function Kf(e) {
        var t = e._scrollSettings;
        if (t) {
            var n = t.maxSynchronousAlignments,
                r = function(e, t) {
                    var n,
                        r,
                        i,
                        o,
                        a,
                        s,
                        l,
                        u = e.align,
                        c = e.target.getBoundingClientRect(),
                        d = u && null != u.left ? u.left : .5,
                        p = u && null != u.top ? u.top : .5,
                        f = u && null != u.leftOffset ? u.leftOffset : 0,
                        h = u && null != u.topOffset ? u.topOffset : 0,
                        m = d,
                        v = p;
                    if (e.isWindow(t))
                        s = Math.min(c.width, t.innerWidth), l = Math.min(c.height, t.innerHeight), r = c.left + t.pageXOffset - t.innerWidth * m + s * m, i = c.top + t.pageYOffset - t.innerHeight * v + l * v, i -= h, o = (r -= f) - t.pageXOffset, a = i - t.pageYOffset;
                    else {
                        s = c.width, l = c.height, n = t.getBoundingClientRect();
                        var g = c.left - (n.left - t.scrollLeft),
                            y = c.top - (n.top - t.scrollTop);
                        r = g + s * m - t.clientWidth * m, i = y + l * v - t.clientHeight * v, r -= f, i -= h, r = Math.max(Math.min(r, t.scrollWidth - t.clientWidth), 0), i = Math.max(Math.min(i, t.scrollHeight - t.clientHeight), 0), o = r - t.scrollLeft, a = i - t.scrollTop
                    }
                    return {
                        x: r,
                        y: i,
                        differenceX: o,
                        differenceY: a
                    }
                }(t, e),
                i = Date.now() - t.startTime,
                o = Math.min(1 / t.time * i, 1);
            if (t.endIterations >= n)
                return Zf(e, r.x, r.y, t.lockX, t.lockY), e._scrollSettings = null, t.end(Uf);
            var a = 1 - t.ease(o);
            if (Zf(e, r.x - r.differenceX * a, r.y - r.differenceY * a, t.lockX, t.lockY), i >= t.time)
                return t.endIterations++, Kf(e);
            !function(e) {
                if ("requestAnimationFrame" in window)
                    return window.requestAnimationFrame(e);
                setTimeout(e, 16)
            }(Kf.bind(null, e))
        }
    }
    function Yf(e) {
        return e.self === e
    }
    function Xf(e, t, n, r) {
        var i,
            o = !t._scrollSettings,
            a = t._scrollSettings,
            s = Date.now(),
            l = {
                passive: !0
            };
        function u(e) {
            t._scrollSettings = null, t.parentElement && t.parentElement._scrollSettings && t.parentElement._scrollSettings.end(e), n.debug && console.log("Scrolling ended with type", e, "for", t), r(e), i && (t.removeEventListener("touchstart", i, l), t.removeEventListener("wheel", i, l))
        }
        a && a.end(Gf);
        var c = n.maxSynchronousAlignments;
        null == c && (c = 3), t._scrollSettings = {
            startTime: a ? a.startTime : Date.now(),
            endIterations: 0,
            target: e,
            time: n.time + (a ? s - a.startTime : 0),
            ease: n.ease,
            align: n.align,
            isWindow: n.isWindow || Yf,
            maxSynchronousAlignments: c,
            end: u,
            lockX: n.lockX,
            lockY: n.lockY
        }, "cancellable" in n && !n.cancellable || (i = u.bind(null, Gf), t.addEventListener("touchstart", i, l), t.addEventListener("wheel", i, l)), o && Kf(t)
    }
    function Jf(e) {
        return "pageXOffset" in e || (e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth) && "hidden" !== getComputedStyle(e).overflow
    }
    function Qf() {
        return !0
    }
    function eh(e) {
        if (e.assignedSlot)
            return eh(e.assignedSlot);
        if (e.parentElement)
            return "BODY" === e.parentElement.tagName ? e.parentElement.ownerDocument.defaultView || e.parentElement.ownerDocument.ownerWindow : e.parentElement;
        if (e.getRootNode) {
            var t = e.getRootNode();
            if (11 === t.nodeType)
                return t.host
        }
    }
    var th = t((function(e, t, n) {
        if (e) {
            "function" == typeof t && (n = t, t = null), t || (t = {}), t.time = isNaN(t.time) ? 1e3 : t.time, t.ease = t.ease || function(e) {
                return 1 - Math.pow(1 - e, e / 2)
            }, t.lockX = t.lockX || !1, t.lockY = t.lockY || !1, t.scrollAllParents = "boolean" != typeof t.scrollAllParents || t.scrollAllParents;
            var r = eh(e),
                i = 1,
                o = t.validTarget || Qf,
                a = t.isScrollable;
            for (t.debug && (console.log("About to scroll to", e), r || console.error("Target did not have a parent, is it mounted in the DOM?")); r;)
                if (t.debug && console.log("Scrolling parent node", r), o(r, i) && (a ? a(r, Jf) : Jf(r)) && (i++, Xf(e, r, t, s)), r = eh(r), !t.scrollAllParents || !r) {
                    s(Uf);
                    break
                }
        }
        function s(e) {
            --i || n && n(e)
        }
    }));
    var nh;
    nh = function(e, t) {
        if (t = t.split(":")[0], !(e = +e))
            return !1;
        switch (t) {
        case "http":
        case "ws":
            return 80 !== e;
        case "https":
        case "wss":
            return 443 !== e;
        case "ftp":
            return 21 !== e;
        case "gopher":
            return 70 !== e;
        case "file":
            return !1
        }
        return 0 !== e
    };
    var rh = {},
        ih = Object.prototype.hasOwnProperty;
    function oh(e) {
        try {
            return decodeURIComponent(e.replace(/\+/g, " "))
        } catch (e) {
            return null
        }
    }
    var ah = function(e, t) {
        t = t || "";
        var n,
            r,
            i = [];
        for (r in "string" != typeof t && (t = "?"), e)
            if (ih.call(e, r)) {
                if ((n = e[r]) || null != n && !isNaN(n) || (n = ""), r = encodeURIComponent(r), n = encodeURIComponent(n), null === r || null === n)
                    continue;
                i.push(r + "=" + n)
            }
        return i.length ? t + i.join("&") : ""
    };
    rh.stringify = ah;
    var sh = function(e) {
        for (var t, n = /([^=?&]+)=?([^&]*)/g, r = {}; t = n.exec(e);) {
            var i = oh(t[1]),
                o = oh(t[2]);
            null === i || null === o || i in r || (r[i] = o)
        }
        return r
    };
    rh.parse = sh;
    var lh = nh,
        uh = rh,
        ch = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
        dh = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
        ph = new RegExp("^[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]+");
    function fh(e) {
        return (e || "").toString().replace(ph, "")
    }
    var hh = [["#", "hash"], ["?", "query"], function(e) {
            return e.replace("\\", "/")
        }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d+)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]],
        mh = {
            hash: 1,
            query: 1
        };
    function vh(t) {
        var n,
            r = ("undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {}).location || {},
            i = {},
            o = typeof (t = t || r);
        if ("blob:" === t.protocol)
            i = new yh(unescape(t.pathname), {});
        else if ("string" === o)
            for (n in i = new yh(t, {}), mh)
                delete i[n];
        else if ("object" === o) {
            for (n in t)
                n in mh || (i[n] = t[n]);
            void 0 === i.slashes && (i.slashes = ch.test(t.href))
        }
        return i
    }
    function gh(e) {
        e = fh(e);
        var t = dh.exec(e);
        return {
            protocol: t[1] ? t[1].toLowerCase() : "",
            slashes: !!t[2],
            rest: t[3]
        }
    }
    function yh(e, t, n) {
        if (e = fh(e), !(this instanceof yh))
            return new yh(e, t, n);
        var r,
            i,
            o,
            a,
            s,
            l,
            u = hh.slice(),
            c = typeof t,
            d = this,
            p = 0;
        for ("object" !== c && "string" !== c && (n = t, t = null), n && "function" != typeof n && (n = uh.parse), t = vh(t), r = !(i = gh(e || "")).protocol && !i.slashes, d.slashes = i.slashes || r && t.slashes, d.protocol = i.protocol || t.protocol || "", e = i.rest, i.slashes || (u[3] = [/(.*)/, "pathname"]); p < u.length; p++)
            "function" != typeof (a = u[p]) ? (o = a[0], l = a[1], o != o ? d[l] = e : "string" == typeof o ? ~(s = e.indexOf(o)) && ("number" == typeof a[2] ? (d[l] = e.slice(0, s), e = e.slice(s + a[2])) : (d[l] = e.slice(s), e = e.slice(0, s))) : (s = o.exec(e)) && (d[l] = s[1], e = e.slice(0, s.index)), d[l] = d[l] || r && a[3] && t[l] || "", a[4] && (d[l] = d[l].toLowerCase())) : e = a(e);
        n && (d.query = n(d.query)), r && t.slashes && "/" !== d.pathname.charAt(0) && ("" !== d.pathname || "" !== t.pathname) && (d.pathname = function(e, t) {
            if ("" === e)
                return t;
            for (var n = (t || "/").split("/").slice(0, -1).concat(e.split("/")), r = n.length, i = n[r - 1], o = !1, a = 0; r--;)
                "." === n[r] ? n.splice(r, 1) : ".." === n[r] ? (n.splice(r, 1), a++) : a && (0 === r && (o = !0), n.splice(r, 1), a--);
            return o && n.unshift(""), "." !== i && ".." !== i || n.push(""), n.join("/")
        }(d.pathname, t.pathname)), lh(d.port, d.protocol) || (d.host = d.hostname, d.port = ""), d.username = d.password = "", d.auth && (a = d.auth.split(":"), d.username = a[0] || "", d.password = a[1] || ""), d.origin = d.protocol && d.host && "file:" !== d.protocol ? d.protocol + "//" + d.host : "null", d.href = d.toString()
    }
    yh.prototype = {
        set: function(e, t, n) {
            var r = this;
            switch (e) {
            case "query":
                "string" == typeof t && t.length && (t = (n || uh.parse)(t)), r[e] = t;
                break;
            case "port":
                r[e] = t, lh(t, r.protocol) ? t && (r.host = r.hostname + ":" + t) : (r.host = r.hostname, r[e] = "");
                break;
            case "hostname":
                r[e] = t, r.port && (t += ":" + r.port), r.host = t;
                break;
            case "host":
                r[e] = t, /:\d+$/.test(t) ? (t = t.split(":"), r.port = t.pop(), r.hostname = t.join(":")) : (r.hostname = t, r.port = "");
                break;
            case "protocol":
                r.protocol = t.toLowerCase(), r.slashes = !n;
                break;
            case "pathname":
            case "hash":
                if (t) {
                    var i = "pathname" === e ? "/" : "#";
                    r[e] = t.charAt(0) !== i ? i + t : t
                } else
                    r[e] = t;
                break;
            default:
                r[e] = t
            }
            for (var o = 0; o < hh.length; o++) {
                var a = hh[o];
                a[4] && (r[a[1]] = r[a[1]].toLowerCase())
            }
            return r.origin = r.protocol && r.host && "file:" !== r.protocol ? r.protocol + "//" + r.host : "null", r.href = r.toString(), r
        },
        toString: function(e) {
            e && "function" == typeof e || (e = uh.stringify);
            var t,
                n = this,
                r = n.protocol;
            r && ":" !== r.charAt(r.length - 1) && (r += ":");
            var i = r + (n.slashes ? "//" : "");
            return n.username && (i += n.username, n.password && (i += ":" + n.password), i += "@"), i += n.host + n.pathname, (t = "object" == typeof n.query ? e(n.query) : n.query) && (i += "?" !== t.charAt(0) ? "?" + t : t), n.hash && (i += n.hash), i
        }
    }, yh.extractProtocol = gh, yh.location = vh, yh.trimLeft = fh, yh.qs = uh;
    var bh = t(yh),
        wh = {};
    Object.defineProperty(wh, "__esModule", {
        value: !0
    });
    var xh = function(e, t) {
        "string" == typeof e && (e = [e]);
        for (var n = 0; n < e.length; n++) {
            kh(Th(e[n], t))
        }
    };
    wh.preload = xh;
    var _h = kh;
    wh.loadImage = _h;
    var Ch = function(e) {
        var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        return t ? t[1] : null
    };
    wh.imageSize = Ch;
    var Eh = Th;
    wh.getSizedImageUrl = Eh;
    var Sh = Oh;
    function kh(e) {
        (new Image).src = e
    }
    function Th(e, t) {
        if (null === t)
            return e;
        if ("master" === t)
            return Oh(e);
        var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|heic|psd)(\?.*)/i);
        if (n) {
            var r = e.split(n[0]),
                i = n[0];
            return Oh(r[0] + "_" + t + i)
        }
        return null
    }
    function Oh(e) {
        return e.replace(/http(s)?:/, "")
    }
    wh.removeProtocol = Sh;
    var Mh = new Error("Element already at target scroll position"),
        Rh = new Error("Scroll cancelled"),
        Ph = Math.min,
        Ah = Date.now;
    function Ih(e) {
        return function(t, n, r, i) {
            "function" == typeof (r = r || {}) && (i = r, r = {}), "function" != typeof i && (i = Lh);
            var o = Ah(),
                a = t[e],
                s = r.ease || zh,
                l = isNaN(r.duration) ? 350 : +r.duration,
                u = !1;
            return a === n ? i(Mh, t[e]) : requestAnimationFrame((function r(c) {
                if (u)
                    return i(Rh, t[e]);
                var d = Ah(),
                    p = Ph(1, (d - o) / l),
                    f = s(p);
                t[e] = f * (n - a) + a, p < 1 ? requestAnimationFrame(r) : requestAnimationFrame((function() {
                    i(null, t[e])
                }))
            })), function() {
                u = !0
            }
        }
    }
    function zh(e) {
        return .5 * (1 - Math.cos(Math.PI * e))
    }
    function Lh() {}
    var Dh = t({
        left: Ih("scrollLeft"),
        top: Ih("scrollTop")
    });
    const Nh = ["//pwzimg.b-cdn.net", "//pwzimg.com", "//b.pwzimg.com"],
        Bh = e => (t=null, n=null, r=!1) => {
            if (null === t && null === n)
                return e;
            if ("string" == typeof e && Nh.find((t => e.indexOf(t) > -1))) {
                return ((e, t=null, n=null) => {
                    try {
                        const r = new URL(e),
                            i = 5760,
                            o = new URLSearchParams(r.search);
                        if (null !== t) {
                            const e = Math.min(Math.ceil(t), i);
                            o.append("width", `${e}`)
                        }
                        if (null !== n) {
                            const e = Math.min(Math.ceil(n), i);
                            o.append("height", `${e}`)
                        }
                        return `${r.origin}${r.pathname}?${o}`
                    } catch (e) {}
                    return e
                })(e, t, n)
            }
            const i = ((e, t=!1) => t ? `${e}_crop_center` : e)(((e=null, t=null) => {
                const n = 5760;
                if (null === e)
                    return `x${Math.min(Math.ceil(t), n)}`;
                if (null === t)
                    return `${Math.min(Math.ceil(e), n)}x`;
                return `${Math.min(Math.ceil(e), n)}x${Math.min(Math.ceil(t), n)}`
            })(t, n), r);
            return wh.getSizedImageUrl(e, i)
        };
    function Fh() {
        return window.devicePixelRatio || 1
    }
    const Wh = e => (t, n) => t[e] > n[e] ? -1 : n[e] > t[e] ? 1 : 0;
    function Hh(e, t) {
        const n = Math.ceil(e.scrollLeft),
            r = Math.ceil(e.scrollTop),
            i = Math.floor(e.scrollLeft),
            o = Math.floor(e.scrollTop);
        return {
            start: t ? 0 === o : 0 === i,
            end: t ? e.offsetHeight + r >= e.scrollHeight : e.offsetWidth + n >= e.scrollWidth
        }
    }
    function jh(e, t, n) {
        return new Promise((r => {t ? Dh.top(e, e.scrollTop + n * e.clientHeight, (() => {r(Hh(e, t))})) : Dh.left(e, e.scrollLeft + n * e.clientWidth, (() => {r(Hh(e, t))}))}))
    }
    function $h(e, t, n, r="media") {
        const i = {
            muted: !1,
            autoPlay: !0,
            controls: !0,
            loop: !1,
            autoRotate: !0
        };
        if (Array.isArray(n)) {
            const o = n.find((t => t.id === e));
            if (o && Array.isArray(o[r])) {
                const e = o[r].find((e => e.id === t));
                if (e) {
                    const {id: t, ...n} = e;
                    return {
                        ...i,
                        ...n
                    }
                }
            }
        }
        return i
    }
    const Vh = (e, t, n, r=!1) => {
        const i = e.find((e => e.id === n));
        if (i)
            return i;
        const o = (Array.isArray(t) ? t : []).find((e => e.id === n));
        if (o) {
            const t = o.value;
            if ("string" == typeof t) {
                const i = e.find((e => (e => {
                    try {
                        const {pathname: t} = new URL(e),
                            n = t.lastIndexOf("/");
                        return -1 !== n ? t.substring(n + 1) : t
                    } catch (e) {}
                    return null
                })(e.originalSrc) === t));
                if (i)
                    return console.log(`Fixed invalid image reference of ${n} ${t} to`), console.log(i), r ? {
                        ...i,
                        rescued: !0
                    } : i
            }
        }
        return console.log(`Could not find a match for media ${n}`), null
    };
    function qh(e) {
        return "left" === e || "right" === e
    }
    function Uh(e) {
        return Math.min(180 * Math.ceil(e / 180), 5760)
    }
    function Gh(e) {
        return "number" == typeof e && Number.isFinite(e) ? `${(1 / e * 100).toFixed(3)}%` : "100%"
    }
    function Zh(e) {
        const t = e.media.concat().sort((n = "position", (e, t) => e[n] > t[n] ? 1 : t[n] > e[n] ? -1 : 0)).map((e => {
            return (t = function(e) {
                const {media_type: t, aspect_ratio: n, preview_image: r, external_id: i, src: o, host: a, sources: s, id: l, alt: u, width: c} = e,
                    d = {
                        id: `${l}`,
                        type: t,
                        alt: u
                    },
                    p = s || [];
                if ("image" === t)
                    return {
                        ...d,
                        transformedSrc: Bh(o),
                        originalSrc: o,
                        scale: Gh(n),
                        width: c
                    };
                if ("video" === t) {
                    const e = p.filter((e => "video/mp4" === e.mime_type)).sort(((e, t) => t.height - e.height)).map((e => ({
                        mimeType: e.mime_type,
                        url: e.url
                    })));
                    if (e.length > 0) {
                        const t = [],
                            i = p.find((e => "application/x-mpegURL" === e.mime_type));
                        return i && t.push({
                            mimeType: i.mime_type,
                            url: i.url
                        }), t.push(e[0]), {
                            ...d,
                            transformedSrc: Bh(r.src),
                            scale: Gh(r.aspect_ratio),
                            sources: t,
                            scaleSources: Gh(n)
                        }
                    }
                }
                if ("external_video" === t && "youtube" === a && "string" == typeof i)
                    return {
                        ...d,
                        transformedSrc: Bh(r.src),
                        scale: Gh(r.aspect_ratio),
                        sources: [i],
                        scaleSources: Gh(n)
                    };
                if ("model" === t) {
                    const e = p.find((e => "glb" === e.format));
                    if (e && "string" == typeof e.url)
                        return {
                            ...d,
                            transformedSrc: Bh(r.src),
                            scale: Gh(r.aspect_ratio),
                            sources: [e.url],
                            scaleSources: Gh(r.aspect_ratio)
                        }
                }
                return null
            }(e)) ? {
                ...t,
                rioSettings: {
                    muted: !1,
                    autoPlay: !0,
                    controls: !0,
                    loop: !1,
                    autoRotate: !0
                }
            } : null;
            var t
        })).filter((e => null !== e));
        var n;
        const r = e.variants.map((e => ({
            id: `${e.id}`,
            featuredMediaIndex: e.featured_media ? t.findIndex((t => `${e.featured_media.id}` === t.id)) : -1,
            available: e.available
        })));
        return {
            media: t,
            variants: r
        }
    }
    const Kh = Tt.shape({
            autoPlay: Tt.bool.isRequired,
            autoRotate: Tt.bool.isRequired,
            controls: Tt.bool.isRequired,
            loop: Tt.bool.isRequired,
            muted: Tt.bool.isRequired
        }),
        Yh = Tt.exact({
            id: Tt.string.isRequired,
            gqlId: Tt.string.isRequired,
            type: Tt.string.isRequired,
            alt: Tt.string.isRequired,
            originalSrc: Tt.string.isRequired,
            transformedSrc: Tt.func.isRequired,
            source: Tt.string,
            filename: Tt.string,
            scale: Tt.number,
            rioSettings: Kh.isRequired
        }),
        Xh = (Tt.shape({
            id: Tt.string.isRequired,
            title: Tt.string.isRequired,
            sku: Tt.string.isRequired,
            media: Tt.arrayOf(Yh).isRequired,
            variantMediaId: Tt.string,
            fullTitle: Tt.string,
            options: Tt.arrayOf(Tt.exact({
                name: Tt.string.isRequired,
                value: Tt.string.isRequired
            })).isRequired
        }), (e, t, n) => "number" != typeof e.thumbnailWidth && "number" != typeof e.thumbnailsPerRow ? new Error(`One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' required by '${n}' component are not numbers`) : e.thumbnailWidth || e.thumbnailsPerRow ? qh(e.orientation) && e.thumbnailsPerRow && !e.thumbnailWidth && !e.container ? new Error(`Both 'thumbnails.thumbnailWidth' and 'thumbnails.thumbnailsPerRow' is required by '${n}' component.`) : void 0 : new Error(`One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' is required by '${n}' component.`)),
        Jh = Tt.shape({
            navigation: Tt.bool.isRequired,
            pagination: Tt.bool.isRequired,
            clickablePagination: Tt.bool,
            swipe: Tt.bool.isRequired,
            keyboard: Tt.bool,
            vertical: (e, t, n) => {
                if (e.vertical) {
                    if (e.magnify)
                        return new Error(`'magnify' cannot be true when 'vertical' is true in '${n}' component.`);
                    if (e.thumbnails)
                        return new Error(`'thumbnails' cannot be true when 'vertical' is true in '${n}' component.`)
                }
            },
            verticalSpacing: Tt.string,
            maxHeight: Tt.string,
            magnify: Tt.oneOfType([Tt.oneOf([!1]), Tt.exact({
                width: Tt.string,
                height: Tt.string,
                zoom: Tt.number
            })]),
            thumbnails: Tt.oneOfType([Tt.oneOf([!1]), Tt.exact({
                orientation: Tt.oneOf(["bottom", "top", "right", "left"]).isRequired,
                multiRow: (e, t, n) => "boolean" != typeof e.multiRow ? new Error(`'thumbnails.multiRow' is required to be a boolean by '${n}' component.`) : !e.multiRow && qh(e.orientation) ? new Error(`'thumbnails.muliRow' cannot be false with left or right 'thumbnails.orientation' in '${n}' component.`) : void 0,
                thumbnailWidth: Xh,
                thumbnailsPerRow: Xh,
                container: (e, t, n) => {
                    if (e.container)
                        return "number" != typeof e.container ? new Error(`'thumbnails.container' needs to be a number in '${n}' component.`) : e.container < 0 || e.container > 1 ? new Error(`'thumbnails.container' needs to be between 0.0 and 1.0 (inclusive) in '${n}' component.`) : "number" != typeof e.thumbnailsPerRow ? new Error(`'thumbnails.thumbnailsPerRow' needs to also be set in conjuction with 'thumbnails.container' in '${n}' component.`) : "number" == typeof e.thumbnailWidth ? new Error(`'thumbnails.thumbnailWidth' cannot also be set with 'thumbnails.container' and 'thumbnails.thumbnailsPerRow' in '${n}' component.`) : void 0
                },
                navigation: Tt.bool.isRequired,
                verticalOverflow: (e, t, n) => {
                    if ("boolean" == typeof e.verticalOverflow)
                        return e.verticalOverflow && !qh(e.orientation) ? new Error(`'thumbnails.verticalOverflow' cannot be true with top or bottom 'thumbnails.orientation' in '${n}' component.`) : !e.verticalOverflow && e.navigation ? new Error(`'thumbnails.verticalOverflow' cannot be false with 'thumbnails.navigation' also being true in '${n}' component.`) : void 0
                },
                square: Tt.bool,
                centerCrop: Tt.bool
            })]),
            lightBox: Tt.bool.isRequired,
            lightBoxZoom: (e, t, n) => {
                if (e.lightBox && !Number.isFinite(e.lightBoxZoom))
                    return new Error(`'lightBoxZoom' is required when 'lightBox' is true in '${n}' component.`)
            }
        }),
        Qh = Tt.exact({
            id: Tt.string.isRequired,
            type: Tt.string.isRequired,
            alt: Tt.string,
            width: Tt.number,
            rioSettings: Kh.isRequired,
            transformedSrc: Tt.func.isRequired,
            originalSrc: Tt.string,
            scale: Tt.string,
            sources: Tt.oneOfType([Tt.arrayOf(Tt.string), Tt.arrayOf(Tt.shape({
                url: Tt.string.isRequired,
                mimeType: Tt.string.isRequired
            }))]),
            scaleSources: Tt.string
        });
    var em,
        tm,
        nm = {};
    /*! PhotoSwipe - v4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov;*/
    em = nm, tm = function() {
        return function(e, t, n, r) {
            var i = {
                features: null,
                bind: function(e, t, n, r) {
                    var i = (r ? "remove" : "add") + "EventListener";
                    t = t.split(" ");
                    for (var o = 0; o < t.length; o++)
                        t[o] && e[i](t[o], n, !1)
                },
                isArray: function(e) {
                    return e instanceof Array
                },
                createEl: function(e, t) {
                    var n = document.createElement(t || "div");
                    return e && (n.className = e), n
                },
                getScrollY: function() {
                    var e = window.pageYOffset;
                    return void 0 !== e ? e : document.documentElement.scrollTop
                },
                unbind: function(e, t, n) {
                    i.bind(e, t, n, !0)
                },
                removeClass: function(e, t) {
                    var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
                    e.className = e.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                },
                addClass: function(e, t) {
                    i.hasClass(e, t) || (e.className += (e.className ? " " : "") + t)
                },
                hasClass: function(e, t) {
                    return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
                },
                getChildByClass: function(e, t) {
                    for (var n = e.firstChild; n;) {
                        if (i.hasClass(n, t))
                            return n;
                        n = n.nextSibling
                    }
                },
                arraySearch: function(e, t, n) {
                    for (var r = e.length; r--;)
                        if (e[r][n] === t)
                            return r;
                    return -1
                },
                extend: function(e, t, n) {
                    for (var r in t)
                        if (t.hasOwnProperty(r)) {
                            if (n && e.hasOwnProperty(r))
                                continue;
                            e[r] = t[r]
                        }
                },
                easing: {
                    sine: {
                        out: function(e) {
                            return Math.sin(e * (Math.PI / 2))
                        },
                        inOut: function(e) {
                            return -(Math.cos(Math.PI * e) - 1) / 2
                        }
                    },
                    cubic: {
                        out: function(e) {
                            return --e * e * e + 1
                        }
                    }
                },
                detectFeatures: function() {
                    if (i.features)
                        return i.features;
                    var e = i.createEl().style,
                        t = "",
                        n = {};
                    if (n.oldIE = document.all && !document.addEventListener, n.touch = "ontouchstart" in window, window.requestAnimationFrame && (n.raf = window.requestAnimationFrame, n.caf = window.cancelAnimationFrame), n.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !n.pointerEvent) {
                        var r = navigator.userAgent;
                        if (/iP(hone|od)/.test(navigator.platform)) {
                            var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            o && o.length > 0 && (o = parseInt(o[1], 10)) >= 1 && o < 8 && (n.isOldIOSPhone = !0)
                        }
                        var a = r.match(/Android\s([0-9\.]*)/),
                            s = a ? a[1] : 0;
                        (s = parseFloat(s)) >= 1 && (s < 4.4 && (n.isOldAndroid = !0), n.androidVersion = s), n.isMobileOpera = /opera mini|opera mobi/i.test(r)
                    }
                    for (var l, u, c = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], p = 0; p < 4; p++) {
                        t = d[p];
                        for (var f = 0; f < 3; f++)
                            l = c[f], u = t + (t ? l.charAt(0).toUpperCase() + l.slice(1) : l), !n[l] && u in e && (n[l] = u);
                        t && !n.raf && (t = t.toLowerCase(), n.raf = window[t + "RequestAnimationFrame"], n.raf && (n.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]))
                    }
                    if (!n.raf) {
                        var h = 0;
                        n.raf = function(e) {
                            var t = (new Date).getTime(),
                                n = Math.max(0, 16 - (t - h)),
                                r = window.setTimeout((function() {
                                    e(t + n)
                                }), n);
                            return h = t + n, r
                        }, n.caf = function(e) {
                            clearTimeout(e)
                        }
                    }
                    return n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, i.features = n, n
                }
            };
            i.detectFeatures(), i.features.oldIE && (i.bind = function(e, t, n, r) {
                t = t.split(" ");
                for (var i, o = (r ? "detach" : "attach") + "Event", a = function() {
                        n.handleEvent.call(n)
                    }, s = 0; s < t.length; s++)
                    if (i = t[s])
                        if ("object" == typeof n && n.handleEvent) {
                            if (r) {
                                if (!n["oldIE" + i])
                                    return !1
                            } else
                                n["oldIE" + i] = a;
                            e[o]("on" + i, n["oldIE" + i])
                        } else
                            e[o]("on" + i, n)
            });
            var o = this,
                a = {
                    allowPanToNext: !0,
                    spacing: .12,
                    bgOpacity: 1,
                    mouseUsed: !1,
                    loop: !0,
                    pinchToClose: !0,
                    closeOnScroll: !0,
                    closeOnVerticalDrag: !0,
                    verticalDragRange: .75,
                    hideAnimationDuration: 333,
                    showAnimationDuration: 333,
                    showHideOpacity: !1,
                    focus: !0,
                    escKey: !0,
                    arrowKeys: !0,
                    mainScrollEndFriction: .35,
                    panEndFriction: .35,
                    isClickableElement: function(e) {
                        return "A" === e.tagName
                    },
                    getDoubleTapZoom: function(e, t) {
                        return e || t.initialZoomLevel < .7 ? 1 : 1.33
                    },
                    maxSpreadZoom: 1.33,
                    modal: !0,
                    scaleMode: "fit"
                };
            i.extend(a, r);
            var s,
                l,
                u,
                c,
                d,
                p,
                f,
                h,
                m,
                v,
                g,
                y,
                b,
                w,
                x,
                _,
                C,
                E,
                S,
                k,
                T,
                O,
                M,
                R,
                P,
                A,
                I,
                z,
                L,
                D,
                N,
                B,
                F,
                W,
                H,
                j,
                $,
                V,
                q,
                U,
                G,
                Z,
                K,
                Y,
                X,
                J,
                Q,
                ee,
                te,
                ne,
                re,
                ie,
                oe,
                ae,
                se,
                le,
                ue = {
                    x: 0,
                    y: 0
                },
                ce = {
                    x: 0,
                    y: 0
                },
                de = {
                    x: 0,
                    y: 0
                },
                pe = {},
                fe = 0,
                he = {},
                me = {
                    x: 0,
                    y: 0
                },
                ve = 0,
                ge = !0,
                ye = [],
                be = {},
                we = !1,
                xe = function(e, t) {
                    i.extend(o, t.publicMethods), ye.push(e)
                },
                _e = function(e) {
                    var t = Ht();
                    return e > t - 1 ? e - t : e < 0 ? t + e : e
                },
                Ce = {},
                Ee = function(e, t) {
                    return Ce[e] || (Ce[e] = []), Ce[e].push(t)
                },
                Se = function(e) {
                    var t = Ce[e];
                    if (t) {
                        var n = Array.prototype.slice.call(arguments);
                        n.shift();
                        for (var r = 0; r < t.length; r++)
                            t[r].apply(o, n)
                    }
                },
                ke = function() {
                    return (new Date).getTime()
                },
                Te = function(e) {
                    ae = e, o.bg.style.opacity = e * a.bgOpacity
                },
                Oe = function(e, t, n, r, i) {
                    (!we || i && i !== o.currItem) && (r /= i ? i.fitRatio : o.currItem.fitRatio), e[O] = y + t + "px, " + n + "px" + b + " scale(" + r + ")"
                },
                Me = function(e) {
                    te && (e && (v > o.currItem.fitRatio ? we || (Yt(o.currItem, !1, !0), we = !0) : we && (Yt(o.currItem), we = !1)), Oe(te, de.x, de.y, v))
                },
                Re = function(e) {
                    e.container && Oe(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e)
                },
                Pe = function(e, t) {
                    t[O] = y + e + "px, 0px" + b
                },
                Ae = function(e, t) {
                    if (!a.loop && t) {
                        var n = c + (me.x * fe - e) / me.x,
                            r = Math.round(e - ct.x);
                        (n < 0 && r > 0 || n >= Ht() - 1 && r < 0) && (e = ct.x + r * a.mainScrollEndFriction)
                    }
                    ct.x = e, Pe(e, d)
                },
                Ie = function(e, t) {
                    var n = dt[e] - he[e];
                    return ce[e] + ue[e] + n - n * (t / g)
                },
                ze = function(e, t) {
                    e.x = t.x, e.y = t.y, t.id && (e.id = t.id)
                },
                Le = function(e) {
                    e.x = Math.round(e.x), e.y = Math.round(e.y)
                },
                De = null,
                Ne = function() {
                    De && (i.unbind(document, "mousemove", Ne), i.addClass(e, "pwwp--has_mouse"), a.mouseUsed = !0, Se("mouseUsed")), De = setTimeout((function() {
                        De = null
                    }), 100)
                },
                Be = function(e, t) {
                    var n = Ut(o.currItem, pe, e);
                    return t && (ee = n), n
                },
                Fe = function(e) {
                    return e || (e = o.currItem), e.initialZoomLevel
                },
                We = function(e) {
                    return e || (e = o.currItem), e.w > 0 ? a.maxSpreadZoom : 1
                },
                He = function(e, t, n, r) {
                    return r === o.currItem.initialZoomLevel ? (n[e] = o.currItem.initialPosition[e], !0) : (n[e] = Ie(e, r), n[e] > t.min[e] ? (n[e] = t.min[e], !0) : n[e] < t.max[e] && (n[e] = t.max[e], !0))
                },
                je = function(e) {
                    var t = "";
                    a.escKey && 27 === e.keyCode ? t = "close" : a.arrowKeys && (37 === e.keyCode ? t = "prev" : 39 === e.keyCode && (t = "next")), t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : e.returnValue = !1, o[t]()))
                },
                $e = function(e) {
                    e && (Z || G || ne || $) && (e.preventDefault(), e.stopPropagation())
                },
                Ve = function() {
                    o.setScrollOffset(0, i.getScrollY())
                },
                qe = {},
                Ue = 0,
                Ge = function(e) {
                    qe[e] && (qe[e].raf && A(qe[e].raf), Ue--, delete qe[e])
                },
                Ze = function(e) {
                    qe[e] && Ge(e), qe[e] || (Ue++, qe[e] = {})
                },
                Ke = function() {
                    for (var e in qe)
                        qe.hasOwnProperty(e) && Ge(e)
                },
                Ye = function(e, t, n, r, i, o, a) {
                    var s,
                        l = ke();
                    Ze(e);
                    var u = function() {
                        if (qe[e]) {
                            if ((s = ke() - l) >= r)
                                return Ge(e), o(n), void (a && a());
                            o((n - t) * i(s / r) + t), qe[e].raf = P(u)
                        }
                    };
                    u()
                },
                Xe = {
                    shout: Se,
                    listen: Ee,
                    viewportSize: pe,
                    options: a,
                    isMainScrollAnimating: function() {
                        return ne
                    },
                    getZoomLevel: function() {
                        return v
                    },
                    getCurrentIndex: function() {
                        return c
                    },
                    isDragging: function() {
                        return q
                    },
                    isZooming: function() {
                        return J
                    },
                    setScrollOffset: function(e, t) {
                        he.x = e, D = he.y = t, Se("updateScrollOffset", he)
                    },
                    applyZoomPan: function(e, t, n, r) {
                        de.x = t, de.y = n, v = e, Me(r)
                    },
                    init: function() {
                        if (!s && !l) {
                            var n;
                            o.framework = i, o.template = e, o.bg = i.getChildByClass(e, "pwwp__bg"), I = e.className, s = !0, N = i.detectFeatures(), P = N.raf, A = N.caf, O = N.transform, L = N.oldIE, o.scrollWrap = i.getChildByClass(e, "pwwp__scroll-wrap"), o.container = i.getChildByClass(o.scrollWrap, "pwwp__container"), d = o.container.style, o.itemHolders = _ = [{
                                el: o.container.children[0],
                                wrap: 0,
                                index: -1
                            }, {
                                el: o.container.children[1],
                                wrap: 0,
                                index: -1
                            }, {
                                el: o.container.children[2],
                                wrap: 0,
                                index: -1
                            }], _[0].el.style.display = _[2].el.style.display = "none", function() {
                                if (O) {
                                    var t = N.perspective && !R;
                                    return y = "translate" + (t ? "3d(" : "("), void (b = N.perspective ? ", 0px)" : ")")
                                }
                                O = "left", i.addClass(e, "pwwp--ie"), Pe = function(e, t) {
                                    t.left = e + "px"
                                }, Re = function(e) {
                                    var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                                        n = e.container.style,
                                        r = t * e.w,
                                        i = t * e.h;
                                    n.width = r + "px", n.height = i + "px", n.left = e.initialPosition.x + "px", n.top = e.initialPosition.y + "px"
                                }, Me = function() {
                                    if (te) {
                                        var e = te,
                                            t = o.currItem,
                                            n = t.fitRatio > 1 ? 1 : t.fitRatio,
                                            r = n * t.w,
                                            i = n * t.h;
                                        e.width = r + "px", e.height = i + "px", e.left = de.x + "px", e.top = de.y + "px"
                                    }
                                }
                            }(), m = {
                                resize: o.updateSize,
                                orientationchange: function() {
                                    clearTimeout(B), B = setTimeout((function() {
                                        pe.x !== o.scrollWrap.clientWidth && o.updateSize()
                                    }), 500)
                                },
                                scroll: Ve,
                                keydown: je,
                                click: $e
                            };
                            var r = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
                            for (N.animationName && N.transform && !r || (a.showAnimationDuration = a.hideAnimationDuration = 0), n = 0; n < ye.length; n++)
                                o["init" + ye[n]]();
                            t && (o.ui = new t(o, i)).init(), Se("firstUpdate"), c = c || a.index || 0, (isNaN(c) || c < 0 || c >= Ht()) && (c = 0), o.currItem = Wt(c), (N.isOldIOSPhone || N.isOldAndroid) && (ge = !1), e.setAttribute("aria-hidden", "false"), a.modal && (ge ? e.style.position = "fixed" : (e.style.position = "absolute", e.style.top = i.getScrollY() + "px")), void 0 === D && (Se("initialLayout"), D = z = i.getScrollY());
                            var u = "pwwp--open ";
                            for (a.mainClass && (u += a.mainClass + " "), a.showHideOpacity && (u += "pwwp--animate_opacity "), u += R ? "pwwp--touch" : "pwwp--notouch", u += N.animationName ? " pwwp--css_animation" : "", u += N.svg ? " pwwp--svg" : "", i.addClass(e, u), o.updateSize(), p = -1, ve = null, n = 0; n < 3; n++)
                                Pe((n + p) * me.x, _[n].el.style);
                            L || i.bind(o.scrollWrap, h, o), Ee("initialZoomInEnd", (function() {
                                o.setContent(_[0], c - 1), o.setContent(_[2], c + 1), _[0].el.style.display = _[2].el.style.display = "block", a.focus && e.focus(), i.bind(document, "keydown", o), N.transform && i.bind(o.scrollWrap, "click", o), a.mouseUsed || i.bind(document, "mousemove", Ne), i.bind(window, "resize scroll orientationchange", o), Se("bindEvents")
                            })), o.setContent(_[1], c), o.updateCurrItem(), Se("afterInit"), ge || (w = setInterval((function() {
                                Ue || q || J || v !== o.currItem.initialZoomLevel || o.updateSize()
                            }), 1e3)), i.addClass(e, "pwwp--visible")
                        }
                    },
                    close: function() {
                        s && (s = !1, l = !0, Se("close"), i.unbind(window, "resize scroll orientationchange", o), i.unbind(window, "scroll", m.scroll), i.unbind(document, "keydown", o), i.unbind(document, "mousemove", Ne), N.transform && i.unbind(o.scrollWrap, "click", o), q && i.unbind(window, f, o), clearTimeout(B), Se("unbindEvents"), jt(o.currItem, null, !0, o.destroy))
                    },
                    destroy: function() {
                        Se("destroy"), Dt && clearTimeout(Dt), e.setAttribute("aria-hidden", "true"), e.className = I, w && clearInterval(w), i.unbind(o.scrollWrap, h, o), i.unbind(window, "scroll", o), ht(), Ke(), Ce = null
                    },
                    panTo: function(e, t, n) {
                        n || (e > ee.min.x ? e = ee.min.x : e < ee.max.x && (e = ee.max.x), t > ee.min.y ? t = ee.min.y : t < ee.max.y && (t = ee.max.y)), de.x = e, de.y = t, Me()
                    },
                    handleEvent: function(e) {
                        e = e || window.event, m[e.type] && m[e.type](e)
                    },
                    goTo: function(e) {
                        var t = (e = _e(e)) - c;
                        ve = t, c = e, o.currItem = Wt(c), fe -= t, Ae(me.x * fe), Ke(), ne = !1, o.updateCurrItem()
                    },
                    next: function() {
                        o.goTo(c + 1)
                    },
                    prev: function() {
                        o.goTo(c - 1)
                    },
                    updateCurrZoomItem: function(e) {
                        if (e && Se("beforeChange", 0), _[1].el.children.length) {
                            var t = _[1].el.children[0];
                            te = i.hasClass(t, "pwwp__zoom-wrap") ? t.style : null
                        } else
                            te = null;
                        ee = o.currItem.bounds, g = v = o.currItem.initialZoomLevel, de.x = ee.center.x, de.y = ee.center.y, e && Se("afterChange")
                    },
                    invalidateCurrItems: function() {
                        x = !0;
                        for (var e = 0; e < 3; e++)
                            _[e].item && (_[e].item.needsUpdate = !0)
                    },
                    updateCurrItem: function(e) {
                        if (0 !== ve) {
                            var t,
                                n = Math.abs(ve);
                            if (!(e && n < 2)) {
                                o.currItem = Wt(c), we = !1, Se("beforeChange", ve), n >= 3 && (p += ve + (ve > 0 ? -3 : 3), n = 3);
                                for (var r = 0; r < n; r++)
                                    ve > 0 ? (t = _.shift(), _[2] = t, p++, Pe((p + 2) * me.x, t.el.style), o.setContent(t, c - n + r + 1 + 1)) : (t = _.pop(), _.unshift(t), p--, Pe(p * me.x, t.el.style), o.setContent(t, c + n - r - 1 - 1));
                                if (te && 1 === Math.abs(ve)) {
                                    var i = Wt(C);
                                    i.initialZoomLevel !== v && (Ut(i, pe), Yt(i), Re(i))
                                }
                                ve = 0, o.updateCurrZoomItem(), C = c, Se("afterChange")
                            }
                        }
                    },
                    updateSize: function(t) {
                        if (!ge && a.modal) {
                            var n = i.getScrollY();
                            if (D !== n && (e.style.top = n + "px", D = n), !t && be.x === window.innerWidth && be.y === window.innerHeight)
                                return;
                            be.x = window.innerWidth, be.y = window.innerHeight, e.style.height = be.y + "px"
                        }
                        if (pe.x = o.scrollWrap.clientWidth, pe.y = o.scrollWrap.clientHeight, Ve(), me.x = pe.x + Math.round(pe.x * a.spacing), me.y = pe.y, Ae(me.x * fe), Se("beforeResize"), void 0 !== p) {
                            for (var r, s, l, u = 0; u < 3; u++)
                                r = _[u], Pe((u + p) * me.x, r.el.style), l = c + u - 1, a.loop && Ht() > 2 && (l = _e(l)), (s = Wt(l)) && (x || s.needsUpdate || !s.bounds) ? (o.cleanSlide(s), o.setContent(r, l), 1 === u && (o.currItem = s, o.updateCurrZoomItem(!0)), s.needsUpdate = !1) : -1 === r.index && l >= 0 && o.setContent(r, l), s && s.container && (Ut(s, pe), Yt(s), Re(s));
                            x = !1
                        }
                        g = v = o.currItem.initialZoomLevel, (ee = o.currItem.bounds) && (de.x = ee.center.x, de.y = ee.center.y, Me(!0)), Se("resize")
                    },
                    zoomTo: function(e, t, n, r, o) {
                        t && (g = v, dt.x = Math.abs(t.x) - de.x, dt.y = Math.abs(t.y) - de.y, ze(ce, de));
                        var a = Be(e, !1),
                            s = {};
                        He("x", a, s, e), He("y", a, s, e);
                        var l = v,
                            u = de.x,
                            c = de.y;
                        Le(s);
                        var d = function(t) {
                            1 === t ? (v = e, de.x = s.x, de.y = s.y) : (v = (e - l) * t + l, de.x = (s.x - u) * t + u, de.y = (s.y - c) * t + c), o && o(t), Me(1 === t)
                        };
                        n ? Ye("customZoomTo", 0, 1, n, r || i.easing.sine.inOut, d) : d(1)
                    }
                },
                Je = {},
                Qe = {},
                et = {},
                tt = {},
                nt = {},
                rt = [],
                it = {},
                ot = [],
                at = {},
                st = 0,
                lt = {
                    x: 0,
                    y: 0
                },
                ut = 0,
                ct = {
                    x: 0,
                    y: 0
                },
                dt = {
                    x: 0,
                    y: 0
                },
                pt = {
                    x: 0,
                    y: 0
                },
                ft = function(e, t) {
                    return at.x = Math.abs(e.x - t.x), at.y = Math.abs(e.y - t.y), Math.sqrt(at.x * at.x + at.y * at.y)
                },
                ht = function() {
                    K && (A(K), K = null)
                },
                mt = function() {
                    q && (K = P(mt), Mt())
                },
                vt = function(e, t) {
                    return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pwwp__scroll-wrap") > -1) && (t(e) ? e : vt(e.parentNode, t))
                },
                gt = {},
                yt = function(e, t) {
                    return gt.prevent = !vt(e.target, a.isClickableElement), Se("preventDragEvent", e, t, gt), gt.prevent
                },
                bt = function(e, t) {
                    return t.x = e.pageX, t.y = e.pageY, t.id = e.identifier, t
                },
                wt = function(e, t, n) {
                    n.x = .5 * (e.x + t.x), n.y = .5 * (e.y + t.y)
                },
                xt = function() {
                    var e = de.y - o.currItem.initialPosition.y;
                    return 1 - Math.abs(e / (pe.y / 2))
                },
                _t = {},
                Ct = {},
                Et = [],
                St = function(e) {
                    for (; Et.length > 0;)
                        Et.pop();
                    return M ? (le = 0, rt.forEach((function(e) {
                        0 === le ? Et[0] = e : 1 === le && (Et[1] = e), le++
                    }))) : e.type.indexOf("touch") > -1 ? e.touches && e.touches.length > 0 && (Et[0] = bt(e.touches[0], _t), e.touches.length > 1 && (Et[1] = bt(e.touches[1], Ct))) : (_t.x = e.pageX, _t.y = e.pageY, _t.id = "", Et[0] = _t), Et
                },
                kt = function(e, t) {
                    var n,
                        r,
                        i,
                        s,
                        l = de[e] + t[e],
                        u = t[e] > 0,
                        c = ct.x + t.x,
                        d = ct.x - it.x;
                    if (n = l > ee.min[e] || l < ee.max[e] ? a.panEndFriction : 1, l = de[e] + t[e] * n, (a.allowPanToNext || v === o.currItem.initialZoomLevel) && (te ? "h" !== re || "x" !== e || G || (u ? (l > ee.min[e] && (n = a.panEndFriction, ee.min[e], r = ee.min[e] - ce[e]), (r <= 0 || d < 0) && Ht() > 1 ? (s = c, d < 0 && c > it.x && (s = it.x)) : ee.min.x !== ee.max.x && (i = l)) : (l < ee.max[e] && (n = a.panEndFriction, ee.max[e], r = ce[e] - ee.max[e]), (r <= 0 || d > 0) && Ht() > 1 ? (s = c, d > 0 && c < it.x && (s = it.x)) : ee.min.x !== ee.max.x && (i = l))) : s = c, "x" === e))
                        return void 0 !== s && (Ae(s, !0), Y = s !== it.x), ee.min.x !== ee.max.x && (void 0 !== i ? de.x = i : Y || (de.x += t.x * n)), void 0 !== s;
                    ne || Y || v > o.currItem.fitRatio && (de[e] += t[e] * n)
                },
                Tt = function(e) {
                    if (!("mousedown" === e.type && e.button > 0))
                        if (Ft)
                            e.preventDefault();
                        else if (!V || "mousedown" !== e.type) {
                            if (yt(e, !0) && e.preventDefault(), Se("pointerDown"), M) {
                                var t = i.arraySearch(rt, e.pointerId, "id");
                                t < 0 && (t = rt.length), rt[t] = {
                                    x: e.pageX,
                                    y: e.pageY,
                                    id: e.pointerId
                                }
                            }
                            var n = St(e),
                                r = n.length;
                            X = null, Ke(), q && 1 !== r || (q = ie = !0, i.bind(window, f, o), j = se = oe = $ = Y = Z = U = G = !1, re = null, Se("firstTouchStart", n), ze(ce, de), ue.x = ue.y = 0, ze(tt, n[0]), ze(nt, tt), it.x = me.x * fe, ot = [{
                                x: tt.x,
                                y: tt.y
                            }], W = F = ke(), Be(v, !0), ht(), mt()), !J && r > 1 && !ne && !Y && (g = v, G = !1, J = U = !0, ue.y = ue.x = 0, ze(ce, de), ze(Je, n[0]), ze(Qe, n[1]), wt(Je, Qe, pt), dt.x = Math.abs(pt.x) - de.x, dt.y = Math.abs(pt.y) - de.y, Q = ft(Je, Qe))
                        }
                },
                Ot = function(e) {
                    if (e.preventDefault(), M) {
                        var t = i.arraySearch(rt, e.pointerId, "id");
                        if (t > -1) {
                            var n = rt[t];
                            n.x = e.pageX, n.y = e.pageY
                        }
                    }
                    if (q) {
                        var r = St(e);
                        if (re || Z || J)
                            X = r;
                        else if (ct.x !== me.x * fe)
                            re = "h";
                        else {
                            var o = Math.abs(r[0].x - tt.x) - Math.abs(r[0].y - tt.y);
                            Math.abs(o) >= 10 && (re = o > 0 ? "h" : "v", X = r)
                        }
                    }
                },
                Mt = function() {
                    if (X) {
                        var e = X.length;
                        if (0 !== e)
                            if (ze(Je, X[0]), et.x = Je.x - tt.x, et.y = Je.y - tt.y, J && e > 1) {
                                if (tt.x = Je.x, tt.y = Je.y, !et.x && !et.y && function(e, t) {
                                    return e.x === t.x && e.y === t.y
                                }(X[1], Qe))
                                    return;
                                ze(Qe, X[1]), G || (G = !0, Se("zoomGestureStarted"));
                                var t = ft(Je, Qe),
                                    n = zt(t);
                                n > o.currItem.initialZoomLevel + o.currItem.initialZoomLevel / 15 && (se = !0);
                                var r = 1,
                                    i = Fe(),
                                    s = We();
                                if (n < i)
                                    if (a.pinchToClose && !se && g <= o.currItem.initialZoomLevel) {
                                        var l = 1 - (i - n) / (i / 1.2);
                                        Te(l), Se("onPinchClose", l), oe = !0
                                    } else
                                        (r = (i - n) / i) > 1 && (r = 1), n = i - r * (i / 3);
                                else
                                    n > s && ((r = (n - s) / (6 * i)) > 1 && (r = 1), n = s + r * i);
                                r < 0 && (r = 0), wt(Je, Qe, lt), ue.x += lt.x - pt.x, ue.y += lt.y - pt.y, ze(pt, lt), de.x = Ie("x", n), de.y = Ie("y", n), j = n > v, v = n, Me()
                            } else {
                                if (!re)
                                    return;
                                if (ie && (ie = !1, Math.abs(et.x) >= 10 && (et.x -= X[0].x - nt.x), Math.abs(et.y) >= 10 && (et.y -= X[0].y - nt.y)), tt.x = Je.x, tt.y = Je.y, 0 === et.x && 0 === et.y)
                                    return;
                                if ("v" === re && a.closeOnVerticalDrag && "fit" === a.scaleMode && v === o.currItem.initialZoomLevel) {
                                    ue.y += et.y, de.y += et.y;
                                    var u = xt();
                                    return $ = !0, Se("onVerticalDrag", u), Te(u), void Me()
                                }
                                !function(e, t, n) {
                                    if (e - W > 50) {
                                        var r = ot.length > 2 ? ot.shift() : {};
                                        r.x = t, r.y = n, ot.push(r), W = e
                                    }
                                }(ke(), Je.x, Je.y), Z = !0, ee = o.currItem.bounds, kt("x", et) || (kt("y", et), Le(de), Me())
                            }
                    }
                },
                Rt = function(e) {
                    if (N.isOldAndroid) {
                        if (V && "mouseup" === e.type)
                            return;
                        e.type.indexOf("touch") > -1 && (clearTimeout(V), V = setTimeout((function() {
                            V = 0
                        }), 600))
                    }
                    var t;
                    if (Se("pointerUp"), yt(e, !1) && e.preventDefault(), M) {
                        var n = i.arraySearch(rt, e.pointerId, "id");
                        n > -1 && (t = rt.splice(n, 1)[0], navigator.msPointerEnabled ? (t.type = {
                            4: "mouse",
                            2: "touch",
                            3: "pen"
                        }[e.pointerType], t.type || (t.type = e.pointerType || "mouse")) : t.type = e.pointerType || "mouse")
                    }
                    var r,
                        s = St(e),
                        l = s.length;
                    if ("mouseup" === e.type && (l = 0), 2 === l)
                        return X = null, !0;
                    1 === l && ze(nt, s[0]), 0 !== l || re || ne || (t || ("mouseup" === e.type ? t = {
                        x: e.pageX,
                        y: e.pageY,
                        type: "mouse"
                    } : e.changedTouches && e.changedTouches[0] && (t = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: "touch"
                    })), Se("touchRelease", e, t));
                    var u = -1;
                    if (0 === l && (q = !1, i.unbind(window, f, o), ht(), J ? u = 0 : -1 !== ut && (u = ke() - ut)), ut = 1 === l ? ke() : -1, r = -1 !== u && u < 150 ? "zoom" : "swipe", J && l < 2 && (J = !1, 1 === l && (r = "zoomPointerUp"), Se("zoomGestureEnded")), X = null, Z || G || ne || $)
                        if (Ke(), H || (H = Pt()), H.calculateSwipeSpeed("x"), $)
                            if (xt() < a.verticalDragRange)
                                o.close();
                            else {
                                var c = de.y,
                                    d = ae;
                                Ye("verticalDrag", 0, 1, 300, i.easing.cubic.out, (function(e) {
                                    de.y = (o.currItem.initialPosition.y - c) * e + c, Te((1 - d) * e + d), Me()
                                })), Se("onVerticalDrag", 1)
                            }
                        else {
                            if ((Y || ne) && 0 === l) {
                                if (It(r, H))
                                    return;
                                r = "zoomPointerUp"
                            }
                            ne || ("swipe" === r ? !Y && v > o.currItem.fitRatio && At(H) : Lt())
                        }
                },
                Pt = function() {
                    var e,
                        t,
                        n = {
                            lastFlickOffset: {},
                            lastFlickDist: {},
                            lastFlickSpeed: {},
                            slowDownRatio: {},
                            slowDownRatioReverse: {},
                            speedDecelerationRatio: {},
                            speedDecelerationRatioAbs: {},
                            distanceOffset: {},
                            backAnimDestination: {},
                            backAnimStarted: {},
                            calculateSwipeSpeed: function(r) {
                                ot.length > 1 ? (e = ke() - W + 50, t = ot[ot.length - 2][r]) : (e = ke() - F, t = nt[r]), n.lastFlickOffset[r] = tt[r] - t, n.lastFlickDist[r] = Math.abs(n.lastFlickOffset[r]), n.lastFlickDist[r] > 20 ? n.lastFlickSpeed[r] = n.lastFlickOffset[r] / e : n.lastFlickSpeed[r] = 0, Math.abs(n.lastFlickSpeed[r]) < .1 && (n.lastFlickSpeed[r] = 0), n.slowDownRatio[r] = .95, n.slowDownRatioReverse[r] = 1 - n.slowDownRatio[r], n.speedDecelerationRatio[r] = 1
                            },
                            calculateOverBoundsAnimOffset: function(e, t) {
                                n.backAnimStarted[e] || (de[e] > ee.min[e] ? n.backAnimDestination[e] = ee.min[e] : de[e] < ee.max[e] && (n.backAnimDestination[e] = ee.max[e]), void 0 !== n.backAnimDestination[e] && (n.slowDownRatio[e] = .7, n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e], n.speedDecelerationRatioAbs[e] < .05 && (n.lastFlickSpeed[e] = 0, n.backAnimStarted[e] = !0, Ye("bounceZoomPan" + e, de[e], n.backAnimDestination[e], t || 300, i.easing.sine.out, (function(t) {
                                    de[e] = t, Me()
                                })))))
                            },
                            calculateAnimOffset: function(e) {
                                n.backAnimStarted[e] || (n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - n.slowDownRatioReverse[e] * n.timeDiff / 10), n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]), n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff, de[e] += n.distanceOffset[e])
                            },
                            panAnimLoop: function() {
                                if (qe.zoomPan && (qe.zoomPan.raf = P(n.panAnimLoop), n.now = ke(), n.timeDiff = n.now - n.lastNow, n.lastNow = n.now, n.calculateAnimOffset("x"), n.calculateAnimOffset("y"), Me(), n.calculateOverBoundsAnimOffset("x"), n.calculateOverBoundsAnimOffset("y"), n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05))
                                    return de.x = Math.round(de.x), de.y = Math.round(de.y), Me(), void Ge("zoomPan")
                            }
                        };
                    return n
                },
                At = function(e) {
                    if (e.calculateSwipeSpeed("y"), ee = o.currItem.bounds, e.backAnimDestination = {}, e.backAnimStarted = {}, Math.abs(e.lastFlickSpeed.x) <= .05 && Math.abs(e.lastFlickSpeed.y) <= .05)
                        return e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0, e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0;
                    Ze("zoomPan"), e.lastNow = ke(), e.panAnimLoop()
                },
                It = function(e, t) {
                    var n,
                        r,
                        s;
                    if (ne || (st = c), "swipe" === e) {
                        var l = tt.x - nt.x,
                            u = t.lastFlickDist.x < 10;
                        l > 30 && (u || t.lastFlickOffset.x > 20) ? r = -1 : l < -30 && (u || t.lastFlickOffset.x < -20) && (r = 1)
                    }
                    r && ((c += r) < 0 ? (c = a.loop ? Ht() - 1 : 0, s = !0) : c >= Ht() && (c = a.loop ? 0 : Ht() - 1, s = !0), s && !a.loop || (ve += r, fe -= r, n = !0));
                    var d,
                        p = me.x * fe,
                        f = Math.abs(p - ct.x);
                    return n || p > ct.x == t.lastFlickSpeed.x > 0 ? (d = Math.abs(t.lastFlickSpeed.x) > 0 ? f / Math.abs(t.lastFlickSpeed.x) : 333, d = Math.min(d, 400), d = Math.max(d, 250)) : d = 333, st === c && (n = !1), ne = !0, Se("mainScrollAnimStart"), Ye("mainScroll", ct.x, p, d, i.easing.cubic.out, Ae, (function() {
                        Ke(), ne = !1, st = -1, (n || st !== c) && o.updateCurrItem(), Se("mainScrollAnimComplete")
                    })), n && o.updateCurrItem(!0), n
                },
                zt = function(e) {
                    return 1 / Q * e * g
                },
                Lt = function() {
                    var e = v,
                        t = Fe(),
                        n = We();
                    v < t ? e = t : v > n && (e = n);
                    var r,
                        a = ae;
                    return oe && !j && !se && v < t ? (o.close(), !0) : (oe && (r = function(e) {
                        Te((1 - a) * e + a)
                    }), o.zoomTo(e, 0, 200, i.easing.cubic.out, r), !0)
                };
            xe("Gestures", {
                publicMethods: {
                    initGestures: function() {
                        var e = function(e, t, n, r, i) {
                            E = e + t, S = e + n, k = e + r, T = i ? e + i : ""
                        };
                        (M = N.pointerEvent) && N.touch && (N.touch = !1), M ? navigator.msPointerEnabled ? e("MSPointer", "Down", "Move", "Up", "Cancel") : e("pointer", "down", "move", "up", "cancel") : N.touch ? (e("touch", "start", "move", "end", "cancel"), R = !0) : e("mouse", "down", "move", "up"), f = S + " " + k + " " + T, h = E, M && !R && (R = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), o.likelyTouchDevice = R, m[E] = Tt, m[S] = Ot, m[k] = Rt, T && (m[T] = m[k]), N.touch && (h += " mousedown", f += " mousemove mouseup", m.mousedown = m[E], m.mousemove = m[S], m.mouseup = m[k]), R || (a.allowPanToNext = !1)
                    }
                }
            });
            var Dt,
                Nt,
                Bt,
                Ft,
                Wt,
                Ht,
                jt = function(t, n, r, s) {
                    var l;
                    Dt && clearTimeout(Dt), Ft = !0, Bt = !0, t.initialLayout ? (l = t.initialLayout, t.initialLayout = null) : l = a.getThumbBoundsFn && a.getThumbBoundsFn(c);
                    var d,
                        p,
                        f = r ? a.hideAnimationDuration : a.showAnimationDuration,
                        h = function() {
                            Ge("initialZoom"), r ? (o.template.removeAttribute("style"), o.bg.removeAttribute("style")) : (Te(1), n && (n.style.display = "block"), i.addClass(e, "pwwp--animated-in"), Se("initialZoom" + (r ? "OutEnd" : "InEnd"))), s && s(), Ft = !1
                        };
                    if (!f || !l || void 0 === l.x)
                        return Se("initialZoom" + (r ? "Out" : "In")), v = t.initialZoomLevel, ze(de, t.initialPosition), Me(), e.style.opacity = r ? 0 : 1, Te(1), void (f ? setTimeout((function() {
                            h()
                        }), f) : h());
                    d = u, p = !o.currItem.src || o.currItem.loadError || a.showHideOpacity, t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"), r || (v = l.w / t.w, de.x = l.x, de.y = l.y - z, o[p ? "template" : "bg"].style.opacity = .001, Me()), Ze("initialZoom"), r && !d && i.removeClass(e, "pwwp--animated-in"), p && (r ? i[(d ? "remove" : "add") + "Class"](e, "pwwp--animate_opacity") : setTimeout((function() {
                        i.addClass(e, "pwwp--animate_opacity")
                    }), 30)), Dt = setTimeout((function() {
                        if (Se("initialZoom" + (r ? "Out" : "In")), r) {
                            var n = l.w / t.w,
                                o = {
                                    x: de.x,
                                    y: de.y
                                },
                                a = v,
                                s = ae,
                                u = function(t) {
                                    1 === t ? (v = n, de.x = l.x, de.y = l.y - D) : (v = (n - a) * t + a, de.x = (l.x - o.x) * t + o.x, de.y = (l.y - D - o.y) * t + o.y), Me(), p ? e.style.opacity = 1 - t : Te(s - t * s)
                                };
                            d ? Ye("initialZoom", 0, 1, f, i.easing.cubic.out, u, h) : (u(1), Dt = setTimeout(h, f + 20))
                        } else
                            v = t.initialZoomLevel, ze(de, t.initialPosition), Me(), Te(1), p ? e.style.opacity = 1 : Te(1), Dt = setTimeout(h, f + 20)
                    }), r ? 25 : 90)
                },
                $t = {},
                Vt = [],
                qt = {
                    index: 0,
                    errorMsg: '<div class="pwwp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                    forceProgressiveLoading: !1,
                    preload: [1, 1],
                    getNumItemsFn: function() {
                        return Nt.length
                    }
                },
                Ut = function(e, t, n) {
                    if (e.src && !e.loadError) {
                        var r = !n;
                        if (r && (e.vGap || (e.vGap = {
                            top: 0,
                            bottom: 0
                        }), Se("parseVerticalMargin", e)), $t.x = t.x, $t.y = t.y - e.vGap.top - e.vGap.bottom, r) {
                            var i = $t.x / e.w,
                                o = $t.y / e.h;
                            e.fitRatio = i < o ? i : o;
                            var s = a.scaleMode;
                            "orig" === s ? n = 1 : "fit" === s && (n = e.fitRatio), n > 1 && (n = 1), e.initialZoomLevel = n, e.bounds || (e.bounds = {
                                center: {
                                    x: 0,
                                    y: 0
                                },
                                max: {
                                    x: 0,
                                    y: 0
                                },
                                min: {
                                    x: 0,
                                    y: 0
                                }
                            })
                        }
                        if (!n)
                            return;
                        return function(e, t, n) {
                            var r = e.bounds;
                            r.center.x = Math.round(($t.x - t) / 2), r.center.y = Math.round(($t.y - n) / 2) + e.vGap.top, r.max.x = t > $t.x ? Math.round($t.x - t) : r.center.x, r.max.y = n > $t.y ? Math.round($t.y - n) + e.vGap.top : r.center.y, r.min.x = t > $t.x ? 0 : r.center.x, r.min.y = n > $t.y ? e.vGap.top : r.center.y
                        }(e, e.w * n, e.h * n), r && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center), e.bounds
                    }
                    return e.w = e.h = 0, e.initialZoomLevel = e.fitRatio = 1, e.bounds = {
                        center: {
                            x: 0,
                            y: 0
                        },
                        max: {
                            x: 0,
                            y: 0
                        },
                        min: {
                            x: 0,
                            y: 0
                        }
                    }, e.initialPosition = e.bounds.center, e.bounds
                },
                Gt = function(e, t, n, r, i, a) {
                    t.loadError || r && (t.imageAppended = !0, Yt(t, r, t === o.currItem && we), n.appendChild(r), a && setTimeout((function() {
                        t && t.loaded && t.placeholder && (t.placeholder.style.display = "none", t.placeholder = null)
                    }), 500))
                },
                Zt = function(e) {
                    e.loading = !0, e.loaded = !1;
                    var t = e.img = i.createEl("pwwp__img", "img"),
                        n = function() {
                            e.loading = !1, e.loaded = !0, e.loadComplete ? e.loadComplete(e) : e.img = null, t.onload = t.onerror = null, t = null
                        };
                    return t.onload = n, t.onerror = function() {
                        e.loadError = !0, n()
                    }, t.src = e.src, t
                },
                Kt = function(e, t) {
                    if (e.src && e.loadError && e.container)
                        return t && (e.container.innerHTML = ""), e.container.innerHTML = a.errorMsg.replace("%url%", e.src), !0
                },
                Yt = function(e, t, n) {
                    if (e.src) {
                        t || (t = e.container.lastChild);
                        var r = n ? e.w : Math.round(e.w * e.fitRatio),
                            i = n ? e.h : Math.round(e.h * e.fitRatio);
                        e.placeholder && !e.loaded && (e.placeholder.style.width = r + "px", e.placeholder.style.height = i + "px"), t.style.width = r + "px", t.style.height = i + "px"
                    }
                },
                Xt = function() {
                    if (Vt.length) {
                        for (var e, t = 0; t < Vt.length; t++)
                            (e = Vt[t]).holder.index === e.index && Gt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
                        Vt = []
                    }
                };
            xe("Controller", {
                publicMethods: {
                    lazyLoadItem: function(e) {
                        e = _e(e);
                        var t = Wt(e);
                        t && (!t.loaded && !t.loading || x) && (Se("gettingData", e, t), t.src && Zt(t))
                    },
                    initController: function() {
                        i.extend(a, qt, !0), o.items = Nt = n, Wt = o.getItemAt, Ht = a.getNumItemsFn, a.loop, Ht() < 3 && (a.loop = !1), Ee("beforeChange", (function(e) {
                            var t,
                                n = a.preload,
                                r = null === e || e >= 0,
                                i = Math.min(n[0], Ht()),
                                s = Math.min(n[1], Ht());
                            for (t = 1; t <= (r ? s : i); t++)
                                o.lazyLoadItem(c + t);
                            for (t = 1; t <= (r ? i : s); t++)
                                o.lazyLoadItem(c - t)
                        })), Ee("initialLayout", (function() {
                            o.currItem.initialLayout = a.getThumbBoundsFn && a.getThumbBoundsFn(c)
                        })), Ee("mainScrollAnimComplete", Xt), Ee("initialZoomInEnd", Xt), Ee("destroy", (function() {
                            for (var e, t = 0; t < Nt.length; t++)
                                (e = Nt[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                            Vt = null
                        }))
                    },
                    getItemAt: function(e) {
                        return e >= 0 && void 0 !== Nt[e] && Nt[e]
                    },
                    allowProgressiveImg: function() {
                        return a.forceProgressiveLoading || !R || a.mouseUsed || screen.width > 1200
                    },
                    setContent: function(e, t) {
                        a.loop && (t = _e(t));
                        var n = o.getItemAt(e.index);
                        n && (n.container = null);
                        var r,
                            l = o.getItemAt(t);
                        if (l) {
                            Se("gettingData", t, l), e.index = t, e.item = l;
                            var u = l.container = i.createEl("pwwp__zoom-wrap");
                            if (!l.src && l.html && (l.html.tagName ? u.appendChild(l.html) : u.innerHTML = l.html), Kt(l), Ut(l, pe), !l.src || l.loadError || l.loaded)
                                l.src && !l.loadError && ((r = i.createEl("pwwp__img", "img")).style.opacity = 1, r.src = l.src, Yt(l, r), Gt(0, l, u, r));
                            else {
                                if (l.loadComplete = function(n) {
                                    if (s) {
                                        if (e && e.index === t) {
                                            if (Kt(n, !0))
                                                return n.loadComplete = n.img = null, Ut(n, pe), Re(n), void (e.index === c && o.updateCurrZoomItem());
                                            n.imageAppended ? !Ft && n.placeholder && (n.placeholder.style.display = "none", n.placeholder = null) : N.transform && (ne || Ft) ? Vt.push({
                                                item: n,
                                                baseDiv: u,
                                                img: n.img,
                                                index: t,
                                                holder: e,
                                                clearPlaceholder: !0
                                            }) : Gt(0, n, u, n.img, 0, !0)
                                        }
                                        n.loadComplete = null, n.img = null, Se("imageLoadComplete", t, n)
                                    }
                                }, i.features.transform) {
                                    var d = "pwwp__img pwwp__img--placeholder";
                                    d += l.msrc ? "" : " pwwp__img--placeholder--blank";
                                    var p = i.createEl(d, l.msrc ? "img" : "");
                                    l.msrc && (p.src = l.msrc), Yt(l, p), u.appendChild(p), l.placeholder = p
                                }
                                l.loading || Zt(l), o.allowProgressiveImg() && (!Bt && N.transform ? Vt.push({
                                    item: l,
                                    baseDiv: u,
                                    img: l.img,
                                    index: t,
                                    holder: e
                                }) : Gt(0, l, u, l.img, 0, !0))
                            }
                            Bt || t !== c ? Re(l) : (te = u.style, jt(l, r || l.img)), e.el.innerHTML = "", e.el.appendChild(u)
                        } else
                            e.el.innerHTML = ""
                    },
                    cleanSlide: function(e) {
                        e.img && (e.img.onload = e.img.onerror = null), e.loaded = e.loading = e.img = e.imageAppended = !1
                    }
                }
            });
            var Jt,
                Qt,
                en = {},
                tn = function(e, t, n) {
                    var r = document.createEvent("CustomEvent"),
                        i = {
                            origEvent: e,
                            target: e.target,
                            releasePoint: t,
                            pointerType: n || "touch"
                        };
                    r.initCustomEvent("pwwpTap", !0, !0, i), e.target.dispatchEvent(r)
                };
            xe("Tap", {
                publicMethods: {
                    initTap: function() {
                        Ee("firstTouchStart", o.onTapStart), Ee("touchRelease", o.onTapRelease), Ee("destroy", (function() {
                            en = {}, Jt = null
                        }))
                    },
                    onTapStart: function(e) {
                        e.length > 1 && (clearTimeout(Jt), Jt = null)
                    },
                    onTapRelease: function(e, t) {
                        var n,
                            r;
                        if (t && !Z && !U && !Ue) {
                            var o = t;
                            if (Jt && (clearTimeout(Jt), Jt = null, n = o, r = en, Math.abs(n.x - r.x) < 25 && Math.abs(n.y - r.y) < 25))
                                return void Se("doubleTap", o);
                            if ("mouse" === t.type)
                                return void tn(e, t, "mouse");
                            if ("BUTTON" === e.target.tagName.toUpperCase() || i.hasClass(e.target, "pwwp__single-tap"))
                                return void tn(e, t);
                            ze(en, o), Jt = setTimeout((function() {
                                tn(e, t), Jt = null
                            }), 300)
                        }
                    }
                }
            }), xe("DesktopZoom", {
                publicMethods: {
                    initDesktopZoom: function() {
                        L || (R ? Ee("mouseUsed", (function() {
                            o.setupDesktopZoom()
                        })) : o.setupDesktopZoom(!0))
                    },
                    setupDesktopZoom: function(t) {
                        Qt = {};
                        var n = "wheel mousewheel DOMMouseScroll";
                        Ee("bindEvents", (function() {
                            i.bind(e, n, o.handleMouseWheel)
                        })), Ee("unbindEvents", (function() {
                            Qt && i.unbind(e, n, o.handleMouseWheel)
                        })), o.mouseZoomedIn = !1;
                        var r,
                            a = function() {
                                o.mouseZoomedIn && (i.removeClass(e, "pwwp--zoomed-in"), o.mouseZoomedIn = !1), v < 1 ? i.addClass(e, "pwwp--zoom-allowed") : i.removeClass(e, "pwwp--zoom-allowed"), s()
                            },
                            s = function() {
                                r && (i.removeClass(e, "pwwp--dragging"), r = !1)
                            };
                        Ee("resize", a), Ee("afterChange", a), Ee("pointerDown", (function() {
                            o.mouseZoomedIn && (r = !0, i.addClass(e, "pwwp--dragging"))
                        })), Ee("pointerUp", s), t || a()
                    },
                    handleMouseWheel: function(e) {
                        if (v <= o.currItem.fitRatio)
                            return a.modal && (!a.closeOnScroll || Ue || q ? e.preventDefault() : O && Math.abs(e.deltaY) > 2 && (u = !0, o.close())), !0;
                        if (e.stopPropagation(), Qt.x = 0, "deltaX" in e)
                            1 === e.deltaMode ? (Qt.x = 18 * e.deltaX, Qt.y = 18 * e.deltaY) : (Qt.x = e.deltaX, Qt.y = e.deltaY);
                        else if ("wheelDelta" in e)
                            e.wheelDeltaX && (Qt.x = -.16 * e.wheelDeltaX), e.wheelDeltaY ? Qt.y = -.16 * e.wheelDeltaY : Qt.y = -.16 * e.wheelDelta;
                        else {
                            if (!("detail" in e))
                                return;
                            Qt.y = e.detail
                        }
                        Be(v, !0);
                        var t = de.x - Qt.x,
                            n = de.y - Qt.y;
                        (a.modal || t <= ee.min.x && t >= ee.max.x && n <= ee.min.y && n >= ee.max.y) && e.preventDefault(), o.panTo(t, n)
                    },
                    toggleDesktopZoom: function(t) {
                        t = t || {
                            x: pe.x / 2 + he.x,
                            y: pe.y / 2 + he.y
                        };
                        var n = a.getDoubleTapZoom(!0, o.currItem),
                            r = v === n;
                        o.mouseZoomedIn = !r, o.zoomTo(r ? o.currItem.initialZoomLevel : n, t, 333), i[(r ? "remove" : "add") + "Class"](e, "pwwp--zoomed-in")
                    }
                }
            });
            var nn,
                rn,
                on,
                an,
                sn,
                ln,
                un,
                cn,
                dn,
                pn,
                fn,
                hn,
                mn = {
                    history: !0,
                    galleryUID: 1
                },
                vn = function() {
                    return fn.hash.substring(1)
                },
                gn = function() {
                    nn && clearTimeout(nn), on && clearTimeout(on)
                },
                yn = function() {
                    var e = vn(),
                        t = {};
                    if (e.length < 5)
                        return t;
                    var n,
                        r = e.split("&");
                    for (n = 0; n < r.length; n++)
                        if (r[n]) {
                            var i = r[n].split("=");
                            i.length < 2 || (t[i[0]] = i[1])
                        }
                    if (a.galleryPIDs) {
                        var o = t.pid;
                        for (t.pid = 0, n = 0; n < Nt.length; n++)
                            if (Nt[n].pid === o) {
                                t.pid = n;
                                break
                            }
                    } else
                        t.pid = parseInt(t.pid, 10) - 1;
                    return t.pid < 0 && (t.pid = 0), t
                },
                bn = function() {
                    if (on && clearTimeout(on), Ue || q)
                        on = setTimeout(bn, 500);
                    else {
                        an ? clearTimeout(rn) : an = !0;
                        var e = c + 1,
                            t = Wt(c);
                        t.hasOwnProperty("pid") && (e = t.pid);
                        var n = un + "&gid=" + a.galleryUID + "&pid=" + e;
                        cn || -1 === fn.hash.indexOf(n) && (pn = !0);
                        var r = fn.href.split("#")[0] + "#" + n;
                        hn ? "#" + n !== window.location.hash && history[cn ? "replaceState" : "pushState"]("", document.title, r) : cn ? fn.replace(r) : fn.hash = n, cn = !0, rn = setTimeout((function() {
                            an = !1
                        }), 60)
                    }
                };
            xe("History", {
                publicMethods: {
                    initHistory: function() {
                        if (i.extend(a, mn, !0), a.history) {
                            fn = window.location, pn = !1, dn = !1, cn = !1, un = vn(), hn = "pushState" in history, un.indexOf("gid=") > -1 && (un = (un = un.split("&gid=")[0]).split("?gid=")[0]), Ee("afterChange", o.updateURL), Ee("unbindEvents", (function() {
                                i.unbind(window, "hashchange", o.onHashChange)
                            }));
                            var e = function() {
                                ln = !0, dn || (pn ? history.back() : un ? fn.hash = un : hn ? history.pushState("", document.title, fn.pathname + fn.search) : fn.hash = ""), gn()
                            };
                            Ee("unbindEvents", (function() {
                                u && e()
                            })), Ee("destroy", (function() {
                                ln || e()
                            })), Ee("firstUpdate", (function() {
                                c = yn().pid
                            }));
                            var t = un.indexOf("pid=");
                            t > -1 && "&" === (un = un.substring(0, t)).slice(-1) && (un = un.slice(0, -1)), setTimeout((function() {
                                s && i.bind(window, "hashchange", o.onHashChange)
                            }), 40)
                        }
                    },
                    onHashChange: function() {
                        if (vn() === un)
                            return dn = !0, void o.close();
                        an || (sn = !0, o.goTo(yn().pid), sn = !1)
                    },
                    updateURL: function() {
                        gn(), sn || (cn ? nn = setTimeout(bn, 800) : bn())
                    }
                }
            }), i.extend(o, Xe)
        }
    }, "object" == typeof nm ? nm = tm() : em.PhotoSwipe = tm();
    var rm = t(nm),
        im = {};
    /*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov;*/
    !function(e, t) {
        "object" == typeof im ? im = t() : e.PhotoSwipeUI_Default = t()
    }(im, (function() {
        return function(e, t) {
            var n,
                r,
                i,
                o,
                a,
                s,
                l,
                u,
                c,
                d,
                p,
                f,
                h,
                m,
                v,
                g,
                y,
                b,
                w = this,
                x = !1,
                _ = !0,
                C = !0,
                E = {
                    barsSize: {
                        top: 44,
                        bottom: "auto"
                    },
                    closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                    timeToIdle: 4e3,
                    timeToIdleOutside: 1e3,
                    loadingIndicatorDelay: 1e3,
                    addCaptionHTMLFn: function(e, t) {
                        return e.title ? (t.children[0].innerHTML = e.title, !0) : (t.children[0].innerHTML = "", !1)
                    },
                    closeEl: !0,
                    captionEl: !0,
                    fullscreenEl: !0,
                    zoomEl: !0,
                    shareEl: !0,
                    counterEl: !0,
                    arrowEl: !0,
                    preloaderEl: !0,
                    tapToClose: !1,
                    tapToToggleControls: !0,
                    clickToCloseNonZoomable: !0,
                    shareButtons: [{
                        id: "facebook",
                        label: "Share on Facebook",
                        url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                    }, {
                        id: "twitter",
                        label: "Tweet",
                        url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                    }, {
                        id: "pinterest",
                        label: "Pin it",
                        url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                    }, {
                        id: "download",
                        label: "Download image",
                        url: "{{raw_image_url}}",
                        download: !0
                    }],
                    getImageURLForShare: function() {
                        return e.currItem.src || ""
                    },
                    getPageURLForShare: function() {
                        return window.location.href
                    },
                    getTextForShare: function() {
                        return e.currItem.title || ""
                    },
                    indexIndicatorSep: " / ",
                    fitControlsWidth: 1200
                },
                S = function(e) {
                    if (g)
                        return !0;
                    e = e || window.event, v.timeToIdle && v.mouseUsed && !c && z();
                    for (var n, r, i = (e.target || e.srcElement).getAttribute("class") || "", o = 0; o < B.length; o++)
                        (n = B[o]).onTap && i.indexOf("pwwp__" + n.name) > -1 && (n.onTap(), r = !0);
                    if (r) {
                        e.stopPropagation && e.stopPropagation(), g = !0;
                        var a = t.features.isOldAndroid ? 600 : 30;
                        setTimeout((function() {
                            g = !1
                        }), a)
                    }
                },
                k = function(e, n, r) {
                    t[(r ? "add" : "remove") + "Class"](e, "pwwp__" + n)
                },
                T = function() {
                    var e = 1 === v.getNumItemsFn();
                    e !== m && (k(r, "ui--one-slide", e), m = e)
                },
                O = function() {
                    k(l, "share-modal--hidden", C)
                },
                M = function() {
                    return (C = !C) ? (t.removeClass(l, "pwwp__share-modal--fade-in"), setTimeout((function() {
                        C && O()
                    }), 300)) : (O(), setTimeout((function() {
                        C || t.addClass(l, "pwwp__share-modal--fade-in")
                    }), 30)), C || P(), !1
                },
                R = function(t) {
                    var n = (t = t || window.event).target || t.srcElement;
                    return e.shout("shareLinkClick", t, n), !!n.href && (!!n.hasAttribute("download") || (window.open(n.href, "pwwp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), C || M(), !1))
                },
                P = function() {
                    for (var e, t, n, r, i = "", o = 0; o < v.shareButtons.length; o++)
                        e = v.shareButtons[o], t = v.getImageURLForShare(e), n = v.getPageURLForShare(e), r = v.getTextForShare(e), i += '<a href="' + e.url.replace("{{url}}", encodeURIComponent(n)).replace("{{image_url}}", encodeURIComponent(t)).replace("{{raw_image_url}}", t).replace("{{text}}", encodeURIComponent(r)) + '" target="_blank" class="pwwp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>", v.parseShareButtonOut && (i = v.parseShareButtonOut(e, i));
                    l.children[0].innerHTML = i, l.children[0].onclick = R
                },
                A = function(e) {
                    for (var n = 0; n < v.closeElClasses.length; n++)
                        if (t.hasClass(e, "pwwp__" + v.closeElClasses[n]))
                            return !0
                },
                I = 0,
                z = function() {
                    clearTimeout(b), I = 0, c && w.setIdle(!1)
                },
                L = function(e) {
                    var t = (e = e || window.event).relatedTarget || e.toElement;
                    t && "HTML" !== t.nodeName || (clearTimeout(b), b = setTimeout((function() {
                        w.setIdle(!0)
                    }), v.timeToIdleOutside))
                },
                D = function(e) {
                    f !== e && (k(p, "preloader--active", !e), f = e)
                },
                N = function(n) {
                    var a = n.vGap;
                    if (!e.likelyTouchDevice || v.mouseUsed || screen.width > v.fitControlsWidth) {
                        var s = v.barsSize;
                        if (v.captionEl && "auto" === s.bottom)
                            if (o || ((o = t.createEl("pwwp__caption pwwp__caption--fake")).appendChild(t.createEl("pwwp__caption__center")), r.insertBefore(o, i), t.addClass(r, "pwwp__ui--fit")), v.addCaptionHTMLFn(n, o, !0)) {
                                var l = o.clientHeight;
                                a.bottom = parseInt(l, 10) || 44
                            } else
                                a.bottom = s.top;
                        else
                            a.bottom = "auto" === s.bottom ? 0 : s.bottom;
                        a.top = s.top
                    } else
                        a.top = a.bottom = 0
                },
                B = [{
                    name: "caption",
                    option: "captionEl",
                    onInit: function(e) {
                        i = e
                    }
                }, {
                    name: "share-modal",
                    option: "shareEl",
                    onInit: function(e) {
                        l = e
                    },
                    onTap: function() {
                        M()
                    }
                }, {
                    name: "button--share",
                    option: "shareEl",
                    onInit: function(e) {
                        s = e
                    },
                    onTap: function() {
                        M()
                    }
                }, {
                    name: "button--zoom",
                    option: "zoomEl",
                    onTap: e.toggleDesktopZoom
                }, {
                    name: "counter",
                    option: "counterEl",
                    onInit: function(e) {
                        a = e
                    }
                }, {
                    name: "button--close",
                    option: "closeEl",
                    onTap: e.close
                }, {
                    name: "button--arrow--left",
                    option: "arrowEl",
                    onTap: e.prev
                }, {
                    name: "button--arrow--right",
                    option: "arrowEl",
                    onTap: e.next
                }, {
                    name: "button--fs",
                    option: "fullscreenEl",
                    onTap: function() {
                        n.isFullscreen() ? n.exit() : n.enter()
                    }
                }, {
                    name: "preloader",
                    option: "preloaderEl",
                    onInit: function(e) {
                        p = e
                    }
                }];
            w.init = function() {
                var a;
                t.extend(e.options, E, !0), v = e.options, r = t.getChildByClass(e.scrollWrap, "pwwp__ui"), (d = e.listen)("onVerticalDrag", (function(e) {
                    _ && e < .95 ? w.hideControls() : !_ && e >= .95 && w.showControls()
                })), d("onPinchClose", (function(e) {
                    _ && e < .9 ? (w.hideControls(), a = !0) : a && !_ && e > .9 && w.showControls()
                })), d("zoomGestureEnded", (function() {
                    (a = !1) && !_ && w.showControls()
                })), d("beforeChange", w.update), d("doubleTap", (function(t) {
                    var n = e.currItem.initialZoomLevel;
                    e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(v.getDoubleTapZoom(!1, e.currItem), t, 333)
                })), d("preventDragEvent", (function(e, t, n) {
                    var r = e.target || e.srcElement;
                    r && r.getAttribute("class") && e.type.indexOf("mouse") > -1 && (r.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(r.tagName)) && (n.prevent = !1)
                })), d("bindEvents", (function() {
                    t.bind(r, "pwwpTap click", S), t.bind(e.scrollWrap, "pwwpTap", w.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", w.onMouseOver)
                })), d("unbindEvents", (function() {
                    C || M(), y && clearInterval(y), t.unbind(document, "mouseout", L), t.unbind(document, "mousemove", z), t.unbind(r, "pwwpTap click", S), t.unbind(e.scrollWrap, "pwwpTap", w.onGlobalTap), t.unbind(e.scrollWrap, "mouseover", w.onMouseOver), n && (t.unbind(document, n.eventK, w.updateFullscreen), n.isFullscreen() && (v.hideAnimationDuration = 0, n.exit()), n = null)
                })), d("destroy", (function() {
                    v.captionEl && (o && r.removeChild(o), t.removeClass(i, "pwwp__caption--empty")), l && (l.children[0].onclick = null), t.removeClass(r, "pwwp__ui--over-close"), t.addClass(r, "pwwp__ui--hidden"), w.setIdle(!1)
                })), v.showAnimationDuration || t.removeClass(r, "pwwp__ui--hidden"), d("initialZoomIn", (function() {
                    v.showAnimationDuration && t.removeClass(r, "pwwp__ui--hidden")
                })), d("initialZoomOut", (function() {
                    t.addClass(r, "pwwp__ui--hidden")
                })), d("parseVerticalMargin", N), function() {
                    var e,
                        n,
                        i,
                        o = function(r) {
                            if (r)
                                for (var o = r.length, a = 0; a < o; a++) {
                                    e = r[a], n = e.className;
                                    for (var s = 0; s < B.length; s++)
                                        i = B[s], n.indexOf("pwwp__" + i.name) > -1 && (v[i.option] ? (t.removeClass(e, "pwwp__element--disabled"), i.onInit && i.onInit(e)) : t.addClass(e, "pwwp__element--disabled"))
                                }
                        };
                    o(r.children);
                    var a = t.getChildByClass(r, "pwwp__top-bar");
                    a && o(a.children)
                }(), v.shareEl && s && l && (C = !0), T(), v.timeToIdle && d("mouseUsed", (function() {
                    t.bind(document, "mousemove", z), t.bind(document, "mouseout", L), y = setInterval((function() {
                        2 == ++I && w.setIdle(!0)
                    }), v.timeToIdle / 2)
                })), v.fullscreenEl && !t.features.isOldAndroid && (n || (n = w.getFullscreenAPI()), n ? (t.bind(document, n.eventK, w.updateFullscreen), w.updateFullscreen(), t.addClass(e.template, "pwwp--supports-fs")) : t.removeClass(e.template, "pwwp--supports-fs")), v.preloaderEl && (D(!0), d("beforeChange", (function() {
                    clearTimeout(h), h = setTimeout((function() {
                        e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || e.currItem.img && !e.currItem.img.naturalWidth) && D(!1) : D(!0)
                    }), v.loadingIndicatorDelay)
                })), d("imageLoadComplete", (function(t, n) {
                    e.currItem === n && D(!0)
                })))
            }, w.setIdle = function(e) {
                c = e, k(r, "ui--idle", e)
            }, w.update = function() {
                _ && e.currItem ? (w.updateIndexIndicator(), v.captionEl && (v.addCaptionHTMLFn(e.currItem, i), k(i, "caption--empty", !e.currItem.title)), x = !0) : x = !1, C || M(), T()
            }, w.updateFullscreen = function(r) {
                r && setTimeout((function() {
                    e.setScrollOffset(0, t.getScrollY())
                }), 50), t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pwwp--fs")
            }, w.updateIndexIndicator = function() {
                v.counterEl && (a.innerHTML = e.getCurrentIndex() + 1 + v.indexIndicatorSep + v.getNumItemsFn())
            }, w.onGlobalTap = function(n) {
                var r = (n = n || window.event).target || n.srcElement;
                if (!g)
                    if (n.detail && "mouse" === n.detail.pointerType) {
                        if (A(r))
                            return void e.close();
                        t.hasClass(r, "pwwp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? v.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint))
                    } else if (v.tapToToggleControls && (_ ? w.hideControls() : w.showControls()), v.tapToClose && (t.hasClass(r, "pwwp__img") || A(r)))
                        return void e.close()
            }, w.onMouseOver = function(e) {
                var t = (e = e || window.event).target || e.srcElement;
                k(r, "ui--over-close", A(t))
            }, w.hideControls = function() {
                t.addClass(r, "pwwp__ui--hidden"), _ = !1
            }, w.showControls = function() {
                _ = !0, x || w.update(), t.removeClass(r, "pwwp__ui--hidden")
            }, w.supportsFullscreen = function() {
                var e = document;
                return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen)
            }, w.getFullscreenAPI = function() {
                var t,
                    n = document.documentElement,
                    r = "fullscreenchange";
                return n.requestFullscreen ? t = {
                    enterK: "requestFullscreen",
                    exitK: "exitFullscreen",
                    elementK: "fullscreenElement",
                    eventK: r
                } : n.mozRequestFullScreen ? t = {
                    enterK: "mozRequestFullScreen",
                    exitK: "mozCancelFullScreen",
                    elementK: "mozFullScreenElement",
                    eventK: "moz" + r
                } : n.webkitRequestFullscreen ? t = {
                    enterK: "webkitRequestFullscreen",
                    exitK: "webkitExitFullscreen",
                    elementK: "webkitFullscreenElement",
                    eventK: "webkit" + r
                } : n.msRequestFullscreen && (t = {
                    enterK: "msRequestFullscreen",
                    exitK: "msExitFullscreen",
                    elementK: "msFullscreenElement",
                    eventK: "MSFullscreenChange"
                }), t && (t.enter = function() {
                    if (u = v.closeOnScroll, v.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK)
                        return e.template[this.enterK]();
                    e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
                }, t.exit = function() {
                    return v.closeOnScroll = u, document[this.exitK]()
                }, t.isFullscreen = function() {
                    return document[this.elementK]
                }), t
            }
        }
    }));
    var om = t(im);
    var am = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        sm = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    function lm(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            n = parseFloat(e);
        return "".concat(n / t).concat(String(e).replace(String(n), "") || "px")
    }
    var um,
        cm,
        dm,
        pm,
        fm,
        hm,
        mm,
        vm,
        gm,
        ym,
        bm,
        wm = lt.forwardRef((function(e, t) {
            var n = e.alignContent,
                r = void 0 === n ? "stretch" : n,
                i = e.alignItems,
                o = void 0 === i ? "stretch" : i,
                a = e.classes,
                s = e.className,
                l = e.component,
                u = void 0 === l ? "div" : l,
                c = e.container,
                d = void 0 !== c && c,
                p = e.direction,
                f = void 0 === p ? "row" : p,
                h = e.item,
                m = void 0 !== h && h,
                v = e.justify,
                g = void 0 === v ? "flex-start" : v,
                y = e.lg,
                b = void 0 !== y && y,
                w = e.md,
                x = void 0 !== w && w,
                _ = e.sm,
                C = void 0 !== _ && _,
                E = e.spacing,
                S = void 0 === E ? 0 : E,
                k = e.wrap,
                T = void 0 === k ? "wrap" : k,
                O = e.xl,
                M = void 0 !== O && O,
                R = e.xs,
                P = void 0 !== R && R,
                A = e.zeroMinWidth,
                I = void 0 !== A && A,
                z = dt(e, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]),
                L = fa(a.root, s, d && [a.container, 0 !== S && a["spacing-xs-".concat(String(S))]], m && a.item, I && a.zeroMinWidth, "row" !== f && a["direction-xs-".concat(String(f))], "wrap" !== T && a["wrap-xs-".concat(String(T))], "stretch" !== o && a["align-items-xs-".concat(String(o))], "stretch" !== r && a["align-content-xs-".concat(String(r))], "flex-start" !== g && a["justify-xs-".concat(String(g))], !1 !== P && a["grid-xs-".concat(String(P))], !1 !== C && a["grid-sm-".concat(String(C))], !1 !== x && a["grid-md-".concat(String(x))], !1 !== b && a["grid-lg-".concat(String(b))], !1 !== M && a["grid-xl-".concat(String(M))]);
            return lt.createElement(u, ft({
                className: L,
                ref: t
            }, z))
        })),
        xm = nu((function(e) {
            return ft({
                root: {},
                container: {
                    boxSizing: "border-box",
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%"
                },
                item: {
                    boxSizing: "border-box",
                    margin: "0"
                },
                zeroMinWidth: {
                    minWidth: 0
                },
                "direction-xs-column": {
                    flexDirection: "column"
                },
                "direction-xs-column-reverse": {
                    flexDirection: "column-reverse"
                },
                "direction-xs-row-reverse": {
                    flexDirection: "row-reverse"
                },
                "wrap-xs-nowrap": {
                    flexWrap: "nowrap"
                },
                "wrap-xs-wrap-reverse": {
                    flexWrap: "wrap-reverse"
                },
                "align-items-xs-center": {
                    alignItems: "center"
                },
                "align-items-xs-flex-start": {
                    alignItems: "flex-start"
                },
                "align-items-xs-flex-end": {
                    alignItems: "flex-end"
                },
                "align-items-xs-baseline": {
                    alignItems: "baseline"
                },
                "align-content-xs-center": {
                    alignContent: "center"
                },
                "align-content-xs-flex-start": {
                    alignContent: "flex-start"
                },
                "align-content-xs-flex-end": {
                    alignContent: "flex-end"
                },
                "align-content-xs-space-between": {
                    alignContent: "space-between"
                },
                "align-content-xs-space-around": {
                    alignContent: "space-around"
                },
                "justify-xs-center": {
                    justifyContent: "center"
                },
                "justify-xs-flex-end": {
                    justifyContent: "flex-end"
                },
                "justify-xs-space-between": {
                    justifyContent: "space-between"
                },
                "justify-xs-space-around": {
                    justifyContent: "space-around"
                },
                "justify-xs-space-evenly": {
                    justifyContent: "space-evenly"
                }
            }, function(e, t) {
                var n = {};
                return am.forEach((function(r) {
                    var i = e.spacing(r);
                    0 !== i && (n["spacing-".concat(t, "-").concat(r)] = {
                        margin: "-".concat(lm(i, 2)),
                        width: "calc(100% + ".concat(lm(i), ")"),
                        "& > $item": {
                            padding: lm(i, 2)
                        }
                    })
                })), n
            }(e, "xs"), {}, e.breakpoints.keys.reduce((function(t, n) {
                return function(e, t, n) {
                    var r = {};
                    sm.forEach((function(e) {
                        var t = "grid-".concat(n, "-").concat(e);
                        if (!0 !== e)
                            if ("auto" !== e) {
                                var i = "".concat(Math.round(e / 12 * 1e8) / 1e6, "%");
                                r[t] = {
                                    flexBasis: i,
                                    flexGrow: 0,
                                    maxWidth: i
                                }
                            } else
                                r[t] = {
                                    flexBasis: "auto",
                                    flexGrow: 0,
                                    maxWidth: "none"
                                };
                        else
                            r[t] = {
                                flexBasis: 0,
                                flexGrow: 1,
                                maxWidth: "100%"
                            }
                    })), "xs" === n ? ft(e, r) : e[t.breakpoints.up(n)] = r
                }(t, e, n), t
            }), {}))
        }), {
            name: "PwzrGrid"
        })(wm),
        _m = !1;
    function Cm(e) {
        "string" != typeof e && (e = String(e));
        for (var t = "", n = 0; n < e.length; n++) {
            var r = e[n];
            switch (r) {
            case "<":
                t += "&lt;";
                break;
            case ">":
                t += "&gt;";
                break;
            case '"':
                t += "&quot;";
                break;
            case "&":
                t += "&amp;";
                break;
            default:
                t += r
            }
        }
        return t
    }
    function Em(e) {
        var t = "";
        for (var n in e) {
            var r = e[n];
            null != r && (t && (t += " "), t += "-" == n[0] ? n : fm[n] || (fm[n] = n.replace(/([A-Z])/g, "-$1").toLowerCase()), t += ": ", t += r, "number" == typeof r && !1 === cm.test(n) && (t += "px"), t += ";")
        }
        return t || void 0
    }
    function Sm(e, t) {
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function km(e, t) {
        return Array.isArray(t) ? t.reduce(km, e) : null != t && !1 !== t && e.push(t), e
    }
    function Tm(e, t, n) {
        var r = function e(t, n, r, i, o, a) {
            if (null == t || "boolean" == typeof t)
                return "";
            Array.isArray(t) && (t = V().createElement(V().Fragment, null, t));
            var s = t.type,
                l = t.props,
                u = !1;
            n = n || {};
            var c,
                d = (r = r || {}).pretty,
                p = d && "string" == typeof d ? d : "\t";
            if ("object" != typeof t && !s)
                return Cm(t);
            if ("function" == typeof s) {
                if (u = !0, !r.shallow || !i && !1 !== r.renderRootComponent) {
                    if (s === V().Fragment) {
                        var f = "",
                            h = [];
                        km(h, t.props.children);
                        for (var m = 0; m < h.length; m++)
                            f += (m > 0 && d ? "\n" : "") + e(h[m], n, r, !1 !== r.shallowHighOrder, o, a);
                        return f
                    }
                    var v,
                        g = t.__c = {
                            __v: t,
                            context: n,
                            props: t.props,
                            setState: gm,
                            forceUpdate: gm,
                            __h: []
                        };
                    if (V().options.__b && V().options.__b(t), V().options.__r && V().options.__r(t), s.prototype && "function" == typeof s.prototype.render) {
                        var y = s.contextType,
                            b = y && n[y.__c],
                            w = null != y ? b ? b.props.value : y.__ : n;
                        (g = t.__c = new s(l, w)).__v = t, g._dirty = g.__d = !0, g.props = l, null == g.state && (g.state = {}), null == g._nextState && null == g.__s && (g._nextState = g.__s = g.state), g.context = w, s.getDerivedStateFromProps ? g.state = Sm(Sm({}, g.state), s.getDerivedStateFromProps(g.props, g.state)) : g.componentWillMount && (g.componentWillMount(), g.state = g._nextState !== g.state ? g._nextState : g.__s !== g.state ? g.__s : g.state), v = g.render(g.props, g.state, g.context)
                    } else {
                        var x = s.contextType,
                            _ = x && n[x.__c],
                            C = null != x ? _ ? _.props.value : x.__ : n;
                        v = s.call(t.__c, l, C)
                    }
                    return g.getChildContext && (n = Sm(Sm({}, n), g.getChildContext())), V().options.diffed && V().options.diffed(t), e(v, n, r, !1 !== r.shallowHighOrder, o, a)
                }
                s = (c = s).displayName || c !== Function && c.name || function(e) {
                    var t = (Function.prototype.toString.call(e).match(/^\s*function\s+([^( ]+)/) || "")[1];
                    if (!t) {
                        for (var n = -1, r = mm.length; r--;)
                            if (mm[r] === e) {
                                n = r;
                                break
                            }
                        n < 0 && (n = mm.push(e) - 1), t = "UnnamedComponent" + n
                    }
                    return t
                }(c)
            }
            var E,
                S,
                k = "";
            if (l) {
                var T = Object.keys(l);
                r && !0 === r.sortAttributes && T.sort();
                for (var O = 0; O < T.length; O++) {
                    var M = T[O],
                        R = l[M];
                    if ("children" !== M) {
                        if (!M.match(/[\s\n\\/='"\0<>]/) && (r && r.allAttributes || "key" !== M && "ref" !== M && "__self" !== M && "__source" !== M && "defaultValue" !== M)) {
                            if ("className" === M) {
                                if (l.class)
                                    continue;
                                M = "class"
                            } else
                                o && M.match(/^xlink:?./) && (M = M.toLowerCase().replace(/^xlink:?/, "xlink:"));
                            if ("htmlFor" === M) {
                                if (l.for)
                                    continue;
                                M = "for"
                            }
                            "style" === M && R && "object" == typeof R && (R = Em(R)), "a" === M[0] && "r" === M[1] && "boolean" == typeof R && (R = String(R));
                            var P = r.attributeHook && r.attributeHook(M, R, n, r, u);
                            if (P || "" === P)
                                k += P;
                            else if ("dangerouslySetInnerHTML" === M)
                                S = R && R.__html;
                            else if ("textarea" === s && "value" === M)
                                E = R;
                            else if ((R || 0 === R || "" === R) && "function" != typeof R) {
                                if (!(!0 !== R && "" !== R || (R = M, r && r.xml))) {
                                    k += " " + M;
                                    continue
                                }
                                if ("value" === M) {
                                    if ("select" === s) {
                                        a = R;
                                        continue
                                    }
                                    "option" === s && a == R && (k += " selected")
                                }
                                k += " " + M + '="' + Cm(R) + '"'
                            }
                        }
                    } else
                        E = R
                }
            }
            if (d) {
                var A = k.replace(/^\n\s*/, " ");
                A === k || ~A.indexOf("\n") ? d && ~k.indexOf("\n") && (k += "\n") : k = A
            }
            if (k = "<" + s + k + ">", String(s).match(/[\s\n\\/='"\0<>]/))
                throw new Error(s + " is not a valid HTML tag name in " + k);
            var I,
                z = String(s).match(vm) || r.voidElements && String(s).match(r.voidElements),
                L = [];
            if (S)
                d && pm(S) && (S = "\n" + p + dm(S, p)), k += S;
            else if (null != E && km(I = [], E).length) {
                for (var D = d && ~k.indexOf("\n"), N = !1, B = 0; B < I.length; B++) {
                    var F = I[B];
                    if (null != F && !1 !== F) {
                        var W = e(F, n, r, !0, "svg" === s || "foreignObject" !== s && o, a);
                        if (d && !D && pm(W) && (D = !0), W)
                            if (d) {
                                var H = W.length > 0 && "<" != W[0];
                                N && H ? L[L.length - 1] += W : L.push(W), N = H
                            } else
                                L.push(W)
                    }
                }
                if (d && D)
                    for (var j = L.length; j--;)
                        L[j] = "\n" + p + dm(L[j], p)
            }
            if (L.length || S)
                k += L.join("");
            else if (r && r.xml)
                return k.substring(0, k.length - 1) + " />";
            return !z || I || S ? (d && ~k.indexOf("\n") && (k += "\n"), k += "</" + s + ">") : k = k.replace(/>$/, " />"), k
        }(e, t, n);
        return V().options.__c && V().options.__c(e, bm), r
    }
    var Om,
        Mm,
        Rm = {};
    try {
        _m || (_m = !0, um = {}, V(), cm = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|^--/i, dm = function(e, t) {
            return String(e).replace(/(\n+)/g, "$1" + (t || "\t"))
        }, pm = function(e, t, n) {
            return String(e).length > (t || 40) || !n && -1 !== String(e).indexOf("\n") || -1 !== String(e).indexOf("<")
        }, fm = {}, hm = {
            shallow: !0
        }, mm = [], vm = /^(area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)$/, gm = function() {}, Tm.render = Tm, ym = function(e, t) {
            return Tm(e, t, hm)
        }, bm = [], Tm.shallowRender = ym, r(um, "default", (function() {
            return Tm
        })), r(um, "shallowRender", (function() {
            return ym
        })), r(um, "renderToString", (function() {
            return Tm
        })), r(um, "renderToStaticMarkup", (function() {
            return Tm
        })), r(um, "render", (function() {
            return Tm
        })), n(um)), Om = (Mm = um).default || Mm
    } catch (e) {
        throw Error('renderToString() error: missing "preact-render-to-string" dependency.')
    }
    Rm = {
        renderToString: Om,
        renderToStaticMarkup: Om
    };
    const Pm = ({scale: e, mediaScale: t}) => {
        const n = (e => {
                const t = window.innerHeight / window.innerWidth,
                    n = window.innerWidth * e;
                return {
                    width: n,
                    height: n * t
                }
            })(e),
            r = Math.min(n.width, n.height / t);
        return {
            width: r,
            height: r * t
        }
    };
    function Am({maxWidthParam: e, zoom: t, scale: n}) {
        const r = [5760];
        "number" == typeof e && r.push(e);
        const i = Math.min(...r);
        for (let e = 100; e > 0; e -= 1) {
            const {width: r, height: o} = Pm({
                scale: t * (e / 100),
                mediaScale: n
            });
            if (r <= i)
                return {
                    width: r,
                    height: o
                }
        }
        return {
            width: i,
            height: i * n
        }
    }
    function Im(e, t, n) {
        const {type: r, sources: i, alt: o, scale: a, scaleSources: s, transformedSrc: l, rioSettings: u, ignoreScale: c=!1} = e,
            d = function({scaleSources: e, scaleParam: t, ignoreScale: n}) {
                if (n)
                    return null;
                const r = e || t;
                return r ? parseFloat(r) / 100 : null
            }({
                scaleSources: s,
                scaleParam: a,
                ignoreScale: c
            });
        if ("image" === r && null !== d) {
            const r = Am({
                    maxWidthParam: e.width,
                    zoom: Math.max(n, Fh()),
                    scale: d
                }),
                i = function({imageSizeScaledWithDPP: e, imageSizeScaled: t}) {
                    return e.width > 0 && e.width > t.width ? t.width / e.width : 1
                }({
                    imageSizeScaled: Am({
                        maxWidthParam: e.width,
                        zoom: n,
                        scale: d
                    }),
                    imageSizeScaledWithDPP: r
                });
            return {
                src: l(r.width),
                msrc: t,
                w: r.width,
                h: r.height,
                maxZoom: i
            }
        }
        const {width: p, height: f} = Pm({
            scale: .8,
            mediaScale: null === d ? 1 : d
        });
        if ("video" === r) {
            const e = `video-${Sd.v4()}`;
            return {
                rioId: e,
                html: Rm.renderToString(lt.createElement(xm, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                }, lt.createElement(xm, {
                    item: !0,
                    style: {
                        width: p,
                        height: f
                    }
                }, lt.createElement("iframe", {
                    id: e,
                    frameBorder: "0",
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=${encodeURIComponent(JSON.stringify({...u,sources: i,autoPlay: !1,poster: t}))}`,
                    title: o
                }))))
            }
        }
        if ("external_video" === r) {
            const e = `external-video-${Sd.v4()}`;
            return {
                rioId: e,
                html: Rm.renderToString(lt.createElement(xm, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                }, lt.createElement(xm, {
                    item: !0,
                    style: {
                        width: p,
                        height: f
                    }
                }, lt.createElement("iframe", {
                    id: e,
                    frameBorder: "0",
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=${encodeURIComponent(JSON.stringify({source: i[0],muted: u.muted,controls: u.controls,autoPlay: !1,title: o || void 0}))}`,
                    title: o
                }))))
            }
        }
        if ("model" === r) {
            const e = t;
            return {
                html: Rm.renderToString(lt.createElement(xm, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                }, lt.createElement(xm, {
                    item: !0,
                    style: {
                        width: p,
                        height: f
                    }
                }, lt.createElement("iframe", {
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; gyroscope",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src=${encodeURIComponent(i[0])}${o ? `&alt=${encodeURIComponent(o)}` : ""}${e ? `&poster=${encodeURIComponent(e)}` : ""}${u.autoRotate ? "&autorotate=true" : ""}`,
                    title: o
                }))))
            }
        }
        return {}
    }
    var zm = (e, t, n, r, i) => {
        const o = (t, o) => {
            const a = (e => {
                    const t = e.childNodes,
                        n = [];
                    for (let e = 0; e < t.length; e += 1) {
                        const r = t[e];
                        if (1 !== r.nodeType) {
                            n.push(null);
                            continue
                        }
                        const i = r.children[0];
                        "IMG" === i.tagName ? n.push(i.getAttribute("src")) : "DIV" === i.tagName && "VIDEO" === i.getAttribute("data-tagname") || "DIV" === i.tagName && "MODEL" === i.getAttribute("data-tagname") ? n.push(i.getAttribute("data-poster")) : n.push(null)
                    }
                    return n
                })(o),
                s = r.map(((e, t) => Im(e, a[t], i))),
                l = function({media: e, items: t}) {
                    const n = [],
                        r = e => {
                            try {
                                e.destroy()
                            } catch {}
                        },
                        i = new MutationObserver((() => {
                            for (let e = 0; e < t.length; e += 1)
                                if (n[e]) {
                                    const [t, i] = n[e];
                                    document.body.contains(i) || (r(t), delete n[e])
                                }
                        }));
                    return i.observe(document.body, {
                        childList: !0,
                        subtree: !0
                    }), {
                        initVideo: r => {
                            if (!n[r]) {
                                const i = e[r],
                                    {rioId: o} = t[r];
                                if ("external_video" === i.type && "string" == typeof o) {
                                    const e = document.querySelector(`#${o}`),
                                        t = (() => {
                                            const t = e.contentWindow;
                                            return {
                                                play: () => {t.postMessage({
                                                        rioOrigin: "video-player",
                                                        play: !0
                                                    }, "*")},
                                                pause: () => {t.postMessage({
                                                        rioOrigin: "video-player",
                                                        pause: !0
                                                    }, "*")},
                                                destroy: () => {t.postMessage({
                                                        rioOrigin: "video-player",
                                                        destroy: !0
                                                    }, "*")}
                                            }
                                        })();
                                    n[r] = [t, e]
                                }
                                if ("video" === i.type && "string" == typeof o) {
                                    const e = document.querySelector(`#${o}`),
                                        t = (() => {
                                            const t = e.contentWindow;
                                            return {
                                                play: () => {t.postMessage({
                                                        play: !0
                                                    }, "*")},
                                                pause: () => {t.postMessage({
                                                        pause: !0
                                                    }, "*")},
                                                destroy: () => {t.postMessage({
                                                        destroy: !0
                                                    }, "*")}
                                            }
                                        })();
                                    n[r] = [t, e]
                                }
                            }
                        },
                        playVideo: r => {
                            for (let e = 0; e < t.length; e += 1)
                                if (e !== r && n[e]) {
                                    const [t] = n[e];
                                    try {
                                        t.pause()
                                    } catch {}
                                }
                            if (n[r] && e[r].rioSettings.autoPlay) {
                                const [e] = n[r];
                                try {
                                    e.play()
                                } catch {}
                            }
                        },
                        destroyVideos: () => {
                            i.disconnect();
                            for (let e = 0; e < t.length; e += 1)
                                if (n[e]) {
                                    const [t] = n[e];
                                    r(t), delete n[e]
                                }
                        }
                    }
                }({
                    media: r,
                    items: s
                }),
                u = {
                    closeEl: !0,
                    captionEl: !1,
                    fullscreenEl: !0,
                    zoomEl: !0,
                    shareEl: !1,
                    counterEl: !1,
                    arrowEl: !0,
                    preloaderEl: !0,
                    history: !1,
                    galleryUID: o.getAttribute("data-pwwp-uid"),
                    index: t,
                    getDoubleTapZoom: (e, t) => {
                        const n = "number" == typeof t.maxZoom ? t.maxZoom : 1;
                        return e || t.initialZoomLevel < .7 ? n : 1.5 * n
                    }
                },
                c = new rm(e.current, om, s, u);
            c.init(), window.productWizRioLightboxOpen = !0, c.listen("unbindEvents", (() => {
                const e = c.getCurrentIndex(),
                    t = n();
                t && t.slideTo(e, 0), l.destroyVideos(), window.productWizRioLightboxOpen = !1
            })), c.listen("afterChange", (() => {
                const e = c.getCurrentIndex();
                l.initVideo(e), l.playVideo(e)
            }))
        };
        t.setAttribute("data-pwwp-uid", 1), t.onclick = e => {
            const t = (e, n) => e && (n(e) ? e : t(e.parentNode, n)),
                n = e || window.event;
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            const i = n.target || n.srcElement,
                a = t(i, (e => e.tagName && "div" === e.tagName.toLowerCase()));
            if (!a)
                return;
            if (!a.id.startsWith("pwzrswiper-slide"))
                return;
            const s = a.parentNode,
                {childNodes: l} = a.parentNode;
            let u,
                c = 0;
            for (let e = 0; e < l.length; e += 1)
                if (1 === l[e].nodeType) {
                    if (l[e] === a) {
                        u = c;
                        break
                    }
                    c += 1
                }
            return u >= 0 && "image" === r[u].type && o(u, s), !1
        }
    };
    function Lm({swiperWrapperElement: e, getSwiper: t, media: n, lightBoxZoom: r}) {
        const i = ae(null);
        return ie((() => {zm(i, e, t, n, r)}), [t, r, n, e]), lt.createElement("div", {
            style: {
                position: "absolute",
                zIndex: 2147483647
            }
        }, lt.createElement("div", {
            ref: i,
            className: "pwwp",
            tabIndex: "-1",
            role: "dialog",
            "aria-hidden": "true"
        }, lt.createElement("div", {
            id: "pwwp__bg-id",
            className: "pwwp__bg"
        }), lt.createElement("div", {
            className: "pwwp__scroll-wrap"
        }, lt.createElement("div", {
            className: "pwwp__container"
        }, lt.createElement("div", {
            className: "pwwp__item"
        }), lt.createElement("div", {
            className: "pwwp__item"
        }), lt.createElement("div", {
            className: "pwwp__item"
        })), lt.createElement("div", {
            className: "pwwp__ui pwwp__ui--hidden"
        }, lt.createElement("div", {
            className: "pwwp__top-bar"
        }, lt.createElement("div", {
            className: "pwwp__counter"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--close",
            title: "Close (Esc)"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--share",
            title: "Share"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--fs",
            title: "Toggle fullscreen"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--zoom",
            title: "Zoom in/out"
        }), lt.createElement("div", {
            className: "pwwp__preloader"
        }, lt.createElement("div", {
            className: "pwwp__preloader__icn"
        }, lt.createElement("div", {
            className: "pwwp__preloader__cut"
        }, lt.createElement("div", {
            className: "pwwp__preloader__donut"
        }))))), lt.createElement("div", {
            className: "pwwp__share-modal pwwp__share-modal--hidden pwwp__single-tap"
        }, lt.createElement("div", {
            className: "pwwp__share-tooltip"
        })), lt.createElement("div", {
            className: "pwwp__button pwwp__button--arrow--left",
            title: "Previous (arrow left)"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--arrow--right",
            title: "Next (arrow right)"
        }), lt.createElement("div", {
            className: "pwwp__caption"
        }, lt.createElement("div", {
            className: "pwwp__caption__center"
        }))))))
    }
    Lm.propTypes = {
        swiperWrapperElement: Tt.object.isRequired,
        getSwiper: Tt.func.isRequired,
        media: Tt.arrayOf(Qh).isRequired,
        lightBoxZoom: Tt.number.isRequired
    };
    const Dm = {
        normal: "\n      .pwzrswiper-pagination-bullet {\n        margin: 0 4px;\n      }\n\n      .pwzrswiper-pagination-bullet-active {\n        color: #fff;\n        background: rgba(0, 0, 0, 0.75);\n      }\n    ",
        clickable: "\n      .pwzrswiper-pagination-bullet {\n        outline: none;\n        width: 20px;\n        height: 20px;\n        text-align: center;\n        line-height: 20px;\n        font-size: 12px;\n        color: #000;\n        opacity: 1;\n        background: rgba(0, 0, 0, 0.2);\n        margin: 0 4px;\n        user-select: none;\n      }\n  \n      .pwzrswiper-pagination-bullet-active {\n        color: #fff;\n        background: rgba(0, 0, 0, 0.75);\n      }\n    "
    };
    let Nm = null;
    function Bm({clickablePagination: e}) {
        const t = ae(null);
        return lt.createElement(lt.Fragment, null, lt.createElement("style", null, `\n          .pwzrswiper-pagination {\n            z-index: unset !important;\n          }\n          ${Dm[e ? "clickable" : "normal"]}\n        `), lt.createElement("div", {
            ref: t,
            style: {
                display: "flex",
                justifyContent: "center",
                minHeight: Nm || "initial"
            }
        }, lt.createElement(Kc, {
            handleHeight: !0,
            onResize: (e, n) => {
                Nm = n;
                const r = t.current;
                r && (r.style.minHeight = "initial")
            }
        }), lt.createElement("div", {
            style: {
                position: "static",
                marginTop: e ? 10 : 5,
                marginBottom: e ? 5 : 2
            },
            className: fa("pwzrswiper-pagination")
        })))
    }
    Bm.defaultProps = {
        clickablePagination: !1
    }, Bm.propTypes = {
        clickablePagination: Tt.bool
    }, zf.use([Nf, Wf, $f]);
    class Fm extends lt.Component {
        static getPlaceholderImageWidth(e)
        {
            return Vf("xl", e) ? 900 : Vf("lg", e) ? 720 : Vf("md", e) ? 540 : 360
        }
        static generatePlaceholderImage(e, t)
        {
            const n = Fm.getPlaceholderImageWidth(t);
            return e.transformedSrc(n)
        }
        static generateResponsiveImage(e, t)
        {
            return e.transformedSrc(t)
        }
        constructor(e)
        {
            super(e), Ba(this, "querySelector", (e => {
                var t;
                return null === (t = this.rootRef.current) || void 0 === t ? void 0 : t.querySelector(e)
            })), Ba(this, "mountPhotoSwipe", (() => {
                const {media: e, config: {lightBox: t, lightBoxZoom: n}} = this.props;
                if (t) {
                    this.photoSwipeId = `photo-swipe-${Sd.v4()}`;
                    const t = document.createElement("div");
                    t.id = this.photoSwipeId, document.body.appendChild(t), je(lt.createElement(Lm, {
                        swiperWrapperElement: this.querySelector("#pwzrswiper-wrapper"),
                        getSwiper: () => this.swiper,
                        media: e,
                        lightBoxZoom: n
                    }), t)
                }
            })), Ba(this, "destroyPhotoSwipe", (() => {
                if (this.photoSwipeId) {
                    const e = document.querySelector(`#${this.photoSwipeId}`);
                    e.parentNode.removeChild(e)
                }
            })), Ba(this, "initVideoPlayers", (() => {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1) {
                    const n = e[t];
                    "external_video" === n.type && (this.videoPlayers[t] = (() => {
                        const e = this.querySelector(`#pwzrswiper-img-frame-${t}`).contentWindow;
                        return {
                            play: () => {e.postMessage({
                                    rioOrigin: "video-player",
                                    play: !0
                                }, "*")},
                            pause: () => {e.postMessage({
                                    rioOrigin: "video-player",
                                    pause: !0
                                }, "*")},
                            destroy: () => {e.postMessage({
                                    rioOrigin: "video-player",
                                    destroy: !0
                                }, "*")}
                        }
                    })()), "video" === n.type && (this.videoPlayers[t] = (() => {
                        const e = this.querySelector(`#pwzrswiper-img-frame-${t}`).contentWindow;
                        return {
                            play: () => {e.postMessage({
                                    play: !0
                                }, "*")},
                            pause: () => {e.postMessage({
                                    pause: !0
                                }, "*")},
                            destroy: () => {e.postMessage({
                                    destroy: !0
                                }, "*")}
                        }
                    })())
                }
            })), Ba(this, "destroyVideoPlayers", (() => {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1)
                    this.videoPlayers[t] && this.videoPlayers[t].destroy()
            })), Ba(this, "mountVideos", (() => {this.videoPlayers = [], this.initVideoPlayers()})), Ba(this, "destroyVideos", (() => {this.destroyVideoPlayers(), delete this.videoPlayers})), Ba(this, "playVideo", (() => {
                if (window.productWizRioLightboxOpen)
                    return;
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1)
                    t !== this.selected && this.videoPlayers[t] && this.videoPlayers[t].pause();
                this.videoPlayers[this.selected] && e[this.selected].rioSettings.autoPlay && this.videoPlayers[this.selected].play()
            })), Ba(this, "mountSwiper", (() => {
                const {onSlideChange: e, config: {pagination: t, clickablePagination: n, navigation: r, keyboard: i, maxHeight: o}} = this.props;
                this.swiper = new zf(this.querySelector(".pwzrswiper-container"), {
                    init: !1,
                    initialSlide: this.selected,
                    autoHeight: !0,
                    allowTouchMove: !0,
                    preloadImages: !1,
                    simulateTouch: !1,
                    lazy: !0,
                    keyboard: {
                        enabled: "boolean" != typeof i || i,
                        onlyInViewport: !1
                    },
                    pagination: !!t && {
                        el: this.querySelector(".pwzrswiper-pagination"),
                        ...n ? {
                            clickable: !0,
                            renderBullet: function(e, t) {
                                return `<span tabindex="-1" class="${t}">${e + 1}</span>`
                            }
                        } : {
                            clickable: !1
                        }
                    },
                    navigation: !!r && {
                        nextEl: this.querySelector(".pwzrswiper-btn-next"),
                        prevEl: this.querySelector(".pwzrswiper-btn-prev")
                    }
                }), this.swiper.on("slideChange", (() => {this.selected = this.swiper.activeIndex, this.updateSwiperContainerWidth(), e(this.selected), this.initOrReinitDriftIfNeeded(), this.playVideo()})), this.swiper.on("slideChangeTransitionStart", (() => {"string" == typeof o && this.swiper.update()}))
            })), Ba(this, "getSwiperContainerWrapperWidth", (() => {
                const e = this.querySelector("#pwzrswiper-container-wrapper");
                return e && "number" == typeof e.clientWidth && e.clientWidth > 0 ? e.clientWidth : null
            })), Ba(this, "getMaxHeightRatio", (e => "width" === e || "square" === e ? 1 : "short" === e ? 3 / 4 : null)), Ba(this, "getSwiperContainerMaxWidth", (() => {
                const {media: e, config: {maxHeight: t}} = this.props;
                if ("string" == typeof t) {
                    const n = parseFloat(this.getScale(e[this.selected]));
                    if (Number.isFinite(n)) {
                        const e = this.getMaxHeightRatio(t);
                        if ("number" == typeof e) {
                            const t = 1e4 * e / n;
                            if (Number.isFinite(t)) {
                                const e = t.toFixed(3);
                                if (e < 100) {
                                    const t = this.getSwiperContainerWrapperWidth();
                                    return "number" == typeof t ? `${Math.floor(t * (e / 100))}px` : `${e}%`
                                }
                            }
                        }
                        if (t.endsWith("px")) {
                            const e = parseFloat(t);
                            if (Number.isFinite(e))
                                return `${Math.floor(100 * e / Math.ceil(n))}px`
                        }
                    }
                }
                return "100%"
            })), Ba(this, "updateSwiperContainerWidth", (() => {
                if (this.swiper) {
                    const e = this.querySelector(".pwzrswiper-container");
                    if (e) {
                        const t = this.getSwiperContainerWidth();
                        t !== this.swiperContainerWidth && (e.style.width = t, this.swiperContainerWidth = t)
                    }
                }
            })), Ba(this, "getSwiperContainerWidth", (() => {
                const {config: {navigation: e}, media: t} = this.props;
                return `min(100%, ${this.getSwiperContainerMaxWidth()})`
            })), Ba(this, "getInitialSwiperContainerWidth", (() => {
                const e = this.getSwiperContainerWidth();
                return this.swiperContainerWidth = e, e
            })), Ba(this, "destroySwiper", (() => {
                if (this.swiper)
                    try {
                        this.swiper.destroy()
                    } catch {}
                delete this.swiper
            })), Ba(this, "initOrReinitDriftIfNeeded", (() => {
                const {config: {magnify: e}, media: t} = this.props;
                if (!e)
                    return;
                if ("image" !== t[this.selected].type)
                    return;
                this.destroyDrift();
                const n = this.querySelector(`#pwzrswiper-img-${this.selected}`),
                    r = this.querySelector(`#pwzrswiper-slide-${this.selected}`),
                    i = (Pp || (Pp = !0, zp()), Mp).default;
                this.drift = new i(n, {
                    inlineContainer: r,
                    inlinePane: !0,
                    containInline: !0,
                    injectBaseStyles: !1,
                    handleTouch: !0,
                    zoomFactor: this.getMagnifyZoom()
                })
            })), Ba(this, "destroyDrift", (() => {this.drift && this.drift.destroy(), delete this.drift})), Ba(this, "updateResponsiveImages", (() => {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1) {
                    const n = e[t],
                        r = this.querySelector(`#pwzrswiper-img-${t}`),
                        i = Fm.generateResponsiveImage(n, this.responsiveImageWidth),
                        o = Fm.generateResponsiveImage(n, Uh(this.containerWidth * Math.max(Fh(), this.getMagnifyZoom())));
                    "video" === n.type ? r.setAttribute("poster", i) : "image" === n.type && ("string" == typeof r.className && (r.className = r.className.replace("pwzrswiper-lazy-loaded", "")), r.setAttribute(this.swiper ? "data-src" : "src", i), r.setAttribute("data-zoom", o))
                }
            })), Ba(this, "getMagnifyZoom", (() => {
                const {config: {magnify: e}} = this.props;
                return e && e.zoom || 3
            })), Ba(this, "getScale", (e => e.scaleSources || e.scale)), Ba(this, "updateScaling", (e => {
                for (let t = 0; t < e.length; t += 1) {
                    const n = e[t],
                        r = this.querySelector(`#pwzrswiper-slide-${t}`),
                        i = this.getScale(n);
                    r.style.paddingBottom = i
                }
            })), this.selected = e.selected, this.rootRef = lt.createRef()
        }
        componentDidMount()
        {
            const {config: {vertical: e}} = this.props;
            e || this.mountSwiper(), this.mountPhotoSwipe(), this.initOrReinitDriftIfNeeded(), this.mountVideos()
        }
        shouldComponentUpdate(e)
        {
            const {selected: t} = e;
            if (this.selected !== t)
                if (this.swiper)
                    this.swiper.slideTo(t);
                else {
                    this.selected = t;
                    const e = this.querySelector(`#pwzrswiper-slide-${this.selected}`);
                    e && th(e, {
                        time: 300
                    })
                }
            return !1
        }
        componentWillUnmount()
        {
            this.destroyVideos(), this.destroyDrift(), this.destroySwiper(), this.destroyPhotoSwipe()
        }
        render()
        {
            const {media: e, classes: t, width: n, config: {pagination: r, clickablePagination: i, navigation: o, magnify: a, lightBox: s, vertical: l, verticalSpacing: u, verticalType: c}} = this.props,
                d = l ? {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap"
                } : {},
                p = l ? {} : {
                    width: this.getInitialSwiperContainerWidth(),
                    ...a ? {
                        [a.width && "full" !== a.width && "--magnify-width"]: a.width,
                        [a.height && "full" !== a.height && "--magnify-height"]: a.height
                    } : {}
                },
                f = 1 === e.length;
            return lt.createElement("div", {
                ref: this.rootRef,
                id: "pwzrswiper-container-wrapper"
            }, !l && lt.createElement(Kc, {
                handleWidth: !0,
                skipOnMount: !0,
                onResize: () => {this.updateSwiperContainerWidth()}
            }), lt.createElement("div", {
                style: {
                    position: "relative"
                }
            }, lt.createElement("div", {
                className: fa("pwzrswiper-container", l ? null : t.containerHidden),
                style: p
            }, lt.createElement(Kc, {
                handleWidth: !0,
                handleHeight: !0,
                onResize: (r, i) => {
                    const o = () => {
                        this.containerWidth = r;
                        const e = Uh(r * Fh());
                        this.responsiveImageWidth !== e && (this.responsiveImageWidth = Math.max(e, Fm.getPlaceholderImageWidth(n)), this.updateResponsiveImages())
                    };
                    if (!l && (this.swiper || this.mountSwiper(), !this.swiper.initialized)) {
                        const n = this.querySelector(".pwzrswiper-container");
                        n.className = n.className.replace(t.containerHidden, t.containerVisible), o(), this.swiper.init(), this.updateScaling(e), this.updateSwiperContainerWidth()
                    }
                    if (o(), this.swiper && this.swiper.update(), a) {
                        const {style: e} = this.querySelector(".pwzrswiper-container");
                        "full" === a.width && (e.setProperty("--magnify-width", `${r}px`), e.setProperty("--magnify-width-full", "yes")), "full" === a.height && (e.setProperty("--magnify-height", `${i}px`), e.setProperty("--magnify-height-full", "yes"))
                    }
                }
            }), lt.createElement("div", {
                id: "pwzrswiper-wrapper",
                className: "pwzrswiper-wrapper",
                style: d
            }, e.map(((e, r) => {
                const i = Fm.generatePlaceholderImage(e, n),
                    {id: o, alt: a, type: d, sources: p, rioSettings: h} = e,
                    m = (l || r === this.selected) && h.muted && h.autoPlay,
                    v = Number.parseInt(u, 10) || 0;
                return lt.createElement("div", {
                    id: `pwzrswiper-slide-${r}`,
                    className: "pwzrswiper-slide",
                    style: {
                        cursor: s && "image" === d ? "pointer" : "default",
                        paddingBottom: (() => {
                            if (!l)
                                return r === this.selected ? this.getScale(e) : void 0;
                            if (!f) {
                                const t = () => {
                                    const t = Number.parseFloat(this.getScale(e)) / 100 * (v / 2);
                                    return `calc((${this.getScale(e)} / 2) - ${t}px)`
                                };
                                if ("two-columns" === c)
                                    return t();
                                if ("two-columns-main" === c && r > 0)
                                    return t()
                            }
                            return this.getScale(e)
                        })(),
                        marginBottom: (() => {
                            if (l)
                                return `${v}px`
                        })(),
                        width: (() => {
                            if (l) {
                                if (!f) {
                                    const e = () => `calc(50% - ${v / 2}px)`;
                                    if ("two-columns" === c)
                                        return e();
                                    if ("two-columns-main" === c && r > 0)
                                        return e()
                                }
                                return "100%"
                            }
                        })(),
                        marginRight: (() => {
                            if (l && !f) {
                                if ("two-columns" === c && r % 2 == 0)
                                    return `${v}px`;
                                if ("two-columns-main" === c && r % 2 != 0)
                                    return `${v}px`
                            }
                        })()
                    },
                    key: o
                }, "video" === d && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: fa("pwzrswiper-lazy", t.slideExternalVideo),
                    "data-tagname": "VIDEO",
                    "data-poster": i
                }, lt.createElement("iframe", {
                    id: `pwzrswiper-img-frame-${r}`,
                    className: t.slideExternalVideoIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=${encodeURIComponent(JSON.stringify({...h,autoPlay: m,sources: p,poster: i}))}`,
                    title: a
                })), "model" === d && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: fa("pwzrswiper-lazy", t.slideModel),
                    "data-tagname": "MODEL",
                    "data-poster": i
                }, lt.createElement("iframe", {
                    className: t.slideModelIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; gyroscope",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src=${encodeURIComponent(p[0])}${a ? `&alt=${encodeURIComponent(a)}` : ""}&poster=${encodeURIComponent(i)}${h.autoRotate ? "&autorotate=true" : ""}`,
                    title: a
                })), "external_video" === d && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: fa("pwzrswiper-lazy", t.slideExternalVideo)
                }, lt.createElement("iframe", {
                    id: `pwzrswiper-img-frame-${r}`,
                    className: t.slideExternalVideoIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=${encodeURIComponent(JSON.stringify({source: p[0],muted: h.muted,controls: h.controls,autoPlay: m,title: a || void 0}))}`,
                    title: a
                })), "image" === d && lt.createElement("img", {
                    id: `pwzrswiper-img-${r}`,
                    className: fa("pwzrswiper-lazy", t.slideImg),
                    src: i,
                    alt: a
                }))
            })))), !l && o && e.length > 1 && lt.createElement(lt.Fragment, null, lt.createElement("style", null, "\n                  .pwzrswiper-button-disabled {\n                    opacity: 0.35;\n                    cursor: auto;\n                    pointer-events: none;\n                  }\n                "), lt.createElement("div", {
                className: fa("pwzrswiper-btn-next", t.arrow, t.arrowRight)
            }, lt.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "30",
                height: "30",
                viewBox: "0 0 20 20"
            }, lt.createElement("path", {
                d: "M5.377 19.523a.675.675 0 010-.955L13.945 10 5.377 1.432a.675.675 0 11.955-.955l8.815 8.816a1 1 0 010 1.414l-8.815 8.816a.675.675 0 01-.955 0z"
            }))), lt.createElement("div", {
                className: fa("pwzrswiper-btn-prev", t.arrow, t.arrowLeft)
            }, lt.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "30",
                height: "30",
                viewBox: "0 0 20 20"
            }, lt.createElement("path", {
                d: "M14.477.477a.675.675 0 010 .955L5.91 10l8.568 8.568a.675.675 0 11-.954.955l-8.816-8.816a1 1 0 010-1.414L13.523.477a.675.675 0 01.954 0z"
            }))))), !l && r && e.length > 1 && lt.createElement(Bm, {
                clickablePagination: i
            }))
        }
    }
    Fm.propTypes = {
        config: Jh.isRequired,
        onSlideChange: Tt.func.isRequired,
        selected: Tt.number.isRequired,
        width: Tt.string.isRequired,
        media: Tt.arrayOf(Qh).isRequired,
        classes: Tt.exact({
            slideImg: Tt.string.isRequired,
            slideModel: Tt.string.isRequired,
            slideModelIframe: Tt.string.isRequired,
            slideExternalVideo: Tt.string.isRequired,
            slideExternalVideoIframe: Tt.string.isRequired,
            arrow: Tt.string.isRequired,
            arrowRight: Tt.string.isRequired,
            arrowLeft: Tt.string.isRequired,
            containerVisible: Tt.string.isRequired,
            containerHidden: Tt.string.isRequired
        }).isRequired
    };
    var Wm = function() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        return function(e) {
            var n = t.reduceRight((function(e, t) {
                return t(e)
            }), e);
            return Sa(n, e)
        }
    }(Wp({
        containerVisible: {
            opacity: 1,
            transition: "opacity 0.2s ease-in-out"
        },
        containerHidden: {
            opacity: 0
        },
        slideImg: {
            position: "absolute",
            width: "100%",
            height: "auto",
            maxWidth: "none"
        },
        slideModel: {
            position: "absolute",
            width: "100%",
            height: "100%",
            maxWidth: "none"
        },
        slideModelIframe: {
            width: "100%",
            height: "100%"
        },
        slideExternalVideo: {
            position: "absolute",
            width: "100%",
            height: "100%",
            maxWidth: "none"
        },
        slideExternalVideoIframe: {
            width: "100%",
            height: "100%"
        },
        arrow: {
            position: "absolute",
            top: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "38px",
            height: "50px",
            marginTop: "-25px",
            zIndex: 1,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.4)"
        },
        arrowRight: {
            right: "5px"
        },
        arrowLeft: {
            left: "5px"
        }
    }), function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return function(t) {
            var n = e.withTheme,
                r = void 0 !== n && n,
                i = e.noSSR,
                o = void 0 !== i && i,
                a = e.initialWidth;
            function s(e) {
                var n = Pa(),
                    i = e.theme || n,
                    s = lr({
                        theme: i,
                        name: "PwzrWithWidth",
                        props: ft({}, e)
                    }),
                    l = s.initialWidth,
                    u = s.width,
                    c = dt(s, ["initialWidth", "width"]),
                    d = lt.useState(!1),
                    p = d[0],
                    f = d[1];
                qf((function() {
                    f(!0)
                }), []);
                var h = to(i.breakpoints.keys).reverse().reduce((function(e, t) {
                        var n = Hl(i.breakpoints.up(t));
                        return !e && n ? t : e
                    }), null),
                    m = ft({
                        width: u || (p || o ? h : void 0) || l || a
                    }, r ? {
                        theme: i
                    } : {}, {}, c);
                return void 0 === m.width ? null : lt.createElement(t, m)
            }
            return Sa(s, t), s
        }
    }())(Fm);
    function Hm() {
        return lt.createElement("svg", {
            riocandrag: "true",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20"
        }, lt.createElement("path", {
            fill: "#212b36",
            d: "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
            opacity: ".9"
        }), lt.createElement("path", {
            fill: "#c4cdd5",
            d: "M8.277 12.927V7.07l4.649 2.927-4.649 2.93zm-.134-7.235a.595.595 0 00-.32-.092c-.344 0-.623.292-.623.653v7.492c0 .119.03.235.089.337.177.309.56.41.855.224l5.954-3.747a.638.638 0 00.214-.224.673.673 0 00-.214-.897L8.144 5.691z"
        }))
    }
    function jm() {
        return lt.createElement("svg", {
            riocandrag: "true",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20"
        }, lt.createElement("path", {
            fill: "#212b36",
            d: "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
            opacity: ".9"
        }), lt.createElement("path", {
            fill: "#c4cdd5",
            d: "M14.139 7.816l-3.877-2.149a.54.54 0 00-.523 0L5.862 7.816a.496.496 0 00-.261.435v4.298c0 .179.1.345.261.435l3.877 2.149a.54.54 0 00.523 0l3.877-2.149a.496.496 0 00.261-.435V8.251c0-.179-.1-.345-.261-.435zM10 6.682l2.831 1.569L10 9.82 7.169 8.251 10 6.682zM6.646 9.12l2.831 1.569v3.139l-2.831-1.57V9.119zm3.877 4.709V10.69l2.831-1.569v3.138l-2.831 1.57z"
        }))
    }
    const $m = Yl((() => ({
        thumbnailImage: {
            position: "relative",
            display: "block",
            width: "100%",
            maxWidth: "none"
        },
        thumbnailPlay: {
            position: "absolute",
            top: "4px",
            right: "2px",
            width: "26px",
            height: "26px"
        },
        thumbnailButton: {
            outline: "none",
            position: "relative",
            boxSizing: "border-box",
            border: "solid",
            borderWidth: "1px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    })));
    const Vm = lt.forwardRef((({config: {thumbnails: {thumbnailWidth: e, thumbnailsPerRow: t, orientation: n, multiRow: r, square: i, centerCrop: o}, pagination: a}, media: s, onThumbnailSelected: l, selected: u, swiperKey: c, onThumbnailsScrolled: d, onThumbnailsResized: p, isDefaultMedia: f}, h) => {
        const m = $m(),
            v = Boolean(e),
            g = qh(n),
            [y, b] = ne(v ? e : 0),
            w = ae(c),
            x = ae(!f),
            _ = ue((e => {
                if (e) {
                    if (w.current !== c && (x.current = !0, w.current = c), x.current)
                        return void (x.current = !1);
                    th(e, {
                        time: 100,
                        lockX: g,
                        lockY: !g,
                        scrollAllParents: !1
                    }, (() => {d()}))
                }
            }), [g, d, c]);
        return lt.createElement(xm, {
            onScroll: () => {d()},
            ref: h,
            container: !0,
            direction: "row",
            justify: r ? "center" : void 0,
            alignItems: "center",
            wrap: r ? "wrap" : "nowrap",
            style: {
                overflow: "auto"
            },
            className: "rio-hide-scrollbar"
        }, lt.createElement(Kc, {
            key: c,
            handleWidth: !g,
            handleHeight: g,
            refreshMode: "debounce",
            refreshRate: 250,
            onResize: () => {p()}
        }), !v && lt.createElement(Kc, {
            handleWidth: !0,
            onResize: e => {
                const n = e / t;
                b(Math.floor(n))
            }
        }), y > 0 && s.map((({transformedSrc: e, id: t, alt: n, scale: c, type: d}, p) => {
            const {width: f, height: h, widthInner: v, heightInner: b, imgWidth: w, imgHeight: x, needsCenterCrop: C} = function({thumbnailWidth: e, scale: t, square: n, centerCrop: r}) {
                    const i = e,
                        o = e * (parseFloat(t) / 100),
                        a = e - 8,
                        s = a * (parseFloat(t) / 100),
                        l = n && i > o,
                        u = l && r;
                    return {
                        width: i,
                        height: l ? i : o,
                        widthInner: a,
                        heightInner: l ? a : s,
                        imgWidth: a,
                        imgHeight: u ? a : s,
                        needsCenterCrop: u
                    }
                }({
                    thumbnailWidth: y,
                    scale: c,
                    square: i,
                    centerCrop: o
                }),
                E = Uh(y * Fh()),
                S = !r && !g,
                k = 0 === p,
                T = p === s.length - 1,
                O = k || T,
                M = !g && O && !r,
                R = g && O,
                P = M ? f - (f - v) / 2 : f,
                A = R ? h - (h - b) / 2 : h,
                I = T ? "flex-end" : "flex-start";
            return lt.createElement(xm, {
                item: !0,
                container: !0,
                ref: p === u ? _ : void 0,
                key: t,
                style: {
                    minWidth: P,
                    minHeight: A,
                    width: P,
                    height: A,
                    ...S && k ? {
                        marginLeft: "auto"
                    } : {},
                    ...S && T ? {
                        marginRight: "auto"
                    } : {}
                },
                alignItems: R ? I : "center",
                justify: M ? I : "center"
            }, lt.createElement("div", {
                role: "none",
                onClick: () => {l(p)},
                onKeyPress: e => {"Enter" === e.key && l(p)},
                tabIndex: a ? -1 : p + 1,
                className: m.thumbnailButton,
                style: {
                    width: v,
                    height: b,
                    ...p === u ? {
                        borderColor: "var(--rio-thumbnail-selection-color, rgb(0, 0, 0))"
                    } : {
                        borderColor: "transparent"
                    }
                }
            }, lt.createElement("img", {
                src: e(E, C ? E : null, C),
                style: {
                    width: w - 2,
                    height: x - 2
                },
                alt: n,
                className: m.thumbnailImage
            }), ("video" === d || "external_video" === d) && lt.createElement("div", {
                className: m.thumbnailPlay
            }, lt.createElement(Hm, null)), "model" === d && lt.createElement("div", {
                className: m.thumbnailPlay
            }, lt.createElement(jm, null))))
        })))
    }));
    Vm.propTypes = {
        config: Jh.isRequired,
        media: Tt.arrayOf(Qh).isRequired,
        selected: Tt.number.isRequired,
        swiperKey: Tt.string.isRequired,
        onThumbnailSelected: Tt.func.isRequired,
        onThumbnailsScrolled: Tt.func.isRequired,
        onThumbnailsResized: Tt.func.isRequired,
        isDefaultMedia: Tt.bool.isRequired
    };
    const qm = Yl((() => ({
        root: {
            display: "flex"
        },
        thumbnailsContainer: {
            display: "flex"
        },
        navigationRoot: {
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            width: "41px",
            height: "41px",
            zIndex: 1,
            "&:hover": {
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                "@media (hover: none)": {
                    backgroundColor: "rgba(0, 0, 0, 0.5)"
                }
            }
        }
    })));
    function Um(e) {
        if ("bottom" === e)
            return "column-reverse";
        if ("top" === e)
            return "column";
        if ("right" === e)
            return "row-reverse";
        if ("left" === e)
            return "row";
        throw Error(`Unknown thumbnail orientation '${e}'`)
    }
    function Gm({isLrOrien: e, thumbnails: t}) {
        return e && t.verticalOverflow ? 0 : "auto"
    }
    function Zm({isLrOrien: e, thumbnails: t}) {
        return e ? t.container ? 100 * t.container + "%" : t.thumbnailWidth * t.thumbnailsPerRow + "px" : null
    }
    function Km({media: e, config: t, selected: n, onSelectedChanged: r, swiperKey: i, isDefaultMedia: o}) {
        const a = tu(),
            s = qm(),
            {thumbnails: l, pagination: u} = t,
            c = !!l && qh(l.orientation),
            d = e.length > 1 && l,
            p = !!d && qh(d.orientation),
            f = a.spacing(1),
            [h, m] = ne(Gm({
                isLrOrien: c,
                thumbnails: l
            })),
            [v, g] = ne(Zm({
                isLrOrien: c,
                thumbnails: l
            })),
            [y, b] = ne(!1),
            [w, x] = ne(!1),
            [_, C] = ne(Sd.v4());
        ie((() => {m(Gm({
                isLrOrien: c,
                thumbnails: l
            })), g(Zm({
                isLrOrien: c,
                thumbnails: l
            })), C(Sd.v4())}), [p, d]);
        const [E, S] = ne("100%"),
            k = ae(null),
            T = ue((() => {
                if (!d.navigation)
                    return;
                const e = k.current;
                if (e) {
                    const t = Hh(e, p);
                    x(!t.start), b(!t.end)
                }
            }), [p, d]),
            O = d ? {
                flexDirection: Um(d.orientation)
            } : {
                flexDirection: "column"
            };
        return lt.createElement("div", {
            className: s.root,
            style: O
        }, lt.createElement(Kc, {
            handleWidth: !0,
            key: _,
            onResize: e => {
                let t = v;
                p && d.container && (t = `${Math.floor(e * d.container)}px`, g(t));
                const n = `${Math.floor(e)}px`;
                S("string" == typeof t ? `calc(${n} - ${t} - ${f}px)` : n)
            }
        }), d && lt.createElement("div", {
            style: p ? {
                overflowY: "auto",
                overflowX: "hidden",
                flexDirection: "column",
                alignItems: "center",
                width: v,
                height: h,
                ["margin" + ("left" === d.orientation ? "Right" : "Left")]: f,
                position: "relative",
                boxSizing: "border-box"
            } : {
                flexDirection: "row",
                marginTop: u ? void 0 : f,
                position: "relative",
                alignItems: "center"
            },
            className: fa("rio-hide-scrollbar", s.thumbnailsContainer)
        }, 0 !== h && d.navigation && w && lt.createElement(Hu, {
            component: "div",
            role: "none",
            size: "small",
            classes: {
                root: s.navigationRoot
            },
            onClick: async () => {
                const e = await jh(k.current, p, -1);
                x(!e.start), b(!e.end)
            },
            style: {
                position: "absolute",
                [!p && "left"]: 0,
                [p && "top"]: 0
            }
        }, p && lt.createElement(Ed, {
            fontSize: "large"
        }), !p && lt.createElement(ud, {
            fontSize: "large"
        })), lt.createElement(Vm, {
            ref: k,
            swiperKey: i,
            config: t,
            media: e,
            selected: n,
            onThumbnailSelected: e => {r(e)},
            onThumbnailsScrolled: T,
            onThumbnailsResized: () => {T()},
            isDefaultMedia: o
        }), 0 !== h && d.navigation && y && lt.createElement(Hu, {
            component: "div",
            role: "none",
            size: "small",
            classes: {
                root: s.navigationRoot
            },
            onClick: async () => {
                const e = await jh(k.current, p, 1);
                x(!e.start), b(!e.end)
            },
            style: {
                position: "absolute",
                [!p && "right"]: 0,
                [p && "bottom"]: 0
            }
        }, p && lt.createElement(bd, {
            fontSize: "large"
        }), !p && lt.createElement(hd, {
            fontSize: "large"
        }))), lt.createElement("div", {
            style: p ? {
                flex: 1,
                overflow: "hidden"
            } : void 0
        }, lt.createElement("div", {
            style: {
                maxWidth: E
            }
        }, lt.createElement(Wm, {
            key: i,
            config: t,
            media: e,
            selected: n,
            onSlideChange: e => {r(e)}
        }), p && d.verticalOverflow && lt.createElement(Kc, {
            handleHeight: !0,
            key: _,
            onResize: (e, t) => {m(t)}
        }))))
    }
    function Ym(e, t, n) {
        const r = n || function() {
            const {href: e} = window.location,
                t = bh(e, !0),
                {variant: n} = t.query;
            return n || null
        }();
        if (r)
            if (e) {
                const e = t.variants.find((e => e.id === r));
                if (e && e.featuredMediaIndex > -1)
                    return e.featuredMediaIndex
            } else {
                const e = t.findIndex((e => e.variant === r));
                if (e > -1)
                    return e
            }
        if (e) {
            const e = t.variants.find((e => !0 === e.available));
            if (e && e.featuredMediaIndex > -1)
                return e.featuredMediaIndex
        } else {
            const e = t.findIndex((e => !0 === e.available));
            if (e > -1)
                return e
        }
        return 0
    }
    Km.propTypes = {
        config: Jh.isRequired,
        media: Tt.arrayOf(Qh).isRequired,
        selected: Tt.number.isRequired,
        onSelectedChanged: Tt.func.isRequired,
        swiperKey: Tt.string.isRequired,
        isDefaultMedia: Tt.bool.isRequired
    }, (Fl || (Fl = !0, Wl()), Nl)();
    var Xm,
        Jm,
        Qm = !1;
    function ev(e, t, n) {
        e.addEventListener(t, n)
    }
    function tv(e, t, n) {
        e.removeEventListener(t, n)
    }
    function nv(e) {
        let t = null;
        for (let n = 0; n < document.forms.length; n++) {
            const r = document.forms[n].getAttribute("action");
            r && r.indexOf("/cart/add") >= 0 && (t || (t = Jm(e)), ev(document.forms[n], "change", t))
        }
        return t
    }
    function rv(e) {
        for (let t = 0; t < document.forms.length; t++) {
            const n = document.forms[t].getAttribute("action");
            n && n.indexOf("/cart/add") >= 0 && tv(document.forms[t], "change", e)
        }
    }
    function iv() {
        Jm = e => t => {!function(e, t) {
                try {
                    let n;
                    if (!(n = e.id.options && e.id.options[e.id.selectedIndex] ? e.id.options[e.id.selectedIndex] : e.id))
                        return;
                    t(n.value)
                } catch (e) {
                    console.warn(`[productwiz-rio] Error in trackViewedProductVariant: ${e.message}`)
                }
            }((t = t || window.event).currentTarget, e)}, r(Xm = {}, "addListeners", (function() {
            return nv
        })), r(Xm, "removeListeners", (function() {
            return rv
        }))
    }
    function ov() {
        return Qm || (Qm = !0, iv()), Xm
    }
    var av,
        sv = !1;
    function lv(e) {
        const t = document.querySelector(".rio-current-variant");
        if (t) {
            console.log("rio: rio-current-variant-found");
            const n = t => {console.log(`rio: change to variant ${t.target.value}`), e(`${t.target.value}`)};
            return t.addEventListener("change", n), n
        }
        return console.log("rio: rio-current-variant not found"), null
    }
    function uv(e) {
        const t = document.querySelector(".rio-current-variant");
        t && t.removeEventListener("change", e)
    }
    function cv() {
        return sv || (sv = !0, r(av = {}, "addListeners", (function() {
            return lv
        })), r(av, "removeListeners", (function() {
            return uv
        }))), av
    }
    function dv({isDefaultMedia: e, mediaParam: t, useFormListener: n, useManualListener: r, setSelectedVariant: i, setSelectedMedia: o, selectedVariant: a, setMediaKey: s}) {
        const l = ae(null),
            u = ue((n => {
                const r = Ym(e, t, n);
                if (i(r), !e) {
                    if (!function(e, t, n) {
                        const {media: r} = e[t],
                            {media: i} = e[n];
                        if (Array.isArray(r) && Array.isArray(i)) {
                            const e = r.map((e => e.id)),
                                t = i.map((e => e.id));
                            if (e.length !== t.length)
                                return !1;
                            for (let n = 0; n < e.length; n += 1)
                                if (e[n] !== t[n])
                                    return !1;
                            return !0
                        }
                        return !1
                    }(t, a, r)) {
                        o(0);
                        const {variant: e} = t[r];
                        s(e)
                    }
                }
            }), [e, t, a, s, o, i]);
        ie((() => {l.current = u}), [u]), ie((() => {
            const e = (({useFormListener: e, useManualListener: t, handleLocationChangeRef: n}) => {
                if (e || t) {
                    const {addListeners: t} = e ? ov() : cv();
                    return t((e => {n.current && n.current(e)}))
                }
                const r = () => {n.current && n.current()};
                return window.addEventListener("locationchange", r), r
            })({
                useFormListener: n,
                useManualListener: r,
                handleLocationChangeRef: l
            });
            return () => {e && (({useFormListener: e, useManualListener: t, event: n}) => {
                    if (e || t) {
                        const {removeListeners: t} = e ? ov() : cv();
                        t(n)
                    } else
                        window.removeEventListener("locationchange", n)
                })({
                    useFormListener: n,
                    useManualListener: r,
                    event: e
                })}
        }), [n, r])
    }
    function pv({media: e, mobileConfig: t, desktopConfig: n, breakpoint: r, useFormListener: i, useManualListener: o}) {
        const a = "object" == typeof e.media && "object" == typeof e.variants,
            s = Hl(`(min-width:${"none" === r ? "0px" : r})`, {
                noSsr: !0
            }),
            l = le((() => Ym(a, e)), [a, e]),
            [u, c] = ne(l),
            [d, p] = ne(0),
            [f, h] = ne(a ? null : e[u].variant);
        let m,
            v,
            g,
            y;
        const b = s ? "desktop" : "mobile";
        if (a)
            m = b, v = b, g = e.media, y = u;
        else {
            m = b, v = `${f}-${b}`, g = e[u].media, y = d
        }
        dv({
            isDefaultMedia: a,
            mediaParam: e,
            useFormListener: i,
            useManualListener: o,
            setSelectedVariant: c,
            setSelectedMedia: p,
            selectedVariant: u,
            setMediaKey: h
        });
        const w = function({isDefaultMedia: e, mediaParam: t, config: n}) {
            if (!1 !== n.thumbnails)
                return n;
            const r = e => "video" === e.type || "external_video" === e.type || "model" === e.type;
            if (e) {
                for (const e of t.media)
                    if (r(e))
                        return {
                            ...n,
                            navigation: !0
                        }
            } else
                for (const e of t)
                    for (const t of e.media)
                        if (r(t))
                            return {
                                ...n,
                                navigation: !0
                            };
            return n
        }({
            isDefaultMedia: a,
            mediaParam: e,
            config: s ? n : t
        });
        return lt.createElement(Km, {
            key: m,
            swiperKey: v,
            media: g,
            config: w,
            selected: y,
            onSelectedChanged: e => {a ? c(e) : p(e)},
            isDefaultMedia: a
        })
    }
    function fv(e, t, n, r) {
        return e && !t ? Zh(e) : function(e, t, n, r) {
            const i = Zh(e),
                o = i.variants.map((e => {
                    const o = [],
                        a = t.find((t => t.id === e.id));
                    return a && a.media.forEach((e => {
                        const t = Vh(i.media, r, e);
                        t && o.push({
                            ...t,
                            rioSettings: $h(a.id, e, n)
                        })
                    })), o.length < 1 && o.push(...i.media), {
                        variant: e.id,
                        available: e.available,
                        media: o
                    }
                }));
            return o.length < 1 ? i : o
        }(e, t, n, r)
    }
    if (pv.defaultProps = {
        useFormListener: !1,
        useManualListener: !1
    }, pv.propTypes = {
        breakpoint: Tt.string.isRequired,
        useFormListener: Tt.bool,
        useManualListener: Tt.bool,
        mobileConfig: Jh.isRequired,
        desktopConfig: Jh.isRequired,
        media: Tt.oneOfType([Tt.arrayOf(Tt.exact({
            variant: Tt.string.isRequired,
            available: Tt.bool.isRequired,
            media: Tt.arrayOf(Qh).isRequired
        })), Tt.exact({
            media: Tt.arrayOf(Qh).isRequired,
            variants: Tt.arrayOf(Tt.exact({
                id: Tt.string.isRequired,
                featuredMediaIndex: Tt.number.isRequired,
                available: Tt.bool.isRequired
            })).isRequired
        })]).isRequired
    }, "undefined" != typeof __productWizRio) {
        const {enabled: e, hijackInit: t} = __productWizRio;
        if (e) {
            const e = () => {
                    const {product: e, productRio: t, mediaSettings: n, imageFilenames: r, useFormListener: i, useManualListener: o, config: {mobile: a, desktop: s, breakpoint: l, lightBoxBackgroundColor: u, thumbnailSelectionColor: c}} = __productWizRio,
                        d = fv(e, t, n, r),
                        p = Bl({
                            overrides: {
                                PwzrSvgIcon: {
                                    root: {
                                        width: "35px",
                                        height: "35px"
                                    }
                                }
                            }
                        });
                    return lt.createElement("div", {
                        style: {
                            width: "100%",
                            height: "auto",
                            textAlign: "left"
                        }
                    }, lt.createElement("style", null, `\n              :root {\n                --rio-lightbox-background-color: ${u || "rgb(0, 0, 0)"};\n                --rio-thumbnail-selection-color: ${c || "rgb(0, 0, 0)"};\n              }\n            `), lt.createElement(Ta, {
                        theme: p
                    }, lt.createElement(pv, {
                        media: d,
                        mobileConfig: a,
                        desktopConfig: s,
                        breakpoint: l,
                        useFormListener: "boolean" == typeof i && i,
                        useManualListener: "boolean" == typeof o && o
                    })))
                },
                n = async () => {
                    const t = document.querySelector(".rio-media-gallery");
                    t && je(lt.createElement(e, null), t)
                };
            t ? __productWizRio.init = n : "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", n) : n()
        }
    }
    var hv = {},
        mv = {
            50: "#f3e5f5",
            100: "#e1bee7",
            200: "#ce93d8",
            300: "#ba68c8",
            400: "#ab47bc",
            500: "#9c27b0",
            600: "#8e24aa",
            700: "#7b1fa2",
            800: "#6a1b9a",
            900: "#4a148c",
            A100: "#ea80fc",
            A200: "#e040fb",
            A400: "#d500f9",
            A700: "#aa00ff"
        },
        vv = {
            50: "#ede7f6",
            100: "#d1c4e9",
            200: "#b39ddb",
            300: "#9575cd",
            400: "#7e57c2",
            500: "#673ab7",
            600: "#5e35b1",
            700: "#512da8",
            800: "#4527a0",
            900: "#311b92",
            A100: "#b388ff",
            A200: "#7c4dff",
            A400: "#651fff",
            A700: "#6200ea"
        },
        gv = {
            50: "#e1f5fe",
            100: "#b3e5fc",
            200: "#81d4fa",
            300: "#4fc3f7",
            400: "#29b6f6",
            500: "#03a9f4",
            600: "#039be5",
            700: "#0288d1",
            800: "#0277bd",
            900: "#01579b",
            A100: "#80d8ff",
            A200: "#40c4ff",
            A400: "#00b0ff",
            A700: "#0091ea"
        },
        yv = {
            50: "#e0f7fa",
            100: "#b2ebf2",
            200: "#80deea",
            300: "#4dd0e1",
            400: "#26c6da",
            500: "#00bcd4",
            600: "#00acc1",
            700: "#0097a7",
            800: "#00838f",
            900: "#006064",
            A100: "#84ffff",
            A200: "#18ffff",
            A400: "#00e5ff",
            A700: "#00b8d4"
        },
        bv = {
            50: "#e0f2f1",
            100: "#b2dfdb",
            200: "#80cbc4",
            300: "#4db6ac",
            400: "#26a69a",
            500: "#009688",
            600: "#00897b",
            700: "#00796b",
            800: "#00695c",
            900: "#004d40",
            A100: "#a7ffeb",
            A200: "#64ffda",
            A400: "#1de9b6",
            A700: "#00bfa5"
        },
        wv = {
            50: "#f1f8e9",
            100: "#dcedc8",
            200: "#c5e1a5",
            300: "#aed581",
            400: "#9ccc65",
            500: "#8bc34a",
            600: "#7cb342",
            700: "#689f38",
            800: "#558b2f",
            900: "#33691e",
            A100: "#ccff90",
            A200: "#b2ff59",
            A400: "#76ff03",
            A700: "#64dd17"
        },
        xv = {
            50: "#f9fbe7",
            100: "#f0f4c3",
            200: "#e6ee9c",
            300: "#dce775",
            400: "#d4e157",
            500: "#cddc39",
            600: "#c0ca33",
            700: "#afb42b",
            800: "#9e9d24",
            900: "#827717",
            A100: "#f4ff81",
            A200: "#eeff41",
            A400: "#c6ff00",
            A700: "#aeea00"
        },
        _v = {
            50: "#fffde7",
            100: "#fff9c4",
            200: "#fff59d",
            300: "#fff176",
            400: "#ffee58",
            500: "#ffeb3b",
            600: "#fdd835",
            700: "#fbc02d",
            800: "#f9a825",
            900: "#f57f17",
            A100: "#ffff8d",
            A200: "#ffff00",
            A400: "#ffea00",
            A700: "#ffd600"
        },
        Cv = {
            50: "#fff8e1",
            100: "#ffecb3",
            200: "#ffe082",
            300: "#ffd54f",
            400: "#ffca28",
            500: "#ffc107",
            600: "#ffb300",
            700: "#ffa000",
            800: "#ff8f00",
            900: "#ff6f00",
            A100: "#ffe57f",
            A200: "#ffd740",
            A400: "#ffc400",
            A700: "#ffab00"
        },
        Ev = {
            50: "#fbe9e7",
            100: "#ffccbc",
            200: "#ffab91",
            300: "#ff8a65",
            400: "#ff7043",
            500: "#ff5722",
            600: "#f4511e",
            700: "#e64a19",
            800: "#d84315",
            900: "#bf360c",
            A100: "#ff9e80",
            A200: "#ff6e40",
            A400: "#ff3d00",
            A700: "#dd2c00"
        },
        Sv = {
            50: "#efebe9",
            100: "#d7ccc8",
            200: "#bcaaa4",
            300: "#a1887f",
            400: "#8d6e63",
            500: "#795548",
            600: "#6d4c41",
            700: "#5d4037",
            800: "#4e342e",
            900: "#3e2723",
            A100: "#d7ccc8",
            A200: "#bcaaa4",
            A400: "#8d6e63",
            A700: "#5d4037"
        },
        kv = {
            50: "#eceff1",
            100: "#cfd8dc",
            200: "#b0bec5",
            300: "#90a4ae",
            400: "#78909c",
            500: "#607d8b",
            600: "#546e7a",
            700: "#455a64",
            800: "#37474f",
            900: "#263238",
            A100: "#cfd8dc",
            A200: "#b0bec5",
            A400: "#78909c",
            A700: "#455a64"
        };
    r(hv, "common", (function() {
        return Rn
    })), r(hv, "red", (function() {
        return zn
    })), r(hv, "pink", (function() {
        return In
    })), r(hv, "purple", (function() {
        return mv
    })), r(hv, "deepPurple", (function() {
        return vv
    })), r(hv, "indigo", (function() {
        return An
    })), r(hv, "blue", (function() {
        return Dn
    })), r(hv, "lightBlue", (function() {
        return gv
    })), r(hv, "cyan", (function() {
        return yv
    })), r(hv, "teal", (function() {
        return bv
    })), r(hv, "green", (function() {
        return Nn
    })), r(hv, "lightGreen", (function() {
        return wv
    })), r(hv, "lime", (function() {
        return xv
    })), r(hv, "yellow", (function() {
        return _v
    })), r(hv, "amber", (function() {
        return Cv
    })), r(hv, "orange", (function() {
        return Ln
    })), r(hv, "deepOrange", (function() {
        return Ev
    })), r(hv, "brown", (function() {
        return Sv
    })), r(hv, "grey", (function() {
        return Pn
    })), r(hv, "blueGrey", (function() {
        return kv
    }));
    function Tv(e, t) {
        return t ? gt(e, t, {
            clone: !1
        }) : e
    }
    var Ov = {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920
        },
        Mv = {
            keys: ["xs", "sm", "md", "lg", "xl"],
            up: function(e) {
                return "@media (min-width:".concat(Ov[e], "px)")
            }
        };
    function Rv(e, t, n) {
        if (Array.isArray(t)) {
            var r = e.theme.breakpoints || Mv;
            return t.reduce((function(e, i, o) {
                return e[r.up(r.keys[o])] = n(t[o]), e
            }), {})
        }
        if ("object" === mt(t)) {
            var i = e.theme.breakpoints || Mv;
            return Object.keys(t).reduce((function(e, r) {
                return e[i.up(r)] = n(t[r]), e
            }), {})
        }
        return n(t)
    }
    function Pv(e, t) {
        return t && "string" == typeof t ? t.split(".").reduce((function(e, t) {
            return e && e[t] ? e[t] : null
        }), e) : null
    }
    function Av(e) {
        var t = e.prop,
            n = e.cssProperty,
            r = void 0 === n ? e.prop : n,
            i = e.themeKey,
            o = e.transform,
            a = function(e) {
                if (null == e[t])
                    return null;
                var n = e[t],
                    a = Pv(e.theme, i) || {};
                return Rv(e, n, (function(e) {
                    var t;
                    return "function" == typeof a ? t = a(e) : Array.isArray(a) ? t = a[e] || e : (t = Pv(a, e) || e, o && (t = o(t))), !1 === r ? t : ut({}, r, t)
                }))
            };
        return a.propTypes = {}, a.filterProps = [t], a
    }
    function Iv() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        var r = function(e) {
            return t.reduce((function(t, n) {
                var r = n(e);
                return r ? Tv(t, r) : t
            }), {})
        };
        return r.propTypes = {}, r.filterProps = t.reduce((function(e, t) {
            return e.concat(t.filterProps)
        }), []), r
    }
    function zv(e) {
        return "number" != typeof e ? e : "".concat(e, "px solid")
    }
    var Lv = Iv(Av({
        prop: "border",
        themeKey: "borders",
        transform: zv
    }), Av({
        prop: "borderTop",
        themeKey: "borders",
        transform: zv
    }), Av({
        prop: "borderRight",
        themeKey: "borders",
        transform: zv
    }), Av({
        prop: "borderBottom",
        themeKey: "borders",
        transform: zv
    }), Av({
        prop: "borderLeft",
        themeKey: "borders",
        transform: zv
    }), Av({
        prop: "borderColor",
        themeKey: "palette"
    }), Av({
        prop: "borderRadius",
        themeKey: "shape"
    }));
    var Dv = Iv(Av({
            prop: "displayPrint",
            cssProperty: !1,
            transform: function(e) {
                return {
                    "@media print": {
                        display: e
                    }
                }
            }
        }), Av({
            prop: "display"
        }), Av({
            prop: "overflow"
        }), Av({
            prop: "textOverflow"
        }), Av({
            prop: "visibility"
        }), Av({
            prop: "whiteSpace"
        })),
        Nv = Iv(Av({
            prop: "flexBasis"
        }), Av({
            prop: "flexDirection"
        }), Av({
            prop: "flexWrap"
        }), Av({
            prop: "justifyContent"
        }), Av({
            prop: "alignItems"
        }), Av({
            prop: "alignContent"
        }), Av({
            prop: "order"
        }), Av({
            prop: "flex"
        }), Av({
            prop: "flexGrow"
        }), Av({
            prop: "flexShrink"
        }), Av({
            prop: "alignSelf"
        }), Av({
            prop: "justifyItems"
        }), Av({
            prop: "justifySelf"
        })),
        Bv = Iv(Av({
            prop: "gridGap"
        }), Av({
            prop: "gridColumnGap"
        }), Av({
            prop: "gridRowGap"
        }), Av({
            prop: "gridColumn"
        }), Av({
            prop: "gridRow"
        }), Av({
            prop: "gridAutoFlow"
        }), Av({
            prop: "gridAutoColumns"
        }), Av({
            prop: "gridAutoRows"
        }), Av({
            prop: "gridTemplateColumns"
        }), Av({
            prop: "gridTemplateRows"
        }), Av({
            prop: "gridTemplateAreas"
        }), Av({
            prop: "gridArea"
        })),
        Fv = Iv(Av({
            prop: "color",
            themeKey: "palette"
        }), Av({
            prop: "bgcolor",
            cssProperty: "backgroundColor",
            themeKey: "palette"
        })),
        Wv = Iv(Av({
            prop: "position"
        }), Av({
            prop: "zIndex",
            themeKey: "zIndex"
        }), Av({
            prop: "top"
        }), Av({
            prop: "right"
        }), Av({
            prop: "bottom"
        }), Av({
            prop: "left"
        })),
        Hv = Av({
            prop: "boxShadow",
            themeKey: "shadows"
        });
    function jv(e) {
        return e <= 1 ? "".concat(100 * e, "%") : e
    }
    var $v = Av({
            prop: "width",
            transform: jv
        }),
        Vv = Av({
            prop: "maxWidth",
            transform: jv
        }),
        qv = Av({
            prop: "minWidth",
            transform: jv
        }),
        Uv = Av({
            prop: "height",
            transform: jv
        }),
        Gv = Av({
            prop: "maxHeight",
            transform: jv
        }),
        Zv = Av({
            prop: "minHeight",
            transform: jv
        }),
        Kv = (Av({
            prop: "size",
            cssProperty: "width",
            transform: jv
        }), Av({
            prop: "size",
            cssProperty: "height",
            transform: jv
        }), Iv($v, Vv, qv, Uv, Gv, Zv, Av({
            prop: "boxSizing"
        })));
    function Yv(e, t) {
        return function(e) {
                if (Array.isArray(e))
                    return e
            }(e) || function(e, t) {
                if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
                    var n = [],
                        r = !0,
                        i = !1,
                        o = void 0;
                    try {
                        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0)
                            ;
                    } catch (e) {
                        i = !0, o = e
                    } finally {
                        try {
                            r || null == s.return || s.return()
                        } finally {
                            if (i)
                                throw o
                        }
                    }
                    return n
                }
            }(e, t) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance")
            }()
    }
    var Xv,
        Jv,
        Qv = {
            m: "margin",
            p: "padding"
        },
        eg = {
            t: "Top",
            r: "Right",
            b: "Bottom",
            l: "Left",
            x: ["Left", "Right"],
            y: ["Top", "Bottom"]
        },
        tg = {
            marginX: "mx",
            marginY: "my",
            paddingX: "px",
            paddingY: "py"
        },
        ng = (Xv = function(e) {
            if (e.length > 2) {
                if (!tg[e])
                    return [e];
                e = tg[e]
            }
            var t = Yv(e.split(""), 2),
                n = t[0],
                r = t[1],
                i = Qv[n],
                o = eg[r] || "";
            return Array.isArray(o) ? o.map((function(e) {
                return i + e
            })) : [i + o]
        }, Jv = {}, function(e) {
            return void 0 === Jv[e] && (Jv[e] = Xv(e)), Jv[e]
        }),
        rg = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
    function ig(e, t) {
        return function(n) {
            return e.reduce((function(e, r) {
                return e[r] = function(e, t) {
                    if ("string" == typeof t)
                        return t;
                    var n = e(Math.abs(t));
                    return t >= 0 ? n : "number" == typeof n ? -n : "-".concat(n)
                }(t, n), e
            }), {})
        }
    }
    function og(e) {
        var t = function(e) {
            var t = e.spacing || 8;
            return "number" == typeof t ? function(e) {
                return t * e
            } : Array.isArray(t) ? function(e) {
                return t[e]
            } : "function" == typeof t ? t : function() {}
        }(e.theme);
        return Object.keys(e).map((function(n) {
            if (-1 === rg.indexOf(n))
                return null;
            var r = ig(ng(n), t),
                i = e[n];
            return Rv(e, i, r)
        })).reduce(Tv, {})
    }
    og.propTypes = {}, og.filterProps = rg;
    var ag,
        sg,
        lg,
        ug = Iv(Av({
            prop: "fontFamily",
            themeKey: "typography"
        }), Av({
            prop: "fontSize",
            themeKey: "typography"
        }), Av({
            prop: "fontStyle",
            themeKey: "typography"
        }), Av({
            prop: "fontWeight",
            themeKey: "typography"
        }), Av({
            prop: "letterSpacing"
        }), Av({
            prop: "lineHeight"
        }), Av({
            prop: "textAlign"
        })),
        cg = (ag = Iv(Lv, Dv, Nv, Bv, Wv, Fv, Hv, Kv, og, ug), (sg = function(e) {
            var t = ag(e);
            return e.css ? ft({}, Tv(t, ag(ft({
                theme: e.theme
            }, e.css))), {}, function(e, t) {
                var n = {};
                return Object.keys(e).forEach((function(r) {
                    -1 === t.indexOf(r) && (n[r] = e[r])
                })), n
            }(e.css, [ag.filterProps])) : t
        }).propTypes = {}, sg.filterProps = ["css"].concat(to(ag.filterProps)), sg),
        dg = (lg = function(e) {
            return function(t) {
                var n,
                    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    i = r.name,
                    o = dt(r, ["name"]),
                    a = i,
                    s = da("function" == typeof t ? function(e) {
                        return {
                            root: function(n) {
                                return t(ft({
                                    theme: e
                                }, n))
                            }
                        }
                    } : {
                        root: t
                    }, ft({
                        Component: e,
                        name: i || e.displayName,
                        classNamePrefix: a
                    }, o));
                t.filterProps && (n = t.filterProps, delete t.filterProps), t.propTypes && (t.propTypes, delete t.propTypes);
                var l = lt.forwardRef((function(t, r) {
                    var i = t.children,
                        o = t.className,
                        a = t.clone,
                        l = t.component,
                        u = dt(t, ["children", "className", "clone", "component"]),
                        c = s(t),
                        d = fa(c.root, o),
                        p = u;
                    if (n && (p = ka(p, n)), a)
                        return lt.cloneElement(i, ft({
                            className: fa(i.props.className, d)
                        }, p));
                    if ("function" == typeof i)
                        return i(ft({
                            className: d
                        }, p));
                    var f = l || e;
                    return lt.createElement(f, ft({
                        ref: r,
                        className: d
                    }, p), i)
                }));
                return Sa(l, e), l
            }
        }("div"), function(e, t) {
            return lg(e, ft({
                defaultTheme: Ma
            }, t))
        })(cg, {
            name: "PwzrBox"
        }),
        pg = lt.forwardRef((function(e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.color,
                a = void 0 === o ? "default" : o,
                s = e.component,
                l = void 0 === s ? "button" : s,
                u = e.disabled,
                c = void 0 !== u && u,
                d = e.disableElevation,
                p = void 0 !== d && d,
                f = e.disableFocusRipple,
                h = void 0 !== f && f,
                m = e.endIcon,
                v = e.focusVisibleClassName,
                g = e.fullWidth,
                y = void 0 !== g && g,
                b = e.size,
                w = void 0 === b ? "medium" : b,
                x = e.startIcon,
                _ = e.type,
                C = void 0 === _ ? "button" : _,
                E = e.variant,
                S = void 0 === E ? "text" : E,
                k = dt(e, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]),
                T = x && lt.createElement("span", {
                    className: fa(r.startIcon, r["iconSize".concat(Fu(w))])
                }, x),
                O = m && lt.createElement("span", {
                    className: fa(r.endIcon, r["iconSize".concat(Fu(w))])
                }, m);
            return lt.createElement(Bu, ft({
                className: fa(r.root, r[S], i, "inherit" === a ? r.colorInherit : "default" !== a && r["".concat(S).concat(Fu(a))], "medium" !== w && [r["".concat(S, "Size").concat(Fu(w))], r["size".concat(Fu(w))]], p && r.disableElevation, c && r.disabled, y && r.fullWidth),
                component: l,
                disabled: c,
                focusRipple: !h,
                focusVisibleClassName: fa(r.focusVisible, v),
                ref: t,
                type: C
            }, k), lt.createElement("span", {
                className: r.label
            }, T, n, O))
        })),
        fg = nu((function(e) {
            return {
                root: ft({}, e.typography.button, {
                    boxSizing: "border-box",
                    minWidth: 64,
                    padding: "6px 16px",
                    borderRadius: e.shape.borderRadius,
                    color: e.palette.text.primary,
                    transition: e.transitions.create(["background-color", "box-shadow", "border"], {
                        duration: e.transitions.duration.short
                    }),
                    "&:hover": {
                        textDecoration: "none",
                        backgroundColor: $n(e.palette.text.primary, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        },
                        "&$disabled": {
                            backgroundColor: "transparent"
                        }
                    },
                    "&$disabled": {
                        color: e.palette.action.disabled
                    }
                }),
                label: {
                    width: "100%",
                    display: "inherit",
                    alignItems: "inherit",
                    justifyContent: "inherit"
                },
                text: {
                    padding: "6px 8px"
                },
                textPrimary: {
                    color: e.palette.primary.main,
                    "&:hover": {
                        backgroundColor: $n(e.palette.primary.main, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                },
                textSecondary: {
                    color: e.palette.secondary.main,
                    "&:hover": {
                        backgroundColor: $n(e.palette.secondary.main, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                },
                outlined: {
                    padding: "5px 15px",
                    border: "1px solid ".concat("light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
                    "&$disabled": {
                        border: "1px solid ".concat(e.palette.action.disabledBackground)
                    }
                },
                outlinedPrimary: {
                    color: e.palette.primary.main,
                    border: "1px solid ".concat($n(e.palette.primary.main, .5)),
                    "&:hover": {
                        border: "1px solid ".concat(e.palette.primary.main),
                        backgroundColor: $n(e.palette.primary.main, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                },
                outlinedSecondary: {
                    color: e.palette.secondary.main,
                    border: "1px solid ".concat($n(e.palette.secondary.main, .5)),
                    "&:hover": {
                        border: "1px solid ".concat(e.palette.secondary.main),
                        backgroundColor: $n(e.palette.secondary.main, e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    },
                    "&$disabled": {
                        border: "1px solid ".concat(e.palette.action.disabled)
                    }
                },
                contained: {
                    color: e.palette.getContrastText(e.palette.grey[300]),
                    backgroundColor: e.palette.grey[300],
                    boxShadow: e.shadows[2],
                    "&:hover": {
                        backgroundColor: e.palette.grey.A100,
                        boxShadow: e.shadows[4],
                        "@media (hover: none)": {
                            boxShadow: e.shadows[2],
                            backgroundColor: e.palette.grey[300]
                        },
                        "&$disabled": {
                            backgroundColor: e.palette.action.disabledBackground
                        }
                    },
                    "&$focusVisible": {
                        boxShadow: e.shadows[6]
                    },
                    "&:active": {
                        boxShadow: e.shadows[8]
                    },
                    "&$disabled": {
                        color: e.palette.action.disabled,
                        boxShadow: e.shadows[0],
                        backgroundColor: e.palette.action.disabledBackground
                    }
                },
                containedPrimary: {
                    color: e.palette.primary.contrastText,
                    backgroundColor: e.palette.primary.main,
                    "&:hover": {
                        backgroundColor: e.palette.primary.dark,
                        "@media (hover: none)": {
                            backgroundColor: e.palette.primary.main
                        }
                    }
                },
                containedSecondary: {
                    color: e.palette.secondary.contrastText,
                    backgroundColor: e.palette.secondary.main,
                    "&:hover": {
                        backgroundColor: e.palette.secondary.dark,
                        "@media (hover: none)": {
                            backgroundColor: e.palette.secondary.main
                        }
                    }
                },
                disableElevation: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "none"
                    },
                    "&$focusVisible": {
                        boxShadow: "none"
                    },
                    "&:active": {
                        boxShadow: "none"
                    },
                    "&$disabled": {
                        boxShadow: "none"
                    }
                },
                focusVisible: {},
                disabled: {},
                colorInherit: {
                    color: "inherit",
                    borderColor: "currentColor"
                },
                textSizeSmall: {
                    padding: "4px 5px",
                    fontSize: e.typography.pxToRem(13)
                },
                textSizeLarge: {
                    padding: "8px 11px",
                    fontSize: e.typography.pxToRem(15)
                },
                outlinedSizeSmall: {
                    padding: "3px 9px",
                    fontSize: e.typography.pxToRem(13)
                },
                outlinedSizeLarge: {
                    padding: "7px 21px",
                    fontSize: e.typography.pxToRem(15)
                },
                containedSizeSmall: {
                    padding: "4px 10px",
                    fontSize: e.typography.pxToRem(13)
                },
                containedSizeLarge: {
                    padding: "8px 22px",
                    fontSize: e.typography.pxToRem(15)
                },
                sizeSmall: {},
                sizeLarge: {},
                fullWidth: {
                    width: "100%"
                },
                startIcon: {
                    display: "inherit",
                    marginRight: 8,
                    marginLeft: -4,
                    "&$iconSizeSmall": {
                        marginLeft: -2
                    }
                },
                endIcon: {
                    display: "inherit",
                    marginRight: -4,
                    marginLeft: 8,
                    "&$iconSizeSmall": {
                        marginRight: -2
                    }
                },
                iconSizeSmall: {
                    "& > *:first-child": {
                        fontSize: 18
                    }
                },
                iconSizeMedium: {
                    "& > *:first-child": {
                        fontSize: 20
                    }
                },
                iconSizeLarge: {
                    "& > *:first-child": {
                        fontSize: 22
                    }
                }
            }
        }), {
            name: "PwzrButton"
        })(pg),
        hg = {
            h1: "h1",
            h2: "h2",
            h3: "h3",
            h4: "h4",
            h5: "h5",
            h6: "h6",
            subtitle1: "h6",
            subtitle2: "h6",
            body1: "p",
            body2: "p"
        },
        mg = lt.forwardRef((function(e, t) {
            var n = e.align,
                r = void 0 === n ? "inherit" : n,
                i = e.classes,
                o = e.className,
                a = e.color,
                s = void 0 === a ? "initial" : a,
                l = e.component,
                u = e.display,
                c = void 0 === u ? "initial" : u,
                d = e.gutterBottom,
                p = void 0 !== d && d,
                f = e.noWrap,
                h = void 0 !== f && f,
                m = e.paragraph,
                v = void 0 !== m && m,
                g = e.variant,
                y = void 0 === g ? "body1" : g,
                b = e.variantMapping,
                w = void 0 === b ? hg : b,
                x = dt(e, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]),
                _ = l || (v ? "p" : w[y] || hg[y]) || "span";
            return lt.createElement(_, ft({
                className: fa(i.root, o, "inherit" !== y && i[y], "initial" !== s && i["color".concat(Fu(s))], h && i.noWrap, p && i.gutterBottom, v && i.paragraph, "inherit" !== r && i["align".concat(Fu(r))], "initial" !== c && i["display".concat(Fu(c))]),
                ref: t
            }, x))
        })),
        vg = nu((function(e) {
            return {
                root: {
                    margin: 0
                },
                body2: e.typography.body2,
                body1: e.typography.body1,
                caption: e.typography.caption,
                button: e.typography.button,
                h1: e.typography.h1,
                h2: e.typography.h2,
                h3: e.typography.h3,
                h4: e.typography.h4,
                h5: e.typography.h5,
                h6: e.typography.h6,
                subtitle1: e.typography.subtitle1,
                subtitle2: e.typography.subtitle2,
                overline: e.typography.overline,
                srOnly: {
                    position: "absolute",
                    height: 1,
                    width: 1,
                    overflow: "hidden"
                },
                alignLeft: {
                    textAlign: "left"
                },
                alignCenter: {
                    textAlign: "center"
                },
                alignRight: {
                    textAlign: "right"
                },
                alignJustify: {
                    textAlign: "justify"
                },
                noWrap: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                },
                gutterBottom: {
                    marginBottom: "0.35em"
                },
                paragraph: {
                    marginBottom: 16
                },
                colorInherit: {
                    color: "inherit"
                },
                colorPrimary: {
                    color: e.palette.primary.main
                },
                colorSecondary: {
                    color: e.palette.secondary.main
                },
                colorTextPrimary: {
                    color: e.palette.text.primary
                },
                colorTextSecondary: {
                    color: e.palette.text.secondary
                },
                colorError: {
                    color: e.palette.error.main
                },
                displayInline: {
                    display: "inline"
                },
                displayBlock: {
                    display: "block"
                }
            }
        }), {
            name: "PwzrTypography"
        })(mg),
        gg = lt.forwardRef((function(e, t) {
            var n = e.classes,
                r = e.className,
                i = e.color,
                o = void 0 === i ? "primary" : i,
                a = e.component,
                s = void 0 === a ? "a" : a,
                l = e.onBlur,
                u = e.onFocus,
                c = e.TypographyClasses,
                d = e.underline,
                p = void 0 === d ? "hover" : d,
                f = e.variant,
                h = void 0 === f ? "inherit" : f,
                m = dt(e, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]),
                v = yu(),
                g = v.isFocusVisible,
                y = v.onBlurVisible,
                b = v.ref,
                w = lt.useState(!1),
                x = w[0],
                _ = w[1],
                C = iu(t, b);
            return lt.createElement(vg, ft({
                className: fa(n.root, n["underline".concat(Fu(p))], r, x && n.focusVisible, "button" === s && n.button),
                classes: c,
                color: o,
                component: s,
                onBlur: function(e) {
                    x && (y(), _(!1)), l && l(e)
                },
                onFocus: function(e) {
                    g(e) && _(!0), u && u(e)
                },
                ref: C,
                variant: h
            }, m))
        })),
        yg = nu({
            root: {},
            underlineNone: {
                textDecoration: "none"
            },
            underlineHover: {
                textDecoration: "none",
                "&:hover": {
                    textDecoration: "underline"
                }
            },
            underlineAlways: {
                textDecoration: "underline"
            },
            button: {
                position: "relative",
                WebkitTapHighlightColor: "transparent",
                backgroundColor: "transparent",
                outline: 0,
                border: 0,
                margin: 0,
                borderRadius: 0,
                padding: 0,
                cursor: "pointer",
                userSelect: "none",
                verticalAlign: "middle",
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                "&::-moz-focus-inner": {
                    borderStyle: "none"
                },
                "&$focusVisible": {
                    outline: "auto"
                }
            },
            focusVisible: {}
        }, {
            name: "PwzrLink"
        })(gg);
    function bg(e, t) {
        return lt.isValidElement(e) && -1 !== t.indexOf(e.type.muiName)
    }
    var wg = lt.createContext({});
    var xg = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect,
        _g = lt.forwardRef((function(e, t) {
            var n = e.alignItems,
                r = void 0 === n ? "center" : n,
                i = e.autoFocus,
                o = void 0 !== i && i,
                a = e.button,
                s = void 0 !== a && a,
                l = e.children,
                u = e.classes,
                c = e.className,
                d = e.component,
                p = e.ContainerComponent,
                f = void 0 === p ? "li" : p,
                h = e.ContainerProps,
                m = (h = void 0 === h ? {} : h).className,
                v = dt(h, ["className"]),
                g = e.dense,
                y = void 0 !== g && g,
                b = e.disabled,
                w = void 0 !== b && b,
                x = e.disableGutters,
                _ = void 0 !== x && x,
                C = e.divider,
                E = void 0 !== C && C,
                S = e.focusVisibleClassName,
                k = e.selected,
                T = void 0 !== k && k,
                O = dt(e, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]),
                M = lt.useContext(wg),
                R = {
                    dense: y || M.dense || !1,
                    alignItems: r
                },
                P = lt.useRef(null);
            xg((function() {
                o && P.current && P.current.focus()
            }), [o]);
            var A = lt.Children.toArray(l),
                I = A.length && bg(A[A.length - 1], ["ListItemSecondaryAction"]),
                z = iu(lt.useCallback((function(e) {
                    P.current = lt.findDOMNode(e)
                }), []), t),
                L = ft({
                    className: fa(u.root, c, R.dense && u.dense, !_ && u.gutters, E && u.divider, w && u.disabled, s && u.button, "center" !== r && u.alignItemsFlexStart, I && u.secondaryAction, T && u.selected),
                    disabled: w
                }, O),
                D = d || "li";
            return s && (L.component = d || "div", L.focusVisibleClassName = fa(u.focusVisible, S), D = Bu), I ? (D = L.component || d ? D : "div", "li" === f && ("li" === D ? D = "div" : "li" === L.component && (L.component = "div")), lt.createElement(wg.Provider, {
                value: R
            }, lt.createElement(f, ft({
                className: fa(u.container, m),
                ref: z
            }, v), lt.createElement(D, L, A), A.pop()))) : lt.createElement(wg.Provider, {
                value: R
            }, lt.createElement(D, ft({
                ref: z
            }, L), A))
        })),
        Cg = nu((function(e) {
            return {
                root: {
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    position: "relative",
                    textDecoration: "none",
                    width: "100%",
                    boxSizing: "border-box",
                    textAlign: "left",
                    paddingTop: 8,
                    paddingBottom: 8,
                    "&$focusVisible": {
                        backgroundColor: e.palette.action.selected
                    },
                    "&$selected, &$selected:hover": {
                        backgroundColor: e.palette.action.selected
                    },
                    "&$disabled": {
                        opacity: .5
                    }
                },
                container: {
                    position: "relative"
                },
                focusVisible: {},
                dense: {
                    paddingTop: 4,
                    paddingBottom: 4
                },
                alignItemsFlexStart: {
                    alignItems: "flex-start"
                },
                disabled: {},
                divider: {
                    borderBottom: "1px solid ".concat(e.palette.divider),
                    backgroundClip: "padding-box"
                },
                gutters: {
                    paddingLeft: 16,
                    paddingRight: 16
                },
                button: {
                    transition: e.transitions.create("background-color", {
                        duration: e.transitions.duration.shortest
                    }),
                    "&:hover": {
                        textDecoration: "none",
                        backgroundColor: e.palette.action.hover,
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                },
                secondaryAction: {
                    paddingRight: 48
                },
                selected: {}
            }
        }), {
            name: "PwzrListItem"
        })(_g),
        Eg = lt.forwardRef((function(e, t) {
            var n,
                r = e.classes,
                i = e.className,
                o = e.component,
                a = void 0 === o ? "li" : o,
                s = e.disableGutters,
                l = void 0 !== s && s,
                u = e.role,
                c = void 0 === u ? "menuitem" : u,
                d = e.selected,
                p = e.tabIndex,
                f = dt(e, ["classes", "className", "component", "disableGutters", "role", "selected", "tabIndex"]);
            return e.disabled || (n = void 0 !== p ? p : -1), lt.createElement(Cg, ft({
                button: !0,
                role: c,
                tabIndex: n,
                component: a,
                selected: d,
                disableGutters: l,
                classes: {
                    dense: r.dense
                },
                className: fa(r.root, i, d && r.selected, !l && r.gutters),
                ref: t
            }, f))
        })),
        Sg = nu((function(e) {
            return {
                root: ft({}, e.typography.body1, ut({
                    minHeight: 48,
                    paddingTop: 6,
                    paddingBottom: 6,
                    boxSizing: "border-box",
                    width: "auto",
                    overflow: "hidden",
                    whiteSpace: "nowrap"
                }, e.breakpoints.up("sm"), {
                    minHeight: "auto"
                })),
                gutters: {},
                selected: {},
                dense: ft({}, e.typography.body2, {
                    minHeight: "auto"
                })
            }
        }), {
            name: "PwzrMenuItem"
        })(Eg);
    function kg(e) {
        var t,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 166;
        function r() {
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
                i[o] = arguments[o];
            var a = this,
                s = function() {
                    e.apply(a, i)
                };
            clearTimeout(t), t = setTimeout(s, n)
        }
        return r.clear = function() {
            clearTimeout(t)
        }, r
    }
    function Tg(e) {
        return e && e.ownerDocument || document
    }
    function Og(e) {
        return Tg(e).defaultView || window
    }
    function Mg() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        return t.reduce((function(e, t) {
            return null == t ? e : function() {
                for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
                    r[i] = arguments[i];
                e.apply(this, r), t.apply(this, r)
            }
        }), (function() {}))
    }
    var Rg = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect,
        Pg = lt.forwardRef((function(e, t) {
            var n = e.children,
                r = e.container,
                i = e.disablePortal,
                o = void 0 !== i && i,
                a = e.onRendered,
                s = lt.useState(null),
                l = s[0],
                u = s[1],
                c = iu(lt.isValidElement(n) ? n.ref : null, t);
            return Rg((function() {
                o || u(function(e) {
                    return e = "function" == typeof e ? e() : e, lt.findDOMNode(e)
                }(r) || document.body)
            }), [r, o]), Rg((function() {
                if (l && !o)
                    return ru(t, l), function() {
                        ru(t, null)
                    }
            }), [t, l, o]), Rg((function() {
                a && (l || o) && a()
            }), [a, l, o]), o ? lt.isValidElement(n) ? lt.cloneElement(n, {
                ref: c
            }) : n : l ? lt.createPortal(n, l) : l
        }));
    function Ag() {
        var e = document.createElement("div");
        e.style.width = "99px", e.style.height = "99px", e.style.position = "absolute", e.style.top = "-9999px", e.style.overflow = "scroll", document.body.appendChild(e);
        var t = e.offsetWidth - e.clientWidth;
        return document.body.removeChild(e), t
    }
    function Ig(e, t) {
        t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden")
    }
    function zg(e) {
        return parseInt(window.getComputedStyle(e)["padding-right"], 10) || 0
    }
    function Lg(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [],
            i = arguments.length > 4 ? arguments[4] : void 0,
            o = [t, n].concat(to(r)),
            a = ["TEMPLATE", "SCRIPT", "STYLE"];
        [].forEach.call(e.children, (function(e) {
            1 === e.nodeType && -1 === o.indexOf(e) && -1 === a.indexOf(e.tagName) && Ig(e, i)
        }))
    }
    function Dg(e, t) {
        var n = -1;
        return e.some((function(e, r) {
            return !!t(e) && (n = r, !0)
        })), n
    }
    function Ng(e, t) {
        var n,
            r = [],
            i = [],
            o = e.container;
        if (!t.disableScrollLock) {
            if (function(e) {
                var t = Tg(e);
                return t.body === e ? Og(t).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight
            }(o)) {
                var a = Ag();
                r.push({
                    value: o.style.paddingRight,
                    key: "padding-right",
                    el: o
                }), o.style["padding-right"] = "".concat(zg(o) + a, "px"), n = Tg(o).querySelectorAll(".mui-fixed"), [].forEach.call(n, (function(e) {
                    i.push(e.style.paddingRight), e.style.paddingRight = "".concat(zg(e) + a, "px")
                }))
            }
            var s = o.parentElement,
                l = "HTML" === s.nodeName && "scroll" === window.getComputedStyle(s)["overflow-y"] ? s : o;
            r.push({
                value: l.style.overflow,
                key: "overflow",
                el: l
            }), l.style.overflow = "hidden"
        }
        return function() {
            n && [].forEach.call(n, (function(e, t) {
                i[t] ? e.style.paddingRight = i[t] : e.style.removeProperty("padding-right")
            })), r.forEach((function(e) {
                var t = e.value,
                    n = e.el,
                    r = e.key;
                t ? n.style.setProperty(r, t) : n.style.removeProperty(r)
            }))
        }
    }
    var Bg = function() {
        function e() {
            !function(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }(this, e), this.modals = [], this.containers = []
        }
        return pr(e, [{
            key: "add",
            value: function(e, t) {
                var n = this.modals.indexOf(e);
                if (-1 !== n)
                    return n;
                n = this.modals.length, this.modals.push(e), e.modalRef && Ig(e.modalRef, !1);
                var r = function(e) {
                    var t = [];
                    return [].forEach.call(e.children, (function(e) {
                        e.getAttribute && "true" === e.getAttribute("aria-hidden") && t.push(e)
                    })), t
                }(t);
                Lg(t, e.mountNode, e.modalRef, r, !0);
                var i = Dg(this.containers, (function(e) {
                    return e.container === t
                }));
                return -1 !== i ? (this.containers[i].modals.push(e), n) : (this.containers.push({
                    modals: [e],
                    container: t,
                    restore: null,
                    hiddenSiblingNodes: r
                }), n)
            }
        }, {
            key: "mount",
            value: function(e, t) {
                var n = Dg(this.containers, (function(t) {
                        return -1 !== t.modals.indexOf(e)
                    })),
                    r = this.containers[n];
                r.restore || (r.restore = Ng(r, t))
            }
        }, {
            key: "remove",
            value: function(e) {
                var t = this.modals.indexOf(e);
                if (-1 === t)
                    return t;
                var n = Dg(this.containers, (function(t) {
                        return -1 !== t.modals.indexOf(e)
                    })),
                    r = this.containers[n];
                if (r.modals.splice(r.modals.indexOf(e), 1), this.modals.splice(t, 1), 0 === r.modals.length)
                    r.restore && r.restore(), e.modalRef && Ig(e.modalRef, !0), Lg(r.container, e.mountNode, e.modalRef, r.hiddenSiblingNodes, !1), this.containers.splice(n, 1);
                else {
                    var i = r.modals[r.modals.length - 1];
                    i.modalRef && Ig(i.modalRef, !1)
                }
                return t
            }
        }, {
            key: "isTopModal",
            value: function(e) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === e
            }
        }]), e
    }();
    function Fg(e) {
        var t = e.children,
            n = e.disableAutoFocus,
            r = void 0 !== n && n,
            i = e.disableEnforceFocus,
            o = void 0 !== i && i,
            a = e.disableRestoreFocus,
            s = void 0 !== a && a,
            l = e.getDoc,
            u = e.isEnabled,
            c = e.open,
            d = lt.useRef(),
            p = lt.useRef(null),
            f = lt.useRef(null),
            h = lt.useRef(),
            m = lt.useRef(null),
            v = lt.useCallback((function(e) {
                m.current = lt.findDOMNode(e)
            }), []),
            g = iu(t.ref, v);
        return lt.useMemo((function() {
            c && "undefined" != typeof window && (h.current = l().activeElement)
        }), [c]), lt.useEffect((function() {
            if (c) {
                var e = Tg(m.current);
                r || !m.current || m.current.contains(e.activeElement) || (m.current.hasAttribute("tabIndex") || m.current.setAttribute("tabIndex", -1), m.current.focus());
                var t = function() {
                        o || !u() || d.current ? d.current = !1 : m.current && !m.current.contains(e.activeElement) && m.current.focus()
                    },
                    n = function(t) {
                        !o && u() && 9 === t.keyCode && e.activeElement === m.current && (d.current = !0, t.shiftKey ? f.current.focus() : p.current.focus())
                    };
                e.addEventListener("focus", t, !0), e.addEventListener("keydown", n, !0);
                var i = setInterval((function() {
                    t()
                }), 50);
                return function() {
                    clearInterval(i), e.removeEventListener("focus", t, !0), e.removeEventListener("keydown", n, !0), s || (h.current && h.current.focus && h.current.focus(), h.current = null)
                }
            }
        }), [r, o, s, u, c]), lt.createElement(lt.Fragment, null, lt.createElement("div", {
            tabIndex: 0,
            ref: p,
            "data-test": "sentinelStart"
        }), lt.cloneElement(t, {
            ref: g
        }), lt.createElement("div", {
            tabIndex: 0,
            ref: f,
            "data-test": "sentinelEnd"
        }))
    }
    var Wg = {
            root: {
                zIndex: -1,
                position: "fixed",
                right: 0,
                bottom: 0,
                top: 0,
                left: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                WebkitTapHighlightColor: "transparent"
            },
            invisible: {
                backgroundColor: "transparent"
            }
        },
        Hg = lt.forwardRef((function(e, t) {
            var n = e.invisible,
                r = void 0 !== n && n,
                i = e.open,
                o = dt(e, ["invisible", "open"]);
            return i ? lt.createElement("div", ft({
                "aria-hidden": !0,
                ref: t
            }, o, {
                style: ft({}, Wg.root, {}, r ? Wg.invisible : {}, {}, o.style)
            })) : null
        }));
    var jg = new Bg,
        $g = lt.forwardRef((function(e, t) {
            var n = Si(),
                r = lr({
                    name: "PwzrModal",
                    props: ft({}, e),
                    theme: n
                }),
                i = r.BackdropComponent,
                o = void 0 === i ? Hg : i,
                a = r.BackdropProps,
                s = r.children,
                l = r.closeAfterTransition,
                u = void 0 !== l && l,
                c = r.container,
                d = r.disableAutoFocus,
                p = void 0 !== d && d,
                f = r.disableBackdropClick,
                h = void 0 !== f && f,
                m = r.disableEnforceFocus,
                v = void 0 !== m && m,
                g = r.disableEscapeKeyDown,
                y = void 0 !== g && g,
                b = r.disablePortal,
                w = void 0 !== b && b,
                x = r.disableRestoreFocus,
                _ = void 0 !== x && x,
                C = r.disableScrollLock,
                E = void 0 !== C && C,
                S = r.hideBackdrop,
                k = void 0 !== S && S,
                T = r.keepMounted,
                O = void 0 !== T && T,
                M = r.manager,
                R = void 0 === M ? jg : M,
                P = r.onBackdropClick,
                A = r.onClose,
                I = r.onEscapeKeyDown,
                z = r.onRendered,
                L = r.open,
                D = dt(r, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]),
                N = lt.useState(!0),
                B = N[0],
                F = N[1],
                W = lt.useRef({}),
                H = lt.useRef(null),
                j = lt.useRef(null),
                $ = iu(j, t),
                V = function(e) {
                    return !!e.children && e.children.props.hasOwnProperty("in")
                }(r),
                q = function() {
                    return Tg(H.current)
                },
                U = function() {
                    return W.current.modalRef = j.current, W.current.mountNode = H.current, W.current
                },
                G = function() {
                    R.mount(U(), {
                        disableScrollLock: E
                    }), j.current.scrollTop = 0
                },
                Z = au((function() {
                    var e = function(e) {
                        return e = "function" == typeof e ? e() : e, lt.findDOMNode(e)
                    }(c) || q().body;
                    R.add(U(), e), j.current && G()
                })),
                K = lt.useCallback((function() {
                    return R.isTopModal(U())
                }), [R]),
                Y = au((function(e) {
                    H.current = e, e && (z && z(), L && K() ? G() : Ig(j.current, !0))
                })),
                X = lt.useCallback((function() {
                    R.remove(U())
                }), [R]);
            if (lt.useEffect((function() {
                return function() {
                    X()
                }
            }), [X]), lt.useEffect((function() {
                L ? Z() : V && u || X()
            }), [L, X, V, u, Z]), !O && !L && (!V || B))
                return null;
            var J = function(e) {
                    return {
                        root: {
                            position: "fixed",
                            zIndex: e.zIndex.modal,
                            right: 0,
                            bottom: 0,
                            top: 0,
                            left: 0
                        },
                        hidden: {
                            visibility: "hidden"
                        }
                    }
                }(n || {
                    zIndex: ar
                }),
                Q = {};
            return void 0 === s.props.tabIndex && (Q.tabIndex = s.props.tabIndex || "-1"), V && (Q.onEnter = Mg((function() {
                F(!1)
            }), s.props.onEnter), Q.onExited = Mg((function() {
                F(!0), u && X()
            }), s.props.onExited)), lt.createElement(Pg, {
                ref: Y,
                container: c,
                disablePortal: w
            }, lt.createElement("div", ft({
                ref: $,
                onKeyDown: function(e) {
                    "Escape" === e.key && K() && (e.stopPropagation(), I && I(e), !y && A && A(e, "escapeKeyDown"))
                },
                role: "presentation"
            }, D, {
                style: ft({}, J.root, {}, !L && B ? J.hidden : {}, {}, D.style)
            }), k ? null : lt.createElement(o, ft({
                open: L,
                onClick: function(e) {
                    e.target === e.currentTarget && (P && P(e), !h && A && A(e, "backdropClick"))
                }
            }, a)), lt.createElement(Fg, {
                disableEnforceFocus: v,
                disableAutoFocus: p,
                disableRestoreFocus: _,
                getDoc: q,
                isEnabled: K,
                open: L
            }, lt.cloneElement(s, Q))))
        }));
    function Vg(e, t) {
        var n = e.timeout,
            r = e.style,
            i = void 0 === r ? {} : r;
        return {
            duration: i.transitionDuration || "number" == typeof n ? n : n[t.mode] || 0,
            delay: i.transitionDelay
        }
    }
    function qg(e) {
        return "scale(".concat(e, ", ").concat(Math.pow(e, 2), ")")
    }
    var Ug = {
            entering: {
                opacity: 1,
                transform: qg(1)
            },
            entered: {
                opacity: 1,
                transform: "none"
            }
        },
        Gg = lt.forwardRef((function(e, t) {
            var n = e.children,
                r = e.in,
                i = e.onEnter,
                o = e.onExit,
                a = e.style,
                s = e.timeout,
                l = void 0 === s ? "auto" : s,
                u = dt(e, ["children", "in", "onEnter", "onExit", "style", "timeout"]),
                c = lt.useRef(),
                d = lt.useRef(),
                p = iu(n.ref, t),
                f = Pa();
            return lt.useEffect((function() {
                return function() {
                    clearTimeout(c.current)
                }
            }), []), lt.createElement(Pu, ft({
                appear: !0,
                in: r,
                onEnter: function(e, t) {
                    !function(e) {
                        e.scrollTop
                    }(e);
                    var n,
                        r = Vg({
                            style: a,
                            timeout: l
                        }, {
                            mode: "enter"
                        }),
                        o = r.duration,
                        s = r.delay;
                    "auto" === l ? (n = f.transitions.getAutoHeightDuration(e.clientHeight), d.current = n) : n = o, e.style.transition = [f.transitions.create("opacity", {
                        duration: n,
                        delay: s
                    }), f.transitions.create("transform", {
                        duration: .666 * n,
                        delay: s
                    })].join(","), i && i(e, t)
                },
                onExit: function(e) {
                    var t,
                        n = Vg({
                            style: a,
                            timeout: l
                        }, {
                            mode: "exit"
                        }),
                        r = n.duration,
                        i = n.delay;
                    "auto" === l ? (t = f.transitions.getAutoHeightDuration(e.clientHeight), d.current = t) : t = r, e.style.transition = [f.transitions.create("opacity", {
                        duration: t,
                        delay: i
                    }), f.transitions.create("transform", {
                        duration: .666 * t,
                        delay: i || .333 * t
                    })].join(","), e.style.opacity = "0", e.style.transform = qg(.75), o && o(e)
                },
                addEndListener: function(e, t) {
                    "auto" === l && (c.current = setTimeout(t, d.current || 0))
                },
                timeout: "auto" === l ? null : l
            }, u), (function(e, t) {
                return lt.cloneElement(n, ft({
                    style: ft({
                        opacity: 0,
                        transform: qg(.75),
                        visibility: "exited" !== e || r ? void 0 : "hidden"
                    }, Ug[e], {}, a, {}, n.props.style),
                    ref: p
                }, t))
            }))
        }));
    Gg.muiSupportAuto = !0;
    var Zg = lt.forwardRef((function(e, t) {
            var n = e.classes,
                r = e.className,
                i = e.component,
                o = void 0 === i ? "div" : i,
                a = e.square,
                s = void 0 !== a && a,
                l = e.elevation,
                u = void 0 === l ? 1 : l,
                c = e.variant,
                d = void 0 === c ? "elevation" : c,
                p = dt(e, ["classes", "className", "component", "square", "elevation", "variant"]);
            return lt.createElement(o, ft({
                className: fa(n.root, r, "outlined" === d ? n.outlined : n["elevation".concat(u)], !s && n.rounded),
                ref: t
            }, p))
        })),
        Kg = nu((function(e) {
            var t = {};
            return e.shadows.forEach((function(e, n) {
                t["elevation".concat(n)] = {
                    boxShadow: e
                }
            })), ft({
                root: {
                    backgroundColor: e.palette.background.paper,
                    color: e.palette.text.primary,
                    transition: e.transitions.create("box-shadow")
                },
                rounded: {
                    borderRadius: e.shape.borderRadius
                },
                outlined: {
                    border: "1px solid ".concat(e.palette.divider)
                }
            }, t)
        }), {
            name: "PwzrPaper"
        })(Zg);
    function Yg(e, t) {
        var n = 0;
        return "number" == typeof t ? n = t : "center" === t ? n = e.height / 2 : "bottom" === t && (n = e.height), n
    }
    function Xg(e, t) {
        var n = 0;
        return "number" == typeof t ? n = t : "center" === t ? n = e.width / 2 : "right" === t && (n = e.width), n
    }
    function Jg(e) {
        return [e.horizontal, e.vertical].map((function(e) {
            return "number" == typeof e ? "".concat(e, "px") : e
        })).join(" ")
    }
    function Qg(e) {
        return "function" == typeof e ? e() : e
    }
    var ey = lt.forwardRef((function(e, t) {
            var n = e.action,
                r = e.anchorEl,
                i = e.anchorOrigin,
                o = void 0 === i ? {
                    vertical: "top",
                    horizontal: "left"
                } : i,
                a = e.anchorPosition,
                s = e.anchorReference,
                l = void 0 === s ? "anchorEl" : s,
                u = e.children,
                c = e.classes,
                d = e.className,
                p = e.container,
                f = e.elevation,
                h = void 0 === f ? 8 : f,
                m = e.getContentAnchorEl,
                v = e.marginThreshold,
                g = void 0 === v ? 16 : v,
                y = e.onEnter,
                b = e.onEntered,
                w = e.onEntering,
                x = e.onExit,
                _ = e.onExited,
                C = e.onExiting,
                E = e.open,
                S = e.PaperProps,
                k = void 0 === S ? {} : S,
                T = e.transformOrigin,
                O = void 0 === T ? {
                    vertical: "top",
                    horizontal: "left"
                } : T,
                M = e.TransitionComponent,
                R = void 0 === M ? Gg : M,
                P = e.transitionDuration,
                A = void 0 === P ? "auto" : P,
                I = e.TransitionProps,
                z = void 0 === I ? {} : I,
                L = dt(e, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]),
                D = lt.useRef(),
                N = lt.useCallback((function(e) {
                    if ("anchorPosition" === l)
                        return a;
                    var t = Qg(r),
                        n = t instanceof Og(t).Element ? t : Tg(D.current).body,
                        i = n.getBoundingClientRect(),
                        s = 0 === e ? o.vertical : "center";
                    return {
                        top: i.top + Yg(i, s),
                        left: i.left + Xg(i, o.horizontal)
                    }
                }), [r, o.horizontal, o.vertical, a, l]),
                B = lt.useCallback((function(e) {
                    var t = 0;
                    if (m && "anchorEl" === l) {
                        var n = m(e);
                        if (n && e.contains(n)) {
                            var r = function(e, t) {
                                for (var n = t, r = 0; n && n !== e;)
                                    r += (n = n.parentElement).scrollTop;
                                return r
                            }(e, n);
                            t = n.offsetTop + n.clientHeight / 2 - r || 0
                        }
                        0
                    }
                    return t
                }), [o.vertical, l, m]),
                F = lt.useCallback((function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    return {
                        vertical: Yg(e, O.vertical) + t,
                        horizontal: Xg(e, O.horizontal)
                    }
                }), [O.horizontal, O.vertical]),
                W = lt.useCallback((function(e) {
                    var t = B(e),
                        n = {
                            width: e.offsetWidth,
                            height: e.offsetHeight
                        },
                        i = F(n, t);
                    if ("none" === l)
                        return {
                            top: null,
                            left: null,
                            transformOrigin: Jg(i)
                        };
                    var o = N(t),
                        a = o.top - i.vertical,
                        s = o.left - i.horizontal,
                        u = a + n.height,
                        c = s + n.width,
                        d = Og(Qg(r)),
                        p = d.innerHeight - g,
                        f = d.innerWidth - g;
                    if (a < g) {
                        var h = a - g;
                        a -= h, i.vertical += h
                    } else if (u > p) {
                        var m = u - p;
                        a -= m, i.vertical += m
                    }
                    if (s < g) {
                        var v = s - g;
                        s -= v, i.horizontal += v
                    } else if (c > f) {
                        var y = c - f;
                        s -= y, i.horizontal += y
                    }
                    return {
                        top: "".concat(Math.round(a), "px"),
                        left: "".concat(Math.round(s), "px"),
                        transformOrigin: Jg(i)
                    }
                }), [r, l, N, B, F, g]),
                H = lt.useCallback((function() {
                    var e = D.current;
                    if (e) {
                        var t = W(e);
                        null !== t.top && (e.style.top = t.top), null !== t.left && (e.style.left = t.left), e.style.transformOrigin = t.transformOrigin
                    }
                }), [W]),
                j = lt.useCallback((function(e) {
                    D.current = lt.findDOMNode(e)
                }), []);
            lt.useEffect((function() {
                E && H()
            })), lt.useImperativeHandle(n, (function() {
                return E ? {
                    updatePosition: function() {
                        H()
                    }
                } : null
            }), [E, H]), lt.useEffect((function() {
                if (E) {
                    var e = kg((function() {
                        H()
                    }));
                    return window.addEventListener("resize", e), function() {
                        e.clear(), window.removeEventListener("rezise", e)
                    }
                }
            }), [E, H]);
            var $ = A;
            "auto" !== A || R.muiSupportAuto || ($ = void 0);
            var V = p || (r ? Tg(Qg(r)).body : void 0);
            return lt.createElement($g, ft({
                container: V,
                open: E,
                ref: t,
                BackdropProps: {
                    invisible: !0
                },
                className: fa(c.root, d)
            }, L), lt.createElement(R, ft({
                appear: !0,
                in: E,
                onEnter: y,
                onEntered: b,
                onExit: x,
                onExited: _,
                onExiting: C,
                timeout: $
            }, z, {
                onEntering: Mg((function(e, t) {
                    w && w(e, t), H()
                }), z.onEntering)
            }), lt.createElement(Kg, ft({
                elevation: h,
                ref: j
            }, k, {
                className: fa(c.paper, k.className)
            }), u)))
        })),
        ty = nu({
            root: {},
            paper: {
                position: "absolute",
                overflowY: "auto",
                overflowX: "hidden",
                minWidth: 16,
                minHeight: 16,
                maxWidth: "calc(100% - 32px)",
                maxHeight: "calc(100% - 32px)",
                outline: 0
            }
        }, {
            name: "PwzrPopover"
        })(ey),
        ny = lt.forwardRef((function(e, t) {
            var n = e.children,
                r = e.classes,
                i = e.className,
                o = e.component,
                a = void 0 === o ? "ul" : o,
                s = e.dense,
                l = void 0 !== s && s,
                u = e.disablePadding,
                c = void 0 !== u && u,
                d = e.subheader,
                p = dt(e, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]),
                f = lt.useMemo((function() {
                    return {
                        dense: l
                    }
                }), [l]);
            return lt.createElement(wg.Provider, {
                value: f
            }, lt.createElement(a, ft({
                className: fa(r.root, i, l && r.dense, !c && r.padding, d && r.subheader),
                ref: t
            }, p), d, n))
        })),
        ry = nu({
            root: {
                listStyle: "none",
                margin: 0,
                padding: 0,
                position: "relative"
            },
            padding: {
                paddingTop: 8,
                paddingBottom: 8
            },
            dense: {},
            subheader: {
                paddingTop: 0
            }
        }, {
            name: "PwzrList"
        })(ny);
    function iy(e, t, n) {
        return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild
    }
    function oy(e, t, n) {
        return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild
    }
    function ay(e, t) {
        if (void 0 === t)
            return !0;
        var n = e.innerText;
        return void 0 === n && (n = e.textContent), 0 !== (n = n.trim().toLowerCase()).length && (t.repeating ? n[0] === t.keys[0] : 0 === n.indexOf(t.keys.join("")))
    }
    function sy(e, t, n, r, i) {
        for (var o = !1, a = r(e, t, !!t && n); a;) {
            if (a === e.firstChild) {
                if (o)
                    return !1;
                o = !0
            }
            if (a.hasAttribute("tabindex") && !a.disabled && "true" !== a.getAttribute("aria-disabled") && ay(a, i))
                return a.focus(), !0;
            a = r(e, a, n)
        }
        return !1
    }
    var ly = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect,
        uy = lt.forwardRef((function(e, t) {
            var n = e.actions,
                r = e.autoFocus,
                i = void 0 !== r && r,
                o = e.autoFocusItem,
                a = void 0 !== o && o,
                s = e.children,
                l = e.className,
                u = e.onKeyDown,
                c = e.disableListWrap,
                d = void 0 !== c && c,
                p = e.variant,
                f = void 0 === p ? "selectedMenu" : p,
                h = dt(e, ["actions", "autoFocus", "autoFocusItem", "children", "className", "onKeyDown", "disableListWrap", "variant"]),
                m = lt.useRef(null),
                v = lt.useRef({
                    keys: [],
                    repeating: !0,
                    previousKeyMatched: !0,
                    lastTime: null
                });
            ly((function() {
                i && m.current.focus()
            }), [i]), lt.useImperativeHandle(n, (function() {
                return {
                    adjustStyleForScrollbar: function(e, t) {
                        var n = !m.current.style.width;
                        if (e.clientHeight < m.current.clientHeight && n) {
                            var r = "".concat(Ag(), "px");
                            m.current.style["rtl" === t.direction ? "paddingLeft" : "paddingRight"] = r, m.current.style.width = "calc(100% + ".concat(r, ")")
                        }
                        return m.current
                    }
                }
            }), []);
            var g = iu(lt.useCallback((function(e) {
                    m.current = lt.findDOMNode(e)
                }), []), t),
                y = -1;
            lt.Children.forEach(s, (function(e, t) {
                lt.isValidElement(e) && (e.props.disabled || ("selectedMenu" === f && e.props.selected || -1 === y) && (y = t))
            }));
            var b = lt.Children.map(s, (function(e, t) {
                if (t === y) {
                    var n = {};
                    if (a && (n.autoFocus = !0), void 0 === e.props.tabIndex && "selectedMenu" === f && (n.tabIndex = 0), null !== n)
                        return lt.cloneElement(e, n)
                }
                return e
            }));
            return lt.createElement(ry, ft({
                role: "menu",
                ref: g,
                className: l,
                onKeyDown: function(e) {
                    var t = m.current,
                        n = e.key,
                        r = Tg(t).activeElement;
                    if ("ArrowDown" === n)
                        e.preventDefault(), sy(t, r, d, iy);
                    else if ("ArrowUp" === n)
                        e.preventDefault(), sy(t, r, d, oy);
                    else if ("Home" === n)
                        e.preventDefault(), sy(t, null, d, iy);
                    else if ("End" === n)
                        e.preventDefault(), sy(t, null, d, oy);
                    else if (1 === n.length) {
                        var i = v.current,
                            o = n.toLowerCase(),
                            a = performance.now();
                        i.keys.length > 0 && (a - i.lastTime > 500 ? (i.keys = [], i.repeating = !0, i.previousKeyMatched = !0) : i.repeating && o !== i.keys[0] && (i.repeating = !1)), i.lastTime = a, i.keys.push(o);
                        var s = r && !i.repeating && ay(r, i);
                        i.previousKeyMatched && (s || sy(t, r, !1, iy, i)) ? e.preventDefault() : i.previousKeyMatched = !1
                    }
                    u && u(e)
                },
                tabIndex: i ? 0 : -1
            }, h), b)
        })),
        cy = {
            vertical: "top",
            horizontal: "right"
        },
        dy = {
            vertical: "top",
            horizontal: "left"
        },
        py = lt.forwardRef((function(e, t) {
            var n = e.autoFocus,
                r = void 0 === n || n,
                i = e.children,
                o = e.classes,
                a = e.disableAutoFocusItem,
                s = void 0 !== a && a,
                l = e.MenuListProps,
                u = void 0 === l ? {} : l,
                c = e.onClose,
                d = e.onEntering,
                p = e.open,
                f = e.PaperProps,
                h = void 0 === f ? {} : f,
                m = e.PopoverClasses,
                v = e.transitionDuration,
                g = void 0 === v ? "auto" : v,
                y = e.variant,
                b = void 0 === y ? "selectedMenu" : y,
                w = dt(e, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]),
                x = Pa(),
                _ = r && !s && p,
                C = lt.useRef(null),
                E = lt.useRef(null),
                S = -1;
            lt.Children.map(i, (function(e, t) {
                lt.isValidElement(e) && (e.props.disabled || ("menu" !== b && e.props.selected || -1 === S) && (S = t))
            }));
            var k = lt.Children.map(i, (function(e, t) {
                return t === S ? lt.cloneElement(e, {
                    ref: function(t) {
                        E.current = lt.findDOMNode(t), ru(e.ref, t)
                    }
                }) : e
            }));
            return lt.createElement(ty, ft({
                getContentAnchorEl: function() {
                    return E.current
                },
                classes: m,
                onClose: c,
                onEntering: function(e, t) {
                    C.current && C.current.adjustStyleForScrollbar(e, x), d && d(e, t)
                },
                anchorOrigin: "rtl" === x.direction ? cy : dy,
                transformOrigin: "rtl" === x.direction ? cy : dy,
                PaperProps: ft({}, h, {
                    classes: ft({}, h.classes, {
                        root: o.paper
                    })
                }),
                open: p,
                ref: t,
                transitionDuration: g
            }, w), lt.createElement(uy, ft({
                onKeyDown: function(e) {
                    "Tab" === e.key && (e.preventDefault(), c && c(e, "tabKeyDown"))
                },
                actions: C,
                autoFocus: r && (-1 === S || s),
                autoFocusItem: _,
                variant: b
            }, u, {
                className: fa(o.list, u.className)
            }), k))
        })),
        fy = nu({
            paper: {
                maxHeight: "calc(100% - 96px)",
                WebkitOverflowScrolling: "touch"
            },
            list: {
                outline: 0
            }
        }, {
            name: "PwzrMenu"
        })(py);
    function hy(e) {
        return null != e && !(Array.isArray(e) && 0 === e.length)
    }
    function my(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return e && (hy(e.value) && "" !== e.value || t && hy(e.defaultValue) && "" !== e.defaultValue)
    }
    function vy(e) {
        var t = e.controlled,
            n = e.default,
            r = (e.name, lt.useRef(void 0 !== t).current),
            i = lt.useState(n),
            o = i[0],
            a = i[1];
        return [r ? t : o, lt.useCallback((function(e) {
            r || a(e)
        }), [])]
    }
    function gy(e, t) {
        return "object" === mt(t) && null !== t ? e === t : String(e) === String(t)
    }
    var yy = lt.forwardRef((function(e, t) {
        var n = e.autoFocus,
            r = e.autoWidth,
            i = e.children,
            o = e.classes,
            a = e.className,
            s = e.defaultValue,
            l = e.disabled,
            u = e.displayEmpty,
            c = e.IconComponent,
            d = e.inputRef,
            p = e.labelId,
            f = e.MenuProps,
            h = void 0 === f ? {} : f,
            m = e.multiple,
            v = e.name,
            g = e.onBlur,
            y = e.onChange,
            b = e.onClose,
            w = e.onFocus,
            x = e.onOpen,
            _ = e.open,
            C = e.readOnly,
            E = e.renderValue,
            S = (e.required, e.SelectDisplayProps),
            k = void 0 === S ? {} : S,
            T = e.tabIndex,
            O = (e.type, e.value),
            M = e.variant,
            R = void 0 === M ? "standard" : M,
            P = dt(e, ["autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]),
            A = Yv(vy({
                controlled: O,
                default: s,
                name: "SelectInput"
            }), 2),
            I = A[0],
            z = A[1],
            L = lt.useRef(null),
            D = lt.useState(null),
            N = D[0],
            B = D[1],
            F = lt.useRef(null != _).current,
            W = lt.useState(),
            H = W[0],
            j = W[1],
            $ = lt.useState(!1),
            V = $[0],
            q = $[1],
            U = iu(t, d);
        lt.useImperativeHandle(U, (function() {
            return {
                focus: function() {
                    N.focus()
                },
                node: L.current,
                value: I
            }
        }), [N, I]), lt.useEffect((function() {
            n && N && N.focus()
        }), [n, N]);
        var G,
            Z,
            K = function(e, t) {
                e ? x && x(t) : b && b(t), F || (j(r ? null : N.clientWidth), q(e))
            },
            Y = function(e) {
                return function(t) {
                    var n;
                    if (m || K(!1, t), m) {
                        n = Array.isArray(I) ? to(I) : [];
                        var r = I.indexOf(e.props.value);
                        -1 === r ? n.push(e.props.value) : n.splice(r, 1)
                    } else
                        n = e.props.value;
                    z(n), y && (t.persist(), Object.defineProperty(t, "target", {
                        writable: !0,
                        value: {
                            value: n,
                            name: v
                        }
                    }), y(t, e))
                }
            },
            X = null !== N && (F ? _ : V);
        delete P["aria-invalid"];
        var J = [],
            Q = !1;
        (my({
            value: I
        }) || u) && (E ? G = E(I) : Q = !0);
        var ee = lt.Children.map(i, (function(e) {
            if (!lt.isValidElement(e))
                return null;
            var t;
            if (m) {
                if (!Array.isArray(I))
                    throw new Error("Material-UI: the `value` prop must be an array when using the `Select` component with `multiple`.");
                (t = I.some((function(t) {
                    return gy(t, e.props.value)
                }))) && Q && J.push(e.props.children)
            } else
                (t = gy(I, e.props.value)) && Q && (Z = e.props.children);
            return t && !0, lt.cloneElement(e, {
                "aria-selected": t ? "true" : void 0,
                onClick: Y(e),
                onKeyUp: function(t) {
                    " " === t.key && t.preventDefault();
                    var n = e.props.onKeyUp;
                    "function" == typeof n && n(t)
                },
                role: "option",
                selected: t,
                value: void 0,
                "data-value": e.props.value
            })
        }));
        Q && (G = m ? J.join(", ") : Z);
        var te,
            ne = H;
        !r && F && N && (ne = N.clientWidth), te = void 0 !== T ? T : l ? null : 0;
        var re = k.id || (v ? "mui-component-select-".concat(v) : void 0);
        return lt.createElement(lt.Fragment, null, lt.createElement("div", ft({
            className: fa(o.root, o.select, o.selectMenu, o[R], a, l && o.disabled),
            ref: B,
            tabIndex: te,
            role: "button",
            "aria-expanded": X ? "true" : void 0,
            "aria-labelledby": "".concat(p || "", " ").concat(re || ""),
            "aria-haspopup": "listbox",
            onKeyDown: function(e) {
                if (!C) {
                    -1 !== [" ", "ArrowUp", "ArrowDown", "Enter"].indexOf(e.key) && (e.preventDefault(), K(!0, e))
                }
            },
            onMouseDown: l || C ? null : function(e) {
                0 === e.button && (e.preventDefault(), N.focus(), K(!0, e))
            },
            onBlur: function(e) {
                !X && g && (e.persist(), Object.defineProperty(e, "target", {
                    writable: !0,
                    value: {
                        value: I,
                        name: v
                    }
                }), g(e))
            },
            onFocus: w
        }, k, {
            id: re
        }), function(e) {
            return null == e || "string" == typeof e && !e.trim()
        }(G) ? lt.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: "&#8203;"
            }
        }) : G), lt.createElement("input", ft({
            value: Array.isArray(I) ? I.join(",") : I,
            name: v,
            ref: L,
            type: "hidden",
            autoFocus: n
        }, P)), lt.createElement(c, {
            className: fa(o.icon, o["icon".concat(Fu(R))], X && o.iconOpen)
        }), lt.createElement(fy, ft({
            id: "menu-".concat(v || ""),
            anchorEl: N,
            open: X,
            onClose: function(e) {
                K(!1, e)
            }
        }, h, {
            MenuListProps: ft({
                "aria-labelledby": p,
                role: "listbox",
                disableListWrap: !0
            }, h.MenuListProps),
            PaperProps: ft({}, h.PaperProps, {
                style: ft({
                    minWidth: ne
                }, null != h.PaperProps ? h.PaperProps.style : null)
            })
        }), ee))
    }));
    function by(e) {
        var t = e.props,
            n = e.states,
            r = e.muiFormControl;
        return n.reduce((function(e, n) {
            return e[n] = t[n], r && void 0 === t[n] && (e[n] = r[n]), e
        }), {})
    }
    var wy = lt.createContext();
    function xy() {
        return lt.useContext(wy)
    }
    var _y = function(e, t) {
        var n = lt.memo(lt.forwardRef((function(t, n) {
            return lt.createElement(sd, ft({}, t, {
                ref: n
            }), e)
        })));
        return n.muiName = sd.muiName, n
    }(lt.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
    function Cy(e, t) {
        return parseInt(e[t], 10) || 0
    }
    var Ey = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect,
        Sy = {
            visibility: "hidden",
            position: "absolute",
            overflow: "hidden",
            height: 0,
            top: 0,
            left: 0,
            transform: "translateZ(0)"
        },
        ky = lt.forwardRef((function(e, t) {
            var n = e.onChange,
                r = e.rows,
                i = e.rowsMax,
                o = e.rowsMin,
                a = void 0 === o ? 1 : o,
                s = e.style,
                l = e.value,
                u = dt(e, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]),
                c = r || a,
                d = lt.useRef(null != l).current,
                p = lt.useRef(null),
                f = iu(t, p),
                h = lt.useRef(null),
                m = lt.useState({}),
                v = m[0],
                g = m[1],
                y = lt.useCallback((function() {
                    var t = p.current,
                        n = window.getComputedStyle(t),
                        r = h.current;
                    r.style.width = n.width, r.value = t.value || e.placeholder || "x";
                    var o = n["box-sizing"],
                        a = Cy(n, "padding-bottom") + Cy(n, "padding-top"),
                        s = Cy(n, "border-bottom-width") + Cy(n, "border-top-width"),
                        l = r.scrollHeight - a;
                    r.value = "x";
                    var u = r.scrollHeight - a,
                        d = l;
                    c && (d = Math.max(Number(c) * u, d)), i && (d = Math.min(Number(i) * u, d));
                    var f = (d = Math.max(d, u)) + ("border-box" === o ? a + s : 0),
                        m = Math.abs(d - l) <= 1;
                    g((function(e) {
                        return f > 0 && Math.abs((e.outerHeightStyle || 0) - f) > 1 || e.overflow !== m ? {
                            overflow: m,
                            outerHeightStyle: f
                        } : e
                    }))
                }), [i, c, e.placeholder]);
            lt.useEffect((function() {
                var e = kg((function() {
                    y()
                }));
                return window.addEventListener("resize", e), function() {
                    e.clear(), window.removeEventListener("resize", e)
                }
            }), [y]), Ey((function() {
                y()
            }));
            return lt.createElement(lt.Fragment, null, lt.createElement("textarea", ft({
                value: l,
                onChange: function(e) {
                    d || y(), n && n(e)
                },
                ref: f,
                rows: c,
                style: ft({
                    height: v.outerHeightStyle,
                    overflow: v.overflow ? "hidden" : null
                }, s)
            }, u)), lt.createElement("textarea", {
                "aria-hidden": !0,
                className: e.className,
                readOnly: !0,
                ref: h,
                tabIndex: -1,
                style: ft({}, Sy, {}, s)
            }))
        })),
        Ty = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect,
        Oy = lt.forwardRef((function(e, t) {
            var n = e["aria-describedby"],
                r = e.autoComplete,
                i = e.autoFocus,
                o = e.classes,
                a = e.className,
                s = (e.color, e.defaultValue),
                l = e.disabled,
                u = e.endAdornment,
                c = (e.error, e.fullWidth),
                d = void 0 !== c && c,
                p = e.id,
                f = e.inputComponent,
                h = void 0 === f ? "input" : f,
                m = e.inputProps,
                v = void 0 === m ? {} : m,
                g = e.inputRef,
                y = (e.margin, e.multiline),
                b = void 0 !== y && y,
                w = e.name,
                x = e.onBlur,
                _ = e.onChange,
                C = e.onClick,
                E = e.onFocus,
                S = e.onKeyDown,
                k = e.onKeyUp,
                T = e.placeholder,
                O = e.readOnly,
                M = e.renderSuffix,
                R = e.rows,
                P = e.rowsMax,
                A = e.rowsMin,
                I = e.startAdornment,
                z = e.type,
                L = void 0 === z ? "text" : z,
                D = e.value,
                N = dt(e, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]),
                B = null != v.value ? v.value : D,
                F = lt.useRef(null != B).current,
                W = lt.useRef(),
                H = lt.useCallback((function(e) {
                    0
                }), []),
                j = iu(v.ref, H),
                $ = iu(g, j),
                V = iu(W, $),
                q = lt.useState(!1),
                U = q[0],
                G = q[1],
                Z = lt.useContext(wy);
            var K = by({
                props: e,
                muiFormControl: Z,
                states: ["color", "disabled", "error", "hiddenLabel", "margin", "required", "filled"]
            });
            K.focused = Z ? Z.focused : U, lt.useEffect((function() {
                !Z && l && U && (G(!1), x && x())
            }), [Z, l, U, x]);
            var Y = Z && Z.onFilled,
                X = Z && Z.onEmpty,
                J = lt.useCallback((function(e) {
                    my(e) ? Y && Y() : X && X()
                }), [Y, X]);
            Ty((function() {
                F && J({
                    value: B
                })
            }), [B, J, F]);
            lt.useEffect((function() {
                J(W.current)
            }), []);
            var Q = h,
                ee = ft({}, v, {
                    ref: V
                });
            "string" != typeof Q ? ee = ft({
                inputRef: V,
                type: L
            }, ee, {
                ref: null
            }) : b ? !R || P || A ? (ee = ft({
                rows: R,
                rowsMax: P
            }, ee), Q = ky) : Q = "textarea" : ee = ft({
                type: L
            }, ee);
            return lt.useEffect((function() {
                Z && Z.setAdornedStart(Boolean(I))
            }), [Z, I]), lt.createElement("div", ft({
                className: fa(o.root, o["color".concat(Fu(K.color || "primary"))], a, K.disabled && o.disabled, K.error && o.error, d && o.fullWidth, K.focused && o.focused, Z && o.formControl, b && o.multiline, I && o.adornedStart, u && o.adornedEnd, "dense" === K.margin && o.marginDense),
                onClick: function(e) {
                    W.current && e.currentTarget === e.target && W.current.focus(), C && C(e)
                },
                ref: t
            }, N), I, lt.createElement(wy.Provider, {
                value: null
            }, lt.createElement(Q, ft({
                "aria-invalid": K.error,
                "aria-describedby": n,
                autoComplete: r,
                autoFocus: i,
                defaultValue: s,
                disabled: K.disabled,
                id: p,
                onAnimationStart: function(e) {
                    J("mui-auto-fill-cancel" === e.animationName ? W.current : {
                        value: "x"
                    })
                },
                name: w,
                placeholder: T,
                readOnly: O,
                required: K.required,
                rows: R,
                value: B,
                onKeyDown: S,
                onKeyUp: k
            }, ee, {
                className: fa(o.input, v.className, K.disabled && o.disabled, b && o.inputMultiline, K.hiddenLabel && o.inputHiddenLabel, I && o.inputAdornedStart, u && o.inputAdornedEnd, "search" === L && o.inputTypeSearch, "dense" === K.margin && o.inputMarginDense),
                onBlur: function(e) {
                    x && x(e), v.onBlur && v.onBlur(e), Z && Z.onBlur ? Z.onBlur(e) : G(!1)
                },
                onChange: function(e) {
                    if (!F) {
                        var t = e.target || W.current;
                        if (null == t)
                            throw new TypeError("Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info.");
                        J({
                            value: t.value
                        })
                    }
                    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
                        r[i - 1] = arguments[i];
                    v.onChange && v.onChange.apply(v, [e].concat(r)), _ && _.apply(void 0, [e].concat(r))
                },
                onFocus: function(e) {
                    K.disabled ? e.stopPropagation() : (E && E(e), v.onFocus && v.onFocus(e), Z && Z.onFocus ? Z.onFocus(e) : G(!0))
                }
            }))), u, M ? M(ft({}, K, {
                startAdornment: I
            })) : null)
        })),
        My = nu((function(e) {
            var t = "light" === e.palette.type,
                n = {
                    color: "currentColor",
                    opacity: t ? .42 : .5,
                    transition: e.transitions.create("opacity", {
                        duration: e.transitions.duration.shorter
                    })
                },
                r = {
                    opacity: "0 !important"
                },
                i = {
                    opacity: t ? .42 : .5
                };
            return {
                "@global": {
                    "@keyframes mui-auto-fill": {
                        from: {}
                    },
                    "@keyframes mui-auto-fill-cancel": {
                        from: {}
                    }
                },
                root: ft({}, e.typography.body1, {
                    color: e.palette.text.primary,
                    lineHeight: "1.1875em",
                    boxSizing: "border-box",
                    position: "relative",
                    cursor: "text",
                    display: "inline-flex",
                    alignItems: "center",
                    "&$disabled": {
                        color: e.palette.text.disabled,
                        cursor: "default"
                    }
                }),
                formControl: {},
                focused: {},
                disabled: {},
                adornedStart: {},
                adornedEnd: {},
                error: {},
                marginDense: {},
                multiline: {
                    padding: "".concat(6, "px 0 ").concat(7, "px"),
                    "&$marginDense": {
                        paddingTop: 3
                    }
                },
                colorSecondary: {},
                fullWidth: {
                    width: "100%"
                },
                input: {
                    font: "inherit",
                    color: "currentColor",
                    padding: "".concat(6, "px 0 ").concat(7, "px"),
                    border: 0,
                    boxSizing: "content-box",
                    background: "none",
                    height: "1.1875em",
                    margin: 0,
                    WebkitTapHighlightColor: "transparent",
                    display: "block",
                    minWidth: 0,
                    width: "100%",
                    animationName: "mui-auto-fill-cancel",
                    "&::-webkit-input-placeholder": n,
                    "&::-moz-placeholder": n,
                    "&:-ms-input-placeholder": n,
                    "&::-ms-input-placeholder": n,
                    "&:focus": {
                        outline: 0
                    },
                    "&:invalid": {
                        boxShadow: "none"
                    },
                    "&::-webkit-search-decoration": {
                        "-webkit-appearance": "none"
                    },
                    "label[data-shrink=false] + $formControl &": {
                        "&::-webkit-input-placeholder": r,
                        "&::-moz-placeholder": r,
                        "&:-ms-input-placeholder": r,
                        "&::-ms-input-placeholder": r,
                        "&:focus::-webkit-input-placeholder": i,
                        "&:focus::-moz-placeholder": i,
                        "&:focus:-ms-input-placeholder": i,
                        "&:focus::-ms-input-placeholder": i
                    },
                    "&$disabled": {
                        opacity: 1
                    },
                    "&:-webkit-autofill": {
                        animationDuration: "5000s",
                        animationName: "mui-auto-fill"
                    }
                },
                inputMarginDense: {
                    paddingTop: 3
                },
                inputMultiline: {
                    height: "auto",
                    resize: "none",
                    padding: 0
                },
                inputTypeSearch: {
                    "-moz-appearance": "textfield",
                    "-webkit-appearance": "textfield"
                },
                inputAdornedStart: {},
                inputAdornedEnd: {},
                inputHiddenLabel: {}
            }
        }), {
            name: "PwzrInputBase"
        })(Oy),
        Ry = lt.forwardRef((function(e, t) {
            var n = e.disableUnderline,
                r = e.classes,
                i = e.fullWidth,
                o = void 0 !== i && i,
                a = e.inputComponent,
                s = void 0 === a ? "input" : a,
                l = e.multiline,
                u = void 0 !== l && l,
                c = e.type,
                d = void 0 === c ? "text" : c,
                p = dt(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
            return lt.createElement(My, ft({
                classes: ft({}, r, {
                    root: fa(r.root, !n && r.underline),
                    underline: null
                }),
                fullWidth: o,
                inputComponent: s,
                multiline: u,
                ref: t,
                type: d
            }, p))
        }));
    Ry.muiName = "Input";
    var Py = nu((function(e) {
            var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
            return {
                root: {
                    position: "relative"
                },
                formControl: {
                    "label + &": {
                        marginTop: 16
                    }
                },
                focused: {},
                disabled: {},
                colorSecondary: {
                    "&$underline:after": {
                        borderBottomColor: e.palette.secondary.main
                    }
                },
                underline: {
                    "&:after": {
                        borderBottom: "2px solid ".concat(e.palette.primary.main),
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: e.transitions.create("transform", {
                            duration: e.transitions.duration.shorter,
                            easing: e.transitions.easing.easeOut
                        }),
                        pointerEvents: "none"
                    },
                    "&$focused:after": {
                        transform: "scaleX(1)"
                    },
                    "&$error:after": {
                        borderBottomColor: e.palette.error.main,
                        transform: "scaleX(1)"
                    },
                    "&:before": {
                        borderBottom: "1px solid ".concat(t),
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: e.transitions.create("border-bottom-color", {
                            duration: e.transitions.duration.shorter
                        }),
                        pointerEvents: "none"
                    },
                    "&:hover:not($disabled):before": {
                        borderBottom: "2px solid ".concat(e.palette.text.primary),
                        "@media (hover: none)": {
                            borderBottom: "1px solid ".concat(t)
                        }
                    },
                    "&$disabled:before": {
                        borderBottomStyle: "dotted"
                    }
                },
                error: {},
                marginDense: {},
                multiline: {},
                fullWidth: {},
                input: {},
                inputMarginDense: {},
                inputMultiline: {},
                inputTypeSearch: {}
            }
        }), {
            name: "PwzrInput"
        })(Ry),
        Ay = lt.forwardRef((function(e, t) {
            var n = e.classes,
                r = e.className,
                i = e.disabled,
                o = e.IconComponent,
                a = e.inputRef,
                s = e.variant,
                l = void 0 === s ? "standard" : s,
                u = dt(e, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
            return lt.createElement(lt.Fragment, null, lt.createElement("select", ft({
                className: fa(n.root, n.select, n[l], r, i && n.disabled),
                disabled: i,
                ref: a || t
            }, u)), e.multiple ? null : lt.createElement(o, {
                className: fa(n.icon, n["icon".concat(Fu(l))])
            }))
        })),
        Iy = function(e) {
            return {
                root: {},
                select: {
                    "-moz-appearance": "none",
                    "-webkit-appearance": "none",
                    userSelect: "none",
                    borderRadius: 0,
                    minWidth: 16,
                    cursor: "pointer",
                    "&:focus": {
                        backgroundColor: "light" === e.palette.type ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                        borderRadius: 0
                    },
                    "&::-ms-expand": {
                        display: "none"
                    },
                    "&$disabled": {
                        cursor: "default"
                    },
                    "&[multiple]": {
                        height: "auto"
                    },
                    "&:not([multiple]) option, &:not([multiple]) optgroup": {
                        backgroundColor: e.palette.background.paper
                    },
                    "&&": {
                        paddingRight: 24
                    }
                },
                filled: {
                    "&&": {
                        paddingRight: 32
                    }
                },
                outlined: {
                    borderRadius: e.shape.borderRadius,
                    "&&": {
                        paddingRight: 32
                    }
                },
                selectMenu: {
                    height: "auto",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden"
                },
                disabled: {},
                icon: {
                    position: "absolute",
                    right: 0,
                    top: "calc(50% - 12px)",
                    color: e.palette.action.active,
                    pointerEvents: "none"
                },
                iconOpen: {
                    transform: "rotate(180deg)"
                },
                iconFilled: {
                    right: 7
                },
                iconOutlined: {
                    right: 7
                }
            }
        },
        zy = lt.createElement(Py, null),
        Ly = lt.forwardRef((function(e, t) {
            var n = e.children,
                r = e.classes,
                i = e.IconComponent,
                o = void 0 === i ? _y : i,
                a = e.input,
                s = void 0 === a ? zy : a,
                l = e.inputProps,
                u = (e.variant, dt(e, ["children", "classes", "IconComponent", "input", "inputProps", "variant"])),
                c = by({
                    props: e,
                    muiFormControl: xy(),
                    states: ["variant"]
                });
            return lt.cloneElement(s, ft({
                inputComponent: Ay,
                inputProps: ft({
                    children: n,
                    classes: r,
                    IconComponent: o,
                    variant: c.variant,
                    type: void 0
                }, l, {}, s ? s.props.inputProps : {}),
                ref: t
            }, u))
        }));
    Ly.muiName = "Select";
    nu(Iy, {
        name: "PwzrNativeSelect"
    })(Ly);
    var Dy = lt.forwardRef((function(e, t) {
        var n = e.disableUnderline,
            r = e.classes,
            i = e.fullWidth,
            o = void 0 !== i && i,
            a = e.inputComponent,
            s = void 0 === a ? "input" : a,
            l = e.multiline,
            u = void 0 !== l && l,
            c = e.type,
            d = void 0 === c ? "text" : c,
            p = dt(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
        return lt.createElement(My, ft({
            classes: ft({}, r, {
                root: fa(r.root, !n && r.underline),
                underline: null
            }),
            fullWidth: o,
            inputComponent: s,
            multiline: u,
            ref: t,
            type: d
        }, p))
    }));
    Dy.muiName = "Input";
    var Ny = nu((function(e) {
            var t = "light" === e.palette.type,
                n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)",
                r = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
            return {
                root: {
                    position: "relative",
                    backgroundColor: r,
                    borderTopLeftRadius: e.shape.borderRadius,
                    borderTopRightRadius: e.shape.borderRadius,
                    transition: e.transitions.create("background-color", {
                        duration: e.transitions.duration.shorter,
                        easing: e.transitions.easing.easeOut
                    }),
                    "&:hover": {
                        backgroundColor: t ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                        "@media (hover: none)": {
                            backgroundColor: r
                        }
                    },
                    "&$focused": {
                        backgroundColor: t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
                    },
                    "&$disabled": {
                        backgroundColor: t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
                    }
                },
                colorSecondary: {
                    "&$underline:after": {
                        borderBottomColor: e.palette.secondary.main
                    }
                },
                underline: {
                    "&:after": {
                        borderBottom: "2px solid ".concat(e.palette.primary.main),
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: e.transitions.create("transform", {
                            duration: e.transitions.duration.shorter,
                            easing: e.transitions.easing.easeOut
                        }),
                        pointerEvents: "none"
                    },
                    "&$focused:after": {
                        transform: "scaleX(1)"
                    },
                    "&$error:after": {
                        borderBottomColor: e.palette.error.main,
                        transform: "scaleX(1)"
                    },
                    "&:before": {
                        borderBottom: "1px solid ".concat(n),
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: e.transitions.create("border-bottom-color", {
                            duration: e.transitions.duration.shorter
                        }),
                        pointerEvents: "none"
                    },
                    "&:hover:before": {
                        borderBottom: "1px solid ".concat(e.palette.text.primary)
                    },
                    "&$disabled:before": {
                        borderBottomStyle: "dotted"
                    }
                },
                focused: {},
                disabled: {},
                adornedStart: {
                    paddingLeft: 12
                },
                adornedEnd: {
                    paddingRight: 12
                },
                error: {},
                marginDense: {},
                multiline: {
                    padding: "27px 12px 10px",
                    "&$marginDense": {
                        paddingTop: 23,
                        paddingBottom: 6
                    }
                },
                input: {
                    padding: "27px 12px 10px",
                    "&:-webkit-autofill": {
                        WebkitBoxShadow: "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
                        WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
                        borderTopLeftRadius: "inherit",
                        borderTopRightRadius: "inherit"
                    }
                },
                inputMarginDense: {
                    paddingTop: 23,
                    paddingBottom: 6
                },
                inputHiddenLabel: {
                    paddingTop: 18,
                    paddingBottom: 19,
                    "&$inputMarginDense": {
                        paddingTop: 10,
                        paddingBottom: 11
                    }
                },
                inputMultiline: {
                    padding: 0
                },
                inputAdornedStart: {
                    paddingLeft: 0
                },
                inputAdornedEnd: {
                    paddingRight: 0
                }
            }
        }), {
            name: "PwzrFilledInput"
        })(Dy),
        By = lt.forwardRef((function(e, t) {
            e.children;
            var n = e.classes,
                r = e.className,
                i = e.label,
                o = e.labelWidth,
                a = e.notched,
                s = e.style,
                l = dt(e, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]),
                u = "rtl" === Pa().direction ? "right" : "left";
            if (void 0 !== i)
                return lt.createElement("fieldset", ft({
                    "aria-hidden": !0,
                    className: fa(n.root, r),
                    ref: t,
                    style: s
                }, l), lt.createElement("legend", {
                    className: fa(n.legendLabelled, a && n.legendNotched)
                }, i ? lt.createElement("span", null, i) : lt.createElement("span", {
                    dangerouslySetInnerHTML: {
                        __html: "&#8203;"
                    }
                })));
            var c = o > 0 ? .75 * o + 8 : .01;
            return lt.createElement("fieldset", ft({
                "aria-hidden": !0,
                style: ft(ut({}, "padding".concat(Fu(u)), 8), s),
                className: fa(n.root, r),
                ref: t
            }, l), lt.createElement("legend", {
                className: n.legend,
                style: {
                    width: a ? c : .01
                }
            }, lt.createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: "&#8203;"
                }
            })))
        })),
        Fy = nu((function(e) {
            return {
                root: {
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    top: -5,
                    left: 0,
                    margin: 0,
                    padding: 0,
                    paddingLeft: 8,
                    pointerEvents: "none",
                    borderRadius: "inherit",
                    borderStyle: "solid",
                    borderWidth: 1
                },
                legend: {
                    textAlign: "left",
                    padding: 0,
                    lineHeight: "11px",
                    transition: e.transitions.create("width", {
                        duration: 150,
                        easing: e.transitions.easing.easeOut
                    })
                },
                legendLabelled: {
                    display: "block",
                    width: "auto",
                    textAlign: "left",
                    padding: 0,
                    height: 11,
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: .01,
                    transition: e.transitions.create("max-width", {
                        duration: 50,
                        easing: e.transitions.easing.easeOut
                    }),
                    "& span": {
                        paddingLeft: 5,
                        paddingRight: 5
                    }
                },
                legendNotched: {
                    maxWidth: 1e3,
                    transition: e.transitions.create("max-width", {
                        duration: 100,
                        easing: e.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        }), {
            name: "PrivateNotchedOutline"
        })(By),
        Wy = lt.forwardRef((function(e, t) {
            var n = e.classes,
                r = e.fullWidth,
                i = void 0 !== r && r,
                o = e.inputComponent,
                a = void 0 === o ? "input" : o,
                s = e.label,
                l = e.labelWidth,
                u = void 0 === l ? 0 : l,
                c = e.multiline,
                d = void 0 !== c && c,
                p = e.notched,
                f = e.type,
                h = void 0 === f ? "text" : f,
                m = dt(e, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
            return lt.createElement(My, ft({
                renderSuffix: function(e) {
                    return lt.createElement(Fy, {
                        className: n.notchedOutline,
                        label: s,
                        labelWidth: u,
                        notched: void 0 !== p ? p : Boolean(e.startAdornment || e.filled || e.focused)
                    })
                },
                classes: ft({}, n, {
                    root: fa(n.root, n.underline),
                    notchedOutline: null
                }),
                fullWidth: i,
                inputComponent: a,
                multiline: d,
                ref: t,
                type: h
            }, m))
        }));
    Wy.muiName = "Input";
    var Hy = nu((function(e) {
            var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
            return {
                root: {
                    position: "relative",
                    borderRadius: e.shape.borderRadius,
                    "&:hover $notchedOutline": {
                        borderColor: e.palette.text.primary
                    },
                    "@media (hover: none)": {
                        "&:hover $notchedOutline": {
                            borderColor: t
                        }
                    },
                    "&$focused $notchedOutline": {
                        borderColor: e.palette.primary.main,
                        borderWidth: 2
                    },
                    "&$error $notchedOutline": {
                        borderColor: e.palette.error.main
                    },
                    "&$disabled $notchedOutline": {
                        borderColor: e.palette.action.disabled
                    }
                },
                colorSecondary: {
                    "&$focused $notchedOutline": {
                        borderColor: e.palette.secondary.main
                    }
                },
                focused: {},
                disabled: {},
                adornedStart: {
                    paddingLeft: 14
                },
                adornedEnd: {
                    paddingRight: 14
                },
                error: {},
                marginDense: {},
                multiline: {
                    padding: "18.5px 14px",
                    "&$marginDense": {
                        paddingTop: 10.5,
                        paddingBottom: 10.5
                    }
                },
                notchedOutline: {
                    borderColor: t
                },
                input: {
                    padding: "18.5px 14px",
                    "&:-webkit-autofill": {
                        WebkitBoxShadow: "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
                        WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
                        borderRadius: "inherit"
                    }
                },
                inputMarginDense: {
                    paddingTop: 10.5,
                    paddingBottom: 10.5
                },
                inputMultiline: {
                    padding: 0
                },
                inputAdornedStart: {
                    paddingLeft: 0
                },
                inputAdornedEnd: {
                    paddingRight: 0
                }
            }
        }), {
            name: "PwzrOutlinedInput"
        })(Wy),
        jy = Iy,
        $y = lt.createElement(Py, null),
        Vy = lt.createElement(Ny, null),
        qy = lt.forwardRef((function e(t, n) {
            var r = t.autoWidth,
                i = void 0 !== r && r,
                o = t.children,
                a = t.classes,
                s = t.displayEmpty,
                l = void 0 !== s && s,
                u = t.IconComponent,
                c = void 0 === u ? _y : u,
                d = t.id,
                p = t.input,
                f = t.inputProps,
                h = t.label,
                m = t.labelId,
                v = t.labelWidth,
                g = void 0 === v ? 0 : v,
                y = t.MenuProps,
                b = t.multiple,
                w = void 0 !== b && b,
                x = t.native,
                _ = void 0 !== x && x,
                C = t.onClose,
                E = t.onOpen,
                S = t.open,
                k = t.renderValue,
                T = t.SelectDisplayProps,
                O = t.variant,
                M = void 0 === O ? "standard" : O,
                R = dt(t, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]),
                P = _ ? Ay : yy,
                A = by({
                    props: t,
                    muiFormControl: xy(),
                    states: ["variant"]
                }).variant || M,
                I = p || {
                    standard: $y,
                    outlined: lt.createElement(Hy, {
                        label: h,
                        labelWidth: g
                    }),
                    filled: Vy
                }[A];
            return lt.cloneElement(I, ft({
                inputComponent: P,
                inputProps: ft({
                    children: o,
                    IconComponent: c,
                    variant: A,
                    type: void 0,
                    multiple: w
                }, _ ? {
                    id: d
                } : {
                    autoWidth: i,
                    displayEmpty: l,
                    labelId: m,
                    MenuProps: y,
                    onClose: C,
                    onOpen: E,
                    open: S,
                    renderValue: k,
                    SelectDisplayProps: ft({
                        id: d
                    }, T)
                }, {}, f, {
                    classes: f ? wi({
                        baseClasses: a,
                        newClasses: f.classes,
                        Component: e
                    }) : a
                }, p ? p.props.inputProps : {}),
                ref: n
            }, R))
        }));
    qy.muiName = "Select";
    var Uy = nu(jy, {
            name: "PwzrSelect"
        })(qy),
        Gy = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
        Zy = function() {
            for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
                if (Gy && navigator.userAgent.indexOf(e[t]) >= 0)
                    return 1;
            return 0
        }();
    /**!
  * @fileOverview Kickass library to create and place poppers near their reference elements.
  * @version 1.16.1
  * @license
  * Copyright (c) 2016 Federico Zivolo and contributors
  *
  * Permission is hereby granted, free of charge, to any person obtaining a copy
  * of this software and associated documentation files (the "Software"), to deal
  * in the Software without restriction, including without limitation the rights
  * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  * copies of the Software, and to permit persons to whom the Software is
  * furnished to do so, subject to the following conditions:
  *
  * The above copyright notice and this permission notice shall be included in all
  * copies or substantial portions of the Software.
  *
  * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  * SOFTWARE.
  */
    var Ky = Gy && window.Promise ? function(e) {
        var t = !1;
        return function() {
            t || (t = !0, window.Promise.resolve().then((function() {
                t = !1, e()
            })))
        }
    } : function(e) {
        var t = !1;
        return function() {
            t || (t = !0, setTimeout((function() {
                t = !1, e()
            }), Zy))
        }
    };
    function Yy(e) {
        return e && "[object Function]" === {}.toString.call(e)
    }
    function Xy(e, t) {
        if (1 !== e.nodeType)
            return [];
        var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
        return t ? n[t] : n
    }
    function Jy(e) {
        return "HTML" === e.nodeName ? e : e.parentNode || e.host
    }
    function Qy(e) {
        if (!e)
            return document.body;
        switch (e.nodeName) {
        case "HTML":
        case "BODY":
            return e.ownerDocument.body;
        case "#document":
            return e.body
        }
        var t = Xy(e),
            n = t.overflow,
            r = t.overflowX,
            i = t.overflowY;
        return /(auto|scroll|overlay)/.test(n + i + r) ? e : Qy(Jy(e))
    }
    function eb(e) {
        return e && e.referenceNode ? e.referenceNode : e
    }
    var tb = Gy && !(!window.MSInputMethodContext || !document.documentMode),
        nb = Gy && /MSIE 10/.test(navigator.userAgent);
    function rb(e) {
        return 11 === e ? tb : 10 === e ? nb : tb || nb
    }
    function ib(e) {
        if (!e)
            return document.documentElement;
        for (var t = rb(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;)
            n = (e = e.nextElementSibling).offsetParent;
        var r = n && n.nodeName;
        return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === Xy(n, "position") ? ib(n) : n : e ? e.ownerDocument.documentElement : document.documentElement
    }
    function ob(e) {
        return null !== e.parentNode ? ob(e.parentNode) : e
    }
    function ab(e, t) {
        if (!(e && e.nodeType && t && t.nodeType))
            return document.documentElement;
        var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
            r = n ? e : t,
            i = n ? t : e,
            o = document.createRange();
        o.setStart(r, 0), o.setEnd(i, 0);
        var a,
            s,
            l = o.commonAncestorContainer;
        if (e !== l && t !== l || r.contains(i))
            return "BODY" === (s = (a = l).nodeName) || "HTML" !== s && ib(a.firstElementChild) !== a ? ib(l) : l;
        var u = ob(e);
        return u.host ? ab(u.host, t) : ab(e, ob(t).host)
    }
    function sb(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top",
            n = "top" === t ? "scrollTop" : "scrollLeft",
            r = e.nodeName;
        if ("BODY" === r || "HTML" === r) {
            var i = e.ownerDocument.documentElement,
                o = e.ownerDocument.scrollingElement || i;
            return o[n]
        }
        return e[n]
    }
    function lb(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = sb(t, "top"),
            i = sb(t, "left"),
            o = n ? -1 : 1;
        return e.top += r * o, e.bottom += r * o, e.left += i * o, e.right += i * o, e
    }
    function ub(e, t) {
        var n = "x" === t ? "Left" : "Top",
            r = "Left" === n ? "Right" : "Bottom";
        return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + r + "Width"])
    }
    function cb(e, t, n, r) {
        return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], rb(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0)
    }
    function db(e) {
        var t = e.body,
            n = e.documentElement,
            r = rb(10) && getComputedStyle(n);
        return {
            height: cb("Height", t, n, r),
            width: cb("Width", t, n, r)
        }
    }
    var pb = function(e, t) {
            if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function")
        },
        fb = function() {
            function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
                }
            }
            return function(t, n, r) {
                return n && e(t.prototype, n), r && e(t, r), t
            }
        }(),
        hb = function(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e
        },
        mb = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        };
    function vb(e) {
        return mb({}, e, {
            right: e.left + e.width,
            bottom: e.top + e.height
        })
    }
    function gb(e) {
        var t = {};
        try {
            if (rb(10)) {
                t = e.getBoundingClientRect();
                var n = sb(e, "top"),
                    r = sb(e, "left");
                t.top += n, t.left += r, t.bottom += n, t.right += r
            } else
                t = e.getBoundingClientRect()
        } catch (e) {}
        var i = {
                left: t.left,
                top: t.top,
                width: t.right - t.left,
                height: t.bottom - t.top
            },
            o = "HTML" === e.nodeName ? db(e.ownerDocument) : {},
            a = o.width || e.clientWidth || i.width,
            s = o.height || e.clientHeight || i.height,
            l = e.offsetWidth - a,
            u = e.offsetHeight - s;
        if (l || u) {
            var c = Xy(e);
            l -= ub(c, "x"), u -= ub(c, "y"), i.width -= l, i.height -= u
        }
        return vb(i)
    }
    function yb(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = rb(10),
            i = "HTML" === t.nodeName,
            o = gb(e),
            a = gb(t),
            s = Qy(e),
            l = Xy(t),
            u = parseFloat(l.borderTopWidth),
            c = parseFloat(l.borderLeftWidth);
        n && i && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0));
        var d = vb({
            top: o.top - a.top - u,
            left: o.left - a.left - c,
            width: o.width,
            height: o.height
        });
        if (d.marginTop = 0, d.marginLeft = 0, !r && i) {
            var p = parseFloat(l.marginTop),
                f = parseFloat(l.marginLeft);
            d.top -= u - p, d.bottom -= u - p, d.left -= c - f, d.right -= c - f, d.marginTop = p, d.marginLeft = f
        }
        return (r && !n ? t.contains(s) : t === s && "BODY" !== s.nodeName) && (d = lb(d, t)), d
    }
    function bb(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = e.ownerDocument.documentElement,
            r = yb(e, n),
            i = Math.max(n.clientWidth, window.innerWidth || 0),
            o = Math.max(n.clientHeight, window.innerHeight || 0),
            a = t ? 0 : sb(n),
            s = t ? 0 : sb(n, "left"),
            l = {
                top: a - r.top + r.marginTop,
                left: s - r.left + r.marginLeft,
                width: i,
                height: o
            };
        return vb(l)
    }
    function wb(e) {
        var t = e.nodeName;
        if ("BODY" === t || "HTML" === t)
            return !1;
        if ("fixed" === Xy(e, "position"))
            return !0;
        var n = Jy(e);
        return !!n && wb(n)
    }
    function xb(e) {
        if (!e || !e.parentElement || rb())
            return document.documentElement;
        for (var t = e.parentElement; t && "none" === Xy(t, "transform");)
            t = t.parentElement;
        return t || document.documentElement
    }
    function _b(e, t, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
            o = {
                top: 0,
                left: 0
            },
            a = i ? xb(e) : ab(e, eb(t));
        if ("viewport" === r)
            o = bb(a, i);
        else {
            var s = void 0;
            "scrollParent" === r ? "BODY" === (s = Qy(Jy(t))).nodeName && (s = e.ownerDocument.documentElement) : s = "window" === r ? e.ownerDocument.documentElement : r;
            var l = yb(s, a, i);
            if ("HTML" !== s.nodeName || wb(a))
                o = l;
            else {
                var u = db(e.ownerDocument),
                    c = u.height,
                    d = u.width;
                o.top += l.top - l.marginTop, o.bottom = c + l.top, o.left += l.left - l.marginLeft, o.right = d + l.left
            }
        }
        var p = "number" == typeof (n = n || 0);
        return o.left += p ? n : n.left || 0, o.top += p ? n : n.top || 0, o.right -= p ? n : n.right || 0, o.bottom -= p ? n : n.bottom || 0, o
    }
    function Cb(e) {
        return e.width * e.height
    }
    function Eb(e, t, n, r, i) {
        var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === e.indexOf("auto"))
            return e;
        var a = _b(n, r, o, i),
            s = {
                top: {
                    width: a.width,
                    height: t.top - a.top
                },
                right: {
                    width: a.right - t.right,
                    height: a.height
                },
                bottom: {
                    width: a.width,
                    height: a.bottom - t.bottom
                },
                left: {
                    width: t.left - a.left,
                    height: a.height
                }
            },
            l = Object.keys(s).map((function(e) {
                return mb({
                    key: e
                }, s[e], {
                    area: Cb(s[e])
                })
            })).sort((function(e, t) {
                return t.area - e.area
            })),
            u = l.filter((function(e) {
                var t = e.width,
                    r = e.height;
                return t >= n.clientWidth && r >= n.clientHeight
            })),
            c = u.length > 0 ? u[0].key : l[0].key,
            d = e.split("-")[1];
        return c + (d ? "-" + d : "")
    }
    function Sb(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            i = r ? xb(t) : ab(t, eb(n));
        return yb(n, i, r)
    }
    function kb(e) {
        var t = e.ownerDocument.defaultView.getComputedStyle(e),
            n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
            r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
        return {
            width: e.offsetWidth + r,
            height: e.offsetHeight + n
        }
    }
    function Tb(e) {
        var t = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return e.replace(/left|right|bottom|top/g, (function(e) {
            return t[e]
        }))
    }
    function Ob(e, t, n) {
        n = n.split("-")[0];
        var r = kb(e),
            i = {
                width: r.width,
                height: r.height
            },
            o = -1 !== ["right", "left"].indexOf(n),
            a = o ? "top" : "left",
            s = o ? "left" : "top",
            l = o ? "height" : "width",
            u = o ? "width" : "height";
        return i[a] = t[a] + t[l] / 2 - r[l] / 2, i[s] = n === s ? t[s] - r[u] : t[Tb(s)], i
    }
    function Mb(e, t) {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0]
    }
    function Rb(e, t, n) {
        return (void 0 === n ? e : e.slice(0, function(e, t, n) {
            if (Array.prototype.findIndex)
                return e.findIndex((function(e) {
                    return e[t] === n
                }));
            var r = Mb(e, (function(e) {
                return e[t] === n
            }));
            return e.indexOf(r)
        }(e, "name", n))).forEach((function(e) {
            e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var n = e.function || e.fn;
            e.enabled && Yy(n) && (t.offsets.popper = vb(t.offsets.popper), t.offsets.reference = vb(t.offsets.reference), t = n(t, e))
        })), t
    }
    function Pb() {
        if (!this.state.isDestroyed) {
            var e = {
                instance: this,
                styles: {},
                arrowStyles: {},
                attributes: {},
                flipped: !1,
                offsets: {}
            };
            e.offsets.reference = Sb(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = Eb(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = Ob(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = Rb(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e))
        }
    }
    function Ab(e, t) {
        return e.some((function(e) {
            var n = e.name;
            return e.enabled && n === t
        }))
    }
    function Ib(e) {
        for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++) {
            var i = t[r],
                o = i ? "" + i + n : e;
            if (void 0 !== document.body.style[o])
                return o
        }
        return null
    }
    function zb() {
        return this.state.isDestroyed = !0, Ab(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[Ib("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
    }
    function Lb(e) {
        var t = e.ownerDocument;
        return t ? t.defaultView : window
    }
    function Db(e, t, n, r) {
        var i = "BODY" === e.nodeName,
            o = i ? e.ownerDocument.defaultView : e;
        o.addEventListener(t, n, {
            passive: !0
        }), i || Db(Qy(o.parentNode), t, n, r), r.push(o)
    }
    function Nb(e, t, n, r) {
        n.updateBound = r, Lb(e).addEventListener("resize", n.updateBound, {
            passive: !0
        });
        var i = Qy(e);
        return Db(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n
    }
    function Bb() {
        this.state.eventsEnabled || (this.state = Nb(this.reference, this.options, this.state, this.scheduleUpdate))
    }
    function Fb() {
        var e,
            t;
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, Lb(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach((function(e) {
            e.removeEventListener("scroll", t.updateBound)
        })), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t))
    }
    function Wb(e) {
        return "" !== e && !isNaN(parseFloat(e)) && isFinite(e)
    }
    function Hb(e, t) {
        Object.keys(t).forEach((function(n) {
            var r = "";
            -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && Wb(t[n]) && (r = "px"), e.style[n] = t[n] + r
        }))
    }
    var jb = Gy && /Firefox/i.test(navigator.userAgent);
    function $b(e, t, n) {
        var r = Mb(e, (function(e) {
                return e.name === t
            })),
            i = !!r && e.some((function(e) {
                return e.name === n && e.enabled && e.order < r.order
            }));
        if (!i) {
            var o = "`" + t + "`",
                a = "`" + n + "`";
            console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
        }
        return i
    }
    var Vb = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
        qb = Vb.slice(3);
    function Ub(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = qb.indexOf(e),
            r = qb.slice(n + 1).concat(qb.slice(0, n));
        return t ? r.reverse() : r
    }
    var Gb = "flip",
        Zb = "clockwise",
        Kb = "counterclockwise";
    function Yb(e, t, n, r) {
        var i = [0, 0],
            o = -1 !== ["right", "left"].indexOf(r),
            a = e.split(/(\+|\-)/).map((function(e) {
                return e.trim()
            })),
            s = a.indexOf(Mb(a, (function(e) {
                return -1 !== e.search(/,|\s/)
            })));
        a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var l = /\s*,\s*|\s+/,
            u = -1 !== s ? [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))] : [a];
        return (u = u.map((function(e, r) {
            var i = (1 === r ? !o : o) ? "height" : "width",
                a = !1;
            return e.reduce((function(e, t) {
                return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, a = !0, e) : a ? (e[e.length - 1] += t, a = !1, e) : e.concat(t)
            }), []).map((function(e) {
                return function(e, t, n, r) {
                    var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                        o = +i[1],
                        a = i[2];
                    if (!o)
                        return e;
                    if (0 === a.indexOf("%")) {
                        var s = void 0;
                        switch (a) {
                        case "%p":
                            s = n;
                            break;
                        case "%":
                        case "%r":
                        default:
                            s = r
                        }
                        return vb(s)[t] / 100 * o
                    }
                    if ("vh" === a || "vw" === a)
                        return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
                    return o
                }(e, i, t, n)
            }))
        }))).forEach((function(e, t) {
            e.forEach((function(n, r) {
                Wb(n) && (i[t] += n * ("-" === e[r - 1] ? -1 : 1))
            }))
        })), i
    }
    var Xb = {
            placement: "bottom",
            positionFixed: !1,
            eventsEnabled: !0,
            removeOnDestroy: !1,
            onCreate: function() {},
            onUpdate: function() {},
            modifiers: {
                shift: {
                    order: 100,
                    enabled: !0,
                    fn: function(e) {
                        var t = e.placement,
                            n = t.split("-")[0],
                            r = t.split("-")[1];
                        if (r) {
                            var i = e.offsets,
                                o = i.reference,
                                a = i.popper,
                                s = -1 !== ["bottom", "top"].indexOf(n),
                                l = s ? "left" : "top",
                                u = s ? "width" : "height",
                                c = {
                                    start: hb({}, l, o[l]),
                                    end: hb({}, l, o[l] + o[u] - a[u])
                                };
                            e.offsets.popper = mb({}, a, c[r])
                        }
                        return e
                    }
                },
                offset: {
                    order: 200,
                    enabled: !0,
                    fn: function(e, t) {
                        var n = t.offset,
                            r = e.placement,
                            i = e.offsets,
                            o = i.popper,
                            a = i.reference,
                            s = r.split("-")[0],
                            l = void 0;
                        return l = Wb(+n) ? [+n, 0] : Yb(n, o, a, s), "left" === s ? (o.top += l[0], o.left -= l[1]) : "right" === s ? (o.top += l[0], o.left += l[1]) : "top" === s ? (o.left += l[0], o.top -= l[1]) : "bottom" === s && (o.left += l[0], o.top += l[1]), e.popper = o, e
                    },
                    offset: 0
                },
                preventOverflow: {
                    order: 300,
                    enabled: !0,
                    fn: function(e, t) {
                        var n = t.boundariesElement || ib(e.instance.popper);
                        e.instance.reference === n && (n = ib(n));
                        var r = Ib("transform"),
                            i = e.instance.popper.style,
                            o = i.top,
                            a = i.left,
                            s = i[r];
                        i.top = "", i.left = "", i[r] = "";
                        var l = _b(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
                        i.top = o, i.left = a, i[r] = s, t.boundaries = l;
                        var u = t.priority,
                            c = e.offsets.popper,
                            d = {
                                primary: function(e) {
                                    var n = c[e];
                                    return c[e] < l[e] && !t.escapeWithReference && (n = Math.max(c[e], l[e])), hb({}, e, n)
                                },
                                secondary: function(e) {
                                    var n = "right" === e ? "left" : "top",
                                        r = c[n];
                                    return c[e] > l[e] && !t.escapeWithReference && (r = Math.min(c[n], l[e] - ("right" === e ? c.width : c.height))), hb({}, n, r)
                                }
                            };
                        return u.forEach((function(e) {
                            var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                            c = mb({}, c, d[t](e))
                        })), e.offsets.popper = c, e
                    },
                    priority: ["left", "right", "top", "bottom"],
                    padding: 5,
                    boundariesElement: "scrollParent"
                },
                keepTogether: {
                    order: 400,
                    enabled: !0,
                    fn: function(e) {
                        var t = e.offsets,
                            n = t.popper,
                            r = t.reference,
                            i = e.placement.split("-")[0],
                            o = Math.floor,
                            a = -1 !== ["top", "bottom"].indexOf(i),
                            s = a ? "right" : "bottom",
                            l = a ? "left" : "top",
                            u = a ? "width" : "height";
                        return n[s] < o(r[l]) && (e.offsets.popper[l] = o(r[l]) - n[u]), n[l] > o(r[s]) && (e.offsets.popper[l] = o(r[s])), e
                    }
                },
                arrow: {
                    order: 500,
                    enabled: !0,
                    fn: function(e, t) {
                        var n;
                        if (!$b(e.instance.modifiers, "arrow", "keepTogether"))
                            return e;
                        var r = t.element;
                        if ("string" == typeof r) {
                            if (!(r = e.instance.popper.querySelector(r)))
                                return e
                        } else if (!e.instance.popper.contains(r))
                            return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
                        var i = e.placement.split("-")[0],
                            o = e.offsets,
                            a = o.popper,
                            s = o.reference,
                            l = -1 !== ["left", "right"].indexOf(i),
                            u = l ? "height" : "width",
                            c = l ? "Top" : "Left",
                            d = c.toLowerCase(),
                            p = l ? "left" : "top",
                            f = l ? "bottom" : "right",
                            h = kb(r)[u];
                        s[f] - h < a[d] && (e.offsets.popper[d] -= a[d] - (s[f] - h)), s[d] + h > a[f] && (e.offsets.popper[d] += s[d] + h - a[f]), e.offsets.popper = vb(e.offsets.popper);
                        var m = s[d] + s[u] / 2 - h / 2,
                            v = Xy(e.instance.popper),
                            g = parseFloat(v["margin" + c]),
                            y = parseFloat(v["border" + c + "Width"]),
                            b = m - e.offsets.popper[d] - g - y;
                        return b = Math.max(Math.min(a[u] - h, b), 0), e.arrowElement = r, e.offsets.arrow = (hb(n = {}, d, Math.round(b)), hb(n, p, ""), n), e
                    },
                    element: "[x-arrow]"
                },
                flip: {
                    order: 600,
                    enabled: !0,
                    fn: function(e, t) {
                        if (Ab(e.instance.modifiers, "inner"))
                            return e;
                        if (e.flipped && e.placement === e.originalPlacement)
                            return e;
                        var n = _b(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed),
                            r = e.placement.split("-")[0],
                            i = Tb(r),
                            o = e.placement.split("-")[1] || "",
                            a = [];
                        switch (t.behavior) {
                        case Gb:
                            a = [r, i];
                            break;
                        case Zb:
                            a = Ub(r);
                            break;
                        case Kb:
                            a = Ub(r, !0);
                            break;
                        default:
                            a = t.behavior
                        }
                        return a.forEach((function(s, l) {
                            if (r !== s || a.length === l + 1)
                                return e;
                            r = e.placement.split("-")[0], i = Tb(r);
                            var u = e.offsets.popper,
                                c = e.offsets.reference,
                                d = Math.floor,
                                p = "left" === r && d(u.right) > d(c.left) || "right" === r && d(u.left) < d(c.right) || "top" === r && d(u.bottom) > d(c.top) || "bottom" === r && d(u.top) < d(c.bottom),
                                f = d(u.left) < d(n.left),
                                h = d(u.right) > d(n.right),
                                m = d(u.top) < d(n.top),
                                v = d(u.bottom) > d(n.bottom),
                                g = "left" === r && f || "right" === r && h || "top" === r && m || "bottom" === r && v,
                                y = -1 !== ["top", "bottom"].indexOf(r),
                                b = !!t.flipVariations && (y && "start" === o && f || y && "end" === o && h || !y && "start" === o && m || !y && "end" === o && v),
                                w = !!t.flipVariationsByContent && (y && "start" === o && h || y && "end" === o && f || !y && "start" === o && v || !y && "end" === o && m),
                                x = b || w;
                            (p || g || x) && (e.flipped = !0, (p || g) && (r = a[l + 1]), x && (o = function(e) {
                                return "end" === e ? "start" : "start" === e ? "end" : e
                            }(o)), e.placement = r + (o ? "-" + o : ""), e.offsets.popper = mb({}, e.offsets.popper, Ob(e.instance.popper, e.offsets.reference, e.placement)), e = Rb(e.instance.modifiers, e, "flip"))
                        })), e
                    },
                    behavior: "flip",
                    padding: 5,
                    boundariesElement: "viewport",
                    flipVariations: !1,
                    flipVariationsByContent: !1
                },
                inner: {
                    order: 700,
                    enabled: !1,
                    fn: function(e) {
                        var t = e.placement,
                            n = t.split("-")[0],
                            r = e.offsets,
                            i = r.popper,
                            o = r.reference,
                            a = -1 !== ["left", "right"].indexOf(n),
                            s = -1 === ["top", "left"].indexOf(n);
                        return i[a ? "left" : "top"] = o[n] - (s ? i[a ? "width" : "height"] : 0), e.placement = Tb(t), e.offsets.popper = vb(i), e
                    }
                },
                hide: {
                    order: 800,
                    enabled: !0,
                    fn: function(e) {
                        if (!$b(e.instance.modifiers, "hide", "preventOverflow"))
                            return e;
                        var t = e.offsets.reference,
                            n = Mb(e.instance.modifiers, (function(e) {
                                return "preventOverflow" === e.name
                            })).boundaries;
                        if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                            if (!0 === e.hide)
                                return e;
                            e.hide = !0, e.attributes["x-out-of-boundaries"] = ""
                        } else {
                            if (!1 === e.hide)
                                return e;
                            e.hide = !1, e.attributes["x-out-of-boundaries"] = !1
                        }
                        return e
                    }
                },
                computeStyle: {
                    order: 850,
                    enabled: !0,
                    fn: function(e, t) {
                        var n = t.x,
                            r = t.y,
                            i = e.offsets.popper,
                            o = Mb(e.instance.modifiers, (function(e) {
                                return "applyStyle" === e.name
                            })).gpuAcceleration;
                        void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                        var a = void 0 !== o ? o : t.gpuAcceleration,
                            s = ib(e.instance.popper),
                            l = gb(s),
                            u = {
                                position: i.position
                            },
                            c = function(e, t) {
                                var n = e.offsets,
                                    r = n.popper,
                                    i = n.reference,
                                    o = Math.round,
                                    a = Math.floor,
                                    s = function(e) {
                                        return e
                                    },
                                    l = o(i.width),
                                    u = o(r.width),
                                    c = -1 !== ["left", "right"].indexOf(e.placement),
                                    d = -1 !== e.placement.indexOf("-"),
                                    p = t ? c || d || l % 2 == u % 2 ? o : a : s,
                                    f = t ? o : s;
                                return {
                                    left: p(l % 2 == 1 && u % 2 == 1 && !d && t ? r.left - 1 : r.left),
                                    top: f(r.top),
                                    bottom: f(r.bottom),
                                    right: p(r.right)
                                }
                            }(e, window.devicePixelRatio < 2 || !jb),
                            d = "bottom" === n ? "top" : "bottom",
                            p = "right" === r ? "left" : "right",
                            f = Ib("transform"),
                            h = void 0,
                            m = void 0;
                        if (m = "bottom" === d ? "HTML" === s.nodeName ? -s.clientHeight + c.bottom : -l.height + c.bottom : c.top, h = "right" === p ? "HTML" === s.nodeName ? -s.clientWidth + c.right : -l.width + c.right : c.left, a && f)
                            u[f] = "translate3d(" + h + "px, " + m + "px, 0)", u[d] = 0, u[p] = 0, u.willChange = "transform";
                        else {
                            var v = "bottom" === d ? -1 : 1,
                                g = "right" === p ? -1 : 1;
                            u[d] = m * v, u[p] = h * g, u.willChange = d + ", " + p
                        }
                        var y = {
                            "x-placement": e.placement
                        };
                        return e.attributes = mb({}, y, e.attributes), e.styles = mb({}, u, e.styles), e.arrowStyles = mb({}, e.offsets.arrow, e.arrowStyles), e
                    },
                    gpuAcceleration: !0,
                    x: "bottom",
                    y: "right"
                },
                applyStyle: {
                    order: 900,
                    enabled: !0,
                    fn: function(e) {
                        var t,
                            n;
                        return Hb(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach((function(e) {
                            !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e)
                        })), e.arrowElement && Object.keys(e.arrowStyles).length && Hb(e.arrowElement, e.arrowStyles), e
                    },
                    onLoad: function(e, t, n, r, i) {
                        var o = Sb(i, t, e, n.positionFixed),
                            a = Eb(n.placement, o, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                        return t.setAttribute("x-placement", a), Hb(t, {
                            position: n.positionFixed ? "fixed" : "absolute"
                        }), n
                    },
                    gpuAcceleration: void 0
                }
            }
        },
        Jb = function() {
            function e(t, n) {
                var r = this,
                    i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                pb(this, e), this.scheduleUpdate = function() {
                    return requestAnimationFrame(r.update)
                }, this.update = Ky(this.update.bind(this)), this.options = mb({}, e.Defaults, i), this.state = {
                    isDestroyed: !1,
                    isCreated: !1,
                    scrollParents: []
                }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(mb({}, e.Defaults.modifiers, i.modifiers)).forEach((function(t) {
                    r.options.modifiers[t] = mb({}, e.Defaults.modifiers[t] || {}, i.modifiers ? i.modifiers[t] : {})
                })), this.modifiers = Object.keys(this.options.modifiers).map((function(e) {
                    return mb({
                        name: e
                    }, r.options.modifiers[e])
                })).sort((function(e, t) {
                    return e.order - t.order
                })), this.modifiers.forEach((function(e) {
                    e.enabled && Yy(e.onLoad) && e.onLoad(r.reference, r.popper, r.options, e, r.state)
                })), this.update();
                var o = this.options.eventsEnabled;
                o && this.enableEventListeners(), this.state.eventsEnabled = o
            }
            return fb(e, [{
                key: "update",
                value: function() {
                    return Pb.call(this)
                }
            }, {
                key: "destroy",
                value: function() {
                    return zb.call(this)
                }
            }, {
                key: "enableEventListeners",
                value: function() {
                    return Bb.call(this)
                }
            }, {
                key: "disableEventListeners",
                value: function() {
                    return Fb.call(this)
                }
            }]), e
        }();
    function Qb(e) {
        return "function" == typeof e ? e() : e
    }
    Jb.Utils = ("undefined" != typeof window ? window : e).PopperUtils, Jb.placements = Vb, Jb.Defaults = Xb;
    var ew = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect,
        tw = {},
        nw = lt.forwardRef((function(e, t) {
            var n = e.anchorEl,
                r = e.children,
                i = e.container,
                o = e.disablePortal,
                a = void 0 !== o && o,
                s = e.keepMounted,
                l = void 0 !== s && s,
                u = e.modifiers,
                c = e.open,
                d = e.placement,
                p = void 0 === d ? "bottom" : d,
                f = e.popperOptions,
                h = void 0 === f ? tw : f,
                m = e.popperRef,
                v = e.transition,
                g = void 0 !== v && v,
                y = dt(e, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition"]),
                b = lt.useRef(null),
                w = iu(b, t),
                x = lt.useRef(null),
                _ = iu(x, m),
                C = lt.useRef(_);
            ew((function() {
                C.current = _
            }), [_]), lt.useImperativeHandle(m, (function() {
                return x.current
            }), []);
            var E = lt.useState(!0),
                S = E[0],
                k = E[1],
                T = function(e, t) {
                    if ("ltr" === (t && t.direction || "ltr"))
                        return e;
                    switch (e) {
                    case "bottom-end":
                        return "bottom-start";
                    case "bottom-start":
                        return "bottom-end";
                    case "top-end":
                        return "top-start";
                    case "top-start":
                        return "top-end";
                    default:
                        return e
                    }
                }(p, Si()),
                O = lt.useState(T),
                M = O[0],
                R = O[1];
            lt.useEffect((function() {
                x.current && x.current.update()
            }));
            var P = lt.useCallback((function() {
                    if (b.current && n && c) {
                        x.current && (x.current.destroy(), C.current(null));
                        var e = function(e) {
                                R(e.placement)
                            },
                            t = (Qb(n), new Jb(Qb(n), b.current, ft({
                                placement: T
                            }, h, {
                                modifiers: ft({}, a ? {} : {
                                    preventOverflow: {
                                        boundariesElement: "window"
                                    }
                                }, {}, u, {}, h.modifiers),
                                onCreate: Mg(e, h.onCreate),
                                onUpdate: Mg(e, h.onUpdate)
                            })));
                        C.current(t)
                    }
                }), [n, a, u, c, T, h]),
                A = lt.useCallback((function(e) {
                    ru(w, e), P()
                }), [w, P]),
                I = function() {
                    x.current && (x.current.destroy(), C.current(null))
                };
            if (lt.useEffect((function() {
                P()
            }), [P]), lt.useEffect((function() {
                return function() {
                    I()
                }
            }), []), lt.useEffect((function() {
                c || g || I()
            }), [c, g]), !l && !c && (!g || S))
                return null;
            var z = {
                placement: M
            };
            return g && (z.TransitionProps = {
                in: c,
                onEnter: function() {
                    k(!1)
                },
                onExited: function() {
                    k(!0), I()
                }
            }), lt.createElement(Pg, {
                disablePortal: a,
                container: i
            }, lt.createElement("div", ft({
                ref: A,
                role: "tooltip"
            }, y, {
                style: ft({
                    position: "fixed",
                    top: 0,
                    left: 0
                }, y.style)
            }), "function" == typeof r ? r(z) : r))
        }));
    function rw(e) {
        return Math.round(1e5 * e) / 1e5
    }
    var iw = !1,
        ow = null,
        aw = lt.forwardRef((function(e, t) {
            var n = e.arrow,
                r = void 0 !== n && n,
                i = e.children,
                o = e.classes,
                a = e.disableFocusListener,
                s = void 0 !== a && a,
                l = e.disableHoverListener,
                u = void 0 !== l && l,
                c = e.disableTouchListener,
                d = void 0 !== c && c,
                p = e.enterDelay,
                f = void 0 === p ? 0 : p,
                h = e.enterTouchDelay,
                m = void 0 === h ? 700 : h,
                v = e.id,
                g = e.interactive,
                y = void 0 !== g && g,
                b = e.leaveDelay,
                w = void 0 === b ? 0 : b,
                x = e.leaveTouchDelay,
                _ = void 0 === x ? 1500 : x,
                C = e.onClose,
                E = e.onOpen,
                S = e.open,
                k = e.placement,
                T = void 0 === k ? "bottom" : k,
                O = e.PopperProps,
                M = e.title,
                R = e.TransitionComponent,
                P = void 0 === R ? Gg : R,
                A = e.TransitionProps,
                I = dt(e, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"]),
                z = Pa(),
                L = lt.useState(),
                D = L[0],
                N = L[1],
                B = lt.useState(null),
                F = B[0],
                W = B[1],
                H = lt.useRef(!1),
                j = lt.useRef(),
                $ = lt.useRef(),
                V = lt.useRef(),
                q = lt.useRef(),
                U = Yv(vy({
                    controlled: S,
                    default: !1,
                    name: "Tooltip"
                }), 2),
                G = U[0],
                Z = U[1],
                K = G,
                Y = lt.useState(),
                X = Y[0],
                J = Y[1],
                Q = v || X;
            lt.useEffect((function() {
                K && !X && J("mui-tooltip-".concat(Math.round(1e5 * Math.random())))
            }), [K, X]), lt.useEffect((function() {
                return function() {
                    clearTimeout(j.current), clearTimeout($.current), clearTimeout(V.current), clearTimeout(q.current)
                }
            }), []);
            var ee = function(e) {
                    clearTimeout(ow), iw = !0, Z(!0), E && E(e)
                },
                te = function(e) {
                    var t = i.props;
                    "mouseover" === e.type && t.onMouseOver && e.currentTarget === D && t.onMouseOver(e), H.current && "touchstart" !== e.type || (D && D.removeAttribute("title"), clearTimeout($.current), clearTimeout(V.current), f && !iw ? (e.persist(), $.current = setTimeout((function() {
                        ee(e)
                    }), f)) : ee(e))
                },
                ne = yu(),
                re = ne.isFocusVisible,
                ie = ne.onBlurVisible,
                oe = ne.ref,
                ae = lt.useState(!1),
                se = ae[0],
                le = ae[1],
                ue = function(e) {
                    clearTimeout(ow), ow = setTimeout((function() {
                        iw = !1
                    }), 500), Z(!1), C && C(e), clearTimeout(j.current), j.current = setTimeout((function() {
                        H.current = !1
                    }), z.transitions.duration.shortest)
                },
                ce = function(e) {
                    var t = i.props;
                    "blur" === e.type && (t.onBlur && e.currentTarget === D && t.onBlur(e), se && (le(!1), ie())), "mouseleave" === e.type && t.onMouseLeave && e.currentTarget === D && t.onMouseLeave(e), clearTimeout($.current), clearTimeout(V.current), e.persist(), V.current = setTimeout((function() {
                        ue(e)
                    }), w)
                },
                de = iu(N, t),
                pe = iu(oe, de),
                fe = lt.useCallback((function(e) {
                    ru(pe, lt.findDOMNode(e))
                }), [pe]),
                he = iu(i.ref, fe);
            "" === M && (K = !1);
            var me = ft({
                "aria-describedby": K ? Q : null,
                title: !K && !u && "string" == typeof M ? M : null
            }, I, {}, i.props, {
                className: fa(I.className, i.props.className)
            });
            d || (me.onTouchStart = function(e) {
                H.current = !0;
                var t = i.props;
                t.onTouchStart && t.onTouchStart(e), clearTimeout(V.current), clearTimeout(j.current), clearTimeout(q.current), e.persist(), q.current = setTimeout((function() {
                    te(e)
                }), m)
            }, me.onTouchEnd = function(e) {
                i.props.onTouchEnd && i.props.onTouchEnd(e), clearTimeout(q.current), clearTimeout(V.current), e.persist(), V.current = setTimeout((function() {
                    ue(e)
                }), _)
            }), u || (me.onMouseOver = te, me.onMouseLeave = ce), s || (me.onFocus = function(e) {
                D || N(e.currentTarget), re(e) && (le(!0), te(e));
                var t = i.props;
                t.onFocus && e.currentTarget === D && t.onFocus(e)
            }, me.onBlur = ce);
            var ve = y ? {
                onMouseOver: me.onMouseOver,
                onMouseLeave: me.onMouseLeave,
                onFocus: me.onFocus,
                onBlur: me.onBlur
            } : {};
            var ge = lt.useMemo((function() {
                return {
                    modifiers: {
                        arrow: {
                            enabled: Boolean(F),
                            element: F
                        }
                    }
                }
            }), [F]);
            return lt.createElement(lt.Fragment, null, lt.cloneElement(i, ft({
                ref: he
            }, me)), lt.createElement(nw, ft({
                className: fa(o.popper, y && o.popperInteractive, r && o.popperArrow),
                placement: T,
                anchorEl: D,
                open: !!D && K,
                id: me["aria-describedby"],
                transition: !0,
                popperOptions: ge
            }, ve, O), (function(e) {
                var t = e.placement,
                    n = e.TransitionProps;
                return lt.createElement(P, ft({
                    timeout: z.transitions.duration.shorter
                }, n, A), lt.createElement("div", {
                    className: fa(o.tooltip, o["tooltipPlacement".concat(Fu(t.split("-")[0]))], H.current && o.touch, r && o.tooltipArrow)
                }, M, r ? lt.createElement("span", {
                    className: o.arrow,
                    ref: W
                }) : null))
            })))
        })),
        sw = nu((function(e) {
            return {
                popper: {
                    zIndex: e.zIndex.tooltip,
                    pointerEvents: "none",
                    flip: !1
                },
                popperInteractive: {
                    pointerEvents: "auto"
                },
                popperArrow: {
                    '&[x-placement*="bottom"] $arrow': {
                        flip: !1,
                        top: 0,
                        left: 0,
                        marginTop: "-0.95em",
                        marginLeft: 4,
                        marginRight: 4,
                        width: "2em",
                        height: "1em",
                        "&::before": {
                            flip: !1,
                            borderWidth: "0 1em 1em 1em",
                            borderColor: "transparent transparent currentcolor transparent"
                        }
                    },
                    '&[x-placement*="top"] $arrow': {
                        flip: !1,
                        bottom: 0,
                        left: 0,
                        marginBottom: "-0.95em",
                        marginLeft: 4,
                        marginRight: 4,
                        width: "2em",
                        height: "1em",
                        "&::before": {
                            flip: !1,
                            borderWidth: "1em 1em 0 1em",
                            borderColor: "currentcolor transparent transparent transparent"
                        }
                    },
                    '&[x-placement*="right"] $arrow': {
                        flip: !1,
                        left: 0,
                        marginLeft: "-0.95em",
                        marginTop: 4,
                        marginBottom: 4,
                        height: "2em",
                        width: "1em",
                        "&::before": {
                            flip: !1,
                            borderWidth: "1em 1em 1em 0",
                            borderColor: "transparent currentcolor transparent transparent"
                        }
                    },
                    '&[x-placement*="left"] $arrow': {
                        flip: !1,
                        right: 0,
                        marginRight: "-0.95em",
                        marginTop: 4,
                        marginBottom: 4,
                        height: "2em",
                        width: "1em",
                        "&::before": {
                            flip: !1,
                            borderWidth: "1em 0 1em 1em",
                            borderColor: "transparent transparent transparent currentcolor"
                        }
                    }
                },
                tooltip: {
                    backgroundColor: $n(e.palette.grey[700], .9),
                    borderRadius: e.shape.borderRadius,
                    color: e.palette.common.white,
                    fontFamily: e.typography.fontFamily,
                    padding: "4px 8px",
                    fontSize: e.typography.pxToRem(10),
                    lineHeight: "".concat(rw(1.4), "em"),
                    maxWidth: 300,
                    wordWrap: "break-word",
                    fontWeight: e.typography.fontWeightMedium
                },
                tooltipArrow: {
                    position: "relative",
                    margin: "0"
                },
                arrow: {
                    position: "absolute",
                    fontSize: 6,
                    color: $n(e.palette.grey[700], .9),
                    "&::before": {
                        content: '""',
                        margin: "auto",
                        display: "block",
                        width: 0,
                        height: 0,
                        borderStyle: "solid"
                    }
                },
                touch: {
                    padding: "8px 16px",
                    fontSize: e.typography.pxToRem(14),
                    lineHeight: "".concat(rw(16 / 14), "em"),
                    fontWeight: e.typography.fontWeightRegular
                },
                tooltipPlacementLeft: ut({
                    transformOrigin: "right center",
                    margin: "0 24px "
                }, e.breakpoints.up("sm"), {
                    margin: "0 14px"
                }),
                tooltipPlacementRight: ut({
                    transformOrigin: "left center",
                    margin: "0 24px"
                }, e.breakpoints.up("sm"), {
                    margin: "0 14px"
                }),
                tooltipPlacementTop: ut({
                    transformOrigin: "center bottom",
                    margin: "24px 0"
                }, e.breakpoints.up("sm"), {
                    margin: "14px 0"
                }),
                tooltipPlacementBottom: ut({
                    transformOrigin: "center top",
                    margin: "24px 0"
                }, e.breakpoints.up("sm"), {
                    margin: "14px 0"
                })
            }
        }), {
            name: "PwzrTooltip"
        })(aw),
        lw = {},
        uw = Aa;
    Object.defineProperty(lw, "__esModule", {
        value: !0
    });
    var cw = void 0;
    lw.default = cw;
    var dw = uw(f);
    cw = (0, uw(ed).default)(dw.default.createElement("path", {
        d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    }), "Edit"), lw.default = cw;
    var pw,
        fw = t(lw),
        hw = !1;
    function mw() {
        pw = function() {
            var t = this,
                n = {
                    exports: this
                },
                r = "__lodash_hash_undefined__",
                i = 9007199254740991,
                o = "[object Arguments]",
                a = "[object Function]",
                s = "[object Object]",
                l = /^\[object .+?Constructor\]$/,
                u = /^(?:0|[1-9]\d*)$/,
                c = {};
            c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c[o] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c[a] = c["[object Map]"] = c["[object Number]"] = c[s] = c["[object RegExp]"] = c["[object Set]"] = c["[object String]"] = c["[object WeakMap]"] = !1;
            var d = "object" == typeof e && e && e.Object === Object && e,
                p = "object" == typeof self && self && self.Object === Object && self,
                f = d || p || Function("return this")(),
                h = "object" == typeof t && t && !t.nodeType && t,
                m = h && "object" == typeof n && n && !n.nodeType && n,
                v = m && m.exports === h,
                g = v && d.process,
                y = function() {
                    try {
                        var e = m && m.require && m.require("util").types;
                        return e || g && g.binding && g.binding("util")
                    } catch (e) {}
                }(),
                b = y && y.isTypedArray;
            function w(e, t, n) {
                switch (n.length) {
                case 0:
                    return e.call(t);
                case 1:
                    return e.call(t, n[0]);
                case 2:
                    return e.call(t, n[0], n[1]);
                case 3:
                    return e.call(t, n[0], n[1], n[2])
                }
                return e.apply(t, n)
            }
            var x,
                _,
                C,
                E = Array.prototype,
                S = Function.prototype,
                k = Object.prototype,
                T = f["__core-js_shared__"],
                O = S.toString,
                M = k.hasOwnProperty,
                R = (x = /[^.]+$/.exec(T && T.keys && T.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "",
                P = k.toString,
                A = O.call(Object),
                I = RegExp("^" + O.call(M).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
                z = v ? f.Buffer : void 0,
                L = f.Symbol,
                D = f.Uint8Array,
                N = z ? z.allocUnsafe : void 0,
                B = (_ = Object.getPrototypeOf, C = Object, function(e) {
                    return _(C(e))
                }),
                F = Object.create,
                W = k.propertyIsEnumerable,
                H = E.splice,
                j = L ? L.toStringTag : void 0,
                $ = function() {
                    try {
                        var e = he(Object, "defineProperty");
                        return e({}, "", {}), e
                    } catch (e) {}
                }(),
                V = z ? z.isBuffer : void 0,
                q = Math.max,
                U = Date.now,
                G = he(f, "Map"),
                Z = he(Object, "create"),
                K = function() {
                    function e() {}
                    return function(t) {
                        if (!ke(t))
                            return {};
                        if (F)
                            return F(t);
                        e.prototype = t;
                        var n = new e;
                        return e.prototype = void 0, n
                    }
                }();
            function Y(e) {
                var t = -1,
                    n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n;) {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }
            function X(e) {
                var t = -1,
                    n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n;) {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }
            function J(e) {
                var t = -1,
                    n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n;) {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }
            function Q(e) {
                var t = this.__data__ = new X(e);
                this.size = t.size
            }
            function ee(e, t) {
                var n = xe(e),
                    r = !n && we(e),
                    i = !n && !r && Ce(e),
                    o = !n && !r && !i && Oe(e),
                    a = n || r || i || o,
                    s = a ? function(e, t) {
                        for (var n = -1, r = Array(e); ++n < e;)
                            r[n] = t(n);
                        return r
                    }(e.length, String) : [],
                    l = s.length;
                for (var u in e)
                    !t && !M.call(e, u) || a && ("length" == u || i && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || me(u, l)) || s.push(u);
                return s
            }
            function te(e, t, n) {
                (void 0 !== n && !be(e[t], n) || void 0 === n && !(t in e)) && ie(e, t, n)
            }
            function ne(e, t, n) {
                var r = e[t];
                M.call(e, t) && be(r, n) && (void 0 !== n || t in e) || ie(e, t, n)
            }
            function re(e, t) {
                for (var n = e.length; n--;)
                    if (be(e[n][0], t))
                        return n;
                return -1
            }
            function ie(e, t, n) {
                "__proto__" == t && $ ? $(e, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: n,
                    writable: !0
                }) : e[t] = n
            }
            Y.prototype.clear = function() {
                this.__data__ = Z ? Z(null) : {}, this.size = 0
            }, Y.prototype.delete = function(e) {
                var t = this.has(e) && delete this.__data__[e];
                return this.size -= t ? 1 : 0, t
            }, Y.prototype.get = function(e) {
                var t = this.__data__;
                if (Z) {
                    var n = t[e];
                    return n === r ? void 0 : n
                }
                return M.call(t, e) ? t[e] : void 0
            }, Y.prototype.has = function(e) {
                var t = this.__data__;
                return Z ? void 0 !== t[e] : M.call(t, e)
            }, Y.prototype.set = function(e, t) {
                var n = this.__data__;
                return this.size += this.has(e) ? 0 : 1, n[e] = Z && void 0 === t ? r : t, this
            }, X.prototype.clear = function() {
                this.__data__ = [], this.size = 0
            }, X.prototype.delete = function(e) {
                var t = this.__data__,
                    n = re(t, e);
                return !(n < 0) && (n == t.length - 1 ? t.pop() : H.call(t, n, 1), --this.size, !0)
            }, X.prototype.get = function(e) {
                var t = this.__data__,
                    n = re(t, e);
                return n < 0 ? void 0 : t[n][1]
            }, X.prototype.has = function(e) {
                return re(this.__data__, e) > -1
            }, X.prototype.set = function(e, t) {
                var n = this.__data__,
                    r = re(n, e);
                return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this
            }, J.prototype.clear = function() {
                this.size = 0, this.__data__ = {
                    hash: new Y,
                    map: new (G || X),
                    string: new Y
                }
            }, J.prototype.delete = function(e) {
                var t = fe(this, e).delete(e);
                return this.size -= t ? 1 : 0, t
            }, J.prototype.get = function(e) {
                return fe(this, e).get(e)
            }, J.prototype.has = function(e) {
                return fe(this, e).has(e)
            }, J.prototype.set = function(e, t) {
                var n = fe(this, e),
                    r = n.size;
                return n.set(e, t), this.size += n.size == r ? 0 : 1, this
            }, Q.prototype.clear = function() {
                this.__data__ = new X, this.size = 0
            }, Q.prototype.delete = function(e) {
                var t = this.__data__,
                    n = t.delete(e);
                return this.size = t.size, n
            }, Q.prototype.get = function(e) {
                return this.__data__.get(e)
            }, Q.prototype.has = function(e) {
                return this.__data__.has(e)
            }, Q.prototype.set = function(e, t) {
                var n = this.__data__;
                if (n instanceof X) {
                    var r = n.__data__;
                    if (!G || r.length < 199)
                        return r.push([e, t]), this.size = ++n.size, this;
                    n = this.__data__ = new J(r)
                }
                return n.set(e, t), this.size = n.size, this
            };
            var oe,
                ae = function(e, t, n) {
                    for (var r = -1, i = Object(e), o = n(e), a = o.length; a--;) {
                        var s = o[oe ? a : ++r];
                        if (!1 === t(i[s], s, i))
                            break
                    }
                    return e
                };
            function se(e) {
                return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : j && j in Object(e) ? function(e) {
                    var t = M.call(e, j),
                        n = e[j];
                    try {
                        e[j] = void 0;
                        var r = !0
                    } catch (e) {}
                    var i = P.call(e);
                    r && (t ? e[j] = n : delete e[j]);
                    return i
                }(e) : function(e) {
                    return P.call(e)
                }(e)
            }
            function le(e) {
                return Te(e) && se(e) == o
            }
            function ue(e) {
                return !(!ke(e) || function(e) {
                        return !!R && R in e
                    }(e)) && (Ee(e) ? I : l).test(function(e) {
                        if (null != e) {
                            try {
                                return O.call(e)
                            } catch (e) {}
                            try {
                                return e + ""
                            } catch (e) {}
                        }
                        return ""
                    }(e))
            }
            function ce(e) {
                if (!ke(e))
                    return function(e) {
                        var t = [];
                        if (null != e)
                            for (var n in Object(e))
                                t.push(n);
                        return t
                    }(e);
                var t = ve(e),
                    n = [];
                for (var r in e)
                    ("constructor" != r || !t && M.call(e, r)) && n.push(r);
                return n
            }
            function de(e, t, n, r, i) {
                e !== t && ae(t, (function(o, a) {
                    if (i || (i = new Q), ke(o))
                        !function(e, t, n, r, i, o, a) {
                            var l = ge(e, n),
                                u = ge(t, n),
                                c = a.get(u);
                            if (c)
                                return void te(e, n, c);
                            var d = o ? o(l, u, n + "", e, t, a) : void 0,
                                p = void 0 === d;
                            if (p) {
                                var f = xe(u),
                                    h = !f && Ce(u),
                                    m = !f && !h && Oe(u);
                                d = u, f || h || m ? xe(l) ? d = l : Te(w = l) && _e(w) ? d = function(e, t) {
                                    var n = -1,
                                        r = e.length;
                                    t || (t = Array(r));
                                    for (; ++n < r;)
                                        t[n] = e[n];
                                    return t
                                }(l) : h ? (p = !1, d = function(e, t) {
                                    if (t)
                                        return e.slice();
                                    var n = e.length,
                                        r = N ? N(n) : new e.constructor(n);
                                    return e.copy(r), r
                                }(u, !0)) : m ? (p = !1, v = u, g = !0 ? (y = v.buffer, b = new y.constructor(y.byteLength), new D(b).set(new D(y)), b) : v.buffer, d = new v.constructor(g, v.byteOffset, v.length)) : d = [] : function(e) {
                                    if (!Te(e) || se(e) != s)
                                        return !1;
                                    var t = B(e);
                                    if (null === t)
                                        return !0;
                                    var n = M.call(t, "constructor") && t.constructor;
                                    return "function" == typeof n && n instanceof n && O.call(n) == A
                                }(u) || we(u) ? (d = l, we(l) ? d = function(e) {
                                    return function(e, t, n, r) {
                                        var i = !n;
                                        n || (n = {});
                                        var o = -1,
                                            a = t.length;
                                        for (; ++o < a;) {
                                            var s = t[o],
                                                l = r ? r(n[s], e[s], s, n, e) : void 0;
                                            void 0 === l && (l = e[s]), i ? ie(n, s, l) : ne(n, s, l)
                                        }
                                        return n
                                    }(e, Me(e))
                                }(l) : ke(l) && !Ee(l) || (d = function(e) {
                                    return "function" != typeof e.constructor || ve(e) ? {} : K(B(e))
                                }(u))) : p = !1
                            }
                            var v,
                                g,
                                y,
                                b;
                            var w;
                            p && (a.set(u, d), i(d, u, r, o, a), a.delete(u));
                            te(e, n, d)
                        }(e, t, a, n, de, r, i);
                    else {
                        var l = r ? r(ge(e, a), o, a + "", e, t, i) : void 0;
                        void 0 === l && (l = o), te(e, a, l)
                    }
                }), Me)
            }
            function pe(e, t) {
                return ye(function(e, t, n) {
                    return t = q(void 0 === t ? e.length - 1 : t, 0), function() {
                        for (var r = arguments, i = -1, o = q(r.length - t, 0), a = Array(o); ++i < o;)
                            a[i] = r[t + i];
                        i = -1;
                        for (var s = Array(t + 1); ++i < t;)
                            s[i] = r[i];
                        return s[t] = n(a), w(e, this, s)
                    }
                }(e, t, Ae), e + "")
            }
            function fe(e, t) {
                var n,
                    r,
                    i = e.__data__;
                return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map
            }
            function he(e, t) {
                var n = function(e, t) {
                    return null == e ? void 0 : e[t]
                }(e, t);
                return ue(n) ? n : void 0
            }
            function me(e, t) {
                var n = typeof e;
                return !!(t = null == t ? i : t) && ("number" == n || "symbol" != n && u.test(e)) && e > -1 && e % 1 == 0 && e < t
            }
            function ve(e) {
                var t = e && e.constructor;
                return e === ("function" == typeof t && t.prototype || k)
            }
            function ge(e, t) {
                if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t)
                    return e[t]
            }
            var ye = function(e) {
                var t = 0,
                    n = 0;
                return function() {
                    var r = U(),
                        i = 16 - (r - n);
                    if (n = r, i > 0) {
                        if (++t >= 800)
                            return arguments[0]
                    } else
                        t = 0;
                    return e.apply(void 0, arguments)
                }
            }($ ? function(e, t) {
                return $(e, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: (n = t, function() {
                        return n
                    }),
                    writable: !0
                });
                var n
            } : Ae);
            function be(e, t) {
                return e === t || e != e && t != t
            }
            var we = le(function() {
                    return arguments
                }()) ? le : function(e) {
                    return Te(e) && M.call(e, "callee") && !W.call(e, "callee")
                },
                xe = Array.isArray;
            function _e(e) {
                return null != e && Se(e.length) && !Ee(e)
            }
            var Ce = V || function() {
                return !1
            };
            function Ee(e) {
                if (!ke(e))
                    return !1;
                var t = se(e);
                return t == a || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t
            }
            function Se(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= i
            }
            function ke(e) {
                var t = typeof e;
                return null != e && ("object" == t || "function" == t)
            }
            function Te(e) {
                return null != e && "object" == typeof e
            }
            var Oe = b ? function(e) {
                return function(t) {
                    return e(t)
                }
            }(b) : function(e) {
                return Te(e) && Se(e.length) && !!c[se(e)]
            };
            function Me(e) {
                return _e(e) ? ee(e, !0) : ce(e)
            }
            var Re,
                Pe = (Re = function(e, t, n) {
                    de(e, t, n)
                }, pe((function(e, t) {
                    var n = -1,
                        r = t.length,
                        i = r > 1 ? t[r - 1] : void 0,
                        o = r > 2 ? t[2] : void 0;
                    for (i = Re.length > 3 && "function" == typeof i ? (r--, i) : void 0, o && function(e, t, n) {
                        if (!ke(n))
                            return !1;
                        var r = typeof t;
                        return !!("number" == r ? _e(n) && me(t, n.length) : "string" == r && t in n) && be(n[t], e)
                    }(t[0], t[1], o) && (i = r < 3 ? void 0 : i, r = 1), e = Object(e); ++n < r;) {
                        var a = t[n];
                        a && Re(e, a, n, i)
                    }
                    return e
                })));
            function Ae(e) {
                return e
            }
            return n.exports = Pe, n.exports
        }.call({})
    }
    let vw;
    function gw(e) {
        return "lightbox-background-color" === e || "thumbnail-selection-color" === e ? "rgb(0, 0, 0)" : "border-colors-double" === e ? "rgb(255, 255, 255)" : "border-colors-selected" === e ? "rgb(50, 50, 50)" : "border-colors-unselected" === e ? "rgb(220, 220, 220)" : "border-colors-hovering" === e ? "rgb(100, 100, 100)" : "border-colors-outOfStockCrossOut" === e ? "rgb(25, 25, 25)" : "tooltip-background-color" === e ? "rgba(97, 97, 97)" : "swatch-selected-background-color" === e ? null : "swatch-background-color" === e ? "rgb(255, 255, 255)" : "alert-background-color" === e ? "rgb(237, 247, 237)" : "tooltip-text-color" === e || "unselected-background-color" === e ? "rgb(255, 255, 255)" : "unselected-text-color" === e ? "rgb(0, 0, 0)" : "select-background-color" === e ? "rgb(255, 255, 255)" : "select-text-color" === e || "selected-background-color" === e ? "rgb(0, 0, 0)" : "selected-text-color" === e ? "rgb(255, 255, 255)" : e.endsWith("-background-color") || e.endsWith("-border-color") ? null : "rgb(0, 0, 0)"
    }
    function yw(e) {
        return "swatch-text-size" === e || "swatch-title-text-size" === e ? 14 : "title-text-size" === e ? 18 : "subtitle-text-size" === e ? 16 : "alert-text-size" === e ? 18 : "tooltip-text-size" === e || "selected-text-size" === e ? 14 : "select-text-size" === e ? 16 : "unselected-text-size" === e ? 14 : 18
    }
    function bw(e) {
        return "tooltip-text-padding" === e ? [8, 8, 4, 4] : "swatch-title-text-padding" === e ? [3, 3, 2, 2] : "swatch-text-padding" === e ? [0, 0, 0, 0] : [5, 5, 2, 5]
    }
    function ww(e) {
        return "swatch-title-margin" === e ? [0, 0, 2, 2] : [0, 0, 5, 5]
    }
    function xw(e) {
        return "border-thickness-double" === e ? 3 : 1
    }
    function _w(e) {
        return "border-radius-px" === e ? 4 : 18
    }
    function Cw() {
        return {
            title: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: gw("title-text-color"),
                textSize: yw("title-text-size"),
                textPadding: bw("title-text-padding"),
                backgroundColor: null,
                borderColor: gw("title-border-color"),
                borderStyle: "solid",
                borderThickness: xw("title-border-thickness"),
                borderRadius: _w("title-border-radius"),
                position: ["above", 1],
                margin: ww("title-margin")
            },
            subtitle: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: gw("subtitle-text-color"),
                textSize: yw("subtitle-text-size"),
                textPadding: bw("subtitle-text-padding"),
                backgroundColor: null,
                borderColor: gw("subtitle-border-color"),
                borderStyle: "solid",
                borderThickness: xw("subtitle-border-thickness"),
                borderRadius: _w("subtitle-border-radius"),
                position: ["below", 1],
                margin: ww("subtitle-margin")
            },
            alert: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: gw("alert-text-color"),
                textSize: yw("alert-text-size"),
                textPadding: bw("alert-text-padding"),
                backgroundColor: gw("alert-background-color"),
                borderColor: gw("alert-border-color"),
                borderStyle: "solid",
                borderThickness: xw("alert-border-thickness"),
                borderRadius: _w("alert-border-radius"),
                position: ["above", 1],
                margin: ww("alert-margin")
            }
        }
    }
    function Ew(e, t) {
        const n = Array.isArray(t) ? t : [];
        return e.map((e => {
            const t = n.findIndex((t => t.id === e)),
                r = t > -1 ? n[t] : void 0;
            return {
                id: e,
                name: e,
                config: vw({
                    text: null,
                    textBold: !1,
                    textUppercase: !1,
                    textColor: gw("swatch-text-color"),
                    textSize: yw("swatch-text-size"),
                    textPadding: bw("swatch-text-padding"),
                    backgroundImage: null,
                    backgroundPosition: "left",
                    backgroundSize: 100,
                    backgroundSizePx: 24,
                    backgroundBorderRadius: 18,
                    backgroundType: "one-solid",
                    backgroundColor: gw("swatch-background-color"),
                    backgroundColor2: gw("swatch-background-color"),
                    backgroundColor3: gw("swatch-background-color"),
                    backgroundColor4: gw("swatch-background-color"),
                    selectedBackgroundColor: gw("swatch-selected-background-color"),
                    ...Cw(),
                    tooltip: {
                        enabled: !0,
                        text: null,
                        textBold: !1,
                        textUppercase: !1,
                        textColor: gw("tooltip-text-color"),
                        textSize: yw("tooltip-text-size"),
                        textPadding: bw("tooltip-text-padding"),
                        backgroundColor: gw("tooltip-background-color"),
                        position: ["below"]
                    }
                }, r ? r.config : {})
            }
        }))
    }
    function Sw(e, t) {
        return t.options.map(((t, n) => ({
            id: e.options[n].name,
            value: t
        })))
    }
    function kw(e, t, n=null) {
        const r = t[e],
            i = !(!r.enabled || !r.text);
        if (!n)
            return [i];
        const [o, a] = r.position;
        return [i && o === n, a]
    }
    hw || (hw = !0, mw()), vw = pw;
    const Tw = ["title", "subtitle", "alert"];
    const Ow = lt.createContext("product-options");
    const Mw = {
        "one-solid": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0.176H120V120.176H0z"></path></svg>',
        "two-columns": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M60 0H120V120H60z"></path></svg>',
        "two-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 60H180V180H120z" transform="rotate(90 120 60)"></path></svg>',
        "two-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 0H120V120H0z"></path><path fill="%COLOR1%" d="M0 0l120 120V0H0z"></path></svg>',
        "two-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 120H120V240H0z" transform="rotate(-90 0 120)"></path><path fill="%COLOR1%" d="M0 120L120 0H0v120z"></path></svg>',
        "three-column": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M40 0H120V120H40z"></path><path fill="%COLOR3%" d="M80 0H120V120H80z"></path></svg>',
        "three-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 40H200V160H120z" transform="rotate(90 120 40)"></path><path fill="%COLOR3%" d="M120 80H160V200H120z" transform="rotate(90 120 80)"></path></svg>',
        "three-triangles": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M60 0H120V120H60z"></path><path fill="%COLOR3%" d="M60 60l60 60H0l60-60z"></path></svg>',
        "three-triangles-circle": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 0H240V60H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR3%" d="M120 120H0V93.846L60 60l60 34.872V120z"></path></svg>',
        "three-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 0H120V120H0z"></path><path fill="%COLOR1%" d="M40 0l80 80V0H40z"></path><path fill="%COLOR3%" d="M80 120L0 40v80h80z"></path></svg>',
        "three-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR3%" d="M120 40l-80 80h80V40z"></path><path fill="%COLOR1%" d="M0 80L80 0H0v80z"></path></svg>',
        "four-triangles": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M0 0l120 120V0H0z"></path><path fill="%COLOR3%" d="M120 0L0 120h120V0z"></path><path fill="%COLOR4%" d="M60 60l60 60H0l60-60z"></path></svg>',
        "four-squares": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V119.008H0z"></path><path fill="%COLOR2%" d="M60 0H120V119.008H60z"></path><path fill="%COLOR3%" d="M120 60.496H179.504V180.496H120z" transform="rotate(90 120 60.496)"></path><path fill="%COLOR4%" d="M0 60.496H60V119.999H0z"></path></svg>',
        "four-columns": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M30 0H120V120H30z"></path><path fill="%COLOR3%" d="M60 0H120V120H60z"></path><path fill="%COLOR4%" d="M90 0H120V120H90z"></path></svg>',
        "four-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 30H210V150H120z" transform="rotate(90 120 30)"></path><path fill="%COLOR3%" d="M120 60H180V180H120z" transform="rotate(90 120 60)"></path><path fill="%COLOR4%" d="M120 90H150V210H120z" transform="rotate(90 120 90)"></path></svg>',
        "four-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" fill-rule="evenodd" d="M120 120V60L60 0H0v120h120z" clip-rule="evenodd"></path><path fill="%COLOR3%" d="M120 120L0 0v120h120z"></path><path fill="%COLOR4%" d="M60 120L0 60v60h60z"></path></svg>',
        "four-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" fill-rule="evenodd" d="M0 0v120h120V0H60L0 60V0z" clip-rule="evenodd"></path><path fill="%COLOR3%" d="M120 0L0 120h120V0z"></path><path fill="%COLOR4%" d="M120 60l-60 60h60V60z"></path></svg>'
    };
    Ra((e => ({
        button: {
            width: 50,
            height: 50,
            filter: "brightness(1.1)",
            cursor: "pointer"
        },
        buttonSelected: {
            outline: "solid 2px"
        },
        buttonHovering: {
            filter: "brightness(1.3)"
        }
    })));
    const Rw = lt.createContext("assets");
    function Pw(e) {
        const t = function() {
                if (window.__productWizRio && window.__productWizRioProductOptionsSettings && window.__productWizRioProductOptionsSettings.productOptionsCenteredOnMobile) {
                    const {config: {breakpoint: e}} = window.__productWizRio;
                    return e
                }
                return "none"
            }(),
            n = Hl(`(min-width:${"none" === t ? "0px" : t})`, {
                noSsr: !0
            });
        return "none" === t ? e.centered : !n || e.centered
    }
    function Aw(e, t, n) {
        if ("string" != typeof e)
            return null;
        let r = e;
        return null !== t && (r = r.replace(/%P%/g, function(e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            var n = "",
                r = /\{\{\s*(\w+)\s*\}\}/,
                i = t || "${{amount}}";
            function o(e, t, n, r) {
                if (n = n || ",", r = r || ".", isNaN(e) || null === e)
                    return 0;
                var i = (e = (e / 100).toFixed(t)).split(".");
                return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? r + i[1] : "")
            }
            switch (i.match(r)[1]) {
            case "amount":
                n = o(e, 2);
                break;
            case "amount_no_decimals":
                n = o(e, 0);
                break;
            case "amount_with_comma_separator":
                n = o(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = o(e, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                n = o(e, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                n = o(e, 2, "'")
            }
            return i.replace(r, n)
        }(t, function() {
            var e;
            const t = null === (e = window.__productWizRio) || void 0 === e ? void 0 : e.moneyFormat;
            return "string" == typeof t ? t : null
        }()))), "string" == typeof n && (r = r.replace(/%N%/g, n)), r
    }
    function Iw({selected: e, hovering: t, borderSelectedColor: n, borderUnselectedColor: r, borderHoverColor: i}) {
        const o = e ? n : t ? i : r;
        return o || "transparent"
    }
    const zw = Ra((() => ({
        tooltip: {
            backgroundColor: "var(--rio-tooltip-background-color)",
            color: "var(--rio-tooltip-text-color)",
            boxShadow: "none",
            fontSize: "var(--rio-tooltip-text-size)",
            padding: "var(--rio-tooltip-padding)"
        },
        arrow: {
            color: "var(--rio-tooltip-background-color)"
        }
    })));
    function Lw({outOfStockTooltip: e, value: t, children: n, available: r, name: i, price: o}) {
        zw();
        const a = le((() => `rio-tooltip-${Sd.v4()}`), []),
            {config: {tooltip: {enabled: s, text: l, textSize: u, textBold: c, textUppercase: d, textColor: p, textPadding: f, backgroundColor: h, position: [m]}}} = t,
            v = e && !r,
            g = !(!l || !s),
            y = g || v,
            b = le((() => function() {
                const e = window.__productWizRioProductOptionsSettings;
                return "object" == typeof e && null !== e && "string" == typeof e.outOfStockI18n ? e.outOfStockI18n : "Out of stock"
            }()), []),
            w = g && v ? `${l} - ${b}` : v ? b : g ? l : null;
        return ie((() => {
            const e = `\n        .${a}-tooltip {\n          background-color: ${h};\n          color: ${p};\n          box-shadow: none;\n          font-size: ${u}px;\n          font-weight: ${c ? "bold" : "normal"};\n          text-transform: ${d ? "uppercase" : "none"};\n          padding: ${f[2]}px ${f[1]}px ${f[3]}px ${f[0]}px;\n        }\n        .${a}-arrow {\n          color: ${h};\n        }\n      `,
                t = document.createElement("style");
            return t.textContent = e, document.head.appendChild(t), () => {document.head.removeChild(t)}
        }), [h, c, d, p, f, u, a]), y ? lt.createElement(sw, {
            classes: {
                tooltip: `${a}-tooltip`,
                arrow: `${a}-arrow`
            },
            title: Aw(w, o, i),
            arrow: !0,
            placement: "above" === m ? "top" : "bottom"
        }, n) : n
    }
    function Dw({text: e, config: t}) {
        const {textBold: n, textUppercase: r, textSize: i, textColor: o, backgroundColor: a, textPadding: [s, l, u, c], borderStyle: d, borderColor: p, borderRadius: f, borderThickness: h, margin: [, , m, v], position: [g], useThemeSettings: y} = t;
        return lt.createElement(xm, {
            item: !0,
            container: !0,
            direction: "column"
        }, "below" === g && lt.createElement(dg, {
            height: m
        }), lt.createElement(xm, {
            item: !0
        }, lt.createElement("div", {
            className: y ? "rio-product-option-title" : void 0,
            style: y ? {} : {
                lineHeight: 1,
                fontSize: i,
                fontWeight: n ? "bold" : void 0,
                textTransform: r ? "uppercase" : "none",
                color: o,
                background: a,
                paddingLeft: s,
                paddingRight: l,
                paddingTop: u,
                paddingBottom: c,
                ...p || a ? {
                    ...p ? {
                        borderStyle: `${d}`,
                        borderWidth: `${h}px`
                    } : {},
                    borderRadius: `${f}%`
                } : {}
            }
        }, e)), "above" === g && lt.createElement(dg, {
            height: v
        }))
    }
    const Nw = lt.createContext("spacing");
    function Bw({placeholderKey: e, placeholderCellKey: t}) {
        const [n, r] = ce(Nw);
        return lt.createElement(Kc, {
            handleHeight: !0,
            onResize: (i, o) => {
                const a = [...(n[e] || []).filter((e => e.id !== t)), {
                    id: t,
                    height: o
                }];
                r({
                    ...n,
                    [e]: a
                })
            }
        })
    }
    function Fw({placeholderKey: e, placeholderCellKey: t, outerTextId: n, config: r, price: i, name: o}) {
        const a = function(e) {
            const [t] = ce(Nw),
                n = t[e];
            if (Array.isArray(n))
                return Math.max(...n.map((e => e.height)))
        }(e);
        if ("placeholder" === n)
            return lt.createElement("div", {
                style: {
                    height: a
                }
            });
        const s = r[n],
            {text: l} = s;
        return lt.createElement("div", {
            style: {
                height: a
            }
        }, lt.createElement(xm, {
            container: !0,
            style: {
                height: "100%"
            },
            alignItems: "center"
        }, lt.createElement(xm, {
            item: !0
        }, lt.createElement(Bw, {
            placeholderKey: e,
            placeholderCellKey: t
        }), lt.createElement(Dw, {
            text: Aw(l, i, o),
            config: s
        }))))
    }
    function Ww({hide: e, title: t, selectedOptionName: n, config: r}) {
        const {textAlign: i, displaySelectedOptionValue: o, enabled: a, text: s} = r,
            l = Pw(r),
            u = le((() => l || "center" === i ? {
                justify: "center"
            } : "right" === i ? {
                direction: "row-reverse"
            } : {
                direction: "row"
            }), [l, i]),
            c = le((() => {
                let e;
                return e = s ? Aw(s, null, t) : t, lt.createElement(lt.Fragment, null, e, o && lt.createElement(lt.Fragment, null, ": ", lt.createElement("span", {
                    className: "rio-product-option-title-option-value"
                }, n)))
            }), [o, n, s, t]);
        return !a || e ? null : lt.createElement(xm, Ga({
            container: !0
        }, u), lt.createElement(xm, {
            item: !0
        }, lt.createElement(Dw, {
            text: c,
            config: r
        })))
    }
    function Hw({type: e, buttonType: t, buttonWidth: n, backgroundType: r, backgroundImage: i, size: o, color1: a, color2: s, color3: l, color4: u}) {
        return le((() => {
            if ("button" === e)
                return;
            const c = "fit-text" === t ? n : o;
            if (0 === c)
                return;
            if (!i && "swatch" === e && "one-solid" !== r) {
                return `url('data:image/svg+xml;utf8,${encodeURIComponent(function({id: e, size: t, color1: n, color2: r, color3: i, color4: o}) {const a = Mw[e];return ("string" == typeof a ? a : Mw["one-solid"]).replace(/%SIZE%/g, `${t}px`).replace(/%COLOR1%/g, n).replace(/%COLOR2%/g, r).replace(/%COLOR3%/g, i).replace(/%COLOR4%/g, o)}({id: r,size: c,color1: a,color2: s,color3: l,color4: u}))}')`
            }
            const d = Fh() * c;
            return i ? `url(${Bh(i.url)(d, d)})` : void 0
        }), [e, t, n, o, i, r, a, s, l, u])
    }
    function jw({backgroundImage: e, size: t, borderRadius: n, borderDouble: r, borderDoubleThickness: i, borderDoubleColor: o}) {
        const a = le((() => `rio-button-icon-border-double-${Sd.v4()}`), []),
            s = Math.ceil(Fh() * t),
            l = Bh(e.url)(s, s);
        return lt.createElement("div", {
            className: r ? a : void 0,
            style: {
                width: t,
                height: t,
                backgroundImage: `url(${l})`,
                backgroundSize: "cover",
                borderRadius: `${n}%`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "relative"
            }
        }, r && lt.createElement("style", null, `\n            .${a}:before {\n              content: "";\n              border: ${i}px solid ${o};\n              border-radius: ${n}%;\n              display: block;\n              position: absolute;\n              top: -1px;\n              left: -1px;\n              width: ${t + 2}px;\n              height: ${t + 2}px;\n            }\n          `))
    }
    function $w({id: e, outOfStockStyle: t, available: n, selected: r, onChange: i, values: o}) {
        ie((() => {
            if ("hide" !== t)
                return;
            if (n[r])
                return;
            let a = r,
                s = r,
                l = !1;
            for (; l ? a += 1 : s -= 1, !(s < 0 && a > o.length - 1);) {
                const e = l ? a : s;
                if (e >= 0 && e <= o.length - 1 && n[e]) {
                    l = e;
                    break
                }
                l = !l
            }
            "number" == typeof l && i(e, o[l].id)
        }), [n, e, i, t, r, o])
    }
    function Vw({index: e, position: t, outerTextIndex: n, outerTextId: r, config: i, price: o, name: a}) {
        if (!r)
            return null;
        const s = `${t}-${n}`,
            l = `${e}-${n}`;
        return lt.createElement(Fw, {
            placeholderKey: s,
            placeholderCellKey: l,
            outerTextId: r,
            config: i,
            price: o,
            name: a
        })
    }
    function qw({value: e, index: t, size: n, type: r, buttonType: i, border: o, borderThickness: a, borderRadius: s, borderRadiusPx: l, borderSelectedColor: u, borderUnselectedColor: c, borderHoverColor: d, borderOutOfStockCrossOutColor: p, borderDouble: f, borderDoubleColor: h, borderDoubleThickness: m, outOfStock: v, selected: g, available: y, setSelected: b, hovering: w, setHovering: x, price: _, outerTextMatrices: C, selectedConfig: E, unselectedConfig: S, horizontalCarousel: k, onNavigationScrolled: T, initialScroll: O}) {
        const {id: M, name: R, config: P, config: {backgroundImage: A, backgroundColor: I, backgroundColor2: z, backgroundColor3: L, backgroundColor4: D, selectedBackgroundColor: N, backgroundType: B, backgroundPosition: F, backgroundSize: W, backgroundSizePx: H, backgroundBorderRadius: j, text: $, textPadding: V}} = e,
            [q, U] = ne({
                width: 0,
                height: 0
            }),
            {width: G, height: Z} = q,
            K = Hw({
                type: r,
                buttonType: i,
                buttonWidth: G,
                backgroundType: B,
                backgroundImage: A,
                size: n,
                color1: I,
                color2: z,
                color3: L,
                color4: D
            }),
            Y = le((() => "swatch" === r && "one-solid" === B && null !== N ? N : null), [B, N, r]),
            X = le((() => t === g), [t, g]),
            J = ue((e => "button" === r ? (X ? E : S)[e] : P[e]), [r, P, X, E, S]),
            Q = le((() => "button" === r ? "fit-text" : i), [i, r]),
            ee = le((() => J("backgroundColor")), [J]),
            te = le((() => J("textColor")), [J]),
            re = le((() => J("textSize")), [J]),
            oe = le((() => J("textBold")), [J]),
            ae = le((() => J("textUppercase")), [J]),
            se = le((() => "button" === r ? e.name : $), [$, r, e.name]),
            ce = le((() => {
                if ("swatch" === r && "fit-text" === Q || "button" === r) {
                    const [e, t, n, r] = V;
                    return {
                        paddingLeft: e,
                        paddingRight: t,
                        paddingTop: n,
                        paddingBottom: r
                    }
                }
                return {}
            }), [Q, V, r]),
            de = le((() => `rio-swatch-unavailable-${Sd.v4()}`), []),
            pe = le((() => `rio-swatch-border-double-${Sd.v4()}`), []),
            [fe, he] = ne({
                length: 0,
                radians: 0
            }),
            me = function({size: e, fitText: t}) {
                return t ? 62 === e ? "medium" : 102 === e ? "large" : "small" : e
            }({
                size: n,
                fitText: "button" === r || "fit-text" === Q
            }),
            [ve, ge] = C,
            ye = "button" === r && A ? lt.createElement(jw, {
                backgroundImage: A,
                borderRadius: j,
                size: H,
                borderDouble: f,
                borderDoubleThickness: m,
                borderDoubleColor: h
            }) : null,
            be = le((() => sr({
                overrides: {
                    MuiButton: {
                        label: ce
                    }
                }
            })), [ce]),
            we = function(e, t, n, r, i) {
                if ("swatch" === e) {
                    if ("circular" === t)
                        return "50%";
                    if ("round" === n)
                        return `${r}%`
                }
                if ("button" === e)
                    return `${i}px`
            }(r, Q, o, s, l);
        ie((() => {
            const e = G,
                t = Z,
                n = Math.sqrt(e ** 2 + t ** 2),
                r = Math.PI / 2 - Math.atan(e / t);
            he({
                length: n,
                radians: r
            })
        }), [a, Z, G]);
        const xe = "button" === r || "swatch" === r && "fit-text" === Q ? "1.0" : "0.9",
            _e = ue((e => {
                const t = O.current ? 0 : 100;
                O.current = !1, e && window.requestAnimationFrame((() => {th(e, {
                        time: t,
                        lockX: !1,
                        lockY: !0,
                        validTarget: e => !(!e || "function" != typeof e.matches || !e.matches(".rio-hide-scrollbar"))
                    }, (() => {T()}))}))
            }), [T]),
            Ce = lt.createElement(xm, {
                container: !0,
                direction: "column",
                alignItems: "center"
            }, ve[t].map(((e, n) => lt.createElement(Vw, {
                index: t,
                position: "above",
                key: n,
                outerTextIndex: n,
                outerTextId: e,
                config: P,
                price: _,
                name: R
            }))), lt.createElement("div", null, "cross-out" === v.style && lt.createElement(lt.Fragment, null, lt.createElement("style", null, `\n                .${de} {\n                  opacity: 0.6;\n                }\n                .${de}::after {\n                  content: "";\n                  position: absolute;\n                  transform-origin: 0 0;\n                  top: 50%;\n                  left: 50%;\n                  width: ${fe.length}px;\n                  transform: rotate(${fe.radians}rad) scale(${xe}) translate(-50%, -50%);\n                  border-top: ${a + .5}px solid ${p};\n                }\n            `)), "fade-out" === v.style && lt.createElement("style", null, `\n              .${de} {\n                opacity: 0.6;\n              }     \n            `), "swatch" === r && f && lt.createElement("style", null, `\n            .${pe}:before {\n              content: "";\n              border: ${m}px solid ${h};\n              ${we ? `border-radius: ${we};` : ""}\n              display: block;\n              position: absolute;\n              top: -1;\n              width: -1;\n              width: calc(100% + 2px);\n              height: calc(100% + 2px);\n            }\n          `), lt.createElement(Kc, {
                handleWidth: !0,
                handleHeight: !0,
                onResize: (e, t) => {U({
                        width: e,
                        height: t
                    })}
            }), lt.createElement(Ta, {
                theme: be
            }, lt.createElement(fg, {
                component: "div",
                role: "none",
                ref: k && t === g ? _e : void 0,
                onClick: () => {b(M)},
                onMouseOver: () => {x(t)},
                onMouseOut: () => {x(-1)},
                className: fa(y ? void 0 : de, pe),
                size: "string" == typeof me ? me : void 0,
                startIcon: "left" === F ? ye : void 0,
                endIcon: "right" === F ? ye : void 0,
                style: {
                    position: "relative",
                    backgroundColor: Y && t === g ? Y : ee,
                    backgroundImage: K,
                    backgroundSize: A ? 100 === W ? "cover" : `${W}% auto` : void 0,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    ..."number" == typeof me ? {
                        minWidth: me,
                        width: me,
                        height: me
                    } : {},
                    outline: "none",
                    boxSizing: "border-box",
                    border: "solid",
                    borderWidth: `${a}px`,
                    borderRadius: we,
                    borderColor: Iw({
                        selected: t === g,
                        hovering: t === w,
                        borderSelectedColor: u,
                        borderUnselectedColor: c,
                        borderHoverColor: d
                    })
                }
            }, lt.createElement("span", {
                style: {
                    fontSize: re,
                    color: te,
                    fontWeight: oe ? "bold" : "normal",
                    textTransform: ae ? "uppercase" : "none"
                }
            }, !!se && Aw(se, _, R), !se && " ")))), ge[t].map(((e, n) => lt.createElement(Vw, {
                index: t,
                position: "below",
                key: n,
                outerTextIndex: n,
                outerTextId: e,
                config: P,
                price: _,
                name: R
            }))));
        return lt.createElement(xm, {
            key: M,
            item: !0
        }, lt.createElement(Lw, {
            outOfStockTooltip: v.tooltip,
            available: y,
            value: e,
            name: R,
            price: _
        }, Ce))
    }
    const Uw = Ra((e => ({
        inputLabel: {
            marginBottom: e.spacing(.5)
        },
        helperText: {
            marginTop: e.spacing(.5)
        },
        items: {
            padding: e.spacing(.5)
        },
        navigationRoot: {
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            width: "41px",
            height: "41px",
            margin: "auto",
            bottom: 0,
            top: 0,
            zIndex: 1,
            position: "absolute",
            "&:hover": {
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                "@media (hover: none)": {
                    backgroundColor: "rgba(0, 0, 0, 0.5)"
                }
            }
        }
    })));
    function Gw({children: e, option: t, selected: n}) {
        const {name: r, config: {type: i, horizontalCarousel: o, centered: a, title: s, select: {fullWidth: l}}, values: u} = t,
            c = le((() => "select" !== i ? a && !o ? "center" : void 0 : a ? "center" : void 0), [a, o, i]),
            d = le((() => "select" !== i ? o ? void 0 : "fit-content" : l ? void 0 : "fit-content"), [o, l, i]),
            p = le((() => ({
                title: r,
                config: s,
                selectedOptionName: u[n].name
            })), [r, n, s, u]),
            f = ne({});
        return lt.createElement(Nw.Provider, {
            value: f
        }, lt.createElement(xm, {
            item: !0,
            container: !0,
            justify: c
        }, lt.createElement(xm, {
            container: !0,
            wrap: "nowrap",
            direction: "column",
            style: {
                position: "relative"
            },
            className: "fit-content" === d ? "rio-width-fit-content" : void 0
        }, lt.createElement(Ww, Ga({
            hide: "above" !== s.position[0]
        }, p)), e, lt.createElement(Ww, Ga({
            hide: "below" !== s.position[0]
        }, p)))))
    }
    function Zw({option: e, onChange: t, selected: n, available: r, prices: i}) {
        const {id: o, values: a, config: {size: s, spacing: l, centered: u, horizontalCarousel: c, type: d, buttonType: p, border: f, borderThickness: h, borderRadius: m, borderRadiusPx: v, borderSelectedColor: g, borderUnselectedColor: y, borderHoverColor: b, borderOutOfStockCrossOutColor: w, borderDouble: x, borderDoubleColor: _, borderDoubleThickness: C, outOfStock: E, selected: S, unselected: k}} = e,
            T = Uw(),
            [O, M] = ne(-1),
            R = ue((e => {t(o, e)}), [o, t]);
        $w({
            id: o,
            outOfStockStyle: E.style,
            available: r,
            selected: n,
            onChange: t,
            values: a
        });
        const P = le((() => ["above", "below"].map((e => function({position: e, optionValues: t}) {
                const n = t.map((t => Tw.map((n => {
                    const [r, i] = kw(n, t.config, e);
                    return {
                        enabled: r,
                        id: n,
                        priority: i
                    }
                })).sort(Wh("priority")).map((({enabled: e, id: t}) => e ? t : null))));
                if (n.length > 0)
                    for (let e = 0; e < n[0].length; e += 1) {
                        let t = !0;
                        for (let r = 0; r < n.length; r += 1)
                            n[r][e] && (t = !1);
                        if (!t)
                            for (let t = 0; t < n.length; t += 1)
                                n[t][e] || (n[t][e] = "placeholder")
                    }
                return n
            }({
                position: e,
                optionValues: a
            })))), [a]),
            A = ae(null),
            [I, z] = ne(!1),
            [L, D] = ne(!1),
            N = ae(!0),
            B = ue((() => {
                if (!c)
                    return;
                const e = A.current;
                if (e) {
                    const t = Hh(e, !1);
                    D(!t.start), z(!t.end)
                }
            }), [c]),
            F = a.map(((e, t) => {
                const {id: o} = e;
                return ["hide" === E.style && !r[t], o, lt.createElement(qw, {
                    value: e,
                    values: a,
                    type: d,
                    buttonType: p,
                    size: s,
                    index: t,
                    available: r[t],
                    price: i[t],
                    border: f,
                    borderThickness: h,
                    borderRadius: m,
                    borderRadiusPx: v,
                    borderSelectedColor: g,
                    borderUnselectedColor: y,
                    borderHoverColor: b,
                    borderOutOfStockCrossOutColor: w,
                    borderDouble: x,
                    borderDoubleColor: _,
                    borderDoubleThickness: C,
                    outOfStock: E,
                    selected: n,
                    setSelected: R,
                    hovering: O,
                    setHovering: M,
                    outerTextMatrices: P,
                    selectedConfig: S,
                    unselectedConfig: k,
                    horizontalCarousel: c,
                    onNavigationScrolled: B,
                    initialScroll: N
                })]
            })),
            W = !F.find((([e]) => !e)),
            H = Pa(),
            j = H.spacing(1),
            $ = H.spacing(l);
        return lt.createElement(Gw, {
            option: e,
            selected: n
        }, !W && lt.createElement(lt.Fragment, null, c && lt.createElement(Kc, {
            handleWidth: !0,
            refreshMode: "debounce",
            refreshRate: 250,
            onResize: () => {B()}
        }), c && L && lt.createElement(Hu, {
            component: "div",
            role: "none",
            size: "small",
            classes: {
                root: T.navigationRoot
            },
            onClick: async () => {
                const e = await jh(A.current, !1, -1);
                D(!e.start), z(!e.end)
            },
            style: {
                left: 0
            }
        }, lt.createElement(ud, {
            fontSize: "large"
        })), lt.createElement(xm, {
            ref: A,
            item: !0,
            container: !0,
            direction: "row",
            wrap: c ? "nowrap" : void 0,
            justify: !c && u ? "center" : void 0,
            style: {
                overflowX: "auto",
                alignItems: "center"
            },
            spacing: c ? void 0 : l,
            className: fa("rio-hide-scrollbar", T.items, !c && "rio-width-fit-content")
        }, F.map((([e, t, n], r, i) => e ? lt.createElement(lt.Fragment, {
            key: t
        }) : lt.createElement(xm, {
            item: !0,
            key: t,
            style: {
                paddingRight: c ? r !== i.length - 1 ? $ : j : void 0
            }
        }, n))), c && I && lt.createElement(Hu, {
            component: "div",
            role: "none",
            size: "small",
            classes: {
                root: T.navigationRoot
            },
            onClick: async () => {
                const e = await jh(A.current, !1, 1);
                D(!e.start), z(!e.end)
            },
            style: {
                right: 0
            }
        }, lt.createElement(hd, {
            fontSize: "large"
        })))), W && lt.createElement(xm, {
            item: !0,
            container: !0,
            justify: "center"
        }, lt.createElement(vg, null, "None available")))
    }
    function Kw({option: e, selected: t, setSelected: n, available: r}) {
        const {values: i, config: {select: {backgroundColor: o, textColor: a, textSize: s, textBold: l, textUppercase: u, fullWidth: c, darkMenu: d, variant: p, outerText: f, minWidth: h}, outOfStock: {style: m}, borderUnselectedColor: v, borderSelectedColor: g, borderHoverColor: y, borderThickness: b, borderRadiusPx: w, borderDouble: x, borderDoubleThickness: _, borderDoubleColor: C}} = e,
            E = ue((e => Tw.map((t => {
                const [n, r] = kw(t, f, e);
                return {
                    id: t,
                    priority: r,
                    enabled: n
                }
            })).sort(Wh("priority")).filter((e => e.enabled)).map((e => e.id))), [f]),
            S = le((() => E("above")), [E]),
            k = le((() => E("below")), [E]),
            T = ue((e => {
                if (!r[e] && "none" !== m) {
                    if ("cross-out" === m)
                        return {
                            textDecoration: "line-through"
                        };
                    if ("fade-out" === m)
                        return {
                            opacity: .5
                        }
                }
                return {}
            }), [r, m]),
            O = le((() => {
                const e = {
                        root: {
                            "& $notchedOutline": {
                                borderColor: v,
                                borderWidth: b
                            },
                            "&:hover $notchedOutline": {
                                borderColor: y,
                                borderWidth: b
                            },
                            "&$focused $notchedOutline": {
                                borderColor: g,
                                borderWidth: b
                            }
                        }
                    },
                    t = {
                        underline: {
                            "&::before": {
                                borderBottom: `${b}px solid ${v}`
                            },
                            "&::after": {
                                borderBottom: `${b}px solid ${g}`
                            },
                            "&:hover:not($disabled):not($error):not($focused):before": {
                                borderBottom: `${b}px solid ${y}`
                            }
                        }
                    },
                    n = {
                        root: {
                            "&:focus": {
                                backgroundColor: "transparent !important"
                            }
                        },
                        icon: {
                            color: a
                        }
                    };
                return sr({
                    palette: {
                        type: d ? "dark" : "light"
                    },
                    overrides: {
                        MuiOutlinedInput: e,
                        MuiInput: t,
                        MuiSelect: n,
                        PwzrOutlinedInput: e,
                        PwzrInput: t,
                        PwzrSelect: n
                    }
                })
            }), [y, g, b, v, d, a]),
            M = i.map(((e, t) => {
                if (!r[t] && "hide" === m)
                    return [!0, lt.createElement(lt.Fragment, {
                        key: e.id
                    })];
                const {config: {backgroundImage: n, backgroundSizePx: i, backgroundBorderRadius: o, backgroundPosition: a}} = e,
                    s = n ? lt.createElement(jw, {
                        backgroundImage: n,
                        borderRadius: o,
                        size: i,
                        borderDouble: x,
                        borderDoubleThickness: _,
                        borderDoubleColor: C
                    }) : null;
                return [!1, lt.createElement(Sg, {
                    key: e.id,
                    value: t,
                    style: T(t)
                }, lt.createElement(xm, {
                    container: !0,
                    direction: "row",
                    wrap: "nowrap",
                    alignItems: "center"
                }, s && "left" === a && lt.createElement(lt.Fragment, null, s, lt.createElement(dg, {
                    mr: 1
                })), lt.createElement("span", null, e.name), s && "right" === a && lt.createElement(lt.Fragment, null, lt.createElement(dg, {
                    ml: 1
                }), s))), r[t]]
            }));
        return !M.find((([e]) => !e)) ? lt.createElement(xm, {
            item: !0,
            container: !0,
            justify: "center"
        }, lt.createElement(vg, null, "None available")) : lt.createElement(xm, {
            item: !0,
            container: !0,
            direction: "column",
            alignItems: "center"
        }, S.map(((e, t) => lt.createElement(Vw, {
            index: 0,
            position: "above",
            key: t,
            outerTextIndex: t,
            outerTextId: e,
            config: f
        }))), lt.createElement(Ta, {
            theme: O
        }, lt.createElement(Uy, {
            variant: p,
            value: t,
            fullWidth: c,
            onChange: e => {
                const t = i[e.target.value];
                n(t.id)
            },
            style: {
                backgroundColor: o,
                fontWeight: l ? "bold" : "normal",
                textTransform: u ? "uppercase" : "none",
                textDecoration: M[t][2] ? void 0 : "line-through",
                color: a,
                fontSize: `${s}px`,
                marginTop: 5,
                marginLeft: 5,
                marginBottom: 5,
                minWidth: c ? void 0 : h,
                borderRadius: w
            }
        }, M.map((([, e]) => e)))), k.map(((e, t) => lt.createElement(Vw, {
            index: 0,
            position: "below",
            key: t,
            outerTextIndex: t,
            outerTextId: e,
            config: f
        }))))
    }
    function Yw({option: e, selected: t, onChange: n, available: r}) {
        const {id: i, values: o, config: {outOfStock: {style: a}}} = e,
            s = ue((e => {n(i, e)}), [i, n]);
        return $w({
            id: i,
            outOfStockStyle: a,
            available: r,
            selected: t,
            onChange: n,
            values: o
        }), lt.createElement(Gw, {
            option: e,
            selected: t
        }, lt.createElement(Kw, {
            option: e,
            selected: t,
            setSelected: s,
            available: r
        }))
    }
    function Xw({option: e, variant: t, onChange: n, selected: r, available: i, prices: o}) {
        return "select" !== e.config.type ? lt.createElement(Zw, {
            option: e,
            variant: t,
            onChange: n,
            selected: r,
            available: i,
            prices: o
        }) : lt.createElement(Yw, {
            option: e,
            variant: t,
            onChange: n,
            selected: r,
            available: i,
            prices: o
        })
    }
    function Jw({option: e}) {
        const {assets: t} = ce(Rw),
            n = ue((e => ((e, t) => {
                if (!Array.isArray(e) || "string" != typeof t)
                    return null;
                return e.find((e => e.id === t)) || null
            })(t, e)), [t]),
            r = Pw(e.config);
        return le((() => ({
            ...e,
            config: {
                ...e.config,
                centered: r
            },
            values: e.values.map((e => {
                const {config: {backgroundImage: t}} = e;
                if ("object" == typeof t && null !== t) {
                    const r = n(t.id);
                    return r && "string" == typeof r.url ? {
                        ...e,
                        config: {
                            ...e.config,
                            backgroundImage: {
                                ...e.config.backgroundImage,
                                url: r.url
                            }
                        }
                    } : {
                        ...e,
                        config: {
                            ...e.config,
                            backgroundImage: null
                        }
                    }
                }
                return e
            }))
        })), [r, n, e])
    }
    function Qw({option: e, index: t}) {
        const {selections: n, onChange: r} = ce(Ow),
            i = Jw({
                option: e
            });
        return lt.createElement(lt.Fragment, {
            key: i.id
        }, lt.createElement(Xw, {
            option: i,
            selected: n[t].index,
            available: n[t].available,
            prices: n[t].prices,
            onChange: r
        }))
    }
    const ex = Ra((() => ({
        editContainer: {
            width: "80px",
            marginTop: "24px"
        },
        optionContainer: {
            width: "calc(100% - 80px)"
        },
        edit: {
            backgroundColor: "rgba(94, 109, 191)",
            color: "white",
            "&:hover": {
                backgroundColor: "rgba(94, 109, 191, 0.9)",
                boxShadow: "unset"
            }
        }
    })));
    function tx({editable: e, options: t, optionsToHide: n, spacing: r=1, setEditOption: i}) {
        const o = ex();
        return e ? lt.createElement(xm, {
            container: !0,
            direction: "column"
        }, t.map(((e, n) => lt.createElement(lt.Fragment, {
            key: e.id
        }, lt.createElement(xm, {
            item: !0,
            container: !0,
            direction: "row"
        }, lt.createElement(xm, {
            item: !0,
            container: !0,
            className: o.editContainer,
            alignItems: "center"
        }, lt.createElement(xm, {
            item: !0
        }, lt.createElement(xm, {
            container: !0,
            direction: "column",
            alignItems: "center"
        }, lt.createElement(xm, {
            item: !0
        }, lt.createElement(Hu, {
            onClick: () => {i(e)},
            className: o.edit
        }, lt.createElement(fw, {
            color: "inherit"
        }))), lt.createElement(xm, {
            item: !0
        }, lt.createElement(yg, {
            component: "button",
            variant: "body1",
            onClick: () => {i(e)}
        }, "Edit"))))), lt.createElement(xm, {
            item: !0,
            className: o.optionContainer
        }, lt.createElement(Qw, {
            option: e,
            index: n
        }))), n !== t.length - 1 && lt.createElement(dg, {
            mb: r
        }))))) : lt.createElement(xm, {
            container: !0,
            direction: "column"
        }, t.map(((e, t) => !!n.find((t => t === e.id)) ? lt.createElement(lt.Fragment, {
            key: e.id
        }) : lt.createElement(lt.Fragment, {
            key: e.id
        }, lt.createElement(xm, {
            item: !0,
            container: !0
        }, lt.createElement(Qw, {
            option: e,
            index: t
        })), lt.createElement(dg, {
            mb: r
        })))))
    }
    function nx(e, t) {
        return e.find((e => {
            if (e.options.length !== t.length)
                return !1;
            for (const n of e.options)
                if (!t.find((e => e.id === n.id && e.value === n.value)))
                    return !1;
            return !0
        }))
    }
    function rx(e, t) {
        const n = t.find((t => t.id === e.id));
        if (n) {
            const t = e.values.findIndex((e => e.id === n.value));
            if (t > -1)
                return t
        }
        return 0
    }
    function ix({variants: e, options: t, settings: n, initialSelectedVariantId: r, editable: i=!1, optionsToHide: o=[], onChange: a=(() => {}), selectionType: s="default", setEditOption: l}) {
        const [u, c] = ne(function(e, t) {
                if ("string" == typeof t) {
                    const n = e.find((e => `${e.id}` === t));
                    if (n)
                        return n.options
                }
                return (e.find((e => e.available)) || e[0]).options
            }(e, r)),
            d = le((() => function(e, t, n, r) {
                return t.map((t => {
                    const i = n.filter((e => e.id !== t.id)),
                        o = t.values.map((e => [{
                            id: t.id,
                            value: e.id
                        }, ...i])).map((t => {
                            const n = nx(e, t);
                            return "default" === r ? n || {
                                available: !1,
                                price: 0
                            } : {
                                price: 0,
                                ...n || {},
                                available: "always-available" === r
                            }
                        }));
                    return {
                        id: t.id,
                        index: rx(t, n),
                        available: o.map((e => e.available)),
                        prices: o.map((e => e.price))
                    }
                }))
            }(e, t, u, s)), [s, u, t, e]),
            p = ue(((t, n) => {
                const r = [...u],
                    i = r.findIndex((e => e.id === t));
                i > -1 && (r[i] = {
                    id: t,
                    value: n
                }), c(r), a(r, nx(e, r))
            }), [u, a, e]),
            f = le((() => ({
                onChange: p,
                selections: d,
                editable: i
            })), [i, p, d]);
        return lt.createElement(Ow.Provider, {
            value: f
        }, lt.createElement(tx, {
            options: t,
            editable: i,
            optionsToHide: o,
            spacing: n.spacing,
            setEditOption: l
        }))
    }
    var ox = {};
    const ax = () => {throw new Error("Must be server!")},
        sx = [{
            id: "none",
            name: "None",
            static: !0
        }, {
            id: "partner",
            name: "Partner",
            static: !0
        }, {
            id: "free",
            name: "Free",
            static: !1
        }, {
            id: "starter",
            name: "Starter",
            price: 4.99,
            static: !1
        }, {
            id: "starter",
            name: "Starter",
            price: 3.99,
            static: !1
        }, {
            id: "pro",
            name: "Pro",
            price: 7.99,
            static: !1
        }, {
            id: "pro",
            name: "Pro",
            price: 6.99,
            static: !1
        }],
        lx = (e, t=!0) => {
            const n = sx.find((n => !(!t && n.static) && n.id === e));
            if (!n)
                throw Error(`unknown plan id ${e}`);
            return n
        },
        ux = e => "none-stacked" === e || ("none-stacked-two-columns" === e || "none-stacked-two-columns-main" === e);
    ox = {
        getServerPort: ax,
        getServerEndpoint: () => `http://localhost:${ax()}`,
        getSubscriptionPlanByPrice: e => {
            const t = sx.find((t => `${t.price}` === e));
            if (!t)
                throw Error(`unknown plan price ${e}`);
            return t
        },
        getSubscriptionPlanById: lx,
        delay: e => new Promise((t => setTimeout(t, e))),
        getSubscriptionPlansById: e => sx.filter((t => t.id === e)),
        getSubscriptionPaidPlans: () => [lx("starter"), lx("pro")],
        buildVariantImagesConfig: ({templateConfig: e, customTheme: t, themeSettings: n, settings: {general: r, desktop: i, mobile: o}, logError: a}) => {
            const s = JSON.stringify(e);
            let l = JSON.parse(s);
            const u = (e, t) => {
                const r = l[t],
                    {thumbnails: {desktop: {horizontal: i, vertical: o}, mobile: {horizontal: a, vertical: s}}} = n,
                    u = () => "bottom" === e.thumbnails ? "carousel" === e.thumbnailsNavigation ? {
                        multiRow: !1,
                        navigation: !0
                    } : {
                        multiRow: !0,
                        navigation: !1
                    } : "carousel" === e.thumbnailsNavigation ? {
                        verticalOverflow: !0,
                        navigation: !0
                    } : {
                        verticalOverflow: !1,
                        navigation: !1
                    },
                    c = "desktop" === t ? i : a,
                    d = "desktop" === t ? o : s;
                if (r.swipe = !0, delete r.vertical, delete r.verticalSpacing, delete r.verticalType, "none" === e.thumbnails)
                    r.thumbnails = !1, r.pagination = !0, r.navigation = !1;
                else if ("none-with-navigation" === e.thumbnails)
                    r.thumbnails = !1, r.pagination = !0, r.navigation = !0;
                else if ("bottom" === e.thumbnails) {
                    const e = {
                        ...c,
                        orientation: "bottom",
                        ...u()
                    };
                    r.thumbnails = e, r.pagination = !1, r.navigation = !1
                } else if ("left" === e.thumbnails) {
                    const e = {
                        ...d,
                        orientation: "left",
                        ...u()
                    };
                    r.thumbnails = e, r.pagination = !1, r.navigation = !1
                } else if ("right" === e.thumbnails) {
                    const e = {
                        ...d,
                        orientation: "right",
                        ...u()
                    };
                    r.thumbnails = e, r.pagination = !1, r.navigation = !1
                } else
                    ux(e.thumbnails) && (r.thumbnails = !1, r.pagination = !1, r.navigation = !1, r.vertical = !0, r.verticalSpacing = "15px", "none-stacked-two-columns" === e.thumbnails ? r.verticalType = "two-columns" : "none-stacked-two-columns-main" === e.thumbnails ? r.verticalType = "two-columns-main" : r.verticalType = void 0)
            };
            if (!t)
                try {
                    u(i, "desktop"), u(o, "mobile")
                } catch (e) {
                    l = JSON.parse(s), a(e)
                }
            return l.desktop.lightBox = !!i.lightBox, l.desktop.lightBox && (l.desktop.lightBoxZoom = (null == i ? void 0 : i.zoomAmount) || 2), l.desktop.magnify = !!i.magnify && {
                width: "full",
                height: "full",
                zoom: (null == i ? void 0 : i.zoomAmount) || 2
            }, ux(i.thumbnails) && (l.desktop.magnify = !1), l.mobile.lightBox = !!o.lightBox, l.mobile.lightBox && (l.mobile.lightBoxZoom = (null == o ? void 0 : o.zoomAmount) || 2), l.mobile.magnify = !!o.magnify && {
                width: "full",
                height: "full",
                zoom: (null == o ? void 0 : o.zoomAmount) || 2
            }, ux(o.thumbnails) && (l.mobile.magnify = !1), r && (l.lightBoxBackgroundColor = r.lightBoxBackgroundColor, l.thumbnailSelectionColor = r.thumbnailSelectionColor), l
        },
        isStackedProductGallery: ux,
        decompressAssets: function(e) {
            const t = e.filter((e => !!e.urlBase)),
                n = e.filter((e => !!e.themeIdBase));
            if (t.length < 1 && n.length < 1)
                return e;
            const r = t.map(((e, t) => [`{${t}}`, e.url])),
                i = n.map(((e, t) => [`{${t}}`, e.id])),
                o = e.filter((e => !e.urlBase && !e.themeIdBase)),
                a = [];
            for (const e of o) {
                let t = e.url;
                if ("string" == typeof t) {
                    for (const [e, n] of r)
                        t = t.replace(e, n);
                    t = t.replace("{i}", e.id)
                }
                let n = e.themeId;
                if ("string" == typeof n)
                    for (const [e, t] of i)
                        n = n.replace(e, t);
                a.push({
                    ...e,
                    ...void 0 !== t ? {
                        url: t
                    } : {},
                    ...void 0 !== n ? {
                        themeId: n
                    } : {}
                })
            }
            return a
        }
    };
    const cx = ({config: e}) => {
        const {product: t, options: n, onChange: r, initialSelectedVariantId: i, settings: o} = e,
            [a, s] = ne(Sd.v4());
        console.log(`Rio-options render key: ${a}`), e.forceUpdate = ue((() => {s(Sd.v4())}), []);
        const l = le((() => function(e, t) {
                const n = Array.isArray(t) ? t : [];
                return {
                    options: e.options.map((e => {
                        const {name: t, name: r, values: i} = e,
                            o = n.findIndex((e => e.id === r)),
                            a = o > -1 ? n[o] : void 0;
                        return {
                            id: r,
                            name: t,
                            values: Ew(i, a ? a.values : null),
                            config: vw({
                                type: "button",
                                buttonType: "square",
                                size: 48,
                                spacing: 1,
                                horizontalCarousel: !1,
                                centered: !1,
                                title: {
                                    enabled: !0,
                                    useThemeSettings: !0,
                                    displaySelectedOptionValue: !1,
                                    text: null,
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: gw("swatch-title-text-color"),
                                    textSize: yw("swatch-title-text-size"),
                                    textPadding: bw("swatch-title-text-padding"),
                                    textAlign: "left",
                                    backgroundColor: null,
                                    borderColor: gw("swatch-title-border-color"),
                                    borderStyle: "solid",
                                    borderThickness: xw("swatch-title-border-thickness"),
                                    borderRadius: _w("swatch-title-border-radius"),
                                    position: ["above"],
                                    margin: ww("swatch-title-margin")
                                },
                                border: "round",
                                borderStyle: "solid",
                                borderThickness: xw("border-thickness"),
                                borderRadius: _w("border-radius"),
                                borderRadiusPx: _w("border-radius-px"),
                                borderSelectedColor: gw("border-colors-selected"),
                                borderUnselectedColor: gw("border-colors-unselected"),
                                borderHoverColor: gw("border-colors-hovering"),
                                borderOutOfStockCrossOutColor: gw("border-colors-outOfStockCrossOut"),
                                borderDouble: !1,
                                borderDoubleColor: gw("border-colors-double"),
                                borderDoubleThickness: xw("border-thickness-double"),
                                outOfStock: {
                                    style: "cross-out",
                                    tooltip: !1
                                },
                                unselected: {
                                    backgroundColor: gw("unselected-background-color"),
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: gw("unselected-text-color"),
                                    textSize: yw("unselected-text-size")
                                },
                                selected: {
                                    backgroundColor: gw("selected-background-color"),
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: gw("selected-text-color"),
                                    textSize: yw("selected-text-size")
                                },
                                select: {
                                    variant: "outlined",
                                    minWidth: 120,
                                    fullWidth: !1,
                                    darkMenu: !1,
                                    textSize: yw("select-text-size"),
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: gw("select-text-color"),
                                    backgroundColor: gw("select-background-color"),
                                    outerText: Cw()
                                }
                            }, a ? a.config : {})
                        }
                    })),
                    variants: Array.isArray(e.variants) ? e.variants.map((t => ({
                        id: t.id,
                        title: t.title,
                        price: t.price,
                        available: t.available,
                        options: Sw(e, t)
                    }))) : []
                }
            }(t, n)), []),
            u = sr({
                overrides: {
                    PwzrSvgIcon: {
                        root: {
                            width: "35px",
                            height: "35px"
                        }
                    }
                }
            }),
            c = le((() => {
                if ("undefined" != typeof __productWizRioAssets && Array.isArray(__productWizRioAssets))
                    try {
                        return {
                            assets: ox.decompressAssets(__productWizRioAssets)
                        }
                    } catch (e) {
                        console.log("Failed to decompress assets:"), console.log(e)
                    }
                return {
                    assets: null
                }
            }), []);
        return lt.createElement(Rw.Provider, {
            value: c
        }, lt.createElement(Ta, {
            theme: u
        }, lt.createElement(ix, {
            key: a,
            variants: l.variants,
            options: l.options,
            settings: o,
            initialSelectedVariantId: i,
            onChange: r
        })))
    };
    "undefined" != typeof __productWizRioOptions && (__productWizRioOptions.processRenderQueue = () => {
        const e = [...__productWizRioOptions.renderQueue];
        for (const t of e) {
            const [e, n, r] = t;
            je(lt.createElement(cx, {
                config: n
            }), e, r)
        }
        __productWizRioOptions.renderQueue = __productWizRioOptions.renderQueue.filter((t => !e.includes(t)))
    }, __productWizRioOptions.processRenderQueue())
}();
//# sourceMappingURL=index.js.map

